import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** Input type for dynamic zone oe_relacionado of DescomplicandoCiencia */
  DescomplicandoCienciaOeRelacionadoDynamicZoneInput: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** Input type for dynamic zone componentes_auxiliares of Oes */
  OesComponentesAuxiliaresDynamicZoneInput: any;
  /** Input type for dynamic zone perguntas of Quizz */
  QuizzPerguntasDynamicZoneInput: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type AreaConhecimentoItem = {
  __typename?: 'AreaConhecimentoItem';
  id: Scalars['ID'];
  titulo: Scalars['String'];
};

export type AreaDeConhecimento = {
  __typename?: 'AreaDeConhecimento';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  area_pai?: Maybe<AreaDeConhecimento>;
  icone?: Maybe<UploadFile>;
  imagem_url?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  area_de_conhecimentos?: Maybe<Array<Maybe<AreaDeConhecimento>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
  Banners?: Maybe<Array<Maybe<Banner>>>;
};


export type AreaDeConhecimentoArea_De_ConhecimentosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type AreaDeConhecimentoUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type AreaDeConhecimentoObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type AreaDeConhecimentoBannersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type AreaDeConhecimentoAggregator = {
  __typename?: 'AreaDeConhecimentoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AreaDeConhecimentoConnection = {
  __typename?: 'AreaDeConhecimentoConnection';
  values?: Maybe<Array<Maybe<AreaDeConhecimento>>>;
  groupBy?: Maybe<AreaDeConhecimentoGroupBy>;
  aggregate?: Maybe<AreaDeConhecimentoAggregator>;
};

export type AreaDeConhecimentoConnectionArea_Pai = {
  __typename?: 'AreaDeConhecimentoConnectionArea_pai';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AreaDeConhecimentoConnection>;
};

export type AreaDeConhecimentoConnectionCreated_At = {
  __typename?: 'AreaDeConhecimentoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AreaDeConhecimentoConnection>;
};

export type AreaDeConhecimentoConnectionIcone = {
  __typename?: 'AreaDeConhecimentoConnectionIcone';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AreaDeConhecimentoConnection>;
};

export type AreaDeConhecimentoConnectionId = {
  __typename?: 'AreaDeConhecimentoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AreaDeConhecimentoConnection>;
};

export type AreaDeConhecimentoConnectionImagem_Url = {
  __typename?: 'AreaDeConhecimentoConnectionImagem_url';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AreaDeConhecimentoConnection>;
};

export type AreaDeConhecimentoConnectionPublished_At = {
  __typename?: 'AreaDeConhecimentoConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AreaDeConhecimentoConnection>;
};

export type AreaDeConhecimentoConnectionTitulo = {
  __typename?: 'AreaDeConhecimentoConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AreaDeConhecimentoConnection>;
};

export type AreaDeConhecimentoConnectionUpdated_At = {
  __typename?: 'AreaDeConhecimentoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AreaDeConhecimentoConnection>;
};

export type AreaDeConhecimentoGroupBy = {
  __typename?: 'AreaDeConhecimentoGroupBy';
  id?: Maybe<Array<Maybe<AreaDeConhecimentoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<AreaDeConhecimentoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<AreaDeConhecimentoConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<AreaDeConhecimentoConnectionTitulo>>>;
  area_pai?: Maybe<Array<Maybe<AreaDeConhecimentoConnectionArea_Pai>>>;
  icone?: Maybe<Array<Maybe<AreaDeConhecimentoConnectionIcone>>>;
  imagem_url?: Maybe<Array<Maybe<AreaDeConhecimentoConnectionImagem_Url>>>;
  published_at?: Maybe<Array<Maybe<AreaDeConhecimentoConnectionPublished_At>>>;
};

export type AreaDeConhecimentoInput = {
  titulo?: Maybe<Scalars['String']>;
  area_pai?: Maybe<Scalars['ID']>;
  area_de_conhecimentos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  icone?: Maybe<Scalars['ID']>;
  imagem_url?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Banners?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type AreaDeDestaque = {
  __typename?: 'AreaDeDestaque';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
};

export type AreaDeDestaqueAggregator = {
  __typename?: 'AreaDeDestaqueAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AreaDeDestaqueConnection = {
  __typename?: 'AreaDeDestaqueConnection';
  values?: Maybe<Array<Maybe<AreaDeDestaque>>>;
  groupBy?: Maybe<AreaDeDestaqueGroupBy>;
  aggregate?: Maybe<AreaDeDestaqueAggregator>;
};

export type AreaDeDestaqueConnectionCreated_At = {
  __typename?: 'AreaDeDestaqueConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AreaDeDestaqueConnection>;
};

export type AreaDeDestaqueConnectionId = {
  __typename?: 'AreaDeDestaqueConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AreaDeDestaqueConnection>;
};

export type AreaDeDestaqueConnectionTitulo = {
  __typename?: 'AreaDeDestaqueConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AreaDeDestaqueConnection>;
};

export type AreaDeDestaqueConnectionUpdated_At = {
  __typename?: 'AreaDeDestaqueConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AreaDeDestaqueConnection>;
};

export type AreaDeDestaqueGroupBy = {
  __typename?: 'AreaDeDestaqueGroupBy';
  id?: Maybe<Array<Maybe<AreaDeDestaqueConnectionId>>>;
  created_at?: Maybe<Array<Maybe<AreaDeDestaqueConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<AreaDeDestaqueConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<AreaDeDestaqueConnectionTitulo>>>;
};

export type AreaDeDestaqueInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type AutorConvidado = {
  __typename?: 'AutorConvidado';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  nome?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  aceita_participacao?: Maybe<Scalars['Boolean']>;
  objeto_educacional?: Maybe<ObjetoEducacional>;
  user_autor_responsavel?: Maybe<UsersPermissionsUser>;
  autor_convidado?: Maybe<PerfilDeAutor>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type AutorConvidadoAggregator = {
  __typename?: 'AutorConvidadoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AutorConvidadoConnection = {
  __typename?: 'AutorConvidadoConnection';
  values?: Maybe<Array<Maybe<AutorConvidado>>>;
  groupBy?: Maybe<AutorConvidadoGroupBy>;
  aggregate?: Maybe<AutorConvidadoAggregator>;
};

export type AutorConvidadoConnectionAceita_Participacao = {
  __typename?: 'AutorConvidadoConnectionAceita_participacao';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<AutorConvidadoConnection>;
};

export type AutorConvidadoConnectionAutor_Convidado = {
  __typename?: 'AutorConvidadoConnectionAutor_convidado';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AutorConvidadoConnection>;
};

export type AutorConvidadoConnectionCreated_At = {
  __typename?: 'AutorConvidadoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AutorConvidadoConnection>;
};

export type AutorConvidadoConnectionEmail = {
  __typename?: 'AutorConvidadoConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AutorConvidadoConnection>;
};

export type AutorConvidadoConnectionId = {
  __typename?: 'AutorConvidadoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AutorConvidadoConnection>;
};

export type AutorConvidadoConnectionNome = {
  __typename?: 'AutorConvidadoConnectionNome';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AutorConvidadoConnection>;
};

export type AutorConvidadoConnectionObjeto_Educacional = {
  __typename?: 'AutorConvidadoConnectionObjeto_educacional';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AutorConvidadoConnection>;
};

export type AutorConvidadoConnectionPublished_At = {
  __typename?: 'AutorConvidadoConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AutorConvidadoConnection>;
};

export type AutorConvidadoConnectionStatus = {
  __typename?: 'AutorConvidadoConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AutorConvidadoConnection>;
};

export type AutorConvidadoConnectionUpdated_At = {
  __typename?: 'AutorConvidadoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AutorConvidadoConnection>;
};

export type AutorConvidadoConnectionUser_Autor_Responsavel = {
  __typename?: 'AutorConvidadoConnectionUser_autor_responsavel';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AutorConvidadoConnection>;
};

export type AutorConvidadoGroupBy = {
  __typename?: 'AutorConvidadoGroupBy';
  id?: Maybe<Array<Maybe<AutorConvidadoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<AutorConvidadoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<AutorConvidadoConnectionUpdated_At>>>;
  nome?: Maybe<Array<Maybe<AutorConvidadoConnectionNome>>>;
  email?: Maybe<Array<Maybe<AutorConvidadoConnectionEmail>>>;
  status?: Maybe<Array<Maybe<AutorConvidadoConnectionStatus>>>;
  aceita_participacao?: Maybe<Array<Maybe<AutorConvidadoConnectionAceita_Participacao>>>;
  objeto_educacional?: Maybe<Array<Maybe<AutorConvidadoConnectionObjeto_Educacional>>>;
  user_autor_responsavel?: Maybe<Array<Maybe<AutorConvidadoConnectionUser_Autor_Responsavel>>>;
  autor_convidado?: Maybe<Array<Maybe<AutorConvidadoConnectionAutor_Convidado>>>;
  published_at?: Maybe<Array<Maybe<AutorConvidadoConnectionPublished_At>>>;
};

export type AutorConvidadoInput = {
  nome?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  aceita_participacao?: Maybe<Scalars['Boolean']>;
  objeto_educacional?: Maybe<Scalars['ID']>;
  user_autor_responsavel?: Maybe<Scalars['ID']>;
  autor_convidado?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type AutorConvidadoOe = {
  __typename?: 'AutorConvidadoOE';
  id: Scalars['ID'];
  nome: Scalars['String'];
  email: Scalars['String'];
  status: Scalars['String'];
  aceita_participacao: Scalars['Boolean'];
  autor_convidado?: Maybe<Scalars['ID']>;
};

export type AutorConviteMessage = {
  __typename?: 'AutorConviteMessage';
  message: Scalars['String'];
};

export type AutorizacaoDeUso = {
  __typename?: 'AutorizacaoDeUso';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
};

export type AutorizacaoDeUsoAggregator = {
  __typename?: 'AutorizacaoDeUsoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AutorizacaoDeUsoConnection = {
  __typename?: 'AutorizacaoDeUsoConnection';
  values?: Maybe<Array<Maybe<AutorizacaoDeUso>>>;
  groupBy?: Maybe<AutorizacaoDeUsoGroupBy>;
  aggregate?: Maybe<AutorizacaoDeUsoAggregator>;
};

export type AutorizacaoDeUsoConnectionCreated_At = {
  __typename?: 'AutorizacaoDeUsoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AutorizacaoDeUsoConnection>;
};

export type AutorizacaoDeUsoConnectionId = {
  __typename?: 'AutorizacaoDeUsoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AutorizacaoDeUsoConnection>;
};

export type AutorizacaoDeUsoConnectionTitulo = {
  __typename?: 'AutorizacaoDeUsoConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AutorizacaoDeUsoConnection>;
};

export type AutorizacaoDeUsoConnectionUpdated_At = {
  __typename?: 'AutorizacaoDeUsoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AutorizacaoDeUsoConnection>;
};

export type AutorizacaoDeUsoGroupBy = {
  __typename?: 'AutorizacaoDeUsoGroupBy';
  id?: Maybe<Array<Maybe<AutorizacaoDeUsoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<AutorizacaoDeUsoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<AutorizacaoDeUsoConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<AutorizacaoDeUsoConnectionTitulo>>>;
};

export type AutorizacaoDeUsoInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Banner = {
  __typename?: 'Banner';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  PeriodoPermanenciaInicial: Scalars['Date'];
  PeriodoPermanenciaFinal?: Maybe<Scalars['Date']>;
  LinkFuga?: Maybe<Scalars['String']>;
  ImagemDesktop?: Maybe<UploadFile>;
  ImagemMobile?: Maybe<UploadFile>;
  patrocinador?: Maybe<Patrocinador>;
  Titulo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  AreasConhecimento?: Maybe<Array<Maybe<AreaDeConhecimento>>>;
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
  TiposAreaPagina?: Maybe<Array<Maybe<TipoAreaPagina>>>;
  TiposPaginas?: Maybe<Array<Maybe<TipoPagina>>>;
};


export type BannerAreasConhecimentoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type BannerObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type BannerTiposAreaPaginaArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type BannerTiposPaginasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type BannerAggregator = {
  __typename?: 'BannerAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type BannerConnection = {
  __typename?: 'BannerConnection';
  values?: Maybe<Array<Maybe<Banner>>>;
  groupBy?: Maybe<BannerGroupBy>;
  aggregate?: Maybe<BannerAggregator>;
};

export type BannerConnectionCreated_At = {
  __typename?: 'BannerConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BannerConnection>;
};

export type BannerConnectionId = {
  __typename?: 'BannerConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BannerConnection>;
};

export type BannerConnectionImagemDesktop = {
  __typename?: 'BannerConnectionImagemDesktop';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BannerConnection>;
};

export type BannerConnectionImagemMobile = {
  __typename?: 'BannerConnectionImagemMobile';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BannerConnection>;
};

export type BannerConnectionLinkFuga = {
  __typename?: 'BannerConnectionLinkFuga';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BannerConnection>;
};

export type BannerConnectionPatrocinador = {
  __typename?: 'BannerConnectionPatrocinador';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BannerConnection>;
};

export type BannerConnectionPeriodoPermanenciaFinal = {
  __typename?: 'BannerConnectionPeriodoPermanenciaFinal';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BannerConnection>;
};

export type BannerConnectionPeriodoPermanenciaInicial = {
  __typename?: 'BannerConnectionPeriodoPermanenciaInicial';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BannerConnection>;
};

export type BannerConnectionPublished_At = {
  __typename?: 'BannerConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BannerConnection>;
};

export type BannerConnectionTitulo = {
  __typename?: 'BannerConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BannerConnection>;
};

export type BannerConnectionUpdated_At = {
  __typename?: 'BannerConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BannerConnection>;
};

export type BannerGroupBy = {
  __typename?: 'BannerGroupBy';
  id?: Maybe<Array<Maybe<BannerConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BannerConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BannerConnectionUpdated_At>>>;
  PeriodoPermanenciaInicial?: Maybe<Array<Maybe<BannerConnectionPeriodoPermanenciaInicial>>>;
  PeriodoPermanenciaFinal?: Maybe<Array<Maybe<BannerConnectionPeriodoPermanenciaFinal>>>;
  LinkFuga?: Maybe<Array<Maybe<BannerConnectionLinkFuga>>>;
  ImagemDesktop?: Maybe<Array<Maybe<BannerConnectionImagemDesktop>>>;
  ImagemMobile?: Maybe<Array<Maybe<BannerConnectionImagemMobile>>>;
  patrocinador?: Maybe<Array<Maybe<BannerConnectionPatrocinador>>>;
  Titulo?: Maybe<Array<Maybe<BannerConnectionTitulo>>>;
  published_at?: Maybe<Array<Maybe<BannerConnectionPublished_At>>>;
};

export type BannerInput = {
  PeriodoPermanenciaInicial: Scalars['Date'];
  PeriodoPermanenciaFinal?: Maybe<Scalars['Date']>;
  LinkFuga?: Maybe<Scalars['String']>;
  ImagemDesktop?: Maybe<Scalars['ID']>;
  ImagemMobile?: Maybe<Scalars['ID']>;
  AreasConhecimento?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  TiposAreaPagina?: Maybe<Array<Maybe<Scalars['ID']>>>;
  TiposPaginas?: Maybe<Array<Maybe<Scalars['ID']>>>;
  patrocinador?: Maybe<Scalars['ID']>;
  Titulo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CategoriaPatrocinador = {
  __typename?: 'CategoriaPatrocinador';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo: Scalars['String'];
  published_at?: Maybe<Scalars['DateTime']>;
  patrocinadores?: Maybe<Array<Maybe<Patrocinador>>>;
};


export type CategoriaPatrocinadorPatrocinadoresArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CategoriaPatrocinadorAggregator = {
  __typename?: 'CategoriaPatrocinadorAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CategoriaPatrocinadorConnection = {
  __typename?: 'CategoriaPatrocinadorConnection';
  values?: Maybe<Array<Maybe<CategoriaPatrocinador>>>;
  groupBy?: Maybe<CategoriaPatrocinadorGroupBy>;
  aggregate?: Maybe<CategoriaPatrocinadorAggregator>;
};

export type CategoriaPatrocinadorConnectionCreated_At = {
  __typename?: 'CategoriaPatrocinadorConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoriaPatrocinadorConnection>;
};

export type CategoriaPatrocinadorConnectionId = {
  __typename?: 'CategoriaPatrocinadorConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CategoriaPatrocinadorConnection>;
};

export type CategoriaPatrocinadorConnectionPublished_At = {
  __typename?: 'CategoriaPatrocinadorConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoriaPatrocinadorConnection>;
};

export type CategoriaPatrocinadorConnectionTitulo = {
  __typename?: 'CategoriaPatrocinadorConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoriaPatrocinadorConnection>;
};

export type CategoriaPatrocinadorConnectionUpdated_At = {
  __typename?: 'CategoriaPatrocinadorConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoriaPatrocinadorConnection>;
};

export type CategoriaPatrocinadorGroupBy = {
  __typename?: 'CategoriaPatrocinadorGroupBy';
  id?: Maybe<Array<Maybe<CategoriaPatrocinadorConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CategoriaPatrocinadorConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CategoriaPatrocinadorConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<CategoriaPatrocinadorConnectionTitulo>>>;
  published_at?: Maybe<Array<Maybe<CategoriaPatrocinadorConnectionPublished_At>>>;
};

export type CategoriaPatrocinadorInput = {
  titulo: Scalars['String'];
  patrocinadores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentAlternativaListaAlternativaInput = {
  alternativa1: Scalars['String'];
  alternativa2?: Maybe<Scalars['String']>;
  alternativa3: Scalars['String'];
  alternativa_correta: Scalars['String'];
};

export type ComponentAlternativaListaAlternativas = {
  __typename?: 'ComponentAlternativaListaAlternativas';
  id: Scalars['ID'];
  alternativa1: Scalars['String'];
  alternativa2: Scalars['String'];
  alternativa3: Scalars['String'];
  alternativa_correta: Scalars['String'];
};

export type ComponentAudioAudio = {
  __typename?: 'ComponentAudioAudio';
  id: Scalars['ID'];
  url_vimeo?: Maybe<Scalars['String']>;
  outros_audios?: Maybe<UploadFile>;
  observacao?: Maybe<Scalars['String']>;
  metadados?: Maybe<ComponentFieldGroupMetadadosAutor>;
};

export type ComponentAudioAudioInput = {
  url_vimeo?: Maybe<Scalars['String']>;
  outros_audios?: Maybe<Scalars['ID']>;
  observacao?: Maybe<Scalars['String']>;
  metadados?: Maybe<ComponentFieldGroupMetadadosAutorInput>;
};

export type ComponentAutoresAutor = {
  __typename?: 'ComponentAutoresAutor';
  id: Scalars['ID'];
  NomeCompleto: Scalars['String'];
  Apelido?: Maybe<Scalars['String']>;
  DataNascimento: Scalars['Date'];
  CPF: Scalars['Int'];
  Nacionalidade: Scalars['String'];
  EstadoCivil: Enum_Componentautoresautor_Estadocivil;
  endereco?: Maybe<Array<Maybe<ComponentEnderecosEndereco>>>;
  Profissao: Enum_Componentautoresautor_Profissao;
  Outro?: Maybe<Scalars['String']>;
  CRM?: Maybe<Scalars['String']>;
  area_de_conhecimento?: Maybe<AreaDeConhecimento>;
  Foto?: Maybe<UploadFile>;
  Cargo: Scalars['String'];
  Link_Curriculum?: Maybe<Scalars['String']>;
  Autoriza_divulgacao_do_link_do_curriculo_na_sua_pagina_de_autor: Enum_Componentautoresautor_Autoriza_Divulgacao_Do_Link_Do_Curriculo_Na_Sua_Pagina_De_Autor;
  Email: Scalars['String'];
  Autoriza_divulgacao_do_email_na_sua_pagina_de_autor?: Maybe<Enum_Componentautoresautor_Autoriza_Divulgacao_Do_Email_Na_Sua_Pagina_De_Autor>;
  Aceite: Scalars['Boolean'];
  telefone?: Maybe<Array<Maybe<ComponentTelefoneAutorTelefone>>>;
};

export type ComponentAutoresAutorInput = {
  NomeCompleto: Scalars['String'];
  Apelido?: Maybe<Scalars['String']>;
  DataNascimento: Scalars['Date'];
  CPF: Scalars['Int'];
  Nacionalidade: Scalars['String'];
  EstadoCivil: Enum_Componentautoresautor_Estadocivil;
  endereco?: Maybe<Array<ComponentEnderecosEnderecoInput>>;
  Profissao: Enum_Componentautoresautor_Profissao;
  Outro?: Maybe<Scalars['String']>;
  CRM?: Maybe<Scalars['String']>;
  area_de_conhecimento?: Maybe<Scalars['ID']>;
  Foto?: Maybe<Scalars['ID']>;
  Cargo: Scalars['String'];
  Link_Curriculum?: Maybe<Scalars['String']>;
  Autoriza_divulgacao_do_link_do_curriculo_na_sua_pagina_de_autor: Enum_Componentautoresautor_Autoriza_Divulgacao_Do_Link_Do_Curriculo_Na_Sua_Pagina_De_Autor;
  Email: Scalars['String'];
  Autoriza_divulgacao_do_email_na_sua_pagina_de_autor?: Maybe<Enum_Componentautoresautor_Autoriza_Divulgacao_Do_Email_Na_Sua_Pagina_De_Autor>;
  Aceite: Scalars['Boolean'];
  telefone?: Maybe<Array<ComponentTelefoneAutorTelefoneInput>>;
};

export type ComponentCessaoDeDireitosCessaoDeDireitoInput = {
  NomeCompleto: Scalars['String'];
  RG: Scalars['String'];
  CPF: Scalars['String'];
  TermoDeConcessao?: Maybe<Scalars['ID']>;
};

export type ComponentCessaoDeDireitosCessaoDeDireitos = {
  __typename?: 'ComponentCessaoDeDireitosCessaoDeDireitos';
  id: Scalars['ID'];
  NomeCompleto: Scalars['String'];
  RG: Scalars['String'];
  CPF: Scalars['String'];
  TermoDeConcessao?: Maybe<UploadFile>;
};

export type ComponentCicloDeVidaCicloDeVida = {
  __typename?: 'ComponentCicloDeVidaCicloDeVida';
  id: Scalars['ID'];
  AutorizacaoDeUso: Enum_Componentciclodevidaciclodevida_Autorizacaodeuso;
  ValidadeConteudo: Scalars['Date'];
  Status: Enum_Componentciclodevidaciclodevida_Status;
  DireitosUsoImagemTerceirosPacientes?: Maybe<ComponentCessaoDeDireitosCessaoDeDireitos>;
  DataProducao?: Maybe<Scalars['Date']>;
  DataAtualizacaoProducao?: Maybe<Scalars['Date']>;
};

export type ComponentCicloDeVidaCicloDeVidaInput = {
  AutorizacaoDeUso?: Maybe<Enum_Componentciclodevidaciclodevida_Autorizacaodeuso>;
  ValidadeConteudo: Scalars['Date'];
  Status?: Maybe<Enum_Componentciclodevidaciclodevida_Status>;
  DireitosUsoImagemTerceirosPacientes?: Maybe<ComponentCessaoDeDireitosCessaoDeDireitoInput>;
  DataProducao?: Maybe<Scalars['Date']>;
  DataAtualizacaoProducao?: Maybe<Scalars['Date']>;
};

export type ComponentEnderecosEndereco = {
  __typename?: 'ComponentEnderecosEndereco';
  id: Scalars['ID'];
  CEP: Scalars['Int'];
  Logradouro: Scalars['String'];
  Numero: Scalars['Int'];
  Cidade: Scalars['String'];
  UF: Scalars['String'];
  Tipo: Enum_Componentenderecosendereco_Tipo;
};

export type ComponentEnderecosEnderecoInput = {
  CEP: Scalars['Int'];
  Logradouro: Scalars['String'];
  Numero: Scalars['Int'];
  Cidade: Scalars['String'];
  UF: Scalars['String'];
  Tipo: Enum_Componentenderecosendereco_Tipo;
};

/** Se for podcast ou vídeo, adicione o arquivo e a referência do paper em formato VANCOUVER */
export type ComponentFieldGroupArquivoReferencia = {
  __typename?: 'ComponentFieldGroupArquivoReferencia';
  id: Scalars['ID'];
  referencia: Scalars['String'];
  arquivo?: Maybe<Array<Maybe<UploadFile>>>;
};


/** Se for podcast ou vídeo, adicione o arquivo e a referência do paper em formato VANCOUVER */
export type ComponentFieldGroupArquivoReferenciaArquivoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentFieldGroupArquivoReferenciaInput = {
  arquivo?: Maybe<Array<Maybe<Scalars['ID']>>>;
  referencia: Scalars['String'];
};

export type ComponentFieldGroupFormularioDeSessaoDeUso = {
  __typename?: 'ComponentFieldGroupFormularioDeSessaoDeUso';
  id: Scalars['ID'];
  nome_completo?: Maybe<Scalars['String']>;
  rg?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
};

export type ComponentFieldGroupFormularioDeSessaoDeUsoInput = {
  nome_completo?: Maybe<Scalars['String']>;
  rg?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
};

export type ComponentFieldGroupGestaoDeDestaque = {
  __typename?: 'ComponentFieldGroupGestaoDeDestaque';
  id: Scalars['ID'];
  area_de_destaque?: Maybe<AreaDeDestaque>;
  data_inicio?: Maybe<Scalars['Date']>;
  data_fim?: Maybe<Scalars['Date']>;
};

export type ComponentFieldGroupGestaoDeDestaqueInput = {
  area_de_destaque?: Maybe<Scalars['ID']>;
  data_inicio?: Maybe<Scalars['Date']>;
  data_fim?: Maybe<Scalars['Date']>;
};

export type ComponentFieldGroupImagemEDescricao = {
  __typename?: 'ComponentFieldGroupImagemEDescricao';
  id: Scalars['ID'];
  imagem?: Maybe<UploadFile>;
  descricao: Scalars['String'];
};

export type ComponentFieldGroupImagemEDescricaoInput = {
  imagem?: Maybe<Scalars['ID']>;
  descricao: Scalars['String'];
};

export type ComponentFieldGroupInfografico = {
  __typename?: 'ComponentFieldGroupInfografico';
  id: Scalars['ID'];
  infografico?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentFieldGroupInfograficoInfograficoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentFieldGroupInfograficoInput = {
  infografico?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentFieldGroupMaturidadePublicaAlvo = {
  __typename?: 'ComponentFieldGroupMaturidadePublicaAlvo';
  id: Scalars['ID'];
  maturidade_publico_alvo?: Maybe<MaturidadePublicoAlvo>;
};

export type ComponentFieldGroupMaturidadePublicaAlvoInput = {
  maturidade_publico_alvo?: Maybe<Scalars['ID']>;
};

export type ComponentFieldGroupMetadadosAutor = {
  __typename?: 'ComponentFieldGroupMetadadosAutor';
  id: Scalars['ID'];
  nome_autor?: Maybe<Scalars['String']>;
  cargo_autor?: Maybe<Scalars['String']>;
  link_autor?: Maybe<Scalars['String']>;
  email_autor?: Maybe<Scalars['String']>;
};

export type ComponentFieldGroupMetadadosAutorInput = {
  nome_autor?: Maybe<Scalars['String']>;
  cargo_autor?: Maybe<Scalars['String']>;
  link_autor?: Maybe<Scalars['String']>;
  email_autor?: Maybe<Scalars['String']>;
};

export type ComponentFieldGroupMetadadosCicloDeVida = {
  __typename?: 'ComponentFieldGroupMetadadosCicloDeVida';
  id: Scalars['ID'];
  data_validade?: Maybe<Scalars['Date']>;
  autorizacao_de_uso?: Maybe<AutorizacaoDeUso>;
  cessao_de_direitos?: Maybe<ComponentFieldGroupFormularioDeSessaoDeUso>;
  status_de_publicacao?: Maybe<StatusDePublicacao>;
  versao?: Maybe<Scalars['String']>;
  data_criacao?: Maybe<Scalars['Date']>;
  data_atualizacao?: Maybe<Scalars['Date']>;
  validade_conteudo?: Maybe<Scalars['Date']>;
  status?: Maybe<Enum_Componentfieldgroupmetadadosciclodevida_Status>;
};

export type ComponentFieldGroupMetadadosCicloDeVidaInput = {
  data_validade?: Maybe<Scalars['Date']>;
  autorizacao_de_uso?: Maybe<Scalars['ID']>;
  cessao_de_direitos?: Maybe<ComponentFieldGroupFormularioDeSessaoDeUsoInput>;
  status_de_publicacao?: Maybe<Scalars['ID']>;
  versao?: Maybe<Scalars['String']>;
  data_criacao?: Maybe<Scalars['Date']>;
  data_atualizacao?: Maybe<Scalars['Date']>;
  validade_conteudo?: Maybe<Scalars['Date']>;
  status?: Maybe<Enum_Componentfieldgroupmetadadosciclodevida_Status>;
};

export type ComponentFieldGroupMetadadosEducacional = {
  __typename?: 'ComponentFieldGroupMetadadosEducacional';
  id: Scalars['ID'];
  rotulo?: Maybe<Rotulo>;
  tipo_recurso_educacional?: Maybe<TipoRecursoEducacional>;
  tipos_oe?: Maybe<Array<Maybe<ComponentFieldGroupSeletorTipoOe>>>;
  tipo_interatividade_oe?: Maybe<TipoInteratividadeOe>;
  nivel_objetivo_aprendizagem?: Maybe<Array<Maybe<ComponentFieldGroupSeletorDeNIvelDeObjetivoDeAprendizagem>>>;
  maturidade_publico_alvo?: Maybe<Array<Maybe<ComponentFieldGroupSeletorMaturidadePublicoAlvo>>>;
  densidade_semantica?: Maybe<DensidadeSemantica>;
  granularidade?: Maybe<Granularidade>;
  relacionado?: Maybe<Scalars['String']>;
  relacionando_indicacao_recurso?: Maybe<Enum_Componentfieldgroupmetadadoseducacional_Relacionando_Indicacao_Recurso>;
};

export type ComponentFieldGroupMetadadosEducacionalInput = {
  rotulo?: Maybe<Scalars['ID']>;
  tipo_recurso_educacional?: Maybe<Scalars['ID']>;
  tipos_oe?: Maybe<Array<Maybe<ComponentFieldGroupSeletorTipoOeInput>>>;
  tipo_interatividade_oe?: Maybe<Scalars['ID']>;
  nivel_objetivo_aprendizagem?: Maybe<Array<Maybe<ComponentFieldGroupSeletorDeNIvelDeObjetivoDeAprendizagemInput>>>;
  maturidade_publico_alvo?: Maybe<Array<Maybe<ComponentFieldGroupSeletorMaturidadePublicoAlvoInput>>>;
  densidade_semantica?: Maybe<Scalars['ID']>;
  granularidade?: Maybe<Scalars['ID']>;
  relacionado?: Maybe<Scalars['String']>;
  relacionando_indicacao_recurso?: Maybe<Enum_Componentfieldgroupmetadadoseducacional_Relacionando_Indicacao_Recurso>;
};

export type ComponentFieldGroupMetadadosEinstein = {
  __typename?: 'ComponentFieldGroupMetadadosEinstein';
  id: Scalars['ID'];
  modalidade_de_ensino?: Maybe<ModalidadeDeEnsino>;
  produto_primarios?: Maybe<Array<Maybe<ProdutoPrimario>>>;
};


export type ComponentFieldGroupMetadadosEinsteinProduto_PrimariosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentFieldGroupMetadadosEinsteinInput = {
  modalidade_de_ensino?: Maybe<Scalars['ID']>;
  produto_primarios?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentFieldGroupMetadadosIdentificacao = {
  __typename?: 'ComponentFieldGroupMetadadosIdentificacao';
  id: Scalars['ID'];
  SubAreaDeConhecimento?: Maybe<AreaDeConhecimento>;
  PalavrasChave?: Maybe<Array<Maybe<ComponentFieldGroupPalavraChave>>>;
  Descricao?: Maybe<Scalars['String']>;
  DescricaoResumida?: Maybe<Scalars['String']>;
  restricao_publico_nao_medico?: Maybe<Scalars['Boolean']>;
  autor?: Maybe<Array<Maybe<ComponentFieldGroupMetadadosAutor>>>;
  idioma?: Maybe<Idiomas>;
  imagem_de_capa_home?: Maybe<UploadFile>;
  area_de_destaque?: Maybe<Array<Maybe<ComponentFieldGroupGestaoDeDestaque>>>;
  topico?: Maybe<Topico>;
  imagem_de_capa_conteudo?: Maybe<UploadFile>;
  AreaDeConhecimentos?: Maybe<Array<Maybe<AreaDeConhecimento>>>;
  PublicoAlvo?: Maybe<Array<Maybe<PublicoAlvo>>>;
};


export type ComponentFieldGroupMetadadosIdentificacaoAreaDeConhecimentosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ComponentFieldGroupMetadadosIdentificacaoPublicoAlvoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentFieldGroupMetadadosIdentificacaoInput = {
  AreaDeConhecimentos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  SubAreaDeConhecimento?: Maybe<Scalars['ID']>;
  PalavrasChave?: Maybe<Array<Maybe<ComponentFieldGroupPalavraChaveInput>>>;
  Descricao?: Maybe<Scalars['String']>;
  DescricaoResumida?: Maybe<Scalars['String']>;
  PublicoAlvo?: Maybe<Array<Maybe<Scalars['ID']>>>;
  restricao_publico_nao_medico?: Maybe<Scalars['Boolean']>;
  autor?: Maybe<Array<Maybe<ComponentFieldGroupMetadadosAutorInput>>>;
  idioma?: Maybe<Scalars['ID']>;
  imagem_de_capa_home?: Maybe<Scalars['ID']>;
  area_de_destaque?: Maybe<Array<Maybe<ComponentFieldGroupGestaoDeDestaqueInput>>>;
  topico?: Maybe<Scalars['ID']>;
  imagem_de_capa_conteudo?: Maybe<Scalars['ID']>;
};

export type ComponentFieldGroupObjetivosEResultadoInput = {
  objetivos_metodologias: Scalars['String'];
  resultados: Scalars['String'];
  tabelas_graficos?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentFieldGroupObjetivosEResultados = {
  __typename?: 'ComponentFieldGroupObjetivosEResultados';
  id: Scalars['ID'];
  objetivos_metodologias: Scalars['String'];
  resultados: Scalars['String'];
  tabelas_graficos?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentFieldGroupObjetivosEResultadosTabelas_GraficosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentFieldGroupPalavraChave = {
  __typename?: 'ComponentFieldGroupPalavraChave';
  id: Scalars['ID'];
  palavra_chave?: Maybe<Scalars['String']>;
};

export type ComponentFieldGroupPalavraChaveInput = {
  palavra_chave?: Maybe<Scalars['String']>;
};

export type ComponentFieldGroupResultadoInput = {
  descricao_resultado: Scalars['String'];
  imagem_resultado?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentFieldGroupResultados = {
  __typename?: 'ComponentFieldGroupResultados';
  id: Scalars['ID'];
  descricao_resultado: Scalars['String'];
  imagem_resultado?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentFieldGroupResultadosImagem_ResultadoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentFieldGroupResumoDoConteudoInfografico = {
  __typename?: 'ComponentFieldGroupResumoDoConteudoInfografico';
  id: Scalars['ID'];
  objetivos_metodologia: Scalars['String'];
  resultados: Scalars['String'];
  limitacoes_estudo: Scalars['String'];
  conclusao: Scalars['String'];
};

export type ComponentFieldGroupResumoDoConteudoInfograficoInput = {
  objetivos_metodologia: Scalars['String'];
  resultados: Scalars['String'];
  limitacoes_estudo: Scalars['String'];
  conclusao: Scalars['String'];
};

export type ComponentFieldGroupSeletorAreaDeConhecimento = {
  __typename?: 'ComponentFieldGroupSeletorAreaDeConhecimento';
  id: Scalars['ID'];
  area_de_conhecimento?: Maybe<AreaDeConhecimento>;
};

export type ComponentFieldGroupSeletorAreaDeConhecimentoInput = {
  area_de_conhecimento?: Maybe<Scalars['ID']>;
};

export type ComponentFieldGroupSeletorDeAutoreInput = {
  perfil_de_autor?: Maybe<Scalars['ID']>;
};

export type ComponentFieldGroupSeletorDeAutores = {
  __typename?: 'ComponentFieldGroupSeletorDeAutores';
  id: Scalars['ID'];
  perfil_de_autor?: Maybe<PerfilDeAutor>;
};

export type ComponentFieldGroupSeletorDeNIvelDeObjetivoDeAprendizagem = {
  __typename?: 'ComponentFieldGroupSeletorDeNIvelDeObjetivoDeAprendizagem';
  id: Scalars['ID'];
  nivel_dos_objetivos_de_aprendizagem?: Maybe<NivelDosObjetivosDeAprendizagem>;
};

export type ComponentFieldGroupSeletorDeNIvelDeObjetivoDeAprendizagemInput = {
  nivel_dos_objetivos_de_aprendizagem?: Maybe<Scalars['ID']>;
};

export type ComponentFieldGroupSeletorMaturidadePublicoAlvo = {
  __typename?: 'ComponentFieldGroupSeletorMaturidadePublicoAlvo';
  id: Scalars['ID'];
  maturidade_publico_alvo?: Maybe<MaturidadePublicoAlvo>;
};

export type ComponentFieldGroupSeletorMaturidadePublicoAlvoInput = {
  maturidade_publico_alvo?: Maybe<Scalars['ID']>;
};

export type ComponentFieldGroupSeletorModalidadeDeEnsino = {
  __typename?: 'ComponentFieldGroupSeletorModalidadeDeEnsino';
  id: Scalars['ID'];
  modalidade_de_ensino?: Maybe<ModalidadeDeEnsino>;
};

export type ComponentFieldGroupSeletorModalidadeDeEnsinoInput = {
  modalidade_de_ensino?: Maybe<Scalars['ID']>;
};

export type ComponentFieldGroupSeletorOeRelacionado = {
  __typename?: 'ComponentFieldGroupSeletorOeRelacionado';
  id: Scalars['ID'];
  tipos_relacionamentos_entre_oe?: Maybe<TiposRelacionamentosEntreOe>;
  descomplicando_ciencias?: Maybe<Array<Maybe<DescomplicandoCiencia>>>;
};


export type ComponentFieldGroupSeletorOeRelacionadoDescomplicando_CienciasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentFieldGroupSeletorOeRelacionadoInput = {
  tipos_relacionamentos_entre_oe?: Maybe<Scalars['ID']>;
  descomplicando_ciencias?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentFieldGroupSeletorProdutoPrimario = {
  __typename?: 'ComponentFieldGroupSeletorProdutoPrimario';
  id: Scalars['ID'];
};

export type ComponentFieldGroupSeletorProdutoPrimarioInput = {
  _?: Maybe<Scalars['String']>;
};

export type ComponentFieldGroupSeletorTipoOe = {
  __typename?: 'ComponentFieldGroupSeletorTipoOe';
  id: Scalars['ID'];
  tipo_oe?: Maybe<TipoOe>;
};

export type ComponentFieldGroupSeletorTipoOeInput = {
  tipo_oe?: Maybe<Scalars['ID']>;
};

export type ComponentFieldGroupSolicitacaoInfografico = {
  __typename?: 'ComponentFieldGroupSolicitacaoInfografico';
  id: Scalars['ID'];
  resumo_conteudo?: Maybe<ComponentFieldGroupResumoDoConteudoInfografico>;
  imagem_descricao?: Maybe<Array<Maybe<ComponentFieldGroupImagemEDescricao>>>;
  referencia: Scalars['String'];
};

export type ComponentFieldGroupSolicitacaoInfograficoInput = {
  resumo_conteudo: ComponentFieldGroupResumoDoConteudoInfograficoInput;
  imagem_descricao?: Maybe<Array<ComponentFieldGroupImagemEDescricaoInput>>;
  referencia: Scalars['String'];
};

export type ComponentFieldGroupTecnica = {
  __typename?: 'ComponentFieldGroupTecnica';
  id: Scalars['ID'];
  Tamanho?: Maybe<Scalars['String']>;
  duracao?: Maybe<Scalars['Float']>;
  dimensoes?: Maybe<Scalars['String']>;
  Formato?: Maybe<Enum_Componentfieldgrouptecnica_Formato>;
};

export type ComponentFieldGroupTecnicaInput = {
  Tamanho?: Maybe<Scalars['String']>;
  duracao?: Maybe<Scalars['Float']>;
  dimensoes?: Maybe<Scalars['String']>;
  Formato?: Maybe<Enum_Componentfieldgrouptecnica_Formato>;
};

export type ComponentGrupoEnsinoGrupoEnsino = {
  __typename?: 'ComponentGrupoEnsinoGrupoEnsino';
  id: Scalars['ID'];
  titulo: Scalars['String'];
  ordem?: Maybe<Scalars['Int']>;
  cursos?: Maybe<Array<Maybe<EnsinoEinstein>>>;
};


export type ComponentGrupoEnsinoGrupoEnsinoCursosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentGrupoEnsinoGrupoEnsinoInput = {
  titulo: Scalars['String'];
  cursos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ordem?: Maybe<Scalars['Int']>;
};

export type ComponentHomeConteudosAltaHomeConteudosAlta = {
  __typename?: 'ComponentHomeConteudosAltaHomeConteudosAlta';
  id: Scalars['ID'];
  Quiz?: Maybe<ObjetoEducacional>;
  ObjetosEducacionaisOrdenados?: Maybe<Array<Maybe<ComponentObjetosEducacionaisOrdenadosObjetosEducacionaisOrdenados>>>;
  ObjetosEducacionaisConteudosAlta?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type ComponentHomeConteudosAltaHomeConteudosAltaObjetosEducacionaisConteudosAltaArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentHomeConteudosAltaHomeConteudosAltaInput = {
  ObjetosEducacionaisConteudosAlta?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Quiz?: Maybe<Scalars['ID']>;
  ObjetosEducacionaisOrdenados?: Maybe<Array<Maybe<ComponentObjetosEducacionaisOrdenadosObjetosEducacionaisOrdenadoInput>>>;
};

export type ComponentHomeDestaqueSemanaHomeDestaqueSemana = {
  __typename?: 'ComponentHomeDestaqueSemanaHomeDestaqueSemana';
  id: Scalars['ID'];
  OeQuizz?: Maybe<ObjetoEducacional>;
  OePodcast?: Maybe<ObjetoEducacional>;
  ObjetosEducacionaisOrdenados?: Maybe<Array<Maybe<ComponentObjetosEducacionaisOrdenadosObjetosEducacionaisOrdenados>>>;
  OesDestaqueSemana?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type ComponentHomeDestaqueSemanaHomeDestaqueSemanaOesDestaqueSemanaArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentHomeDestaqueSemanaHomeDestaqueSemanaInput = {
  OeQuizz?: Maybe<Scalars['ID']>;
  OesDestaqueSemana?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OePodcast?: Maybe<Scalars['ID']>;
  ObjetosEducacionaisOrdenados?: Maybe<Array<Maybe<ComponentObjetosEducacionaisOrdenadosObjetosEducacionaisOrdenadoInput>>>;
};

export type ComponentHomeDestaquesSemanaHomeDestaquesSemana = {
  __typename?: 'ComponentHomeDestaquesSemanaHomeDestaquesSemana';
  id: Scalars['ID'];
  QuizSemana?: Maybe<ObjetoEducacional>;
  OEsDestaquesSemana?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type ComponentHomeDestaquesSemanaHomeDestaquesSemanaOEsDestaquesSemanaArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentHomeDestaquesSemanaHomeDestaquesSemanaInput = {
  QuizSemana?: Maybe<Scalars['ID']>;
  OEsDestaquesSemana?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentHomeNovidadesHomeNovidadeInput = {
  objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentHomeNovidadesHomeNovidades = {
  __typename?: 'ComponentHomeNovidadesHomeNovidades';
  id: Scalars['ID'];
  objeto_educacionals?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type ComponentHomeNovidadesHomeNovidadesObjeto_EducacionalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentHomeOutrasAreasHomeOutrasAreaInput = {
  AreasConhecimento?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentHomeOutrasAreasHomeOutrasAreas = {
  __typename?: 'ComponentHomeOutrasAreasHomeOutrasAreas';
  id: Scalars['ID'];
  AreasConhecimento?: Maybe<Array<Maybe<AreaDeConhecimento>>>;
};


export type ComponentHomeOutrasAreasHomeOutrasAreasAreasConhecimentoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentHomeQuizHomeQuiz = {
  __typename?: 'ComponentHomeQuizHomeQuiz';
  id: Scalars['ID'];
  Quiz?: Maybe<Quizz>;
};

export type ComponentHomeQuizHomeQuizInput = {
  Quiz?: Maybe<Scalars['ID']>;
};

export type ComponentHomeTopicosHomeTopicoInput = {
  Topicos?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentHomeTopicosHomeTopicos = {
  __typename?: 'ComponentHomeTopicosHomeTopicos';
  id: Scalars['ID'];
  Topicos?: Maybe<Array<Maybe<Topico>>>;
};


export type ComponentHomeTopicosHomeTopicosTopicosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentHomeVideosAltaHomeVideosAlta = {
  __typename?: 'ComponentHomeVideosAltaHomeVideosAlta';
  id: Scalars['ID'];
  ObjetosEducacionaisVideosAlta?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type ComponentHomeVideosAltaHomeVideosAltaObjetosEducacionaisVideosAltaArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentHomeVideosAltaHomeVideosAltaInput = {
  ObjetosEducacionaisVideosAlta?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentImagemImagem = {
  __typename?: 'ComponentImagemImagem';
  id: Scalars['ID'];
  url_vimeo?: Maybe<Scalars['String']>;
  outra_imagens?: Maybe<UploadFile>;
  observacao?: Maybe<Scalars['String']>;
  imagem?: Maybe<UploadFile>;
  direitos_uso?: Maybe<Enum_Componentimagemimagem_Direitos_Uso>;
  autorizacao?: Maybe<UploadFile>;
};

export type ComponentImagemImagemInput = {
  url_vimeo?: Maybe<Scalars['String']>;
  outra_imagens?: Maybe<Scalars['ID']>;
  observacao?: Maybe<Scalars['String']>;
  imagem?: Maybe<Scalars['ID']>;
  direitos_uso?: Maybe<Enum_Componentimagemimagem_Direitos_Uso>;
  autorizacao?: Maybe<Scalars['ID']>;
};

export type ComponentLinksRodapeLinkInput = {
  itens_rodapes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentLinksRodapeLinks = {
  __typename?: 'ComponentLinksRodapeLinks';
  id: Scalars['ID'];
  itens_rodapes?: Maybe<Array<Maybe<ItemRodapes>>>;
};


export type ComponentLinksRodapeLinksItens_RodapesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentListaAltaAlta = {
  __typename?: 'ComponentListaAltaAlta';
  id: Scalars['ID'];
  oe_altas?: Maybe<Array<Maybe<Oes>>>;
};


export type ComponentListaAltaAltaOe_AltasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentListaAltaAltaInput = {
  oe_altas?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentListaAreasConhecimentoOutrasAreasConhecimento = {
  __typename?: 'ComponentListaAreasConhecimentoOutrasAreasConhecimento';
  id: Scalars['ID'];
};

export type ComponentListaAreasConhecimentoOutrasAreasConhecimentoInput = {
  _?: Maybe<Scalars['String']>;
};

export type ComponentListaContatosRodapeContatosRodape = {
  __typename?: 'ComponentListaContatosRodapeContatosRodape';
  id: Scalars['ID'];
  contato: Scalars['String'];
};

export type ComponentListaContatosRodapeContatosRodapeInput = {
  contato: Scalars['String'];
};

export type ComponentListaEmailsAtendimentoListaEmailsAtendimento = {
  __typename?: 'ComponentListaEmailsAtendimentoListaEmailsAtendimento';
  id: Scalars['ID'];
  email: Scalars['String'];
};

export type ComponentListaEmailsAtendimentoListaEmailsAtendimentoInput = {
  email: Scalars['String'];
};

export type ComponentListaHomeSliderListaHomeSlider = {
  __typename?: 'ComponentListaHomeSliderListaHomeSlider';
  id: Scalars['ID'];
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type ComponentListaHomeSliderListaHomeSliderObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentListaHomeSliderListaHomeSliderInput = {
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentListaHorarioAtendimentoHorarioAtendimento = {
  __typename?: 'ComponentListaHorarioAtendimentoHorarioAtendimento';
  id: Scalars['ID'];
  telefone?: Maybe<Scalars['String']>;
};

export type ComponentListaHorarioAtendimentoHorarioAtendimentoInput = {
  telefone?: Maybe<Scalars['String']>;
};

export type ComponentListaHorariosAtendimentoListaHorariosAtendimento = {
  __typename?: 'ComponentListaHorariosAtendimentoListaHorariosAtendimento';
  id: Scalars['ID'];
  dia_semana: Scalars['String'];
  horario: Scalars['String'];
};

export type ComponentListaHorariosAtendimentoListaHorariosAtendimentoInput = {
  dia_semana: Scalars['String'];
  horario: Scalars['String'];
};

export type ComponentListaMenusItem = {
  __typename?: 'ComponentListaMenusItem';
  id: Scalars['ID'];
  Nome?: Maybe<Scalars['String']>;
  rota?: Maybe<Rotas>;
  Ordem?: Maybe<Scalars['Int']>;
};

export type ComponentListaMenusItemInput = {
  Nome?: Maybe<Scalars['String']>;
  rota?: Maybe<Scalars['ID']>;
  Ordem?: Maybe<Scalars['Int']>;
};

export type ComponentListaMenusRodapeLinksRodape = {
  __typename?: 'ComponentListaMenusRodapeLinksRodape';
  id: Scalars['ID'];
  nome: Scalars['String'];
  ordem: Scalars['Int'];
  rota?: Maybe<Rotas>;
  contatosRodape?: Maybe<Array<Maybe<ComponentListaContatosRodapeContatosRodape>>>;
  icone?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentListaMenusRodapeLinksRodapeIconeArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentListaMenusRodapeLinksRodapeInput = {
  nome: Scalars['String'];
  ordem: Scalars['Int'];
  rota?: Maybe<Scalars['ID']>;
  icone?: Maybe<Array<Maybe<Scalars['ID']>>>;
  contatosRodape?: Maybe<Array<Maybe<ComponentListaContatosRodapeContatosRodapeInput>>>;
};

export type ComponentListaOutrasAreasOutrasAreaInput = {
  _?: Maybe<Scalars['String']>;
};

export type ComponentListaOutrasAreasOutrasAreas = {
  __typename?: 'ComponentListaOutrasAreasOutrasAreas';
  id: Scalars['ID'];
};

export type ComponentListaQuizQuiz = {
  __typename?: 'ComponentListaQuizQuiz';
  id: Scalars['ID'];
  oe_quiz?: Maybe<Oes>;
};

export type ComponentListaQuizQuizInput = {
  oe_quiz?: Maybe<Scalars['ID']>;
};

export type ComponentListaSliderSlider = {
  __typename?: 'ComponentListaSliderSlider';
  id: Scalars['ID'];
  oes_slider?: Maybe<Array<Maybe<Oes>>>;
};


export type ComponentListaSliderSliderOes_SliderArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentListaSliderSliderInput = {
  oes_slider?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentListaTopicosTopico = {
  __typename?: 'ComponentListaTopicosTopico';
  id: Scalars['ID'];
  topicos?: Maybe<Array<Maybe<Topico>>>;
};


export type ComponentListaTopicosTopicoTopicosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentListaTopicosTopicoInput = {
  topicos?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentListaVideosAltaVideosAlta = {
  __typename?: 'ComponentListaVideosAltaVideosAlta';
  id: Scalars['ID'];
};

export type ComponentListaVideosAltaVideosAltaInput = {
  _?: Maybe<Scalars['String']>;
};

export type ComponentMenusRodapeMenusRodape = {
  __typename?: 'ComponentMenusRodapeMenusRodape';
  id: Scalars['ID'];
  nome: Scalars['String'];
  ordem?: Maybe<Scalars['Int']>;
  rota?: Maybe<Rotas>;
  contatosRodape?: Maybe<Array<Maybe<ComponentListaContatosRodapeContatosRodape>>>;
  icone?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentMenusRodapeMenusRodapeIconeArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentMenusRodapeMenusRodapeInput = {
  nome: Scalars['String'];
  ordem?: Maybe<Scalars['Int']>;
  rota?: Maybe<Scalars['ID']>;
  icone?: Maybe<Array<Maybe<Scalars['ID']>>>;
  contatosRodape?: Maybe<Array<Maybe<ComponentListaContatosRodapeContatosRodapeInput>>>;
};

export type ComponentObjetoEducacionalInfogaficoInfografico = {
  __typename?: 'ComponentObjetoEducacionalInfogaficoInfografico';
  id: Scalars['ID'];
  Titulo?: Maybe<Scalars['String']>;
  Imagem?: Maybe<UploadFile>;
  Descricao?: Maybe<Scalars['String']>;
};

export type ComponentObjetoEducacionalInfogaficoInfograficoInput = {
  Titulo?: Maybe<Scalars['String']>;
  Imagem?: Maybe<Scalars['ID']>;
  Descricao?: Maybe<Scalars['String']>;
};

export type ComponentObjetosEducacionaisOrdenadosObjetosEducacionaisOrdenadoInput = {
  objeto_educacional?: Maybe<Scalars['ID']>;
  ordem?: Maybe<Scalars['Int']>;
};

export type ComponentObjetosEducacionaisOrdenadosObjetosEducacionaisOrdenados = {
  __typename?: 'ComponentObjetosEducacionaisOrdenadosObjetosEducacionaisOrdenados';
  id: Scalars['ID'];
  objeto_educacional?: Maybe<ObjetoEducacional>;
  ordem?: Maybe<Scalars['Int']>;
};

export type ComponentOesParcialmenteConsumidasConsumidosParcialmente = {
  __typename?: 'ComponentOesParcialmenteConsumidasConsumidosParcialmente';
  id: Scalars['ID'];
  OE?: Maybe<Oes>;
  TempoAssistido?: Maybe<Scalars['Float']>;
  SecaoParada?: Maybe<Scalars['String']>;
};

export type ComponentOesParcialmenteConsumidasConsumidosParcialmenteInput = {
  OE?: Maybe<Scalars['ID']>;
  TempoAssistido?: Maybe<Scalars['Float']>;
  SecaoParada?: Maybe<Scalars['String']>;
};

export type ComponentPerguntaOpcaoOpcao = {
  __typename?: 'ComponentPerguntaOpcaoOpcao';
  id: Scalars['ID'];
  opcao?: Maybe<Scalars['String']>;
  opcao_correta?: Maybe<Scalars['Boolean']>;
  contador?: Maybe<Scalars['Int']>;
};

export type ComponentPerguntaOpcaoOpcaoInput = {
  opcao?: Maybe<Scalars['String']>;
  opcao_correta?: Maybe<Scalars['Boolean']>;
  contador?: Maybe<Scalars['Int']>;
};

export type ComponentPerguntaOpcaoRespostaInput = {
  opcao: Scalars['String'];
  opcao_correta?: Maybe<Scalars['Boolean']>;
  contador?: Maybe<Scalars['Int']>;
};

export type ComponentPerguntaOpcaoRespostas = {
  __typename?: 'ComponentPerguntaOpcaoRespostas';
  id: Scalars['ID'];
  opcao: Scalars['String'];
  opcao_correta?: Maybe<Scalars['Boolean']>;
  contador?: Maybe<Scalars['Int']>;
};

export type ComponentPerguntaQuizzPergunta = {
  __typename?: 'ComponentPerguntaQuizzPergunta';
  id: Scalars['ID'];
  pergunta?: Maybe<PerguntaQuizz>;
};

export type ComponentPerguntaQuizzPerguntaInput = {
  pergunta?: Maybe<Scalars['ID']>;
};

export type ComponentQuizzesQuiz = {
  __typename?: 'ComponentQuizzesQuiz';
  id: Scalars['ID'];
  quiz?: Maybe<Quizz>;
  duracao?: Maybe<Scalars['Int']>;
};

export type ComponentQuizzesQuizInput = {
  quiz?: Maybe<Scalars['ID']>;
  duracao?: Maybe<Scalars['Int']>;
};

export type ComponentRodapeAtendimentoAtendimento = {
  __typename?: 'ComponentRodapeAtendimentoAtendimento';
  id: Scalars['ID'];
  itens_rodapes?: Maybe<Array<Maybe<ItemRodapes>>>;
};


export type ComponentRodapeAtendimentoAtendimentoItens_RodapesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentRodapeAtendimentoAtendimentoInput = {
  itens_rodapes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentRodapeLinksLinkInput = {
  itens_rodapes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentRodapeLinksLinks = {
  __typename?: 'ComponentRodapeLinksLinks';
  id: Scalars['ID'];
  itens_rodapes?: Maybe<Array<Maybe<ItemRodapes>>>;
};


export type ComponentRodapeLinksLinksItens_RodapesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentRodapeRedeSocialListaTelefonesAtendimento = {
  __typename?: 'ComponentRodapeRedeSocialListaTelefonesAtendimento';
  id: Scalars['ID'];
  telefone?: Maybe<Scalars['String']>;
};

export type ComponentRodapeRedeSocialListaTelefonesAtendimentoInput = {
  telefone?: Maybe<Scalars['String']>;
};

export type ComponentRodapeRedeSocialRedeSocial = {
  __typename?: 'ComponentRodapeRedeSocialRedeSocial';
  id: Scalars['ID'];
  itens_rodapes?: Maybe<Array<Maybe<ItemRodapes>>>;
};


export type ComponentRodapeRedeSocialRedeSocialItens_RodapesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentRodapeRedeSocialRedeSocialInput = {
  itens_rodapes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentSecaoTextSecaoTexto = {
  __typename?: 'ComponentSecaoTextSecaoTexto';
  id: Scalars['ID'];
  Secao: Scalars['String'];
};

export type ComponentSecaoTextSecaoTextoInput = {
  Secao: Scalars['String'];
};

export type ComponentSecaoVideoAudioVideoAudio = {
  __typename?: 'ComponentSecaoVideoAudioVideoAudio';
  id: Scalars['ID'];
  URL: Scalars['String'];
  Observacoes?: Maybe<Scalars['String']>;
  Titulo?: Maybe<Scalars['String']>;
  Descricao?: Maybe<Scalars['String']>;
  url_mp3?: Maybe<Scalars['String']>;
  Thumbs?: Maybe<UploadFile>;
  TempoMedioDuracao?: Maybe<Scalars['Int']>;
  OrdemSequencial?: Maybe<Scalars['Int']>;
  url_spotify?: Maybe<Scalars['String']>;
};

export type ComponentSecaoVideoAudioVideoAudioInput = {
  URL: Scalars['String'];
  Observacoes?: Maybe<Scalars['String']>;
  Titulo?: Maybe<Scalars['String']>;
  Descricao?: Maybe<Scalars['String']>;
  url_mp3?: Maybe<Scalars['String']>;
  Thumbs?: Maybe<Scalars['ID']>;
  TempoMedioDuracao?: Maybe<Scalars['Int']>;
  OrdemSequencial?: Maybe<Scalars['Int']>;
  url_spotify?: Maybe<Scalars['String']>;
};

export type ComponentTelefoneAutorTelefone = {
  __typename?: 'ComponentTelefoneAutorTelefone';
  id: Scalars['ID'];
  Tipo: Enum_Componenttelefoneautortelefone_Tipo;
  Telefone: Scalars['Long'];
};

export type ComponentTelefoneAutorTelefoneInput = {
  Tipo: Enum_Componenttelefoneautortelefone_Tipo;
  Telefone: Scalars['Long'];
};

export type ComponentTextoTexto = {
  __typename?: 'ComponentTextoTexto';
  id: Scalars['ID'];
  texto?: Maybe<Scalars['String']>;
  observacao?: Maybe<Scalars['String']>;
  duracao?: Maybe<Scalars['Int']>;
};

export type ComponentTextoTextoInput = {
  texto?: Maybe<Scalars['String']>;
  observacao?: Maybe<Scalars['String']>;
  duracao?: Maybe<Scalars['Int']>;
};

export type ComponentTipoAprovacaoEtapasAprovacao = {
  __typename?: 'ComponentTipoAprovacaoEtapasAprovacao';
  id: Scalars['ID'];
  status?: Maybe<Enum_Componenttipoaprovacaoetapasaprovacao_Status>;
  observacao?: Maybe<Scalars['String']>;
  tipo_aprovacao?: Maybe<Enum_Componenttipoaprovacaoetapasaprovacao_Tipo_Aprovacao>;
  responsavel?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type ComponentTipoAprovacaoEtapasAprovacaoResponsavelArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentTipoAprovacaoEtapasAprovacaoInput = {
  status?: Maybe<Enum_Componenttipoaprovacaoetapasaprovacao_Status>;
  observacao?: Maybe<Scalars['String']>;
  responsavel?: Maybe<Array<Maybe<Scalars['ID']>>>;
  tipo_aprovacao?: Maybe<Enum_Componenttipoaprovacaoetapasaprovacao_Tipo_Aprovacao>;
};

export type ComponentUserAreaConhecimentoAreaConhecimento = {
  __typename?: 'ComponentUserAreaConhecimentoAreaConhecimento';
  id: Scalars['ID'];
};

export type ComponentUserAreaConhecimentoAreaConhecimentoInput = {
  _?: Maybe<Scalars['String']>;
};

export type ComponentVideoVideo = {
  __typename?: 'ComponentVideoVideo';
  id: Scalars['ID'];
  url_vimeo?: Maybe<Scalars['String']>;
  outros_video?: Maybe<UploadFile>;
  observacao?: Maybe<Scalars['String']>;
  direitosUso?: Maybe<Enum_Componentvideovideo_Direitosuso>;
  duracao?: Maybe<Scalars['Int']>;
  anexoDoc?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentVideoVideoAnexoDocArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentVideoVideoInput = {
  url_vimeo?: Maybe<Scalars['String']>;
  outros_video?: Maybe<Scalars['ID']>;
  observacao?: Maybe<Scalars['String']>;
  direitosUso?: Maybe<Enum_Componentvideovideo_Direitosuso>;
  anexoDoc?: Maybe<Array<Maybe<Scalars['ID']>>>;
  duracao?: Maybe<Scalars['Int']>;
};

export type ContatoInput = {
  mensagem: Scalars['String'];
  tipo_atendimento?: Maybe<Scalars['ID']>;
  nome?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Contatos = {
  __typename?: 'Contatos';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  mensagem: Scalars['String'];
  tipo_atendimento?: Maybe<TipoAtendimento>;
  nome?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  published_at?: Maybe<Scalars['DateTime']>;
};

export type ContatosAggregator = {
  __typename?: 'ContatosAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ContatosConnection = {
  __typename?: 'ContatosConnection';
  values?: Maybe<Array<Maybe<Contatos>>>;
  groupBy?: Maybe<ContatosGroupBy>;
  aggregate?: Maybe<ContatosAggregator>;
};

export type ContatosConnectionCreated_At = {
  __typename?: 'ContatosConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ContatosConnection>;
};

export type ContatosConnectionEmail = {
  __typename?: 'ContatosConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ContatosConnection>;
};

export type ContatosConnectionId = {
  __typename?: 'ContatosConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ContatosConnection>;
};

export type ContatosConnectionMensagem = {
  __typename?: 'ContatosConnectionMensagem';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ContatosConnection>;
};

export type ContatosConnectionNome = {
  __typename?: 'ContatosConnectionNome';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ContatosConnection>;
};

export type ContatosConnectionPublished_At = {
  __typename?: 'ContatosConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ContatosConnection>;
};

export type ContatosConnectionTipo_Atendimento = {
  __typename?: 'ContatosConnectionTipo_atendimento';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ContatosConnection>;
};

export type ContatosConnectionUpdated_At = {
  __typename?: 'ContatosConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ContatosConnection>;
};

export type ContatosGroupBy = {
  __typename?: 'ContatosGroupBy';
  id?: Maybe<Array<Maybe<ContatosConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ContatosConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ContatosConnectionUpdated_At>>>;
  mensagem?: Maybe<Array<Maybe<ContatosConnectionMensagem>>>;
  tipo_atendimento?: Maybe<Array<Maybe<ContatosConnectionTipo_Atendimento>>>;
  nome?: Maybe<Array<Maybe<ContatosConnectionNome>>>;
  email?: Maybe<Array<Maybe<ContatosConnectionEmail>>>;
  published_at?: Maybe<Array<Maybe<ContatosConnectionPublished_At>>>;
};

export type ConvitePendentesData = {
  __typename?: 'ConvitePendentesData';
  id: Scalars['ID'];
  oe_id: Scalars['ID'];
  titulo: Scalars['String'];
  categoria?: Maybe<Scalars['String']>;
  tipo?: Maybe<Scalars['String']>;
  data_criacao?: Maybe<Scalars['String']>;
};

export type ConvitePendentesPayload = {
  __typename?: 'ConvitePendentesPayload';
  total: Scalars['Int'];
  data?: Maybe<Array<ConvitePendentesData>>;
};



export type DensidadeSemantica = {
  __typename?: 'DensidadeSemantica';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
};

export type DensidadeSemanticaAggregator = {
  __typename?: 'DensidadeSemanticaAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type DensidadeSemanticaConnection = {
  __typename?: 'DensidadeSemanticaConnection';
  values?: Maybe<Array<Maybe<DensidadeSemantica>>>;
  groupBy?: Maybe<DensidadeSemanticaGroupBy>;
  aggregate?: Maybe<DensidadeSemanticaAggregator>;
};

export type DensidadeSemanticaConnectionCreated_At = {
  __typename?: 'DensidadeSemanticaConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DensidadeSemanticaConnection>;
};

export type DensidadeSemanticaConnectionId = {
  __typename?: 'DensidadeSemanticaConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DensidadeSemanticaConnection>;
};

export type DensidadeSemanticaConnectionTitulo = {
  __typename?: 'DensidadeSemanticaConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DensidadeSemanticaConnection>;
};

export type DensidadeSemanticaConnectionUpdated_At = {
  __typename?: 'DensidadeSemanticaConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DensidadeSemanticaConnection>;
};

export type DensidadeSemanticaGroupBy = {
  __typename?: 'DensidadeSemanticaGroupBy';
  id?: Maybe<Array<Maybe<DensidadeSemanticaConnectionId>>>;
  created_at?: Maybe<Array<Maybe<DensidadeSemanticaConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<DensidadeSemanticaConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<DensidadeSemanticaConnectionTitulo>>>;
};

export type DensidadeSemanticaInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DescomplicandoCiencia = {
  __typename?: 'DescomplicandoCiencia';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  introducao?: Maybe<Scalars['String']>;
  imagem_resultado?: Maybe<Array<Maybe<ComponentFieldGroupResultados>>>;
  limitacoes_estudo?: Maybe<Scalars['String']>;
  conclusao?: Maybe<Scalars['String']>;
  referencia?: Maybe<Scalars['String']>;
  meta_dados_identificacao?: Maybe<ComponentFieldGroupMetadadosIdentificacao>;
  meta_dados_ciclo_de_vida?: Maybe<ComponentFieldGroupMetadadosCicloDeVida>;
  meta_dados_educacional?: Maybe<ComponentFieldGroupMetadadosEducacional>;
  oe_relacionado?: Maybe<Array<Maybe<DescomplicandoCienciaOeRelacionadoDynamicZone>>>;
  duracao?: Maybe<Scalars['String']>;
  meta_dados_einstein?: Maybe<ComponentFieldGroupMetadadosEinstein>;
  tipo_recurso_educacional?: Maybe<TipoRecursoEducacional>;
  objetivos_resultados?: Maybe<ComponentFieldGroupObjetivosEResultados>;
  infografico?: Maybe<ComponentFieldGroupInfografico>;
  solicitacao_infografico?: Maybe<ComponentFieldGroupSolicitacaoInfografico>;
  arquivo_referencia?: Maybe<ComponentFieldGroupArquivoReferencia>;
  autores?: Maybe<Array<Maybe<ComponentFieldGroupSeletorDeAutores>>>;
  revisado_ortografia?: Maybe<Scalars['Boolean']>;
  revisado_midia?: Maybe<Scalars['Boolean']>;
  revisado_comunicacao?: Maybe<Scalars['Boolean']>;
};

export type DescomplicandoCienciaAggregator = {
  __typename?: 'DescomplicandoCienciaAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type DescomplicandoCienciaConnection = {
  __typename?: 'DescomplicandoCienciaConnection';
  values?: Maybe<Array<Maybe<DescomplicandoCiencia>>>;
  groupBy?: Maybe<DescomplicandoCienciaGroupBy>;
  aggregate?: Maybe<DescomplicandoCienciaAggregator>;
};

export type DescomplicandoCienciaConnectionArquivo_Referencia = {
  __typename?: 'DescomplicandoCienciaConnectionArquivo_referencia';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionConclusao = {
  __typename?: 'DescomplicandoCienciaConnectionConclusao';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionCreated_At = {
  __typename?: 'DescomplicandoCienciaConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionDuracao = {
  __typename?: 'DescomplicandoCienciaConnectionDuracao';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionId = {
  __typename?: 'DescomplicandoCienciaConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionInfografico = {
  __typename?: 'DescomplicandoCienciaConnectionInfografico';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionIntroducao = {
  __typename?: 'DescomplicandoCienciaConnectionIntroducao';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionLimitacoes_Estudo = {
  __typename?: 'DescomplicandoCienciaConnectionLimitacoes_estudo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionMeta_Dados_Ciclo_De_Vida = {
  __typename?: 'DescomplicandoCienciaConnectionMeta_dados_ciclo_de_vida';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionMeta_Dados_Educacional = {
  __typename?: 'DescomplicandoCienciaConnectionMeta_dados_educacional';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionMeta_Dados_Einstein = {
  __typename?: 'DescomplicandoCienciaConnectionMeta_dados_einstein';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionMeta_Dados_Identificacao = {
  __typename?: 'DescomplicandoCienciaConnectionMeta_dados_identificacao';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionObjetivos_Resultados = {
  __typename?: 'DescomplicandoCienciaConnectionObjetivos_resultados';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionReferencia = {
  __typename?: 'DescomplicandoCienciaConnectionReferencia';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionRevisado_Comunicacao = {
  __typename?: 'DescomplicandoCienciaConnectionRevisado_comunicacao';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionRevisado_Midia = {
  __typename?: 'DescomplicandoCienciaConnectionRevisado_midia';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionRevisado_Ortografia = {
  __typename?: 'DescomplicandoCienciaConnectionRevisado_ortografia';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionSolicitacao_Infografico = {
  __typename?: 'DescomplicandoCienciaConnectionSolicitacao_infografico';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionTipo_Recurso_Educacional = {
  __typename?: 'DescomplicandoCienciaConnectionTipo_recurso_educacional';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionTitulo = {
  __typename?: 'DescomplicandoCienciaConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaConnectionUpdated_At = {
  __typename?: 'DescomplicandoCienciaConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DescomplicandoCienciaConnection>;
};

export type DescomplicandoCienciaGroupBy = {
  __typename?: 'DescomplicandoCienciaGroupBy';
  id?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionId>>>;
  created_at?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionTitulo>>>;
  introducao?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionIntroducao>>>;
  limitacoes_estudo?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionLimitacoes_Estudo>>>;
  conclusao?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionConclusao>>>;
  referencia?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionReferencia>>>;
  meta_dados_identificacao?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionMeta_Dados_Identificacao>>>;
  meta_dados_ciclo_de_vida?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionMeta_Dados_Ciclo_De_Vida>>>;
  meta_dados_educacional?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionMeta_Dados_Educacional>>>;
  duracao?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionDuracao>>>;
  meta_dados_einstein?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionMeta_Dados_Einstein>>>;
  tipo_recurso_educacional?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionTipo_Recurso_Educacional>>>;
  objetivos_resultados?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionObjetivos_Resultados>>>;
  infografico?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionInfografico>>>;
  solicitacao_infografico?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionSolicitacao_Infografico>>>;
  arquivo_referencia?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionArquivo_Referencia>>>;
  revisado_ortografia?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionRevisado_Ortografia>>>;
  revisado_midia?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionRevisado_Midia>>>;
  revisado_comunicacao?: Maybe<Array<Maybe<DescomplicandoCienciaConnectionRevisado_Comunicacao>>>;
};

export type DescomplicandoCienciaInput = {
  titulo?: Maybe<Scalars['String']>;
  introducao?: Maybe<Scalars['String']>;
  imagem_resultado?: Maybe<Array<Maybe<ComponentFieldGroupResultadoInput>>>;
  limitacoes_estudo?: Maybe<Scalars['String']>;
  conclusao?: Maybe<Scalars['String']>;
  referencia?: Maybe<Scalars['String']>;
  meta_dados_identificacao?: Maybe<ComponentFieldGroupMetadadosIdentificacaoInput>;
  meta_dados_ciclo_de_vida?: Maybe<ComponentFieldGroupMetadadosCicloDeVidaInput>;
  meta_dados_educacional?: Maybe<ComponentFieldGroupMetadadosEducacionalInput>;
  oe_relacionado?: Maybe<Array<Scalars['DescomplicandoCienciaOeRelacionadoDynamicZoneInput']>>;
  duracao?: Maybe<Scalars['String']>;
  meta_dados_einstein?: Maybe<ComponentFieldGroupMetadadosEinsteinInput>;
  tipo_recurso_educacional?: Maybe<Scalars['ID']>;
  objetivos_resultados?: Maybe<ComponentFieldGroupObjetivosEResultadoInput>;
  infografico?: Maybe<ComponentFieldGroupInfograficoInput>;
  solicitacao_infografico?: Maybe<ComponentFieldGroupSolicitacaoInfograficoInput>;
  arquivo_referencia?: Maybe<ComponentFieldGroupArquivoReferenciaInput>;
  autores?: Maybe<Array<Maybe<ComponentFieldGroupSeletorDeAutoreInput>>>;
  revisado_ortografia?: Maybe<Scalars['Boolean']>;
  revisado_midia?: Maybe<Scalars['Boolean']>;
  revisado_comunicacao?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DescomplicandoCienciaOeRelacionadoDynamicZone = ComponentFieldGroupSeletorOeRelacionado;


export type DriveInsumoObjetoEducacional = {
  __typename?: 'DriveInsumoObjetoEducacional';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  nome: Scalars['String'];
  extensao?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  autor?: Maybe<PerfilDeAutor>;
  objeto_educacional?: Maybe<ObjetoEducacional>;
  tipo?: Maybe<Enum_Driveinsumoobjetoeducacional_Tipo>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type DriveInsumoObjetoEducacionalAggregator = {
  __typename?: 'DriveInsumoObjetoEducacionalAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type DriveInsumoObjetoEducacionalConnection = {
  __typename?: 'DriveInsumoObjetoEducacionalConnection';
  values?: Maybe<Array<Maybe<DriveInsumoObjetoEducacional>>>;
  groupBy?: Maybe<DriveInsumoObjetoEducacionalGroupBy>;
  aggregate?: Maybe<DriveInsumoObjetoEducacionalAggregator>;
};

export type DriveInsumoObjetoEducacionalConnectionAutor = {
  __typename?: 'DriveInsumoObjetoEducacionalConnectionAutor';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DriveInsumoObjetoEducacionalConnection>;
};

export type DriveInsumoObjetoEducacionalConnectionCreated_At = {
  __typename?: 'DriveInsumoObjetoEducacionalConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DriveInsumoObjetoEducacionalConnection>;
};

export type DriveInsumoObjetoEducacionalConnectionExtensao = {
  __typename?: 'DriveInsumoObjetoEducacionalConnectionExtensao';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DriveInsumoObjetoEducacionalConnection>;
};

export type DriveInsumoObjetoEducacionalConnectionId = {
  __typename?: 'DriveInsumoObjetoEducacionalConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DriveInsumoObjetoEducacionalConnection>;
};

export type DriveInsumoObjetoEducacionalConnectionNome = {
  __typename?: 'DriveInsumoObjetoEducacionalConnectionNome';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DriveInsumoObjetoEducacionalConnection>;
};

export type DriveInsumoObjetoEducacionalConnectionObjeto_Educacional = {
  __typename?: 'DriveInsumoObjetoEducacionalConnectionObjeto_educacional';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DriveInsumoObjetoEducacionalConnection>;
};

export type DriveInsumoObjetoEducacionalConnectionPublished_At = {
  __typename?: 'DriveInsumoObjetoEducacionalConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DriveInsumoObjetoEducacionalConnection>;
};

export type DriveInsumoObjetoEducacionalConnectionTipo = {
  __typename?: 'DriveInsumoObjetoEducacionalConnectionTipo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DriveInsumoObjetoEducacionalConnection>;
};

export type DriveInsumoObjetoEducacionalConnectionUpdated_At = {
  __typename?: 'DriveInsumoObjetoEducacionalConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DriveInsumoObjetoEducacionalConnection>;
};

export type DriveInsumoObjetoEducacionalConnectionUrl = {
  __typename?: 'DriveInsumoObjetoEducacionalConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DriveInsumoObjetoEducacionalConnection>;
};

export type DriveInsumoObjetoEducacionalGroupBy = {
  __typename?: 'DriveInsumoObjetoEducacionalGroupBy';
  id?: Maybe<Array<Maybe<DriveInsumoObjetoEducacionalConnectionId>>>;
  created_at?: Maybe<Array<Maybe<DriveInsumoObjetoEducacionalConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<DriveInsumoObjetoEducacionalConnectionUpdated_At>>>;
  nome?: Maybe<Array<Maybe<DriveInsumoObjetoEducacionalConnectionNome>>>;
  extensao?: Maybe<Array<Maybe<DriveInsumoObjetoEducacionalConnectionExtensao>>>;
  url?: Maybe<Array<Maybe<DriveInsumoObjetoEducacionalConnectionUrl>>>;
  autor?: Maybe<Array<Maybe<DriveInsumoObjetoEducacionalConnectionAutor>>>;
  objeto_educacional?: Maybe<Array<Maybe<DriveInsumoObjetoEducacionalConnectionObjeto_Educacional>>>;
  tipo?: Maybe<Array<Maybe<DriveInsumoObjetoEducacionalConnectionTipo>>>;
  published_at?: Maybe<Array<Maybe<DriveInsumoObjetoEducacionalConnectionPublished_At>>>;
};

export type DriveInsumoObjetoEducacionalInput = {
  nome: Scalars['String'];
  extensao?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  autor?: Maybe<Scalars['ID']>;
  objeto_educacional?: Maybe<Scalars['ID']>;
  tipo?: Maybe<Enum_Driveinsumoobjetoeducacional_Tipo>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum Enum_Componentautoresautor_Autoriza_Divulgacao_Do_Email_Na_Sua_Pagina_De_Autor {
  Sim = 'Sim',
  Nao = 'Nao'
}

export enum Enum_Componentautoresautor_Autoriza_Divulgacao_Do_Link_Do_Curriculo_Na_Sua_Pagina_De_Autor {
  Sim = 'Sim',
  Nao = 'Nao'
}

export enum Enum_Componentautoresautor_Estadocivil {
  Solteiro = 'Solteiro',
  Casado = 'Casado',
  Divorciado = 'Divorciado',
  Viuvo = 'Viuvo',
  Separado = 'Separado'
}

export enum Enum_Componentautoresautor_Profissao {
  Biologo = 'BIOLOGO',
  Biomedico = 'BIOMEDICO',
  Bioquimico = 'BIOQUIMICO',
  Dentista = 'DENTISTA',
  EducadorFisico = 'EDUCADOR_FISICO',
  Enfermeiro = 'ENFERMEIRO',
  Farmaceutico = 'FARMACEUTICO',
  Fisioterapeuta = 'FISIOTERAPEUTA',
  Fonoaudiologo = 'FONOAUDIOLOGO',
  Medico = 'MEDICO',
  Nutricionista = 'NUTRICIONISTA',
  Obstetriz = 'OBSTETRIZ',
  Psicologo = 'PSICOLOGO',
  TecnicoOuAuxiliar = 'TECNICO_OU_AUXILIAR',
  TerapeutaOcupacional = 'TERAPEUTA_OCUPACIONAL',
  Outro = 'OUTRO'
}

export enum Enum_Componentciclodevidaciclodevida_Autorizacaodeuso {
  Gratuito = 'Gratuito',
  AssinaturaA = 'AssinaturaA',
  AssinaturaB = 'AssinaturaB'
}

export enum Enum_Componentciclodevidaciclodevida_Status {
  Ativo = 'Ativo',
  Inativo = 'Inativo',
  Expirado = 'Expirado'
}

export enum Enum_Componentenderecosendereco_Tipo {
  Residencial = 'Residencial',
  Comercial = 'Comercial'
}

export enum Enum_Componentfieldgroupmetadadosciclodevida_Status {
  Ativo = 'ativo',
  Inativo = 'inativo',
  Expirado = 'expirado'
}

export enum Enum_Componentfieldgroupmetadadoseducacional_Relacionando_Indicacao_Recurso {
  EFormatadoDo = 'e_formatado_do',
  EParteDe = 'e_parte_de',
  FazReferencia = 'faz_referencia',
  Substitui = 'substitui',
  ERequeridoPor = 'e_requerido_por',
  Requer = 'requer',
  TemParte = 'tem_parte'
}

export enum Enum_Componentfieldgrouptecnica_Formato {
  Pdf = 'PDF',
  Ppt = 'PPT',
  Jpeg = 'JPEG',
  Png = 'PNG',
  Eps = 'EPS',
  Psd = 'PSD',
  Cdr = 'CDR',
  Ai = 'AI',
  Gif = 'GIF',
  Tiff = 'TIFF',
  Html5 = 'HTML5',
  Mp4 = 'MP4',
  Mov = 'MOV',
  Mp3 = 'MP3'
}

export enum Enum_Componentimagemimagem_Direitos_Uso {
  Sim = 'sim',
  Nao = 'nao'
}

export enum Enum_Componenttelefoneautortelefone_Tipo {
  Celular = 'Celular',
  Residencial = 'Residencial',
  Comercial = 'Comercial'
}

export enum Enum_Componenttipoaprovacaoetapasaprovacao_Status {
  Aprovado = 'aprovado',
  Rejeitado = 'rejeitado'
}

export enum Enum_Componenttipoaprovacaoetapasaprovacao_Tipo_Aprovacao {
  Midia = 'Midia',
  Ortografico = 'Ortografico',
  Conteudo = 'Conteudo',
  Curador = 'Curador',
  Comunicacao = 'Comunicacao'
}

export enum Enum_Componentvideovideo_Direitosuso {
  Sim = 'sim',
  Nao = 'nao'
}

export enum Enum_Driveinsumoobjetoeducacional_Tipo {
  Link = 'link',
  Documento = 'documento'
}

export enum Enum_Objetoeducacional_Autorizacaodeuso {
  Gratuito = 'Gratuito',
  AssinaturaA = 'AssinaturaA',
  AssinaturaB = 'AssinaturaB'
}

export enum Enum_Objetoeducacional_Status {
  Ativo = 'Ativo',
  Inativo = 'Inativo',
  Expirado = 'Expirado'
}

export enum Enum_Objeto_Educacional_With_Historico_Avaliacao_Order_By {
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  TituloAsc = 'titulo_asc',
  TituloDesc = 'titulo_desc',
  CategoriaAsc = 'categoria_asc',
  CategoriaDesc = 'categoria_desc',
  TipoAsc = 'tipo_asc',
  TipoDesc = 'tipo_desc',
  DataCriacaoAsc = 'data_criacao_asc',
  DataCriacaoDesc = 'data_criacao_desc',
  DataValidadeAsc = 'data_validade_asc',
  DataValidadeDesc = 'data_validade_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc'
}

export enum Enum_Oes_Rotulo {
  DescomplicandoCiencia = 'descomplicando_ciencia',
  DesafiosClinicos = 'desafios_clinicos',
  OpiniaoDoEspecialista = 'opiniao_do_especialista',
  DeepDive = 'deep_dive',
  ReuniaoCientifica = 'reuniao_cientifica',
  PilulaDeConhecimento = 'pilula_de_conhecimento',
  FastChallenge = 'fast_challenge',
  EinsteinPractice = 'einstein_practice'
}

export enum Enum_Oes_Secao {
  Alta = 'alta',
  Destaque = 'destaque'
}

export enum Enum_Oes_Subrotulo {
  DescomplicandoCienciaPodcast = 'Descomplicando_Ciencia_Podcast',
  DescomplicandoCienciaVideo = 'Descomplicando_Ciencia_Video',
  DescomplicandoCienciaInfografico = 'Descomplicando_Ciencia_Infografico',
  DescomplicandoCienciaTexto = 'Descomplicando_Ciencia_Texto',
  DesafiosClinicosCasoClinicoComentado = 'Desafios_Clinicos_Caso_Clinico_Comentado',
  DesafiosClinicosSolveTheCase = 'Desafios_Clinicos_Solve_the_Case',
  DesafiosClinicosEstudoDeCasoInterativo = 'Desafios_Clinicos_Estudo_de_Caso_Interativo',
  DesafiosClinicosDiscussaoDeCasoEmVideo = 'Desafios_Clinicos_Discussao_de_Caso_em_Video',
  OpiniaoDoEspecialistaPodcast = 'Opiniao_do_Especialista_Podcast',
  OpiniaoDoEspecialistaVideo = 'Opiniao_do_Especialista_Video',
  DeepDiveVideoaula = 'Deep_Dive_Videoaula',
  DeepDiveConteudoInterativo = 'Deep_Dive_Conteudo_Interativo',
  PilulaDeConhecimentoAprendaPorImagem = 'Pilula_de_Conhecimento_Aprenda_por_Imagem',
  FastChallengeDesafioPorImagem = 'Fast_Challenge_Desafio_por_Imagem',
  FastChallengeDiagnosticoVisual = 'Fast_Challenge_Diagnostico_Visual',
  FastChallengeCasoClinicoRapido = 'Fast_Challenge_Caso_Clinico_Rapido',
  EinsteinPracticeVideo = 'Einstein_Practice_Video',
  EinsteinPracticeTexto = 'Einstein_Practice_Texto'
}

export enum Enum_Statusdepublicacao_Enum_Status {
  EmRascunho = 'EM_RASCUNHO',
  EmAnalise = 'EM_ANALISE'
}

export type EnsinoEinstein = {
  __typename?: 'EnsinoEinstein';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo: Scalars['String'];
  corClara?: Maybe<Scalars['String']>;
  corEscura?: Maybe<Scalars['String']>;
  imagem?: Maybe<UploadFile>;
  rota?: Maybe<Rotas>;
  ordem: Scalars['Int'];
  published_at?: Maybe<Scalars['DateTime']>;
};

export type EnsinoEinsteinAggregator = {
  __typename?: 'EnsinoEinsteinAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<EnsinoEinsteinAggregatorSum>;
  avg?: Maybe<EnsinoEinsteinAggregatorAvg>;
  min?: Maybe<EnsinoEinsteinAggregatorMin>;
  max?: Maybe<EnsinoEinsteinAggregatorMax>;
};

export type EnsinoEinsteinAggregatorAvg = {
  __typename?: 'EnsinoEinsteinAggregatorAvg';
  ordem?: Maybe<Scalars['Float']>;
};

export type EnsinoEinsteinAggregatorMax = {
  __typename?: 'EnsinoEinsteinAggregatorMax';
  ordem?: Maybe<Scalars['Float']>;
};

export type EnsinoEinsteinAggregatorMin = {
  __typename?: 'EnsinoEinsteinAggregatorMin';
  ordem?: Maybe<Scalars['Float']>;
};

export type EnsinoEinsteinAggregatorSum = {
  __typename?: 'EnsinoEinsteinAggregatorSum';
  ordem?: Maybe<Scalars['Float']>;
};

export type EnsinoEinsteinConnection = {
  __typename?: 'EnsinoEinsteinConnection';
  values?: Maybe<Array<Maybe<EnsinoEinstein>>>;
  groupBy?: Maybe<EnsinoEinsteinGroupBy>;
  aggregate?: Maybe<EnsinoEinsteinAggregator>;
};

export type EnsinoEinsteinConnectionCorClara = {
  __typename?: 'EnsinoEinsteinConnectionCorClara';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EnsinoEinsteinConnection>;
};

export type EnsinoEinsteinConnectionCorEscura = {
  __typename?: 'EnsinoEinsteinConnectionCorEscura';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EnsinoEinsteinConnection>;
};

export type EnsinoEinsteinConnectionCreated_At = {
  __typename?: 'EnsinoEinsteinConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EnsinoEinsteinConnection>;
};

export type EnsinoEinsteinConnectionId = {
  __typename?: 'EnsinoEinsteinConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EnsinoEinsteinConnection>;
};

export type EnsinoEinsteinConnectionImagem = {
  __typename?: 'EnsinoEinsteinConnectionImagem';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EnsinoEinsteinConnection>;
};

export type EnsinoEinsteinConnectionOrdem = {
  __typename?: 'EnsinoEinsteinConnectionOrdem';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<EnsinoEinsteinConnection>;
};

export type EnsinoEinsteinConnectionPublished_At = {
  __typename?: 'EnsinoEinsteinConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EnsinoEinsteinConnection>;
};

export type EnsinoEinsteinConnectionRota = {
  __typename?: 'EnsinoEinsteinConnectionRota';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EnsinoEinsteinConnection>;
};

export type EnsinoEinsteinConnectionTitulo = {
  __typename?: 'EnsinoEinsteinConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EnsinoEinsteinConnection>;
};

export type EnsinoEinsteinConnectionUpdated_At = {
  __typename?: 'EnsinoEinsteinConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EnsinoEinsteinConnection>;
};

export type EnsinoEinsteinGroupBy = {
  __typename?: 'EnsinoEinsteinGroupBy';
  id?: Maybe<Array<Maybe<EnsinoEinsteinConnectionId>>>;
  created_at?: Maybe<Array<Maybe<EnsinoEinsteinConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<EnsinoEinsteinConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<EnsinoEinsteinConnectionTitulo>>>;
  corClara?: Maybe<Array<Maybe<EnsinoEinsteinConnectionCorClara>>>;
  corEscura?: Maybe<Array<Maybe<EnsinoEinsteinConnectionCorEscura>>>;
  imagem?: Maybe<Array<Maybe<EnsinoEinsteinConnectionImagem>>>;
  rota?: Maybe<Array<Maybe<EnsinoEinsteinConnectionRota>>>;
  ordem?: Maybe<Array<Maybe<EnsinoEinsteinConnectionOrdem>>>;
  published_at?: Maybe<Array<Maybe<EnsinoEinsteinConnectionPublished_At>>>;
};

export type EnsinoEinsteinInput = {
  titulo: Scalars['String'];
  corClara?: Maybe<Scalars['String']>;
  corEscura?: Maybe<Scalars['String']>;
  imagem?: Maybe<Scalars['ID']>;
  rota?: Maybe<Scalars['ID']>;
  ordem?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EnsinoEinsteinPage = {
  __typename?: 'EnsinoEinsteinPage';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  grupos?: Maybe<Array<Maybe<ComponentGrupoEnsinoGrupoEnsino>>>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type EnsinoEinsteinPageInput = {
  grupos?: Maybe<Array<Maybe<ComponentGrupoEnsinoGrupoEnsinoInput>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EntityRelation = {
  __typename?: 'EntityRelation';
  id?: Maybe<Scalars['ID']>;
  titulo?: Maybe<Scalars['String']>;
};

export type EstadoCivil = {
  __typename?: 'EstadoCivil';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
};

export type EstadoCivilAggregator = {
  __typename?: 'EstadoCivilAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EstadoCivilConnection = {
  __typename?: 'EstadoCivilConnection';
  values?: Maybe<Array<Maybe<EstadoCivil>>>;
  groupBy?: Maybe<EstadoCivilGroupBy>;
  aggregate?: Maybe<EstadoCivilAggregator>;
};

export type EstadoCivilConnectionCreated_At = {
  __typename?: 'EstadoCivilConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EstadoCivilConnection>;
};

export type EstadoCivilConnectionId = {
  __typename?: 'EstadoCivilConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EstadoCivilConnection>;
};

export type EstadoCivilConnectionTitulo = {
  __typename?: 'EstadoCivilConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EstadoCivilConnection>;
};

export type EstadoCivilConnectionUpdated_At = {
  __typename?: 'EstadoCivilConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EstadoCivilConnection>;
};

export type EstadoCivilGroupBy = {
  __typename?: 'EstadoCivilGroupBy';
  id?: Maybe<Array<Maybe<EstadoCivilConnectionId>>>;
  created_at?: Maybe<Array<Maybe<EstadoCivilConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<EstadoCivilConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<EstadoCivilConnectionTitulo>>>;
};

export type EstadoCivilInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type GestaoFuncionalidade = {
  __typename?: 'GestaoFuncionalidade';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  published_at?: Maybe<Scalars['DateTime']>;
  users_permissions_roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  status_de_publicacaos?: Maybe<Array<Maybe<StatusDePublicacao>>>;
};


export type GestaoFuncionalidadeUsers_Permissions_RolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type GestaoFuncionalidadeStatus_De_PublicacaosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type GestaoFuncionalidadeAggregator = {
  __typename?: 'GestaoFuncionalidadeAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GestaoFuncionalidadeConnection = {
  __typename?: 'GestaoFuncionalidadeConnection';
  values?: Maybe<Array<Maybe<GestaoFuncionalidade>>>;
  groupBy?: Maybe<GestaoFuncionalidadeGroupBy>;
  aggregate?: Maybe<GestaoFuncionalidadeAggregator>;
};

export type GestaoFuncionalidadeConnectionCreated_At = {
  __typename?: 'GestaoFuncionalidadeConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GestaoFuncionalidadeConnection>;
};

export type GestaoFuncionalidadeConnectionId = {
  __typename?: 'GestaoFuncionalidadeConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<GestaoFuncionalidadeConnection>;
};

export type GestaoFuncionalidadeConnectionPublished_At = {
  __typename?: 'GestaoFuncionalidadeConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GestaoFuncionalidadeConnection>;
};

export type GestaoFuncionalidadeConnectionUpdated_At = {
  __typename?: 'GestaoFuncionalidadeConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GestaoFuncionalidadeConnection>;
};

export type GestaoFuncionalidadeGroupBy = {
  __typename?: 'GestaoFuncionalidadeGroupBy';
  id?: Maybe<Array<Maybe<GestaoFuncionalidadeConnectionId>>>;
  created_at?: Maybe<Array<Maybe<GestaoFuncionalidadeConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<GestaoFuncionalidadeConnectionUpdated_At>>>;
  published_at?: Maybe<Array<Maybe<GestaoFuncionalidadeConnectionPublished_At>>>;
};

export type GestaoFuncionalidadeInput = {
  users_permissions_roles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  status_de_publicacaos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Granularidade = {
  __typename?: 'Granularidade';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
};

export type GranularidadeAggregator = {
  __typename?: 'GranularidadeAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GranularidadeConnection = {
  __typename?: 'GranularidadeConnection';
  values?: Maybe<Array<Maybe<Granularidade>>>;
  groupBy?: Maybe<GranularidadeGroupBy>;
  aggregate?: Maybe<GranularidadeAggregator>;
};

export type GranularidadeConnectionCreated_At = {
  __typename?: 'GranularidadeConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GranularidadeConnection>;
};

export type GranularidadeConnectionId = {
  __typename?: 'GranularidadeConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<GranularidadeConnection>;
};

export type GranularidadeConnectionTitulo = {
  __typename?: 'GranularidadeConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<GranularidadeConnection>;
};

export type GranularidadeConnectionUpdated_At = {
  __typename?: 'GranularidadeConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GranularidadeConnection>;
};

export type GranularidadeGroupBy = {
  __typename?: 'GranularidadeGroupBy';
  id?: Maybe<Array<Maybe<GranularidadeConnectionId>>>;
  created_at?: Maybe<Array<Maybe<GranularidadeConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<GranularidadeConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<GranularidadeConnectionTitulo>>>;
};

export type GranularidadeInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type HeaderPortal = {
  __typename?: 'HeaderPortal';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  logo?: Maybe<UploadFile>;
  item_menus?: Maybe<Array<Maybe<ItemMenu>>>;
};


export type HeaderPortalItem_MenusArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type HeaderPortalInput = {
  logo?: Maybe<Scalars['ID']>;
  item_menus?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type HistoricoAvaliacaoObjetoEducacional = {
  __typename?: 'HistoricoAvaliacaoObjetoEducacional';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  objeto_educacional?: Maybe<ObjetoEducacional>;
  status_de_publicacao?: Maybe<StatusDePublicacao>;
  users_permissions_user?: Maybe<UsersPermissionsUser>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type HistoricoAvaliacaoObjetoEducacionalAggregator = {
  __typename?: 'HistoricoAvaliacaoObjetoEducacionalAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type HistoricoAvaliacaoObjetoEducacionalConnection = {
  __typename?: 'HistoricoAvaliacaoObjetoEducacionalConnection';
  values?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacional>>>;
  groupBy?: Maybe<HistoricoAvaliacaoObjetoEducacionalGroupBy>;
  aggregate?: Maybe<HistoricoAvaliacaoObjetoEducacionalAggregator>;
};

export type HistoricoAvaliacaoObjetoEducacionalConnectionCreated_At = {
  __typename?: 'HistoricoAvaliacaoObjetoEducacionalConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<HistoricoAvaliacaoObjetoEducacionalConnection>;
};

export type HistoricoAvaliacaoObjetoEducacionalConnectionId = {
  __typename?: 'HistoricoAvaliacaoObjetoEducacionalConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<HistoricoAvaliacaoObjetoEducacionalConnection>;
};

export type HistoricoAvaliacaoObjetoEducacionalConnectionObjeto_Educacional = {
  __typename?: 'HistoricoAvaliacaoObjetoEducacionalConnectionObjeto_educacional';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<HistoricoAvaliacaoObjetoEducacionalConnection>;
};

export type HistoricoAvaliacaoObjetoEducacionalConnectionPublished_At = {
  __typename?: 'HistoricoAvaliacaoObjetoEducacionalConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<HistoricoAvaliacaoObjetoEducacionalConnection>;
};

export type HistoricoAvaliacaoObjetoEducacionalConnectionStatus_De_Publicacao = {
  __typename?: 'HistoricoAvaliacaoObjetoEducacionalConnectionStatus_de_publicacao';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<HistoricoAvaliacaoObjetoEducacionalConnection>;
};

export type HistoricoAvaliacaoObjetoEducacionalConnectionUpdated_At = {
  __typename?: 'HistoricoAvaliacaoObjetoEducacionalConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<HistoricoAvaliacaoObjetoEducacionalConnection>;
};

export type HistoricoAvaliacaoObjetoEducacionalConnectionUsers_Permissions_User = {
  __typename?: 'HistoricoAvaliacaoObjetoEducacionalConnectionUsers_permissions_user';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<HistoricoAvaliacaoObjetoEducacionalConnection>;
};

export type HistoricoAvaliacaoObjetoEducacionalGroupBy = {
  __typename?: 'HistoricoAvaliacaoObjetoEducacionalGroupBy';
  id?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacionalConnectionId>>>;
  created_at?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacionalConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacionalConnectionUpdated_At>>>;
  objeto_educacional?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacionalConnectionObjeto_Educacional>>>;
  status_de_publicacao?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacionalConnectionStatus_De_Publicacao>>>;
  users_permissions_user?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacionalConnectionUsers_Permissions_User>>>;
  published_at?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacionalConnectionPublished_At>>>;
};

export type HistoricoAvaliacaoObjetoEducacionalInput = {
  objeto_educacional?: Maybe<Scalars['ID']>;
  status_de_publicacao?: Maybe<Scalars['ID']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type HomeObjetoEducacionalPage = {
  __typename?: 'HomeObjetoEducacionalPage';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  HomeConteudosAlta?: Maybe<ComponentHomeConteudosAltaHomeConteudosAlta>;
  HomeOutrasAreas?: Maybe<ComponentHomeOutrasAreasHomeOutrasAreas>;
  HomeVideosAlta?: Maybe<ComponentHomeVideosAltaHomeVideosAlta>;
  HomeTopicos?: Maybe<ComponentHomeTopicosHomeTopicos>;
  HomeDestaqueSemana?: Maybe<ComponentHomeDestaqueSemanaHomeDestaqueSemana>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type HomeObjetoEducacionalPageInput = {
  HomeConteudosAlta?: Maybe<ComponentHomeConteudosAltaHomeConteudosAltaInput>;
  HomeOutrasAreas?: Maybe<ComponentHomeOutrasAreasHomeOutrasAreaInput>;
  HomeVideosAlta?: Maybe<ComponentHomeVideosAltaHomeVideosAltaInput>;
  HomeTopicos?: Maybe<ComponentHomeTopicosHomeTopicoInput>;
  HomeDestaqueSemana?: Maybe<ComponentHomeDestaqueSemanaHomeDestaqueSemanaInput>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type IdiomaInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Idiomas = {
  __typename?: 'Idiomas';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type IdiomasObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type IdiomasAggregator = {
  __typename?: 'IdiomasAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type IdiomasConnection = {
  __typename?: 'IdiomasConnection';
  values?: Maybe<Array<Maybe<Idiomas>>>;
  groupBy?: Maybe<IdiomasGroupBy>;
  aggregate?: Maybe<IdiomasAggregator>;
};

export type IdiomasConnectionCreated_At = {
  __typename?: 'IdiomasConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<IdiomasConnection>;
};

export type IdiomasConnectionId = {
  __typename?: 'IdiomasConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<IdiomasConnection>;
};

export type IdiomasConnectionTitulo = {
  __typename?: 'IdiomasConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<IdiomasConnection>;
};

export type IdiomasConnectionUpdated_At = {
  __typename?: 'IdiomasConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<IdiomasConnection>;
};

export type IdiomasGroupBy = {
  __typename?: 'IdiomasGroupBy';
  id?: Maybe<Array<Maybe<IdiomasConnectionId>>>;
  created_at?: Maybe<Array<Maybe<IdiomasConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<IdiomasConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<IdiomasConnectionTitulo>>>;
};

export type InputId = {
  id: Scalars['ID'];
};

export type ItemMenu = {
  __typename?: 'ItemMenu';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  nome?: Maybe<Scalars['String']>;
  ordem?: Maybe<Scalars['Int']>;
  rota?: Maybe<Rotas>;
  subMenu?: Maybe<Array<Maybe<ComponentListaMenusItem>>>;
};

export type ItemMenuAggregator = {
  __typename?: 'ItemMenuAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ItemMenuAggregatorSum>;
  avg?: Maybe<ItemMenuAggregatorAvg>;
  min?: Maybe<ItemMenuAggregatorMin>;
  max?: Maybe<ItemMenuAggregatorMax>;
};

export type ItemMenuAggregatorAvg = {
  __typename?: 'ItemMenuAggregatorAvg';
  ordem?: Maybe<Scalars['Float']>;
};

export type ItemMenuAggregatorMax = {
  __typename?: 'ItemMenuAggregatorMax';
  ordem?: Maybe<Scalars['Float']>;
};

export type ItemMenuAggregatorMin = {
  __typename?: 'ItemMenuAggregatorMin';
  ordem?: Maybe<Scalars['Float']>;
};

export type ItemMenuAggregatorSum = {
  __typename?: 'ItemMenuAggregatorSum';
  ordem?: Maybe<Scalars['Float']>;
};

export type ItemMenuConnection = {
  __typename?: 'ItemMenuConnection';
  values?: Maybe<Array<Maybe<ItemMenu>>>;
  groupBy?: Maybe<ItemMenuGroupBy>;
  aggregate?: Maybe<ItemMenuAggregator>;
};

export type ItemMenuConnectionCreated_At = {
  __typename?: 'ItemMenuConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ItemMenuConnection>;
};

export type ItemMenuConnectionId = {
  __typename?: 'ItemMenuConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ItemMenuConnection>;
};

export type ItemMenuConnectionNome = {
  __typename?: 'ItemMenuConnectionNome';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ItemMenuConnection>;
};

export type ItemMenuConnectionOrdem = {
  __typename?: 'ItemMenuConnectionOrdem';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ItemMenuConnection>;
};

export type ItemMenuConnectionRota = {
  __typename?: 'ItemMenuConnectionRota';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ItemMenuConnection>;
};

export type ItemMenuConnectionUpdated_At = {
  __typename?: 'ItemMenuConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ItemMenuConnection>;
};

export type ItemMenuGroupBy = {
  __typename?: 'ItemMenuGroupBy';
  id?: Maybe<Array<Maybe<ItemMenuConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ItemMenuConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ItemMenuConnectionUpdated_At>>>;
  nome?: Maybe<Array<Maybe<ItemMenuConnectionNome>>>;
  ordem?: Maybe<Array<Maybe<ItemMenuConnectionOrdem>>>;
  rota?: Maybe<Array<Maybe<ItemMenuConnectionRota>>>;
};

export type ItemMenuInput = {
  nome?: Maybe<Scalars['String']>;
  ordem?: Maybe<Scalars['Int']>;
  rota?: Maybe<Scalars['ID']>;
  subMenu?: Maybe<Array<ComponentListaMenusItemInput>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ItemRodapeInput = {
  nome: Scalars['String'];
  ordem?: Maybe<Scalars['Int']>;
  MenusRodape?: Maybe<Array<Maybe<ComponentMenusRodapeMenusRodapeInput>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ItemRodapes = {
  __typename?: 'ItemRodapes';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  nome: Scalars['String'];
  ordem?: Maybe<Scalars['Int']>;
  MenusRodape?: Maybe<Array<Maybe<ComponentMenusRodapeMenusRodape>>>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type ItemRodapesAggregator = {
  __typename?: 'ItemRodapesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ItemRodapesAggregatorSum>;
  avg?: Maybe<ItemRodapesAggregatorAvg>;
  min?: Maybe<ItemRodapesAggregatorMin>;
  max?: Maybe<ItemRodapesAggregatorMax>;
};

export type ItemRodapesAggregatorAvg = {
  __typename?: 'ItemRodapesAggregatorAvg';
  ordem?: Maybe<Scalars['Float']>;
};

export type ItemRodapesAggregatorMax = {
  __typename?: 'ItemRodapesAggregatorMax';
  ordem?: Maybe<Scalars['Float']>;
};

export type ItemRodapesAggregatorMin = {
  __typename?: 'ItemRodapesAggregatorMin';
  ordem?: Maybe<Scalars['Float']>;
};

export type ItemRodapesAggregatorSum = {
  __typename?: 'ItemRodapesAggregatorSum';
  ordem?: Maybe<Scalars['Float']>;
};

export type ItemRodapesConnection = {
  __typename?: 'ItemRodapesConnection';
  values?: Maybe<Array<Maybe<ItemRodapes>>>;
  groupBy?: Maybe<ItemRodapesGroupBy>;
  aggregate?: Maybe<ItemRodapesAggregator>;
};

export type ItemRodapesConnectionCreated_At = {
  __typename?: 'ItemRodapesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ItemRodapesConnection>;
};

export type ItemRodapesConnectionId = {
  __typename?: 'ItemRodapesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ItemRodapesConnection>;
};

export type ItemRodapesConnectionNome = {
  __typename?: 'ItemRodapesConnectionNome';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ItemRodapesConnection>;
};

export type ItemRodapesConnectionOrdem = {
  __typename?: 'ItemRodapesConnectionOrdem';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ItemRodapesConnection>;
};

export type ItemRodapesConnectionPublished_At = {
  __typename?: 'ItemRodapesConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ItemRodapesConnection>;
};

export type ItemRodapesConnectionUpdated_At = {
  __typename?: 'ItemRodapesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ItemRodapesConnection>;
};

export type ItemRodapesGroupBy = {
  __typename?: 'ItemRodapesGroupBy';
  id?: Maybe<Array<Maybe<ItemRodapesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ItemRodapesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ItemRodapesConnectionUpdated_At>>>;
  nome?: Maybe<Array<Maybe<ItemRodapesConnectionNome>>>;
  ordem?: Maybe<Array<Maybe<ItemRodapesConnectionOrdem>>>;
  published_at?: Maybe<Array<Maybe<ItemRodapesConnectionPublished_At>>>;
};


export type KeyWordInput = {
  keyWord: Scalars['String'];
};

export type KeyWordPayload = {
  __typename?: 'KeyWordPayload';
  id: Scalars['ID'];
  titulo: Scalars['String'];
};

export type LocaleInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type MaturidadePublicoAlvo = {
  __typename?: 'MaturidadePublicoAlvo';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
};

export type MaturidadePublicoAlvoAggregator = {
  __typename?: 'MaturidadePublicoAlvoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MaturidadePublicoAlvoConnection = {
  __typename?: 'MaturidadePublicoAlvoConnection';
  values?: Maybe<Array<Maybe<MaturidadePublicoAlvo>>>;
  groupBy?: Maybe<MaturidadePublicoAlvoGroupBy>;
  aggregate?: Maybe<MaturidadePublicoAlvoAggregator>;
};

export type MaturidadePublicoAlvoConnectionCreated_At = {
  __typename?: 'MaturidadePublicoAlvoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MaturidadePublicoAlvoConnection>;
};

export type MaturidadePublicoAlvoConnectionId = {
  __typename?: 'MaturidadePublicoAlvoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MaturidadePublicoAlvoConnection>;
};

export type MaturidadePublicoAlvoConnectionTitulo = {
  __typename?: 'MaturidadePublicoAlvoConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MaturidadePublicoAlvoConnection>;
};

export type MaturidadePublicoAlvoConnectionUpdated_At = {
  __typename?: 'MaturidadePublicoAlvoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MaturidadePublicoAlvoConnection>;
};

export type MaturidadePublicoAlvoGroupBy = {
  __typename?: 'MaturidadePublicoAlvoGroupBy';
  id?: Maybe<Array<Maybe<MaturidadePublicoAlvoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<MaturidadePublicoAlvoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<MaturidadePublicoAlvoConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<MaturidadePublicoAlvoConnectionTitulo>>>;
};

export type MaturidadePublicoAlvoInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  message: Scalars['String'];
};

export type ModalidadeDeEnsino = {
  __typename?: 'ModalidadeDeEnsino';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type ModalidadeDeEnsinoObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ModalidadeDeEnsinoAggregator = {
  __typename?: 'ModalidadeDeEnsinoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ModalidadeDeEnsinoConnection = {
  __typename?: 'ModalidadeDeEnsinoConnection';
  values?: Maybe<Array<Maybe<ModalidadeDeEnsino>>>;
  groupBy?: Maybe<ModalidadeDeEnsinoGroupBy>;
  aggregate?: Maybe<ModalidadeDeEnsinoAggregator>;
};

export type ModalidadeDeEnsinoConnectionCreated_At = {
  __typename?: 'ModalidadeDeEnsinoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ModalidadeDeEnsinoConnection>;
};

export type ModalidadeDeEnsinoConnectionId = {
  __typename?: 'ModalidadeDeEnsinoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ModalidadeDeEnsinoConnection>;
};

export type ModalidadeDeEnsinoConnectionTitulo = {
  __typename?: 'ModalidadeDeEnsinoConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModalidadeDeEnsinoConnection>;
};

export type ModalidadeDeEnsinoConnectionUpdated_At = {
  __typename?: 'ModalidadeDeEnsinoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ModalidadeDeEnsinoConnection>;
};

export type ModalidadeDeEnsinoGroupBy = {
  __typename?: 'ModalidadeDeEnsinoGroupBy';
  id?: Maybe<Array<Maybe<ModalidadeDeEnsinoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ModalidadeDeEnsinoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ModalidadeDeEnsinoConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<ModalidadeDeEnsinoConnectionTitulo>>>;
};

export type ModalidadeDeEnsinoInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Morph = UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | AreaConhecimentoItem | ConvitePendentesData | ConvitePendentesPayload | AutorConviteMessage | AutorConvidadoOe | MessageResponse | TotalPayload | ObjetoEducacionalWithHistoricoAvaliacaoData | ObjetoEducacionalWithHistoricoAvaliacaoConnection | EntityRelation | ObjetoEducacionalImage | UserObjetoEducacional | ObjetoEducacionalSearch | ObjetoEducacionalComentarioDriveInsumo | KeyWordPayload | PalavraChaveOe | RotuloItem | TipoOeItem | AreaDeConhecimento | AreaDeConhecimentoConnection | AreaDeConhecimentoAggregator | AreaDeConhecimentoGroupBy | AreaDeConhecimentoConnectionId | AreaDeConhecimentoConnectionCreated_At | AreaDeConhecimentoConnectionUpdated_At | AreaDeConhecimentoConnectionTitulo | AreaDeConhecimentoConnectionArea_Pai | AreaDeConhecimentoConnectionIcone | AreaDeConhecimentoConnectionImagem_Url | AreaDeConhecimentoConnectionPublished_At | CreateAreaDeConhecimentoPayload | UpdateAreaDeConhecimentoPayload | DeleteAreaDeConhecimentoPayload | AreaDeDestaque | AreaDeDestaqueConnection | AreaDeDestaqueAggregator | AreaDeDestaqueGroupBy | AreaDeDestaqueConnectionId | AreaDeDestaqueConnectionCreated_At | AreaDeDestaqueConnectionUpdated_At | AreaDeDestaqueConnectionTitulo | CreateAreaDeDestaquePayload | UpdateAreaDeDestaquePayload | DeleteAreaDeDestaquePayload | AutorConvidado | AutorConvidadoConnection | AutorConvidadoAggregator | AutorConvidadoGroupBy | AutorConvidadoConnectionId | AutorConvidadoConnectionCreated_At | AutorConvidadoConnectionUpdated_At | AutorConvidadoConnectionNome | AutorConvidadoConnectionEmail | AutorConvidadoConnectionStatus | AutorConvidadoConnectionAceita_Participacao | AutorConvidadoConnectionObjeto_Educacional | AutorConvidadoConnectionUser_Autor_Responsavel | AutorConvidadoConnectionAutor_Convidado | AutorConvidadoConnectionPublished_At | CreateAutorConvidadoPayload | UpdateAutorConvidadoPayload | DeleteAutorConvidadoPayload | AutorizacaoDeUso | AutorizacaoDeUsoConnection | AutorizacaoDeUsoAggregator | AutorizacaoDeUsoGroupBy | AutorizacaoDeUsoConnectionId | AutorizacaoDeUsoConnectionCreated_At | AutorizacaoDeUsoConnectionUpdated_At | AutorizacaoDeUsoConnectionTitulo | CreateAutorizacaoDeUsoPayload | UpdateAutorizacaoDeUsoPayload | DeleteAutorizacaoDeUsoPayload | Banner | BannerConnection | BannerAggregator | BannerGroupBy | BannerConnectionId | BannerConnectionCreated_At | BannerConnectionUpdated_At | BannerConnectionPeriodoPermanenciaInicial | BannerConnectionPeriodoPermanenciaFinal | BannerConnectionLinkFuga | BannerConnectionImagemDesktop | BannerConnectionImagemMobile | BannerConnectionPatrocinador | BannerConnectionTitulo | BannerConnectionPublished_At | CreateBannerPayload | UpdateBannerPayload | DeleteBannerPayload | CategoriaPatrocinador | CategoriaPatrocinadorConnection | CategoriaPatrocinadorAggregator | CategoriaPatrocinadorGroupBy | CategoriaPatrocinadorConnectionId | CategoriaPatrocinadorConnectionCreated_At | CategoriaPatrocinadorConnectionUpdated_At | CategoriaPatrocinadorConnectionTitulo | CategoriaPatrocinadorConnectionPublished_At | CreateCategoriaPatrocinadorPayload | UpdateCategoriaPatrocinadorPayload | DeleteCategoriaPatrocinadorPayload | Contatos | ContatosConnection | ContatosAggregator | ContatosGroupBy | ContatosConnectionId | ContatosConnectionCreated_At | ContatosConnectionUpdated_At | ContatosConnectionMensagem | ContatosConnectionTipo_Atendimento | ContatosConnectionNome | ContatosConnectionEmail | ContatosConnectionPublished_At | CreateContatoPayload | UpdateContatoPayload | DeleteContatoPayload | DensidadeSemantica | DensidadeSemanticaConnection | DensidadeSemanticaAggregator | DensidadeSemanticaGroupBy | DensidadeSemanticaConnectionId | DensidadeSemanticaConnectionCreated_At | DensidadeSemanticaConnectionUpdated_At | DensidadeSemanticaConnectionTitulo | CreateDensidadeSemanticaPayload | UpdateDensidadeSemanticaPayload | DeleteDensidadeSemanticaPayload | DescomplicandoCiencia | DescomplicandoCienciaConnection | DescomplicandoCienciaAggregator | DescomplicandoCienciaGroupBy | DescomplicandoCienciaConnectionId | DescomplicandoCienciaConnectionCreated_At | DescomplicandoCienciaConnectionUpdated_At | DescomplicandoCienciaConnectionTitulo | DescomplicandoCienciaConnectionIntroducao | DescomplicandoCienciaConnectionLimitacoes_Estudo | DescomplicandoCienciaConnectionConclusao | DescomplicandoCienciaConnectionReferencia | DescomplicandoCienciaConnectionMeta_Dados_Identificacao | DescomplicandoCienciaConnectionMeta_Dados_Ciclo_De_Vida | DescomplicandoCienciaConnectionMeta_Dados_Educacional | DescomplicandoCienciaConnectionDuracao | DescomplicandoCienciaConnectionMeta_Dados_Einstein | DescomplicandoCienciaConnectionTipo_Recurso_Educacional | DescomplicandoCienciaConnectionObjetivos_Resultados | DescomplicandoCienciaConnectionInfografico | DescomplicandoCienciaConnectionSolicitacao_Infografico | DescomplicandoCienciaConnectionArquivo_Referencia | DescomplicandoCienciaConnectionRevisado_Ortografia | DescomplicandoCienciaConnectionRevisado_Midia | DescomplicandoCienciaConnectionRevisado_Comunicacao | CreateDescomplicandoCienciaPayload | UpdateDescomplicandoCienciaPayload | DeleteDescomplicandoCienciaPayload | DriveInsumoObjetoEducacional | DriveInsumoObjetoEducacionalConnection | DriveInsumoObjetoEducacionalAggregator | DriveInsumoObjetoEducacionalGroupBy | DriveInsumoObjetoEducacionalConnectionId | DriveInsumoObjetoEducacionalConnectionCreated_At | DriveInsumoObjetoEducacionalConnectionUpdated_At | DriveInsumoObjetoEducacionalConnectionNome | DriveInsumoObjetoEducacionalConnectionExtensao | DriveInsumoObjetoEducacionalConnectionUrl | DriveInsumoObjetoEducacionalConnectionAutor | DriveInsumoObjetoEducacionalConnectionObjeto_Educacional | DriveInsumoObjetoEducacionalConnectionTipo | DriveInsumoObjetoEducacionalConnectionPublished_At | CreateDriveInsumoObjetoEducacionalPayload | UpdateDriveInsumoObjetoEducacionalPayload | DeleteDriveInsumoObjetoEducacionalPayload | EnsinoEinsteinPage | UpdateEnsinoEinsteinPagePayload | DeleteEnsinoEinsteinPagePayload | EnsinoEinstein | EnsinoEinsteinConnection | EnsinoEinsteinAggregator | EnsinoEinsteinAggregatorSum | EnsinoEinsteinAggregatorAvg | EnsinoEinsteinAggregatorMin | EnsinoEinsteinAggregatorMax | EnsinoEinsteinGroupBy | EnsinoEinsteinConnectionId | EnsinoEinsteinConnectionCreated_At | EnsinoEinsteinConnectionUpdated_At | EnsinoEinsteinConnectionTitulo | EnsinoEinsteinConnectionCorClara | EnsinoEinsteinConnectionCorEscura | EnsinoEinsteinConnectionImagem | EnsinoEinsteinConnectionRota | EnsinoEinsteinConnectionOrdem | EnsinoEinsteinConnectionPublished_At | CreateEnsinoEinsteinPayload | UpdateEnsinoEinsteinPayload | DeleteEnsinoEinsteinPayload | EstadoCivil | EstadoCivilConnection | EstadoCivilAggregator | EstadoCivilGroupBy | EstadoCivilConnectionId | EstadoCivilConnectionCreated_At | EstadoCivilConnectionUpdated_At | EstadoCivilConnectionTitulo | CreateEstadoCivilPayload | UpdateEstadoCivilPayload | DeleteEstadoCivilPayload | GestaoFuncionalidade | GestaoFuncionalidadeConnection | GestaoFuncionalidadeAggregator | GestaoFuncionalidadeGroupBy | GestaoFuncionalidadeConnectionId | GestaoFuncionalidadeConnectionCreated_At | GestaoFuncionalidadeConnectionUpdated_At | GestaoFuncionalidadeConnectionPublished_At | CreateGestaoFuncionalidadePayload | UpdateGestaoFuncionalidadePayload | DeleteGestaoFuncionalidadePayload | Granularidade | GranularidadeConnection | GranularidadeAggregator | GranularidadeGroupBy | GranularidadeConnectionId | GranularidadeConnectionCreated_At | GranularidadeConnectionUpdated_At | GranularidadeConnectionTitulo | CreateGranularidadePayload | UpdateGranularidadePayload | DeleteGranularidadePayload | HeaderPortal | UpdateHeaderPortalPayload | DeleteHeaderPortalPayload | HistoricoAvaliacaoObjetoEducacional | HistoricoAvaliacaoObjetoEducacionalConnection | HistoricoAvaliacaoObjetoEducacionalAggregator | HistoricoAvaliacaoObjetoEducacionalGroupBy | HistoricoAvaliacaoObjetoEducacionalConnectionId | HistoricoAvaliacaoObjetoEducacionalConnectionCreated_At | HistoricoAvaliacaoObjetoEducacionalConnectionUpdated_At | HistoricoAvaliacaoObjetoEducacionalConnectionObjeto_Educacional | HistoricoAvaliacaoObjetoEducacionalConnectionStatus_De_Publicacao | HistoricoAvaliacaoObjetoEducacionalConnectionUsers_Permissions_User | HistoricoAvaliacaoObjetoEducacionalConnectionPublished_At | CreateHistoricoAvaliacaoObjetoEducacionalPayload | UpdateHistoricoAvaliacaoObjetoEducacionalPayload | DeleteHistoricoAvaliacaoObjetoEducacionalPayload | HomeObjetoEducacionalPage | UpdateHomeObjetoEducacionalPagePayload | DeleteHomeObjetoEducacionalPagePayload | Idiomas | IdiomasConnection | IdiomasAggregator | IdiomasGroupBy | IdiomasConnectionId | IdiomasConnectionCreated_At | IdiomasConnectionUpdated_At | IdiomasConnectionTitulo | CreateIdiomaPayload | UpdateIdiomaPayload | DeleteIdiomaPayload | ItemMenu | ItemMenuConnection | ItemMenuAggregator | ItemMenuAggregatorSum | ItemMenuAggregatorAvg | ItemMenuAggregatorMin | ItemMenuAggregatorMax | ItemMenuGroupBy | ItemMenuConnectionId | ItemMenuConnectionCreated_At | ItemMenuConnectionUpdated_At | ItemMenuConnectionNome | ItemMenuConnectionOrdem | ItemMenuConnectionRota | CreateItemMenuPayload | UpdateItemMenuPayload | DeleteItemMenuPayload | ItemRodapes | ItemRodapesConnection | ItemRodapesAggregator | ItemRodapesAggregatorSum | ItemRodapesAggregatorAvg | ItemRodapesAggregatorMin | ItemRodapesAggregatorMax | ItemRodapesGroupBy | ItemRodapesConnectionId | ItemRodapesConnectionCreated_At | ItemRodapesConnectionUpdated_At | ItemRodapesConnectionNome | ItemRodapesConnectionOrdem | ItemRodapesConnectionPublished_At | CreateItemRodapePayload | UpdateItemRodapePayload | DeleteItemRodapePayload | MaturidadePublicoAlvo | MaturidadePublicoAlvoConnection | MaturidadePublicoAlvoAggregator | MaturidadePublicoAlvoGroupBy | MaturidadePublicoAlvoConnectionId | MaturidadePublicoAlvoConnectionCreated_At | MaturidadePublicoAlvoConnectionUpdated_At | MaturidadePublicoAlvoConnectionTitulo | CreateMaturidadePublicoAlvoPayload | UpdateMaturidadePublicoAlvoPayload | DeleteMaturidadePublicoAlvoPayload | ModalidadeDeEnsino | ModalidadeDeEnsinoConnection | ModalidadeDeEnsinoAggregator | ModalidadeDeEnsinoGroupBy | ModalidadeDeEnsinoConnectionId | ModalidadeDeEnsinoConnectionCreated_At | ModalidadeDeEnsinoConnectionUpdated_At | ModalidadeDeEnsinoConnectionTitulo | CreateModalidadeDeEnsinoPayload | UpdateModalidadeDeEnsinoPayload | DeleteModalidadeDeEnsinoPayload | NivelDosObjetivosDeAprendizagem | NivelDosObjetivosDeAprendizagemConnection | NivelDosObjetivosDeAprendizagemAggregator | NivelDosObjetivosDeAprendizagemGroupBy | NivelDosObjetivosDeAprendizagemConnectionId | NivelDosObjetivosDeAprendizagemConnectionCreated_At | NivelDosObjetivosDeAprendizagemConnectionUpdated_At | NivelDosObjetivosDeAprendizagemConnectionTitulo | CreateNivelDosObjetivosDeAprendizagemPayload | UpdateNivelDosObjetivosDeAprendizagemPayload | DeleteNivelDosObjetivosDeAprendizagemPayload | OEsAssistidosPorUsuario | OEsAssistidosPorUsuarioConnection | OEsAssistidosPorUsuarioAggregator | OEsAssistidosPorUsuarioAggregatorSum | OEsAssistidosPorUsuarioAggregatorAvg | OEsAssistidosPorUsuarioAggregatorMin | OEsAssistidosPorUsuarioAggregatorMax | OEsAssistidosPorUsuarioGroupBy | OEsAssistidosPorUsuarioConnectionId | OEsAssistidosPorUsuarioConnectionCreated_At | OEsAssistidosPorUsuarioConnectionUpdated_At | OEsAssistidosPorUsuarioConnectionDuracao | OEsAssistidosPorUsuarioConnectionSegundos | OEsAssistidosPorUsuarioConnectionVideoAudioId | OEsAssistidosPorUsuarioConnectionImagemOeId | OEsAssistidosPorUsuarioConnectionLeituraOeId | OEsAssistidosPorUsuarioConnectionPublished_At | CreateOEsAssistidosPorUsuarioPayload | UpdateOEsAssistidosPorUsuarioPayload | DeleteOEsAssistidosPorUsuarioPayload | ObjetoEducacional | ObjetoEducacionalConnection | ObjetoEducacionalAggregator | ObjetoEducacionalGroupBy | ObjetoEducacionalConnectionId | ObjetoEducacionalConnectionCreated_At | ObjetoEducacionalConnectionUpdated_At | ObjetoEducacionalConnectionTitulo | ObjetoEducacionalConnectionIdioma | ObjetoEducacionalConnectionRestricaoPublicoMedico | ObjetoEducacionalConnectionImagemCapa | ObjetoEducacionalConnectionImagemPreview | ObjetoEducacionalConnectionDescricao | ObjetoEducacionalConnectionResumo | ObjetoEducacionalConnectionMaturidadePublicoAlvo | ObjetoEducacionalConnectionGranularidade | ObjetoEducacionalConnectionDensidadeSemantica | ObjetoEducacionalConnectionTipoInteratividade | ObjetoEducacionalConnectionProdutoPrimario | ObjetoEducacionalConnectionModalidadeEnsino | ObjetoEducacionalConnectionTempoMedioDuracao | ObjetoEducacionalConnectionPossuiCertificado | ObjetoEducacionalConnectionSubRotulo | ObjetoEducacionalConnectionRevisaoOrtografica | ObjetoEducacionalConnectionPatrocinador | ObjetoEducacionalConnectionAutorizacaoDeUso | ObjetoEducacionalConnectionValidadeConteudo | ObjetoEducacionalConnectionStatus | ObjetoEducacionalConnectionDireitosUsoImagemTerceirosPacientes | ObjetoEducacionalConnectionDataProducao | ObjetoEducacionalConnectionDataAtualizacaoProducao | ObjetoEducacionalConnectionComentario_Drive_Insumo | ObjetoEducacionalConnectionUso_Imagem_Terceiro | ObjetoEducacionalConnectionPublished_At | CreateObjetoEducacionalPayload | UpdateObjetoEducacionalPayload | DeleteObjetoEducacionalPayload | Oes | OesConnection | OesAggregator | OesGroupBy | OesConnectionId | OesConnectionCreated_At | OesConnectionUpdated_At | OesConnectionTitulo | OesConnectionRotulo | OesConnectionSubRotulo | OesConnectionSecao | OesConnectionMetadados_Identificacao | OesConnectionMetadados_Ciclo_De_Vida | OesConnectionMetadados_Educacional | OesConnectionMetadados_Einstein | OesConnectionMetadados_Tecnica | OesConnectionPublished_At | CreateOePayload | UpdateOePayload | DeleteOePayload | PaginaAtendimento | UpdatePaginaAtendimentoPayload | DeletePaginaAtendimentoPayload | PalavraChave | PalavraChaveConnection | PalavraChaveAggregator | PalavraChaveGroupBy | PalavraChaveConnectionId | PalavraChaveConnectionCreated_At | PalavraChaveConnectionUpdated_At | PalavraChaveConnectionTitulo | PalavraChaveConnectionPublished_At | CreatePalavraChavePayload | UpdatePalavraChavePayload | DeletePalavraChavePayload | Patrocinador | PatrocinadorConnection | PatrocinadorAggregator | PatrocinadorGroupBy | PatrocinadorConnectionId | PatrocinadorConnectionCreated_At | PatrocinadorConnectionUpdated_At | PatrocinadorConnectionTitulo | PatrocinadorConnectionLogo | PatrocinadorConnectionCategoria_Patrocinador | PatrocinadorConnectionThumbnail | PatrocinadorConnectionPublished_At | CreatePatrocinadorPayload | UpdatePatrocinadorPayload | DeletePatrocinadorPayload | PerfilDeAutor | PerfilDeAutorConnection | PerfilDeAutorAggregator | PerfilDeAutorGroupBy | PerfilDeAutorConnectionId | PerfilDeAutorConnectionCreated_At | PerfilDeAutorConnectionUpdated_At | PerfilDeAutorConnectionNome_Completo | PerfilDeAutorConnectionNome_Exibicao | PerfilDeAutorConnectionData_Nascimento | PerfilDeAutorConnectionCpf | PerfilDeAutorConnectionNacionalidade | PerfilDeAutorConnectionEstado_Civil | PerfilDeAutorConnectionCep | PerfilDeAutorConnectionEndereco | PerfilDeAutorConnectionNumero | PerfilDeAutorConnectionCidade | PerfilDeAutorConnectionUf | PerfilDeAutorConnectionTelefone | PerfilDeAutorConnectionProfissao | PerfilDeAutorConnectionProfissao_Tecnico | PerfilDeAutorConnectionOutro_Qual | PerfilDeAutorConnectionCrm | PerfilDeAutorConnectionFoto | PerfilDeAutorConnectionCargo | PerfilDeAutorConnectionLink_Do_Curriculo | PerfilDeAutorConnectionAutoriza_Divulgacao_Link | PerfilDeAutorConnectionEmail | PerfilDeAutorConnectionAutoriza_Divulgacao_Email | PerfilDeAutorConnectionTermo_Cessao_Direito | PerfilDeAutorConnectionAutoriza_Termo_Direito | PerfilDeAutorConnectionData_Termo | PerfilDeAutorConnectionNome_Projeto | PerfilDeAutorConnectionLink_Projeto | PerfilDeAutorConnectionUsers_Permissions_User | CreatePerfilDeAutorPayload | UpdatePerfilDeAutorPayload | DeletePerfilDeAutorPayload | PerguntaQuizz | PerguntaQuizzConnection | PerguntaQuizzAggregator | PerguntaQuizzAggregatorSum | PerguntaQuizzAggregatorAvg | PerguntaQuizzAggregatorMin | PerguntaQuizzAggregatorMax | PerguntaQuizzGroupBy | PerguntaQuizzConnectionId | PerguntaQuizzConnectionCreated_At | PerguntaQuizzConnectionUpdated_At | PerguntaQuizzConnectionEnunciado | PerguntaQuizzConnectionImagem | PerguntaQuizzConnectionFeedback_Acerto | PerguntaQuizzConnectionFeedback_Erro | PerguntaQuizzConnectionDuracao | PerguntaQuizzConnectionUrl_Vimeo | PerguntaQuizzConnectionPublished_At | CreatePerguntaQuizzPayload | UpdatePerguntaQuizzPayload | DeletePerguntaQuizzPayload | ProdutoPrimario | ProdutoPrimarioConnection | ProdutoPrimarioAggregator | ProdutoPrimarioGroupBy | ProdutoPrimarioConnectionId | ProdutoPrimarioConnectionCreated_At | ProdutoPrimarioConnectionUpdated_At | ProdutoPrimarioConnectionTitulo | CreateProdutoPrimarioPayload | UpdateProdutoPrimarioPayload | DeleteProdutoPrimarioPayload | ProfissaoTecnico | ProfissaoTecnicoConnection | ProfissaoTecnicoAggregator | ProfissaoTecnicoGroupBy | ProfissaoTecnicoConnectionId | ProfissaoTecnicoConnectionCreated_At | ProfissaoTecnicoConnectionUpdated_At | ProfissaoTecnicoConnectionTitulo | CreateProfissaoTecnicoPayload | UpdateProfissaoTecnicoPayload | DeleteProfissaoTecnicoPayload | Profissao | ProfissaoConnection | ProfissaoAggregator | ProfissaoGroupBy | ProfissaoConnectionId | ProfissaoConnectionCreated_At | ProfissaoConnectionUpdated_At | ProfissaoConnectionTitulo | ProfissaoConnectionPossuiCrm | ProfissaoConnectionProfissaoPai | ProfissaoConnectionEhEstudante | ProfissaoConnectionEhTecnicoAuxiliar | ProfissaoConnectionEhOutro | CreateProfissaoPayload | UpdateProfissaoPayload | DeleteProfissaoPayload | PublicoAlvo | PublicoAlvoConnection | PublicoAlvoAggregator | PublicoAlvoGroupBy | PublicoAlvoConnectionId | PublicoAlvoConnectionCreated_At | PublicoAlvoConnectionUpdated_At | PublicoAlvoConnectionTitulo | CreatePublicoAlvoPayload | UpdatePublicoAlvoPayload | DeletePublicoAlvoPayload | Quizz | QuizzConnection | QuizzAggregator | QuizzGroupBy | QuizzConnectionId | QuizzConnectionCreated_At | QuizzConnectionUpdated_At | QuizzConnectionNome | QuizzConnectionFeedback | QuizzConnectionPublished_At | CreateQuizzPayload | UpdateQuizzPayload | DeleteQuizzPayload | RecuperacaoSenha | RecuperacaoSenhaConnection | RecuperacaoSenhaAggregator | RecuperacaoSenhaGroupBy | RecuperacaoSenhaConnectionId | RecuperacaoSenhaConnectionCreated_At | RecuperacaoSenhaConnectionUpdated_At | RecuperacaoSenhaConnectionHash | RecuperacaoSenhaConnectionUsuario | RecuperacaoSenhaConnectionExpiracao | RecuperacaoSenhaConnectionUtilizado | RecuperacaoSenhaConnectionCanal | CreateRecuperacaoSenhaPayload | UpdateRecuperacaoSenhaPayload | DeleteRecuperacaoSenhaPayload | RodapePortal | UpdateRodapePortalPayload | DeleteRodapePortalPayload | Rotas | RotasConnection | RotasAggregator | RotasGroupBy | RotasConnectionId | RotasConnectionCreated_At | RotasConnectionUpdated_At | RotasConnectionNome | RotasConnectionPath | RotasConnectionPublished_At | CreateRotaPayload | UpdateRotaPayload | DeleteRotaPayload | Rotulo | RotuloConnection | RotuloAggregator | RotuloGroupBy | RotuloConnectionId | RotuloConnectionCreated_At | RotuloConnectionUpdated_At | RotuloConnectionTitulo | RotuloConnectionRotulo_Pai | RotuloConnectionImagemFundo | RotuloConnectionDescricao | CreateRotuloPayload | UpdateRotuloPayload | DeleteRotuloPayload | StatusDePublicacao | StatusDePublicacaoConnection | StatusDePublicacaoAggregator | StatusDePublicacaoGroupBy | StatusDePublicacaoConnectionId | StatusDePublicacaoConnectionCreated_At | StatusDePublicacaoConnectionUpdated_At | StatusDePublicacaoConnectionTitulo | StatusDePublicacaoConnectionEnum_Status | StatusDePublicacaoConnectionStatus_Pai | CreateStatusDePublicacaoPayload | UpdateStatusDePublicacaoPayload | DeleteStatusDePublicacaoPayload | SubAreaConhecimento | SubAreaConhecimentoConnection | SubAreaConhecimentoAggregator | SubAreaConhecimentoGroupBy | SubAreaConhecimentoConnectionId | SubAreaConhecimentoConnectionCreated_At | SubAreaConhecimentoConnectionUpdated_At | SubAreaConhecimentoConnectionNome | SubAreaConhecimentoConnectionPublished_At | CreateSubAreaConhecimentoPayload | UpdateSubAreaConhecimentoPayload | DeleteSubAreaConhecimentoPayload | SubRotulo | SubRotuloConnection | SubRotuloAggregator | SubRotuloGroupBy | SubRotuloConnectionId | SubRotuloConnectionCreated_At | SubRotuloConnectionUpdated_At | SubRotuloConnectionTitulo | CreateSubRotuloPayload | UpdateSubRotuloPayload | DeleteSubRotuloPayload | TermosDeUso | TermosDeUsoConnection | TermosDeUsoAggregator | TermosDeUsoGroupBy | TermosDeUsoConnectionId | TermosDeUsoConnectionCreated_At | TermosDeUsoConnectionUpdated_At | TermosDeUsoConnectionVigencia | TermosDeUsoConnectionConteudo | TermosDeUsoConnectionPublished_At | CreateTermosDeUsoPayload | UpdateTermosDeUsoPayload | DeleteTermosDeUsoPayload | TipoAreaPagina | TipoAreaPaginaConnection | TipoAreaPaginaAggregator | TipoAreaPaginaGroupBy | TipoAreaPaginaConnectionId | TipoAreaPaginaConnectionCreated_At | TipoAreaPaginaConnectionUpdated_At | TipoAreaPaginaConnectionNome | TipoAreaPaginaConnectionTipoPagina | TipoAreaPaginaConnectionPublished_At | CreateTipoAreaPaginaPayload | UpdateTipoAreaPaginaPayload | DeleteTipoAreaPaginaPayload | TipoAtendimento | TipoAtendimentoConnection | TipoAtendimentoAggregator | TipoAtendimentoGroupBy | TipoAtendimentoConnectionId | TipoAtendimentoConnectionCreated_At | TipoAtendimentoConnectionUpdated_At | TipoAtendimentoConnectionTitulo | TipoAtendimentoConnectionEmail_Atendimento | TipoAtendimentoConnectionPublished_At | CreateTipoAtendimentoPayload | UpdateTipoAtendimentoPayload | DeleteTipoAtendimentoPayload | TipoInteratividadeOe | TipoInteratividadeOeConnection | TipoInteratividadeOeAggregator | TipoInteratividadeOeGroupBy | TipoInteratividadeOeConnectionId | TipoInteratividadeOeConnectionCreated_At | TipoInteratividadeOeConnectionUpdated_At | TipoInteratividadeOeConnectionTitulo | CreateTipoInteratividadeOePayload | UpdateTipoInteratividadeOePayload | DeleteTipoInteratividadeOePayload | TipoOe | TipoOeConnection | TipoOeAggregator | TipoOeGroupBy | TipoOeConnectionId | TipoOeConnectionCreated_At | TipoOeConnectionUpdated_At | TipoOeConnectionTitulo | CreateTipoOePayload | UpdateTipoOePayload | DeleteTipoOePayload | TipoPagina | TipoPaginaConnection | TipoPaginaAggregator | TipoPaginaGroupBy | TipoPaginaConnectionId | TipoPaginaConnectionCreated_At | TipoPaginaConnectionUpdated_At | TipoPaginaConnectionNome | TipoPaginaConnectionPublished_At | CreateTipoPaginaPayload | UpdateTipoPaginaPayload | DeleteTipoPaginaPayload | TipoRecursoEducacional | TipoRecursoEducacionalConnection | TipoRecursoEducacionalAggregator | TipoRecursoEducacionalGroupBy | TipoRecursoEducacionalConnectionId | TipoRecursoEducacionalConnectionCreated_At | TipoRecursoEducacionalConnectionUpdated_At | TipoRecursoEducacionalConnectionTitulo | CreateTipoRecursoEducacionalPayload | UpdateTipoRecursoEducacionalPayload | DeleteTipoRecursoEducacionalPayload | TiposRelacionamentosEntreOe | TiposRelacionamentosEntreOeConnection | TiposRelacionamentosEntreOeAggregator | TiposRelacionamentosEntreOeGroupBy | TiposRelacionamentosEntreOeConnectionId | TiposRelacionamentosEntreOeConnectionCreated_At | TiposRelacionamentosEntreOeConnectionUpdated_At | TiposRelacionamentosEntreOeConnectionTitulo | CreateTiposRelacionamentosEntreOePayload | UpdateTiposRelacionamentosEntreOePayload | DeleteTiposRelacionamentosEntreOePayload | Topico | TopicoConnection | TopicoAggregator | TopicoGroupBy | TopicoConnectionId | TopicoConnectionCreated_At | TopicoConnectionUpdated_At | TopicoConnectionTitulo | TopicoConnectionCorclara | TopicoConnectionCorescura | TopicoConnectionRota | TopicoConnectionImagem | TopicoConnectionPublished_At | CreateTopicoPayload | UpdateTopicoPayload | DeleteTopicoPayload | I18NLocale | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnectionCreated_At | UploadFileConnectionUpdated_At | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | DeleteFilePayload | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionNome_Completo | UsersPermissionsUserConnectionData_Nascimento | UsersPermissionsUserConnectionCpf | UsersPermissionsUserConnectionCelular | UsersPermissionsUserConnectionAvatar | UsersPermissionsUserConnectionUf | UsersPermissionsUserConnectionCrm | UsersPermissionsUserConnectionProfissaoFilha | UsersPermissionsUserConnectionOutraProfissaoFilha | UsersPermissionsUserConnectionAcceptTerm | UsersPermissionsUserConnectionAcceptSharePersonData | UsersPermissionsUserConnectionDocumentType | UsersPermissionsUserConnectionDocumentNumber | UsersPermissionsUserConnectionCanal | CreateUserPayload | UpdateUserPayload | DeleteUserPayload | ComponentAlternativaListaAlternativas | ComponentAudioAudio | ComponentAutoresAutor | ComponentCessaoDeDireitosCessaoDeDireitos | ComponentCicloDeVidaCicloDeVida | ComponentEnderecosEndereco | ComponentFieldGroupArquivoReferencia | ComponentFieldGroupFormularioDeSessaoDeUso | ComponentFieldGroupGestaoDeDestaque | ComponentFieldGroupImagemEDescricao | ComponentFieldGroupInfografico | ComponentFieldGroupMaturidadePublicaAlvo | ComponentFieldGroupMetadadosAutor | ComponentFieldGroupMetadadosCicloDeVida | ComponentFieldGroupMetadadosEducacional | ComponentFieldGroupMetadadosEinstein | ComponentFieldGroupMetadadosIdentificacao | ComponentFieldGroupObjetivosEResultados | ComponentFieldGroupPalavraChave | ComponentFieldGroupResultados | ComponentFieldGroupResumoDoConteudoInfografico | ComponentFieldGroupSeletorAreaDeConhecimento | ComponentFieldGroupSeletorDeAutores | ComponentFieldGroupSeletorDeNIvelDeObjetivoDeAprendizagem | ComponentFieldGroupSeletorMaturidadePublicoAlvo | ComponentFieldGroupSeletorModalidadeDeEnsino | ComponentFieldGroupSeletorOeRelacionado | ComponentFieldGroupSeletorProdutoPrimario | ComponentFieldGroupSeletorTipoOe | ComponentFieldGroupSolicitacaoInfografico | ComponentFieldGroupTecnica | ComponentGrupoEnsinoGrupoEnsino | ComponentHomeConteudosAltaHomeConteudosAlta | ComponentHomeDestaqueSemanaHomeDestaqueSemana | ComponentHomeDestaquesSemanaHomeDestaquesSemana | ComponentHomeNovidadesHomeNovidades | ComponentHomeOutrasAreasHomeOutrasAreas | ComponentHomeQuizHomeQuiz | ComponentHomeTopicosHomeTopicos | ComponentHomeVideosAltaHomeVideosAlta | ComponentImagemImagem | ComponentLinksRodapeLinks | ComponentListaAltaAlta | ComponentListaAreasConhecimentoOutrasAreasConhecimento | ComponentListaContatosRodapeContatosRodape | ComponentListaEmailsAtendimentoListaEmailsAtendimento | ComponentListaHomeSliderListaHomeSlider | ComponentListaHorarioAtendimentoHorarioAtendimento | ComponentListaHorariosAtendimentoListaHorariosAtendimento | ComponentListaMenusRodapeLinksRodape | ComponentListaMenusItem | ComponentListaOutrasAreasOutrasAreas | ComponentListaQuizQuiz | ComponentListaSliderSlider | ComponentListaTopicosTopico | ComponentListaVideosAltaVideosAlta | ComponentMenusRodapeMenusRodape | ComponentObjetoEducacionalInfogaficoInfografico | ComponentObjetosEducacionaisOrdenadosObjetosEducacionaisOrdenados | ComponentOesParcialmenteConsumidasConsumidosParcialmente | ComponentPerguntaOpcaoOpcao | ComponentPerguntaOpcaoRespostas | ComponentPerguntaQuizzPergunta | ComponentQuizzesQuiz | ComponentRodapeAtendimentoAtendimento | ComponentRodapeLinksLinks | ComponentRodapeRedeSocialListaTelefonesAtendimento | ComponentRodapeRedeSocialRedeSocial | ComponentSecaoTextSecaoTexto | ComponentSecaoVideoAudioVideoAudio | ComponentTelefoneAutorTelefone | ComponentTextoTexto | ComponentTipoAprovacaoEtapasAprovacao | ComponentUserAreaConhecimentoAreaConhecimento | ComponentVideoVideo;

export type Mutation = {
  __typename?: 'Mutation';
  createAreaDeConhecimento?: Maybe<CreateAreaDeConhecimentoPayload>;
  updateAreaDeConhecimento?: Maybe<UpdateAreaDeConhecimentoPayload>;
  deleteAreaDeConhecimento?: Maybe<DeleteAreaDeConhecimentoPayload>;
  createAreaDeDestaque?: Maybe<CreateAreaDeDestaquePayload>;
  updateAreaDeDestaque?: Maybe<UpdateAreaDeDestaquePayload>;
  deleteAreaDeDestaque?: Maybe<DeleteAreaDeDestaquePayload>;
  createAutorConvidado?: Maybe<CreateAutorConvidadoPayload>;
  updateAutorConvidado?: Maybe<UpdateAutorConvidadoPayload>;
  deleteAutorConvidado?: Maybe<DeleteAutorConvidadoPayload>;
  createAutorizacaoDeUso?: Maybe<CreateAutorizacaoDeUsoPayload>;
  updateAutorizacaoDeUso?: Maybe<UpdateAutorizacaoDeUsoPayload>;
  deleteAutorizacaoDeUso?: Maybe<DeleteAutorizacaoDeUsoPayload>;
  createBanner?: Maybe<CreateBannerPayload>;
  updateBanner?: Maybe<UpdateBannerPayload>;
  deleteBanner?: Maybe<DeleteBannerPayload>;
  createCategoriaPatrocinador?: Maybe<CreateCategoriaPatrocinadorPayload>;
  updateCategoriaPatrocinador?: Maybe<UpdateCategoriaPatrocinadorPayload>;
  deleteCategoriaPatrocinador?: Maybe<DeleteCategoriaPatrocinadorPayload>;
  createContato?: Maybe<CreateContatoPayload>;
  updateContato?: Maybe<UpdateContatoPayload>;
  deleteContato?: Maybe<DeleteContatoPayload>;
  createDensidadeSemantica?: Maybe<CreateDensidadeSemanticaPayload>;
  updateDensidadeSemantica?: Maybe<UpdateDensidadeSemanticaPayload>;
  deleteDensidadeSemantica?: Maybe<DeleteDensidadeSemanticaPayload>;
  createDescomplicandoCiencia?: Maybe<CreateDescomplicandoCienciaPayload>;
  updateDescomplicandoCiencia?: Maybe<UpdateDescomplicandoCienciaPayload>;
  deleteDescomplicandoCiencia?: Maybe<DeleteDescomplicandoCienciaPayload>;
  createDriveInsumoObjetoEducacional?: Maybe<CreateDriveInsumoObjetoEducacionalPayload>;
  updateDriveInsumoObjetoEducacional?: Maybe<UpdateDriveInsumoObjetoEducacionalPayload>;
  deleteDriveInsumoObjetoEducacional?: Maybe<DeleteDriveInsumoObjetoEducacionalPayload>;
  updateEnsinoEinsteinPage?: Maybe<UpdateEnsinoEinsteinPagePayload>;
  deleteEnsinoEinsteinPage?: Maybe<DeleteEnsinoEinsteinPagePayload>;
  createEnsinoEinstein?: Maybe<CreateEnsinoEinsteinPayload>;
  updateEnsinoEinstein?: Maybe<UpdateEnsinoEinsteinPayload>;
  deleteEnsinoEinstein?: Maybe<DeleteEnsinoEinsteinPayload>;
  createEstadoCivil?: Maybe<CreateEstadoCivilPayload>;
  updateEstadoCivil?: Maybe<UpdateEstadoCivilPayload>;
  deleteEstadoCivil?: Maybe<DeleteEstadoCivilPayload>;
  createGestaoFuncionalidade?: Maybe<CreateGestaoFuncionalidadePayload>;
  updateGestaoFuncionalidade?: Maybe<UpdateGestaoFuncionalidadePayload>;
  deleteGestaoFuncionalidade?: Maybe<DeleteGestaoFuncionalidadePayload>;
  createGranularidade?: Maybe<CreateGranularidadePayload>;
  updateGranularidade?: Maybe<UpdateGranularidadePayload>;
  deleteGranularidade?: Maybe<DeleteGranularidadePayload>;
  updateHeaderPortal?: Maybe<UpdateHeaderPortalPayload>;
  deleteHeaderPortal?: Maybe<DeleteHeaderPortalPayload>;
  createHistoricoAvaliacaoObjetoEducacional?: Maybe<CreateHistoricoAvaliacaoObjetoEducacionalPayload>;
  updateHistoricoAvaliacaoObjetoEducacional?: Maybe<UpdateHistoricoAvaliacaoObjetoEducacionalPayload>;
  deleteHistoricoAvaliacaoObjetoEducacional?: Maybe<DeleteHistoricoAvaliacaoObjetoEducacionalPayload>;
  updateHomeObjetoEducacionalPage?: Maybe<UpdateHomeObjetoEducacionalPagePayload>;
  deleteHomeObjetoEducacionalPage?: Maybe<DeleteHomeObjetoEducacionalPagePayload>;
  createIdioma?: Maybe<CreateIdiomaPayload>;
  updateIdioma?: Maybe<UpdateIdiomaPayload>;
  deleteIdioma?: Maybe<DeleteIdiomaPayload>;
  createItemMenu?: Maybe<CreateItemMenuPayload>;
  updateItemMenu?: Maybe<UpdateItemMenuPayload>;
  deleteItemMenu?: Maybe<DeleteItemMenuPayload>;
  createItemRodape?: Maybe<CreateItemRodapePayload>;
  updateItemRodape?: Maybe<UpdateItemRodapePayload>;
  deleteItemRodape?: Maybe<DeleteItemRodapePayload>;
  createMaturidadePublicoAlvo?: Maybe<CreateMaturidadePublicoAlvoPayload>;
  updateMaturidadePublicoAlvo?: Maybe<UpdateMaturidadePublicoAlvoPayload>;
  deleteMaturidadePublicoAlvo?: Maybe<DeleteMaturidadePublicoAlvoPayload>;
  createModalidadeDeEnsino?: Maybe<CreateModalidadeDeEnsinoPayload>;
  updateModalidadeDeEnsino?: Maybe<UpdateModalidadeDeEnsinoPayload>;
  deleteModalidadeDeEnsino?: Maybe<DeleteModalidadeDeEnsinoPayload>;
  createNivelDosObjetivosDeAprendizagem?: Maybe<CreateNivelDosObjetivosDeAprendizagemPayload>;
  updateNivelDosObjetivosDeAprendizagem?: Maybe<UpdateNivelDosObjetivosDeAprendizagemPayload>;
  deleteNivelDosObjetivosDeAprendizagem?: Maybe<DeleteNivelDosObjetivosDeAprendizagemPayload>;
  createOEsAssistidosPorUsuario?: Maybe<CreateOEsAssistidosPorUsuarioPayload>;
  updateOEsAssistidosPorUsuario?: Maybe<UpdateOEsAssistidosPorUsuarioPayload>;
  deleteOEsAssistidosPorUsuario?: Maybe<DeleteOEsAssistidosPorUsuarioPayload>;
  createObjetoEducacional?: Maybe<CreateObjetoEducacionalPayload>;
  updateObjetoEducacional?: Maybe<UpdateObjetoEducacionalPayload>;
  deleteObjetoEducacional?: Maybe<DeleteObjetoEducacionalPayload>;
  createOe?: Maybe<CreateOePayload>;
  updateOe?: Maybe<UpdateOePayload>;
  deleteOe?: Maybe<DeleteOePayload>;
  updatePaginaAtendimento?: Maybe<UpdatePaginaAtendimentoPayload>;
  deletePaginaAtendimento?: Maybe<DeletePaginaAtendimentoPayload>;
  createPalavraChave?: Maybe<CreatePalavraChavePayload>;
  updatePalavraChave?: Maybe<UpdatePalavraChavePayload>;
  deletePalavraChave?: Maybe<DeletePalavraChavePayload>;
  createPatrocinador?: Maybe<CreatePatrocinadorPayload>;
  updatePatrocinador?: Maybe<UpdatePatrocinadorPayload>;
  deletePatrocinador?: Maybe<DeletePatrocinadorPayload>;
  createPerfilDeAutor?: Maybe<CreatePerfilDeAutorPayload>;
  updatePerfilDeAutor?: Maybe<UpdatePerfilDeAutorPayload>;
  deletePerfilDeAutor?: Maybe<DeletePerfilDeAutorPayload>;
  createPerguntaQuizz?: Maybe<CreatePerguntaQuizzPayload>;
  updatePerguntaQuizz?: Maybe<UpdatePerguntaQuizzPayload>;
  deletePerguntaQuizz?: Maybe<DeletePerguntaQuizzPayload>;
  createProdutoPrimario?: Maybe<CreateProdutoPrimarioPayload>;
  updateProdutoPrimario?: Maybe<UpdateProdutoPrimarioPayload>;
  deleteProdutoPrimario?: Maybe<DeleteProdutoPrimarioPayload>;
  createProfissaoTecnico?: Maybe<CreateProfissaoTecnicoPayload>;
  updateProfissaoTecnico?: Maybe<UpdateProfissaoTecnicoPayload>;
  deleteProfissaoTecnico?: Maybe<DeleteProfissaoTecnicoPayload>;
  createProfissao?: Maybe<CreateProfissaoPayload>;
  updateProfissao?: Maybe<UpdateProfissaoPayload>;
  deleteProfissao?: Maybe<DeleteProfissaoPayload>;
  createPublicoAlvo?: Maybe<CreatePublicoAlvoPayload>;
  updatePublicoAlvo?: Maybe<UpdatePublicoAlvoPayload>;
  deletePublicoAlvo?: Maybe<DeletePublicoAlvoPayload>;
  createQuizz?: Maybe<CreateQuizzPayload>;
  updateQuizz?: Maybe<UpdateQuizzPayload>;
  deleteQuizz?: Maybe<DeleteQuizzPayload>;
  createRecuperacaoSenha?: Maybe<CreateRecuperacaoSenhaPayload>;
  updateRecuperacaoSenha?: Maybe<UpdateRecuperacaoSenhaPayload>;
  deleteRecuperacaoSenha?: Maybe<DeleteRecuperacaoSenhaPayload>;
  updateRodapePortal?: Maybe<UpdateRodapePortalPayload>;
  deleteRodapePortal?: Maybe<DeleteRodapePortalPayload>;
  createRota?: Maybe<CreateRotaPayload>;
  updateRota?: Maybe<UpdateRotaPayload>;
  deleteRota?: Maybe<DeleteRotaPayload>;
  createRotulo?: Maybe<CreateRotuloPayload>;
  updateRotulo?: Maybe<UpdateRotuloPayload>;
  deleteRotulo?: Maybe<DeleteRotuloPayload>;
  createStatusDePublicacao?: Maybe<CreateStatusDePublicacaoPayload>;
  updateStatusDePublicacao?: Maybe<UpdateStatusDePublicacaoPayload>;
  deleteStatusDePublicacao?: Maybe<DeleteStatusDePublicacaoPayload>;
  createSubAreaConhecimento?: Maybe<CreateSubAreaConhecimentoPayload>;
  updateSubAreaConhecimento?: Maybe<UpdateSubAreaConhecimentoPayload>;
  deleteSubAreaConhecimento?: Maybe<DeleteSubAreaConhecimentoPayload>;
  createSubRotulo?: Maybe<CreateSubRotuloPayload>;
  updateSubRotulo?: Maybe<UpdateSubRotuloPayload>;
  deleteSubRotulo?: Maybe<DeleteSubRotuloPayload>;
  createTermosDeUso?: Maybe<CreateTermosDeUsoPayload>;
  updateTermosDeUso?: Maybe<UpdateTermosDeUsoPayload>;
  deleteTermosDeUso?: Maybe<DeleteTermosDeUsoPayload>;
  createTipoAreaPagina?: Maybe<CreateTipoAreaPaginaPayload>;
  updateTipoAreaPagina?: Maybe<UpdateTipoAreaPaginaPayload>;
  deleteTipoAreaPagina?: Maybe<DeleteTipoAreaPaginaPayload>;
  createTipoAtendimento?: Maybe<CreateTipoAtendimentoPayload>;
  updateTipoAtendimento?: Maybe<UpdateTipoAtendimentoPayload>;
  deleteTipoAtendimento?: Maybe<DeleteTipoAtendimentoPayload>;
  createTipoInteratividadeOe?: Maybe<CreateTipoInteratividadeOePayload>;
  updateTipoInteratividadeOe?: Maybe<UpdateTipoInteratividadeOePayload>;
  deleteTipoInteratividadeOe?: Maybe<DeleteTipoInteratividadeOePayload>;
  createTipoOe?: Maybe<CreateTipoOePayload>;
  updateTipoOe?: Maybe<UpdateTipoOePayload>;
  deleteTipoOe?: Maybe<DeleteTipoOePayload>;
  createTipoPagina?: Maybe<CreateTipoPaginaPayload>;
  updateTipoPagina?: Maybe<UpdateTipoPaginaPayload>;
  deleteTipoPagina?: Maybe<DeleteTipoPaginaPayload>;
  createTipoRecursoEducacional?: Maybe<CreateTipoRecursoEducacionalPayload>;
  updateTipoRecursoEducacional?: Maybe<UpdateTipoRecursoEducacionalPayload>;
  deleteTipoRecursoEducacional?: Maybe<DeleteTipoRecursoEducacionalPayload>;
  createTiposRelacionamentosEntreOe?: Maybe<CreateTiposRelacionamentosEntreOePayload>;
  updateTiposRelacionamentosEntreOe?: Maybe<UpdateTiposRelacionamentosEntreOePayload>;
  deleteTiposRelacionamentosEntreOe?: Maybe<DeleteTiposRelacionamentosEntreOePayload>;
  createTopico?: Maybe<CreateTopicoPayload>;
  updateTopico?: Maybe<UpdateTopicoPayload>;
  deleteTopico?: Maybe<DeleteTopicoPayload>;
  /** Delete one file */
  deleteFile?: Maybe<DeleteFilePayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  updateFileInfo: UploadFile;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  approveInvitation: AutorConviteMessage;
  deleteDriveInsumo: MessageResponse;
  updateObjetoEducacionalDriveInsumo?: Maybe<ObjetoEducacionalComentarioDriveInsumo>;
};


export type MutationCreateAreaDeConhecimentoArgs = {
  input?: Maybe<CreateAreaDeConhecimentoInput>;
};


export type MutationUpdateAreaDeConhecimentoArgs = {
  input?: Maybe<UpdateAreaDeConhecimentoInput>;
};


export type MutationDeleteAreaDeConhecimentoArgs = {
  input?: Maybe<DeleteAreaDeConhecimentoInput>;
};


export type MutationCreateAreaDeDestaqueArgs = {
  input?: Maybe<CreateAreaDeDestaqueInput>;
};


export type MutationUpdateAreaDeDestaqueArgs = {
  input?: Maybe<UpdateAreaDeDestaqueInput>;
};


export type MutationDeleteAreaDeDestaqueArgs = {
  input?: Maybe<DeleteAreaDeDestaqueInput>;
};


export type MutationCreateAutorConvidadoArgs = {
  input?: Maybe<CreateAutorConvidadoInput>;
};


export type MutationUpdateAutorConvidadoArgs = {
  input?: Maybe<UpdateAutorConvidadoInput>;
};


export type MutationDeleteAutorConvidadoArgs = {
  input?: Maybe<DeleteAutorConvidadoInput>;
};


export type MutationCreateAutorizacaoDeUsoArgs = {
  input?: Maybe<CreateAutorizacaoDeUsoInput>;
};


export type MutationUpdateAutorizacaoDeUsoArgs = {
  input?: Maybe<UpdateAutorizacaoDeUsoInput>;
};


export type MutationDeleteAutorizacaoDeUsoArgs = {
  input?: Maybe<DeleteAutorizacaoDeUsoInput>;
};


export type MutationCreateBannerArgs = {
  input?: Maybe<CreateBannerInput>;
};


export type MutationUpdateBannerArgs = {
  input?: Maybe<UpdateBannerInput>;
};


export type MutationDeleteBannerArgs = {
  input?: Maybe<DeleteBannerInput>;
};


export type MutationCreateCategoriaPatrocinadorArgs = {
  input?: Maybe<CreateCategoriaPatrocinadorInput>;
};


export type MutationUpdateCategoriaPatrocinadorArgs = {
  input?: Maybe<UpdateCategoriaPatrocinadorInput>;
};


export type MutationDeleteCategoriaPatrocinadorArgs = {
  input?: Maybe<DeleteCategoriaPatrocinadorInput>;
};


export type MutationCreateContatoArgs = {
  input?: Maybe<CreateContatoInput>;
};


export type MutationUpdateContatoArgs = {
  input?: Maybe<UpdateContatoInput>;
};


export type MutationDeleteContatoArgs = {
  input?: Maybe<DeleteContatoInput>;
};


export type MutationCreateDensidadeSemanticaArgs = {
  input?: Maybe<CreateDensidadeSemanticaInput>;
};


export type MutationUpdateDensidadeSemanticaArgs = {
  input?: Maybe<UpdateDensidadeSemanticaInput>;
};


export type MutationDeleteDensidadeSemanticaArgs = {
  input?: Maybe<DeleteDensidadeSemanticaInput>;
};


export type MutationCreateDescomplicandoCienciaArgs = {
  input?: Maybe<CreateDescomplicandoCienciaInput>;
};


export type MutationUpdateDescomplicandoCienciaArgs = {
  input?: Maybe<UpdateDescomplicandoCienciaInput>;
};


export type MutationDeleteDescomplicandoCienciaArgs = {
  input?: Maybe<DeleteDescomplicandoCienciaInput>;
};


export type MutationCreateDriveInsumoObjetoEducacionalArgs = {
  input?: Maybe<CreateDriveInsumoObjetoEducacionalInput>;
};


export type MutationUpdateDriveInsumoObjetoEducacionalArgs = {
  input?: Maybe<UpdateDriveInsumoObjetoEducacionalInput>;
};


export type MutationDeleteDriveInsumoObjetoEducacionalArgs = {
  input?: Maybe<DeleteDriveInsumoObjetoEducacionalInput>;
};


export type MutationUpdateEnsinoEinsteinPageArgs = {
  input?: Maybe<UpdateEnsinoEinsteinPageInput>;
};


export type MutationCreateEnsinoEinsteinArgs = {
  input?: Maybe<CreateEnsinoEinsteinInput>;
};


export type MutationUpdateEnsinoEinsteinArgs = {
  input?: Maybe<UpdateEnsinoEinsteinInput>;
};


export type MutationDeleteEnsinoEinsteinArgs = {
  input?: Maybe<DeleteEnsinoEinsteinInput>;
};


export type MutationCreateEstadoCivilArgs = {
  input?: Maybe<CreateEstadoCivilInput>;
};


export type MutationUpdateEstadoCivilArgs = {
  input?: Maybe<UpdateEstadoCivilInput>;
};


export type MutationDeleteEstadoCivilArgs = {
  input?: Maybe<DeleteEstadoCivilInput>;
};


export type MutationCreateGestaoFuncionalidadeArgs = {
  input?: Maybe<CreateGestaoFuncionalidadeInput>;
};


export type MutationUpdateGestaoFuncionalidadeArgs = {
  input?: Maybe<UpdateGestaoFuncionalidadeInput>;
};


export type MutationDeleteGestaoFuncionalidadeArgs = {
  input?: Maybe<DeleteGestaoFuncionalidadeInput>;
};


export type MutationCreateGranularidadeArgs = {
  input?: Maybe<CreateGranularidadeInput>;
};


export type MutationUpdateGranularidadeArgs = {
  input?: Maybe<UpdateGranularidadeInput>;
};


export type MutationDeleteGranularidadeArgs = {
  input?: Maybe<DeleteGranularidadeInput>;
};


export type MutationUpdateHeaderPortalArgs = {
  input?: Maybe<UpdateHeaderPortalInput>;
};


export type MutationCreateHistoricoAvaliacaoObjetoEducacionalArgs = {
  input?: Maybe<CreateHistoricoAvaliacaoObjetoEducacionalInput>;
};


export type MutationUpdateHistoricoAvaliacaoObjetoEducacionalArgs = {
  input?: Maybe<UpdateHistoricoAvaliacaoObjetoEducacionalInput>;
};


export type MutationDeleteHistoricoAvaliacaoObjetoEducacionalArgs = {
  input?: Maybe<DeleteHistoricoAvaliacaoObjetoEducacionalInput>;
};


export type MutationUpdateHomeObjetoEducacionalPageArgs = {
  input?: Maybe<UpdateHomeObjetoEducacionalPageInput>;
};


export type MutationCreateIdiomaArgs = {
  input?: Maybe<CreateIdiomaInput>;
};


export type MutationUpdateIdiomaArgs = {
  input?: Maybe<UpdateIdiomaInput>;
};


export type MutationDeleteIdiomaArgs = {
  input?: Maybe<DeleteIdiomaInput>;
};


export type MutationCreateItemMenuArgs = {
  input?: Maybe<CreateItemMenuInput>;
};


export type MutationUpdateItemMenuArgs = {
  input?: Maybe<UpdateItemMenuInput>;
};


export type MutationDeleteItemMenuArgs = {
  input?: Maybe<DeleteItemMenuInput>;
};


export type MutationCreateItemRodapeArgs = {
  input?: Maybe<CreateItemRodapeInput>;
};


export type MutationUpdateItemRodapeArgs = {
  input?: Maybe<UpdateItemRodapeInput>;
};


export type MutationDeleteItemRodapeArgs = {
  input?: Maybe<DeleteItemRodapeInput>;
};


export type MutationCreateMaturidadePublicoAlvoArgs = {
  input?: Maybe<CreateMaturidadePublicoAlvoInput>;
};


export type MutationUpdateMaturidadePublicoAlvoArgs = {
  input?: Maybe<UpdateMaturidadePublicoAlvoInput>;
};


export type MutationDeleteMaturidadePublicoAlvoArgs = {
  input?: Maybe<DeleteMaturidadePublicoAlvoInput>;
};


export type MutationCreateModalidadeDeEnsinoArgs = {
  input?: Maybe<CreateModalidadeDeEnsinoInput>;
};


export type MutationUpdateModalidadeDeEnsinoArgs = {
  input?: Maybe<UpdateModalidadeDeEnsinoInput>;
};


export type MutationDeleteModalidadeDeEnsinoArgs = {
  input?: Maybe<DeleteModalidadeDeEnsinoInput>;
};


export type MutationCreateNivelDosObjetivosDeAprendizagemArgs = {
  input?: Maybe<CreateNivelDosObjetivosDeAprendizagemInput>;
};


export type MutationUpdateNivelDosObjetivosDeAprendizagemArgs = {
  input?: Maybe<UpdateNivelDosObjetivosDeAprendizagemInput>;
};


export type MutationDeleteNivelDosObjetivosDeAprendizagemArgs = {
  input?: Maybe<DeleteNivelDosObjetivosDeAprendizagemInput>;
};


export type MutationCreateOEsAssistidosPorUsuarioArgs = {
  input?: Maybe<CreateOEsAssistidosPorUsuarioInput>;
};


export type MutationUpdateOEsAssistidosPorUsuarioArgs = {
  input?: Maybe<UpdateOEsAssistidosPorUsuarioInput>;
};


export type MutationDeleteOEsAssistidosPorUsuarioArgs = {
  input?: Maybe<DeleteOEsAssistidosPorUsuarioInput>;
};


export type MutationCreateObjetoEducacionalArgs = {
  input?: Maybe<CreateObjetoEducacionalInput>;
};


export type MutationUpdateObjetoEducacionalArgs = {
  input?: Maybe<UpdateObjetoEducacionalInput>;
};


export type MutationDeleteObjetoEducacionalArgs = {
  input?: Maybe<DeleteObjetoEducacionalInput>;
};


export type MutationCreateOeArgs = {
  input?: Maybe<CreateOeInput>;
};


export type MutationUpdateOeArgs = {
  input?: Maybe<UpdateOeInput>;
};


export type MutationDeleteOeArgs = {
  input?: Maybe<DeleteOeInput>;
};


export type MutationUpdatePaginaAtendimentoArgs = {
  input?: Maybe<UpdatePaginaAtendimentoInput>;
};


export type MutationCreatePalavraChaveArgs = {
  input?: Maybe<CreatePalavraChaveInput>;
};


export type MutationUpdatePalavraChaveArgs = {
  input?: Maybe<UpdatePalavraChaveInput>;
};


export type MutationDeletePalavraChaveArgs = {
  input?: Maybe<DeletePalavraChaveInput>;
};


export type MutationCreatePatrocinadorArgs = {
  input?: Maybe<CreatePatrocinadorInput>;
};


export type MutationUpdatePatrocinadorArgs = {
  input?: Maybe<UpdatePatrocinadorInput>;
};


export type MutationDeletePatrocinadorArgs = {
  input?: Maybe<DeletePatrocinadorInput>;
};


export type MutationCreatePerfilDeAutorArgs = {
  input?: Maybe<CreatePerfilDeAutorInput>;
};


export type MutationUpdatePerfilDeAutorArgs = {
  input?: Maybe<UpdatePerfilDeAutorInput>;
};


export type MutationDeletePerfilDeAutorArgs = {
  input?: Maybe<DeletePerfilDeAutorInput>;
};


export type MutationCreatePerguntaQuizzArgs = {
  input?: Maybe<CreatePerguntaQuizzInput>;
};


export type MutationUpdatePerguntaQuizzArgs = {
  input?: Maybe<UpdatePerguntaQuizzInput>;
};


export type MutationDeletePerguntaQuizzArgs = {
  input?: Maybe<DeletePerguntaQuizzInput>;
};


export type MutationCreateProdutoPrimarioArgs = {
  input?: Maybe<CreateProdutoPrimarioInput>;
};


export type MutationUpdateProdutoPrimarioArgs = {
  input?: Maybe<UpdateProdutoPrimarioInput>;
};


export type MutationDeleteProdutoPrimarioArgs = {
  input?: Maybe<DeleteProdutoPrimarioInput>;
};


export type MutationCreateProfissaoTecnicoArgs = {
  input?: Maybe<CreateProfissaoTecnicoInput>;
};


export type MutationUpdateProfissaoTecnicoArgs = {
  input?: Maybe<UpdateProfissaoTecnicoInput>;
};


export type MutationDeleteProfissaoTecnicoArgs = {
  input?: Maybe<DeleteProfissaoTecnicoInput>;
};


export type MutationCreateProfissaoArgs = {
  input?: Maybe<CreateProfissaoInput>;
};


export type MutationUpdateProfissaoArgs = {
  input?: Maybe<UpdateProfissaoInput>;
};


export type MutationDeleteProfissaoArgs = {
  input?: Maybe<DeleteProfissaoInput>;
};


export type MutationCreatePublicoAlvoArgs = {
  input?: Maybe<CreatePublicoAlvoInput>;
};


export type MutationUpdatePublicoAlvoArgs = {
  input?: Maybe<UpdatePublicoAlvoInput>;
};


export type MutationDeletePublicoAlvoArgs = {
  input?: Maybe<DeletePublicoAlvoInput>;
};


export type MutationCreateQuizzArgs = {
  input?: Maybe<CreateQuizzInput>;
};


export type MutationUpdateQuizzArgs = {
  input?: Maybe<UpdateQuizzInput>;
};


export type MutationDeleteQuizzArgs = {
  input?: Maybe<DeleteQuizzInput>;
};


export type MutationCreateRecuperacaoSenhaArgs = {
  input?: Maybe<CreateRecuperacaoSenhaInput>;
};


export type MutationUpdateRecuperacaoSenhaArgs = {
  input?: Maybe<UpdateRecuperacaoSenhaInput>;
};


export type MutationDeleteRecuperacaoSenhaArgs = {
  input?: Maybe<DeleteRecuperacaoSenhaInput>;
};


export type MutationUpdateRodapePortalArgs = {
  input?: Maybe<UpdateRodapePortalInput>;
};


export type MutationCreateRotaArgs = {
  input?: Maybe<CreateRotaInput>;
};


export type MutationUpdateRotaArgs = {
  input?: Maybe<UpdateRotaInput>;
};


export type MutationDeleteRotaArgs = {
  input?: Maybe<DeleteRotaInput>;
};


export type MutationCreateRotuloArgs = {
  input?: Maybe<CreateRotuloInput>;
};


export type MutationUpdateRotuloArgs = {
  input?: Maybe<UpdateRotuloInput>;
};


export type MutationDeleteRotuloArgs = {
  input?: Maybe<DeleteRotuloInput>;
};


export type MutationCreateStatusDePublicacaoArgs = {
  input?: Maybe<CreateStatusDePublicacaoInput>;
};


export type MutationUpdateStatusDePublicacaoArgs = {
  input?: Maybe<UpdateStatusDePublicacaoInput>;
};


export type MutationDeleteStatusDePublicacaoArgs = {
  input?: Maybe<DeleteStatusDePublicacaoInput>;
};


export type MutationCreateSubAreaConhecimentoArgs = {
  input?: Maybe<CreateSubAreaConhecimentoInput>;
};


export type MutationUpdateSubAreaConhecimentoArgs = {
  input?: Maybe<UpdateSubAreaConhecimentoInput>;
};


export type MutationDeleteSubAreaConhecimentoArgs = {
  input?: Maybe<DeleteSubAreaConhecimentoInput>;
};


export type MutationCreateSubRotuloArgs = {
  input?: Maybe<CreateSubRotuloInput>;
};


export type MutationUpdateSubRotuloArgs = {
  input?: Maybe<UpdateSubRotuloInput>;
};


export type MutationDeleteSubRotuloArgs = {
  input?: Maybe<DeleteSubRotuloInput>;
};


export type MutationCreateTermosDeUsoArgs = {
  input?: Maybe<CreateTermosDeUsoInput>;
};


export type MutationUpdateTermosDeUsoArgs = {
  input?: Maybe<UpdateTermosDeUsoInput>;
};


export type MutationDeleteTermosDeUsoArgs = {
  input?: Maybe<DeleteTermosDeUsoInput>;
};


export type MutationCreateTipoAreaPaginaArgs = {
  input?: Maybe<CreateTipoAreaPaginaInput>;
};


export type MutationUpdateTipoAreaPaginaArgs = {
  input?: Maybe<UpdateTipoAreaPaginaInput>;
};


export type MutationDeleteTipoAreaPaginaArgs = {
  input?: Maybe<DeleteTipoAreaPaginaInput>;
};


export type MutationCreateTipoAtendimentoArgs = {
  input?: Maybe<CreateTipoAtendimentoInput>;
};


export type MutationUpdateTipoAtendimentoArgs = {
  input?: Maybe<UpdateTipoAtendimentoInput>;
};


export type MutationDeleteTipoAtendimentoArgs = {
  input?: Maybe<DeleteTipoAtendimentoInput>;
};


export type MutationCreateTipoInteratividadeOeArgs = {
  input?: Maybe<CreateTipoInteratividadeOeInput>;
};


export type MutationUpdateTipoInteratividadeOeArgs = {
  input?: Maybe<UpdateTipoInteratividadeOeInput>;
};


export type MutationDeleteTipoInteratividadeOeArgs = {
  input?: Maybe<DeleteTipoInteratividadeOeInput>;
};


export type MutationCreateTipoOeArgs = {
  input?: Maybe<CreateTipoOeInput>;
};


export type MutationUpdateTipoOeArgs = {
  input?: Maybe<UpdateTipoOeInput>;
};


export type MutationDeleteTipoOeArgs = {
  input?: Maybe<DeleteTipoOeInput>;
};


export type MutationCreateTipoPaginaArgs = {
  input?: Maybe<CreateTipoPaginaInput>;
};


export type MutationUpdateTipoPaginaArgs = {
  input?: Maybe<UpdateTipoPaginaInput>;
};


export type MutationDeleteTipoPaginaArgs = {
  input?: Maybe<DeleteTipoPaginaInput>;
};


export type MutationCreateTipoRecursoEducacionalArgs = {
  input?: Maybe<CreateTipoRecursoEducacionalInput>;
};


export type MutationUpdateTipoRecursoEducacionalArgs = {
  input?: Maybe<UpdateTipoRecursoEducacionalInput>;
};


export type MutationDeleteTipoRecursoEducacionalArgs = {
  input?: Maybe<DeleteTipoRecursoEducacionalInput>;
};


export type MutationCreateTiposRelacionamentosEntreOeArgs = {
  input?: Maybe<CreateTiposRelacionamentosEntreOeInput>;
};


export type MutationUpdateTiposRelacionamentosEntreOeArgs = {
  input?: Maybe<UpdateTiposRelacionamentosEntreOeInput>;
};


export type MutationDeleteTiposRelacionamentosEntreOeArgs = {
  input?: Maybe<DeleteTiposRelacionamentosEntreOeInput>;
};


export type MutationCreateTopicoArgs = {
  input?: Maybe<CreateTopicoInput>;
};


export type MutationUpdateTopicoArgs = {
  input?: Maybe<UpdateTopicoInput>;
};


export type MutationDeleteTopicoArgs = {
  input?: Maybe<DeleteTopicoInput>;
};


export type MutationDeleteFileArgs = {
  input?: Maybe<DeleteFileInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  info?: Maybe<FileInfoInput>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info: FileInfoInput;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationApproveInvitationArgs = {
  ids?: Maybe<Array<Scalars['ID']>>;
};


export type MutationDeleteDriveInsumoArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateObjetoEducacionalDriveInsumoArgs = {
  id: Scalars['ID'];
  comentario: Scalars['String'];
  uso_imagem_terceiro?: Maybe<Scalars['Boolean']>;
};

export type NivelDosObjetivosDeAprendizagem = {
  __typename?: 'NivelDosObjetivosDeAprendizagem';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
};

export type NivelDosObjetivosDeAprendizagemAggregator = {
  __typename?: 'NivelDosObjetivosDeAprendizagemAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type NivelDosObjetivosDeAprendizagemConnection = {
  __typename?: 'NivelDosObjetivosDeAprendizagemConnection';
  values?: Maybe<Array<Maybe<NivelDosObjetivosDeAprendizagem>>>;
  groupBy?: Maybe<NivelDosObjetivosDeAprendizagemGroupBy>;
  aggregate?: Maybe<NivelDosObjetivosDeAprendizagemAggregator>;
};

export type NivelDosObjetivosDeAprendizagemConnectionCreated_At = {
  __typename?: 'NivelDosObjetivosDeAprendizagemConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NivelDosObjetivosDeAprendizagemConnection>;
};

export type NivelDosObjetivosDeAprendizagemConnectionId = {
  __typename?: 'NivelDosObjetivosDeAprendizagemConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NivelDosObjetivosDeAprendizagemConnection>;
};

export type NivelDosObjetivosDeAprendizagemConnectionTitulo = {
  __typename?: 'NivelDosObjetivosDeAprendizagemConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NivelDosObjetivosDeAprendizagemConnection>;
};

export type NivelDosObjetivosDeAprendizagemConnectionUpdated_At = {
  __typename?: 'NivelDosObjetivosDeAprendizagemConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NivelDosObjetivosDeAprendizagemConnection>;
};

export type NivelDosObjetivosDeAprendizagemGroupBy = {
  __typename?: 'NivelDosObjetivosDeAprendizagemGroupBy';
  id?: Maybe<Array<Maybe<NivelDosObjetivosDeAprendizagemConnectionId>>>;
  created_at?: Maybe<Array<Maybe<NivelDosObjetivosDeAprendizagemConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<NivelDosObjetivosDeAprendizagemConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<NivelDosObjetivosDeAprendizagemConnectionTitulo>>>;
};

export type NivelDosObjetivosDeAprendizagemInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type OEsAssistidosPorUsuario = {
  __typename?: 'OEsAssistidosPorUsuario';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  duracao?: Maybe<Scalars['Int']>;
  segundos?: Maybe<Scalars['Int']>;
  VideoAudioId?: Maybe<Scalars['Int']>;
  ImagemOeId?: Maybe<Scalars['Int']>;
  LeituraOeId?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  ConsumidoresParciais?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  OesAssistidos?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type OEsAssistidosPorUsuarioConsumidoresParciaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type OEsAssistidosPorUsuarioOesAssistidosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type OEsAssistidosPorUsuarioAggregator = {
  __typename?: 'OEsAssistidosPorUsuarioAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<OEsAssistidosPorUsuarioAggregatorSum>;
  avg?: Maybe<OEsAssistidosPorUsuarioAggregatorAvg>;
  min?: Maybe<OEsAssistidosPorUsuarioAggregatorMin>;
  max?: Maybe<OEsAssistidosPorUsuarioAggregatorMax>;
};

export type OEsAssistidosPorUsuarioAggregatorAvg = {
  __typename?: 'OEsAssistidosPorUsuarioAggregatorAvg';
  duracao?: Maybe<Scalars['Float']>;
  segundos?: Maybe<Scalars['Float']>;
  VideoAudioId?: Maybe<Scalars['Float']>;
  ImagemOeId?: Maybe<Scalars['Float']>;
  LeituraOeId?: Maybe<Scalars['Float']>;
};

export type OEsAssistidosPorUsuarioAggregatorMax = {
  __typename?: 'OEsAssistidosPorUsuarioAggregatorMax';
  duracao?: Maybe<Scalars['Float']>;
  segundos?: Maybe<Scalars['Float']>;
  VideoAudioId?: Maybe<Scalars['Float']>;
  ImagemOeId?: Maybe<Scalars['Float']>;
  LeituraOeId?: Maybe<Scalars['Float']>;
};

export type OEsAssistidosPorUsuarioAggregatorMin = {
  __typename?: 'OEsAssistidosPorUsuarioAggregatorMin';
  duracao?: Maybe<Scalars['Float']>;
  segundos?: Maybe<Scalars['Float']>;
  VideoAudioId?: Maybe<Scalars['Float']>;
  ImagemOeId?: Maybe<Scalars['Float']>;
  LeituraOeId?: Maybe<Scalars['Float']>;
};

export type OEsAssistidosPorUsuarioAggregatorSum = {
  __typename?: 'OEsAssistidosPorUsuarioAggregatorSum';
  duracao?: Maybe<Scalars['Float']>;
  segundos?: Maybe<Scalars['Float']>;
  VideoAudioId?: Maybe<Scalars['Float']>;
  ImagemOeId?: Maybe<Scalars['Float']>;
  LeituraOeId?: Maybe<Scalars['Float']>;
};

export type OEsAssistidosPorUsuarioConnection = {
  __typename?: 'OEsAssistidosPorUsuarioConnection';
  values?: Maybe<Array<Maybe<OEsAssistidosPorUsuario>>>;
  groupBy?: Maybe<OEsAssistidosPorUsuarioGroupBy>;
  aggregate?: Maybe<OEsAssistidosPorUsuarioAggregator>;
};

export type OEsAssistidosPorUsuarioConnectionCreated_At = {
  __typename?: 'OEsAssistidosPorUsuarioConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OEsAssistidosPorUsuarioConnection>;
};

export type OEsAssistidosPorUsuarioConnectionDuracao = {
  __typename?: 'OEsAssistidosPorUsuarioConnectionDuracao';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<OEsAssistidosPorUsuarioConnection>;
};

export type OEsAssistidosPorUsuarioConnectionId = {
  __typename?: 'OEsAssistidosPorUsuarioConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OEsAssistidosPorUsuarioConnection>;
};

export type OEsAssistidosPorUsuarioConnectionImagemOeId = {
  __typename?: 'OEsAssistidosPorUsuarioConnectionImagemOeId';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<OEsAssistidosPorUsuarioConnection>;
};

export type OEsAssistidosPorUsuarioConnectionLeituraOeId = {
  __typename?: 'OEsAssistidosPorUsuarioConnectionLeituraOeId';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<OEsAssistidosPorUsuarioConnection>;
};

export type OEsAssistidosPorUsuarioConnectionPublished_At = {
  __typename?: 'OEsAssistidosPorUsuarioConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OEsAssistidosPorUsuarioConnection>;
};

export type OEsAssistidosPorUsuarioConnectionSegundos = {
  __typename?: 'OEsAssistidosPorUsuarioConnectionSegundos';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<OEsAssistidosPorUsuarioConnection>;
};

export type OEsAssistidosPorUsuarioConnectionUpdated_At = {
  __typename?: 'OEsAssistidosPorUsuarioConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OEsAssistidosPorUsuarioConnection>;
};

export type OEsAssistidosPorUsuarioConnectionVideoAudioId = {
  __typename?: 'OEsAssistidosPorUsuarioConnectionVideoAudioId';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<OEsAssistidosPorUsuarioConnection>;
};

export type OEsAssistidosPorUsuarioGroupBy = {
  __typename?: 'OEsAssistidosPorUsuarioGroupBy';
  id?: Maybe<Array<Maybe<OEsAssistidosPorUsuarioConnectionId>>>;
  created_at?: Maybe<Array<Maybe<OEsAssistidosPorUsuarioConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<OEsAssistidosPorUsuarioConnectionUpdated_At>>>;
  duracao?: Maybe<Array<Maybe<OEsAssistidosPorUsuarioConnectionDuracao>>>;
  segundos?: Maybe<Array<Maybe<OEsAssistidosPorUsuarioConnectionSegundos>>>;
  VideoAudioId?: Maybe<Array<Maybe<OEsAssistidosPorUsuarioConnectionVideoAudioId>>>;
  ImagemOeId?: Maybe<Array<Maybe<OEsAssistidosPorUsuarioConnectionImagemOeId>>>;
  LeituraOeId?: Maybe<Array<Maybe<OEsAssistidosPorUsuarioConnectionLeituraOeId>>>;
  published_at?: Maybe<Array<Maybe<OEsAssistidosPorUsuarioConnectionPublished_At>>>;
};

export type OEsAssistidosPorUsuarioInput = {
  duracao?: Maybe<Scalars['Int']>;
  segundos?: Maybe<Scalars['Int']>;
  ConsumidoresParciais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OesAssistidos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  VideoAudioId?: Maybe<Scalars['Int']>;
  ImagemOeId?: Maybe<Scalars['Int']>;
  LeituraOeId?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ObjetoEducacional = {
  __typename?: 'ObjetoEducacional';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Titulo: Scalars['String'];
  Idioma?: Maybe<Idiomas>;
  RestricaoPublicoMedico?: Maybe<Scalars['Boolean']>;
  ImagemCapa?: Maybe<UploadFile>;
  ImagemPreview?: Maybe<UploadFile>;
  Descricao: Scalars['String'];
  Resumo: Scalars['String'];
  MaturidadePublicoAlvo?: Maybe<MaturidadePublicoAlvo>;
  Granularidade?: Maybe<Granularidade>;
  DensidadeSemantica?: Maybe<DensidadeSemantica>;
  TipoInteratividade?: Maybe<TipoInteratividadeOe>;
  SecoesTexto?: Maybe<Array<Maybe<ComponentSecaoTextSecaoTexto>>>;
  VideoAudio?: Maybe<Array<Maybe<ComponentSecaoVideoAudioVideoAudio>>>;
  ProdutoPrimario?: Maybe<ProdutoPrimario>;
  ModalidadeEnsino?: Maybe<ModalidadeDeEnsino>;
  TempoMedioDuracao: Scalars['String'];
  PossuiCertificado?: Maybe<Scalars['Boolean']>;
  SubRotulo?: Maybe<Rotulo>;
  Infografico?: Maybe<Array<Maybe<ComponentObjetoEducacionalInfogaficoInfografico>>>;
  RevisaoOrtografica?: Maybe<Scalars['Boolean']>;
  patrocinador?: Maybe<Patrocinador>;
  AutorizacaoDeUso?: Maybe<Enum_Objetoeducacional_Autorizacaodeuso>;
  ValidadeConteudo?: Maybe<Scalars['Date']>;
  Status?: Maybe<Enum_Objetoeducacional_Status>;
  DireitosUsoImagemTerceirosPacientes?: Maybe<ComponentCessaoDeDireitosCessaoDeDireitos>;
  DataProducao?: Maybe<Scalars['Date']>;
  DataAtualizacaoProducao?: Maybe<Scalars['Date']>;
  comentario_drive_insumo?: Maybe<Scalars['String']>;
  uso_imagem_terceiro?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  Autores?: Maybe<Array<Maybe<PerfilDeAutor>>>;
  Quizzes?: Maybe<Array<Maybe<Quizz>>>;
  AreasConhecimento?: Maybe<Array<Maybe<AreaDeConhecimento>>>;
  PublicoAlvo?: Maybe<Array<Maybe<PublicoAlvo>>>;
  Topicos?: Maybe<Array<Maybe<Topico>>>;
  Rotulos?: Maybe<Array<Maybe<Rotulo>>>;
  TipoRecursosEducionais?: Maybe<Array<Maybe<TipoRecursoEducacional>>>;
  NivelDosObjetosDeAprendizagem?: Maybe<Array<Maybe<NivelDosObjetivosDeAprendizagem>>>;
  TipoObjeto?: Maybe<Array<Maybe<TipoOe>>>;
  Curtidores?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  Favoritadores?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  ConsumidoresTotalmente?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  OesAssistidos?: Maybe<Array<Maybe<OEsAssistidosPorUsuario>>>;
  SubAreaConhecimento?: Maybe<Array<Maybe<SubAreaConhecimento>>>;
  Visualizadores?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  ConteudosRelacionados?: Maybe<Array<Maybe<ObjetoEducacional>>>;
  Banners?: Maybe<Array<Maybe<Banner>>>;
  palavras_chave?: Maybe<Array<Maybe<PalavraChave>>>;
  autor_convidados?: Maybe<Array<Maybe<AutorConvidado>>>;
  drive_insumo_objeto_educacionals?: Maybe<Array<Maybe<DriveInsumoObjetoEducacional>>>;
  historico_avaliacao_objeto_educacionals?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacional>>>;
  autor_convidados_v2?: Maybe<Array<AutorConvidadoOe>>;
};


export type ObjetoEducacionalAutoresArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalQuizzesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalAreasConhecimentoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalPublicoAlvoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalTopicosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalRotulosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalTipoRecursosEducionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalNivelDosObjetosDeAprendizagemArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalTipoObjetoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalCurtidoresArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalFavoritadoresArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalConsumidoresTotalmenteArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalOesAssistidosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalSubAreaConhecimentoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalVisualizadoresArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalConteudosRelacionadosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalBannersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalPalavras_ChaveArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalAutor_ConvidadosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalDrive_Insumo_Objeto_EducacionalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ObjetoEducacionalHistorico_Avaliacao_Objeto_EducacionalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ObjetoEducacionalAggregator = {
  __typename?: 'ObjetoEducacionalAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ObjetoEducacionalComentarioDriveInsumo = {
  __typename?: 'ObjetoEducacionalComentarioDriveInsumo';
  id?: Maybe<Scalars['ID']>;
  comentario?: Maybe<Scalars['String']>;
  uso_imagem_terceiro?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type ObjetoEducacionalConnection = {
  __typename?: 'ObjetoEducacionalConnection';
  values?: Maybe<Array<Maybe<ObjetoEducacional>>>;
  groupBy?: Maybe<ObjetoEducacionalGroupBy>;
  aggregate?: Maybe<ObjetoEducacionalAggregator>;
};

export type ObjetoEducacionalConnectionAutorizacaoDeUso = {
  __typename?: 'ObjetoEducacionalConnectionAutorizacaoDeUso';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionComentario_Drive_Insumo = {
  __typename?: 'ObjetoEducacionalConnectionComentario_drive_insumo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionCreated_At = {
  __typename?: 'ObjetoEducacionalConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionDataAtualizacaoProducao = {
  __typename?: 'ObjetoEducacionalConnectionDataAtualizacaoProducao';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionDataProducao = {
  __typename?: 'ObjetoEducacionalConnectionDataProducao';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionDensidadeSemantica = {
  __typename?: 'ObjetoEducacionalConnectionDensidadeSemantica';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionDescricao = {
  __typename?: 'ObjetoEducacionalConnectionDescricao';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionDireitosUsoImagemTerceirosPacientes = {
  __typename?: 'ObjetoEducacionalConnectionDireitosUsoImagemTerceirosPacientes';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionGranularidade = {
  __typename?: 'ObjetoEducacionalConnectionGranularidade';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionId = {
  __typename?: 'ObjetoEducacionalConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionIdioma = {
  __typename?: 'ObjetoEducacionalConnectionIdioma';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionImagemCapa = {
  __typename?: 'ObjetoEducacionalConnectionImagemCapa';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionImagemPreview = {
  __typename?: 'ObjetoEducacionalConnectionImagemPreview';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionMaturidadePublicoAlvo = {
  __typename?: 'ObjetoEducacionalConnectionMaturidadePublicoAlvo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionModalidadeEnsino = {
  __typename?: 'ObjetoEducacionalConnectionModalidadeEnsino';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionPatrocinador = {
  __typename?: 'ObjetoEducacionalConnectionPatrocinador';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionPossuiCertificado = {
  __typename?: 'ObjetoEducacionalConnectionPossuiCertificado';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionProdutoPrimario = {
  __typename?: 'ObjetoEducacionalConnectionProdutoPrimario';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionPublished_At = {
  __typename?: 'ObjetoEducacionalConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionRestricaoPublicoMedico = {
  __typename?: 'ObjetoEducacionalConnectionRestricaoPublicoMedico';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionResumo = {
  __typename?: 'ObjetoEducacionalConnectionResumo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionRevisaoOrtografica = {
  __typename?: 'ObjetoEducacionalConnectionRevisaoOrtografica';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionStatus = {
  __typename?: 'ObjetoEducacionalConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionSubRotulo = {
  __typename?: 'ObjetoEducacionalConnectionSubRotulo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionTempoMedioDuracao = {
  __typename?: 'ObjetoEducacionalConnectionTempoMedioDuracao';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionTipoInteratividade = {
  __typename?: 'ObjetoEducacionalConnectionTipoInteratividade';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionTitulo = {
  __typename?: 'ObjetoEducacionalConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionUpdated_At = {
  __typename?: 'ObjetoEducacionalConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionUso_Imagem_Terceiro = {
  __typename?: 'ObjetoEducacionalConnectionUso_imagem_terceiro';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalConnectionValidadeConteudo = {
  __typename?: 'ObjetoEducacionalConnectionValidadeConteudo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjetoEducacionalConnection>;
};

export type ObjetoEducacionalGroupBy = {
  __typename?: 'ObjetoEducacionalGroupBy';
  id?: Maybe<Array<Maybe<ObjetoEducacionalConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ObjetoEducacionalConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ObjetoEducacionalConnectionUpdated_At>>>;
  Titulo?: Maybe<Array<Maybe<ObjetoEducacionalConnectionTitulo>>>;
  Idioma?: Maybe<Array<Maybe<ObjetoEducacionalConnectionIdioma>>>;
  RestricaoPublicoMedico?: Maybe<Array<Maybe<ObjetoEducacionalConnectionRestricaoPublicoMedico>>>;
  ImagemCapa?: Maybe<Array<Maybe<ObjetoEducacionalConnectionImagemCapa>>>;
  ImagemPreview?: Maybe<Array<Maybe<ObjetoEducacionalConnectionImagemPreview>>>;
  Descricao?: Maybe<Array<Maybe<ObjetoEducacionalConnectionDescricao>>>;
  Resumo?: Maybe<Array<Maybe<ObjetoEducacionalConnectionResumo>>>;
  MaturidadePublicoAlvo?: Maybe<Array<Maybe<ObjetoEducacionalConnectionMaturidadePublicoAlvo>>>;
  Granularidade?: Maybe<Array<Maybe<ObjetoEducacionalConnectionGranularidade>>>;
  DensidadeSemantica?: Maybe<Array<Maybe<ObjetoEducacionalConnectionDensidadeSemantica>>>;
  TipoInteratividade?: Maybe<Array<Maybe<ObjetoEducacionalConnectionTipoInteratividade>>>;
  ProdutoPrimario?: Maybe<Array<Maybe<ObjetoEducacionalConnectionProdutoPrimario>>>;
  ModalidadeEnsino?: Maybe<Array<Maybe<ObjetoEducacionalConnectionModalidadeEnsino>>>;
  TempoMedioDuracao?: Maybe<Array<Maybe<ObjetoEducacionalConnectionTempoMedioDuracao>>>;
  PossuiCertificado?: Maybe<Array<Maybe<ObjetoEducacionalConnectionPossuiCertificado>>>;
  SubRotulo?: Maybe<Array<Maybe<ObjetoEducacionalConnectionSubRotulo>>>;
  RevisaoOrtografica?: Maybe<Array<Maybe<ObjetoEducacionalConnectionRevisaoOrtografica>>>;
  patrocinador?: Maybe<Array<Maybe<ObjetoEducacionalConnectionPatrocinador>>>;
  AutorizacaoDeUso?: Maybe<Array<Maybe<ObjetoEducacionalConnectionAutorizacaoDeUso>>>;
  ValidadeConteudo?: Maybe<Array<Maybe<ObjetoEducacionalConnectionValidadeConteudo>>>;
  Status?: Maybe<Array<Maybe<ObjetoEducacionalConnectionStatus>>>;
  DireitosUsoImagemTerceirosPacientes?: Maybe<Array<Maybe<ObjetoEducacionalConnectionDireitosUsoImagemTerceirosPacientes>>>;
  DataProducao?: Maybe<Array<Maybe<ObjetoEducacionalConnectionDataProducao>>>;
  DataAtualizacaoProducao?: Maybe<Array<Maybe<ObjetoEducacionalConnectionDataAtualizacaoProducao>>>;
  comentario_drive_insumo?: Maybe<Array<Maybe<ObjetoEducacionalConnectionComentario_Drive_Insumo>>>;
  uso_imagem_terceiro?: Maybe<Array<Maybe<ObjetoEducacionalConnectionUso_Imagem_Terceiro>>>;
  published_at?: Maybe<Array<Maybe<ObjetoEducacionalConnectionPublished_At>>>;
};

export type ObjetoEducacionalImage = {
  __typename?: 'ObjetoEducacionalImage';
  url?: Maybe<Scalars['String']>;
};

export type ObjetoEducacionalInput = {
  Autores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Titulo: Scalars['String'];
  Quizzes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  AreasConhecimento?: Maybe<Array<Maybe<Scalars['ID']>>>;
  PublicoAlvo?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Idioma?: Maybe<Scalars['ID']>;
  RestricaoPublicoMedico?: Maybe<Scalars['Boolean']>;
  Topicos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Rotulos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  TipoRecursosEducionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ImagemCapa?: Maybe<Scalars['ID']>;
  ImagemPreview?: Maybe<Scalars['ID']>;
  Descricao: Scalars['String'];
  Resumo: Scalars['String'];
  MaturidadePublicoAlvo?: Maybe<Scalars['ID']>;
  Granularidade?: Maybe<Scalars['ID']>;
  DensidadeSemantica?: Maybe<Scalars['ID']>;
  TipoInteratividade?: Maybe<Scalars['ID']>;
  NivelDosObjetosDeAprendizagem?: Maybe<Array<Maybe<Scalars['ID']>>>;
  SecoesTexto?: Maybe<Array<Maybe<ComponentSecaoTextSecaoTextoInput>>>;
  VideoAudio?: Maybe<Array<Maybe<ComponentSecaoVideoAudioVideoAudioInput>>>;
  TipoObjeto?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Curtidores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Favoritadores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ConsumidoresTotalmente?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ProdutoPrimario?: Maybe<Scalars['ID']>;
  ModalidadeEnsino?: Maybe<Scalars['ID']>;
  OesAssistidos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  TempoMedioDuracao: Scalars['String'];
  PossuiCertificado?: Maybe<Scalars['Boolean']>;
  SubRotulo?: Maybe<Scalars['ID']>;
  Infografico?: Maybe<Array<Maybe<ComponentObjetoEducacionalInfogaficoInfograficoInput>>>;
  SubAreaConhecimento?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Visualizadores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ConteudosRelacionados?: Maybe<Array<Maybe<Scalars['ID']>>>;
  RevisaoOrtografica?: Maybe<Scalars['Boolean']>;
  Banners?: Maybe<Array<Maybe<Scalars['ID']>>>;
  patrocinador?: Maybe<Scalars['ID']>;
  AutorizacaoDeUso?: Maybe<Enum_Objetoeducacional_Autorizacaodeuso>;
  ValidadeConteudo?: Maybe<Scalars['Date']>;
  Status?: Maybe<Enum_Objetoeducacional_Status>;
  DireitosUsoImagemTerceirosPacientes?: Maybe<ComponentCessaoDeDireitosCessaoDeDireitoInput>;
  DataProducao?: Maybe<Scalars['Date']>;
  DataAtualizacaoProducao?: Maybe<Scalars['Date']>;
  palavras_chave?: Maybe<Array<Maybe<Scalars['ID']>>>;
  autor_convidados?: Maybe<Array<Maybe<Scalars['ID']>>>;
  drive_insumo_objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  comentario_drive_insumo?: Maybe<Scalars['String']>;
  historico_avaliacao_objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  uso_imagem_terceiro?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ObjetoEducacionalSearch = {
  __typename?: 'ObjetoEducacionalSearch';
  id?: Maybe<Scalars['ID']>;
  titulo?: Maybe<Scalars['String']>;
  data_atualizacao_producao?: Maybe<Scalars['String']>;
  areas_de_conhecimento?: Maybe<Array<Maybe<EntityRelation>>>;
  rotulos?: Maybe<Array<Maybe<EntityRelation>>>;
  tipos?: Maybe<Array<Maybe<EntityRelation>>>;
  palavras_chave?: Maybe<Array<Maybe<EntityRelation>>>;
  imagem_capa?: Maybe<ObjetoEducacionalImage>;
  imagem_preview?: Maybe<ObjetoEducacionalImage>;
  visualizadores?: Maybe<Array<UserObjetoEducacional>>;
  curtidores?: Maybe<Array<UserObjetoEducacional>>;
  favoritadores?: Maybe<Array<UserObjetoEducacional>>;
};

export type ObjetoEducacionalWithHistoricoAvaliacaoConnection = {
  __typename?: 'ObjetoEducacionalWithHistoricoAvaliacaoConnection';
  total: Scalars['Int'];
  totalCount: Scalars['Int'];
  data?: Maybe<Array<ObjetoEducacionalWithHistoricoAvaliacaoData>>;
  error?: Maybe<Scalars['String']>;
};

export type ObjetoEducacionalWithHistoricoAvaliacaoData = {
  __typename?: 'ObjetoEducacionalWithHistoricoAvaliacaoData';
  id?: Maybe<Scalars['ID']>;
  titulo?: Maybe<Scalars['String']>;
  categoria?: Maybe<Scalars['String']>;
  tipo?: Maybe<Scalars['String']>;
  data_criacao?: Maybe<Scalars['DateTime']>;
  data_validade?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  expirado?: Maybe<Scalars['Boolean']>;
};

export type ObjetoEducacionalWithHistoricoAvaliacaoInput = {
  status?: Maybe<Array<Scalars['ID']>>;
  categorias?: Maybe<Array<Scalars['ID']>>;
  isExpired: Scalars['Boolean'];
  keyWord?: Maybe<Scalars['String']>;
};

export type OeInput = {
  Titulo?: Maybe<Scalars['String']>;
  Rotulo?: Maybe<Enum_Oes_Rotulo>;
  SubRotulo?: Maybe<Enum_Oes_Subrotulo>;
  componentes_auxiliares?: Maybe<Array<Scalars['OesComponentesAuxiliaresDynamicZoneInput']>>;
  secao?: Maybe<Enum_Oes_Secao>;
  revisao?: Maybe<Array<Maybe<ComponentTipoAprovacaoEtapasAprovacaoInput>>>;
  metadados_identificacao?: Maybe<ComponentFieldGroupMetadadosIdentificacaoInput>;
  metadados_ciclo_de_vida?: Maybe<ComponentFieldGroupMetadadosCicloDeVidaInput>;
  metadados_educacional?: Maybe<ComponentFieldGroupMetadadosEducacionalInput>;
  metadados_einstein?: Maybe<ComponentFieldGroupMetadadosEinsteinInput>;
  metadados_tecnica?: Maybe<ComponentFieldGroupTecnicaInput>;
  ConteudoRelacionado?: Maybe<Array<Maybe<Scalars['ID']>>>;
  oes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Autores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Oes = {
  __typename?: 'Oes';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Titulo?: Maybe<Scalars['String']>;
  Rotulo?: Maybe<Enum_Oes_Rotulo>;
  SubRotulo?: Maybe<Enum_Oes_Subrotulo>;
  componentes_auxiliares?: Maybe<Array<Maybe<OesComponentesAuxiliaresDynamicZone>>>;
  secao?: Maybe<Enum_Oes_Secao>;
  revisao?: Maybe<Array<Maybe<ComponentTipoAprovacaoEtapasAprovacao>>>;
  metadados_identificacao?: Maybe<ComponentFieldGroupMetadadosIdentificacao>;
  metadados_ciclo_de_vida?: Maybe<ComponentFieldGroupMetadadosCicloDeVida>;
  metadados_educacional?: Maybe<ComponentFieldGroupMetadadosEducacional>;
  metadados_einstein?: Maybe<ComponentFieldGroupMetadadosEinstein>;
  metadados_tecnica?: Maybe<ComponentFieldGroupTecnica>;
  published_at?: Maybe<Scalars['DateTime']>;
  ConteudoRelacionado?: Maybe<Array<Maybe<Oes>>>;
  oes?: Maybe<Array<Maybe<Oes>>>;
  Autores?: Maybe<Array<Maybe<PerfilDeAutor>>>;
};


export type OesConteudoRelacionadoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type OesOesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type OesAutoresArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type OesAggregator = {
  __typename?: 'OesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OesComponentesAuxiliaresDynamicZone = ComponentVideoVideo | ComponentAudioAudio | ComponentImagemImagem | ComponentTextoTexto | ComponentQuizzesQuiz;


export type OesConnection = {
  __typename?: 'OesConnection';
  values?: Maybe<Array<Maybe<Oes>>>;
  groupBy?: Maybe<OesGroupBy>;
  aggregate?: Maybe<OesAggregator>;
};

export type OesConnectionCreated_At = {
  __typename?: 'OesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionId = {
  __typename?: 'OesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionMetadados_Ciclo_De_Vida = {
  __typename?: 'OesConnectionMetadados_ciclo_de_vida';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionMetadados_Educacional = {
  __typename?: 'OesConnectionMetadados_educacional';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionMetadados_Einstein = {
  __typename?: 'OesConnectionMetadados_einstein';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionMetadados_Identificacao = {
  __typename?: 'OesConnectionMetadados_identificacao';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionMetadados_Tecnica = {
  __typename?: 'OesConnectionMetadados_tecnica';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionPublished_At = {
  __typename?: 'OesConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionRotulo = {
  __typename?: 'OesConnectionRotulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionSecao = {
  __typename?: 'OesConnectionSecao';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionSubRotulo = {
  __typename?: 'OesConnectionSubRotulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionTitulo = {
  __typename?: 'OesConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OesConnection>;
};

export type OesConnectionUpdated_At = {
  __typename?: 'OesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OesConnection>;
};

export type OesGroupBy = {
  __typename?: 'OesGroupBy';
  id?: Maybe<Array<Maybe<OesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<OesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<OesConnectionUpdated_At>>>;
  Titulo?: Maybe<Array<Maybe<OesConnectionTitulo>>>;
  Rotulo?: Maybe<Array<Maybe<OesConnectionRotulo>>>;
  SubRotulo?: Maybe<Array<Maybe<OesConnectionSubRotulo>>>;
  secao?: Maybe<Array<Maybe<OesConnectionSecao>>>;
  metadados_identificacao?: Maybe<Array<Maybe<OesConnectionMetadados_Identificacao>>>;
  metadados_ciclo_de_vida?: Maybe<Array<Maybe<OesConnectionMetadados_Ciclo_De_Vida>>>;
  metadados_educacional?: Maybe<Array<Maybe<OesConnectionMetadados_Educacional>>>;
  metadados_einstein?: Maybe<Array<Maybe<OesConnectionMetadados_Einstein>>>;
  metadados_tecnica?: Maybe<Array<Maybe<OesConnectionMetadados_Tecnica>>>;
  published_at?: Maybe<Array<Maybe<OesConnectionPublished_At>>>;
};

export type PaginaAtendimento = {
  __typename?: 'PaginaAtendimento';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo: Scalars['String'];
  descricao: Scalars['String'];
  lista_telefones_atendimento?: Maybe<Array<Maybe<ComponentRodapeRedeSocialListaTelefonesAtendimento>>>;
  lista_horarios_atendimento?: Maybe<Array<Maybe<ComponentListaHorariosAtendimentoListaHorariosAtendimento>>>;
  lista_emails_atendimento?: Maybe<Array<Maybe<ComponentListaEmailsAtendimentoListaEmailsAtendimento>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  tipo_atendimentos?: Maybe<Array<Maybe<TipoAtendimento>>>;
};


export type PaginaAtendimentoTipo_AtendimentosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PaginaAtendimentoInput = {
  titulo: Scalars['String'];
  descricao: Scalars['String'];
  lista_telefones_atendimento?: Maybe<Array<Maybe<ComponentRodapeRedeSocialListaTelefonesAtendimentoInput>>>;
  lista_horarios_atendimento?: Maybe<Array<Maybe<ComponentListaHorariosAtendimentoListaHorariosAtendimentoInput>>>;
  lista_emails_atendimento?: Maybe<Array<Maybe<ComponentListaEmailsAtendimentoListaEmailsAtendimentoInput>>>;
  tipo_atendimentos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PalavraChave = {
  __typename?: 'PalavraChave';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo: Scalars['String'];
  published_at?: Maybe<Scalars['DateTime']>;
  objeto_educacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type PalavraChaveObjeto_EducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PalavraChaveAggregator = {
  __typename?: 'PalavraChaveAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PalavraChaveConnection = {
  __typename?: 'PalavraChaveConnection';
  values?: Maybe<Array<Maybe<PalavraChave>>>;
  groupBy?: Maybe<PalavraChaveGroupBy>;
  aggregate?: Maybe<PalavraChaveAggregator>;
};

export type PalavraChaveConnectionCreated_At = {
  __typename?: 'PalavraChaveConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PalavraChaveConnection>;
};

export type PalavraChaveConnectionId = {
  __typename?: 'PalavraChaveConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PalavraChaveConnection>;
};

export type PalavraChaveConnectionPublished_At = {
  __typename?: 'PalavraChaveConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PalavraChaveConnection>;
};

export type PalavraChaveConnectionTitulo = {
  __typename?: 'PalavraChaveConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PalavraChaveConnection>;
};

export type PalavraChaveConnectionUpdated_At = {
  __typename?: 'PalavraChaveConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PalavraChaveConnection>;
};

export type PalavraChaveGroupBy = {
  __typename?: 'PalavraChaveGroupBy';
  id?: Maybe<Array<Maybe<PalavraChaveConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PalavraChaveConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PalavraChaveConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<PalavraChaveConnectionTitulo>>>;
  published_at?: Maybe<Array<Maybe<PalavraChaveConnectionPublished_At>>>;
};

export type PalavraChaveInput = {
  titulo: Scalars['String'];
  objeto_educacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PalavraChaveOe = {
  __typename?: 'PalavraChaveOE';
  id: Scalars['ID'];
  titulo: Scalars['String'];
};

export type Patrocinador = {
  __typename?: 'Patrocinador';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo: Scalars['String'];
  logo?: Maybe<UploadFile>;
  categoria_patrocinador?: Maybe<CategoriaPatrocinador>;
  thumbnail?: Maybe<UploadFile>;
  published_at?: Maybe<Scalars['DateTime']>;
  objeto_educacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
  banners?: Maybe<Array<Maybe<Banner>>>;
};


export type PatrocinadorObjeto_EducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type PatrocinadorBannersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PatrocinadorAggregator = {
  __typename?: 'PatrocinadorAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PatrocinadorConnection = {
  __typename?: 'PatrocinadorConnection';
  values?: Maybe<Array<Maybe<Patrocinador>>>;
  groupBy?: Maybe<PatrocinadorGroupBy>;
  aggregate?: Maybe<PatrocinadorAggregator>;
};

export type PatrocinadorConnectionCategoria_Patrocinador = {
  __typename?: 'PatrocinadorConnectionCategoria_patrocinador';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PatrocinadorConnection>;
};

export type PatrocinadorConnectionCreated_At = {
  __typename?: 'PatrocinadorConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PatrocinadorConnection>;
};

export type PatrocinadorConnectionId = {
  __typename?: 'PatrocinadorConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PatrocinadorConnection>;
};

export type PatrocinadorConnectionLogo = {
  __typename?: 'PatrocinadorConnectionLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PatrocinadorConnection>;
};

export type PatrocinadorConnectionPublished_At = {
  __typename?: 'PatrocinadorConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PatrocinadorConnection>;
};

export type PatrocinadorConnectionThumbnail = {
  __typename?: 'PatrocinadorConnectionThumbnail';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PatrocinadorConnection>;
};

export type PatrocinadorConnectionTitulo = {
  __typename?: 'PatrocinadorConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PatrocinadorConnection>;
};

export type PatrocinadorConnectionUpdated_At = {
  __typename?: 'PatrocinadorConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PatrocinadorConnection>;
};

export type PatrocinadorGroupBy = {
  __typename?: 'PatrocinadorGroupBy';
  id?: Maybe<Array<Maybe<PatrocinadorConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PatrocinadorConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PatrocinadorConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<PatrocinadorConnectionTitulo>>>;
  logo?: Maybe<Array<Maybe<PatrocinadorConnectionLogo>>>;
  categoria_patrocinador?: Maybe<Array<Maybe<PatrocinadorConnectionCategoria_Patrocinador>>>;
  thumbnail?: Maybe<Array<Maybe<PatrocinadorConnectionThumbnail>>>;
  published_at?: Maybe<Array<Maybe<PatrocinadorConnectionPublished_At>>>;
};

export type PatrocinadorInput = {
  titulo: Scalars['String'];
  logo?: Maybe<Scalars['ID']>;
  categoria_patrocinador?: Maybe<Scalars['ID']>;
  objeto_educacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  banners?: Maybe<Array<Maybe<Scalars['ID']>>>;
  thumbnail?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PerfilDeAutor = {
  __typename?: 'PerfilDeAutor';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  nome_completo: Scalars['String'];
  nome_exibicao: Scalars['String'];
  data_nascimento?: Maybe<Scalars['Date']>;
  CPF?: Maybe<Scalars['String']>;
  nacionalidade?: Maybe<Scalars['String']>;
  estado_civil?: Maybe<EstadoCivil>;
  CEP?: Maybe<Scalars['String']>;
  endereco?: Maybe<Scalars['String']>;
  numero?: Maybe<Scalars['String']>;
  cidade?: Maybe<Scalars['String']>;
  UF?: Maybe<Scalars['String']>;
  Telefone?: Maybe<Scalars['String']>;
  profissao?: Maybe<Profissao>;
  profissao_tecnico?: Maybe<ProfissaoTecnico>;
  outro_qual?: Maybe<Scalars['String']>;
  CRM?: Maybe<Scalars['String']>;
  areas_conhecimento?: Maybe<Array<Maybe<ComponentFieldGroupSeletorAreaDeConhecimento>>>;
  foto?: Maybe<UploadFile>;
  cargo?: Maybe<Scalars['String']>;
  link_do_curriculo?: Maybe<Scalars['String']>;
  autoriza_divulgacao_link?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  autoriza_divulgacao_email?: Maybe<Scalars['Boolean']>;
  termo_cessao_direito?: Maybe<Scalars['String']>;
  Autoriza_termo_direito?: Maybe<Scalars['Boolean']>;
  data_termo?: Maybe<Scalars['DateTime']>;
  nome_projeto?: Maybe<Scalars['String']>;
  link_projeto?: Maybe<Scalars['String']>;
  users_permissions_user?: Maybe<UsersPermissionsUser>;
  Publicacoes?: Maybe<Array<Maybe<ObjetoEducacional>>>;
  Seguidores?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  drive_insumo_objeto_educacionals?: Maybe<Array<Maybe<DriveInsumoObjetoEducacional>>>;
};


export type PerfilDeAutorPublicacoesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type PerfilDeAutorSeguidoresArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type PerfilDeAutorDrive_Insumo_Objeto_EducacionalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PerfilDeAutorAggregator = {
  __typename?: 'PerfilDeAutorAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PerfilDeAutorConnection = {
  __typename?: 'PerfilDeAutorConnection';
  values?: Maybe<Array<Maybe<PerfilDeAutor>>>;
  groupBy?: Maybe<PerfilDeAutorGroupBy>;
  aggregate?: Maybe<PerfilDeAutorAggregator>;
};

export type PerfilDeAutorConnectionAutoriza_Divulgacao_Email = {
  __typename?: 'PerfilDeAutorConnectionAutoriza_divulgacao_email';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionAutoriza_Divulgacao_Link = {
  __typename?: 'PerfilDeAutorConnectionAutoriza_divulgacao_link';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionAutoriza_Termo_Direito = {
  __typename?: 'PerfilDeAutorConnectionAutoriza_termo_direito';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionCep = {
  __typename?: 'PerfilDeAutorConnectionCEP';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionCpf = {
  __typename?: 'PerfilDeAutorConnectionCPF';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionCrm = {
  __typename?: 'PerfilDeAutorConnectionCRM';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionCargo = {
  __typename?: 'PerfilDeAutorConnectionCargo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionCidade = {
  __typename?: 'PerfilDeAutorConnectionCidade';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionCreated_At = {
  __typename?: 'PerfilDeAutorConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionData_Nascimento = {
  __typename?: 'PerfilDeAutorConnectionData_nascimento';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionData_Termo = {
  __typename?: 'PerfilDeAutorConnectionData_termo';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionEmail = {
  __typename?: 'PerfilDeAutorConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionEndereco = {
  __typename?: 'PerfilDeAutorConnectionEndereco';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionEstado_Civil = {
  __typename?: 'PerfilDeAutorConnectionEstado_civil';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionFoto = {
  __typename?: 'PerfilDeAutorConnectionFoto';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionId = {
  __typename?: 'PerfilDeAutorConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionLink_Do_Curriculo = {
  __typename?: 'PerfilDeAutorConnectionLink_do_curriculo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionLink_Projeto = {
  __typename?: 'PerfilDeAutorConnectionLink_projeto';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionNacionalidade = {
  __typename?: 'PerfilDeAutorConnectionNacionalidade';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionNome_Completo = {
  __typename?: 'PerfilDeAutorConnectionNome_completo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionNome_Exibicao = {
  __typename?: 'PerfilDeAutorConnectionNome_exibicao';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionNome_Projeto = {
  __typename?: 'PerfilDeAutorConnectionNome_projeto';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionNumero = {
  __typename?: 'PerfilDeAutorConnectionNumero';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionOutro_Qual = {
  __typename?: 'PerfilDeAutorConnectionOutro_qual';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionProfissao = {
  __typename?: 'PerfilDeAutorConnectionProfissao';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionProfissao_Tecnico = {
  __typename?: 'PerfilDeAutorConnectionProfissao_tecnico';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionTelefone = {
  __typename?: 'PerfilDeAutorConnectionTelefone';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionTermo_Cessao_Direito = {
  __typename?: 'PerfilDeAutorConnectionTermo_cessao_direito';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionUf = {
  __typename?: 'PerfilDeAutorConnectionUF';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionUpdated_At = {
  __typename?: 'PerfilDeAutorConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorConnectionUsers_Permissions_User = {
  __typename?: 'PerfilDeAutorConnectionUsers_permissions_user';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PerfilDeAutorConnection>;
};

export type PerfilDeAutorGroupBy = {
  __typename?: 'PerfilDeAutorGroupBy';
  id?: Maybe<Array<Maybe<PerfilDeAutorConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PerfilDeAutorConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PerfilDeAutorConnectionUpdated_At>>>;
  nome_completo?: Maybe<Array<Maybe<PerfilDeAutorConnectionNome_Completo>>>;
  nome_exibicao?: Maybe<Array<Maybe<PerfilDeAutorConnectionNome_Exibicao>>>;
  data_nascimento?: Maybe<Array<Maybe<PerfilDeAutorConnectionData_Nascimento>>>;
  CPF?: Maybe<Array<Maybe<PerfilDeAutorConnectionCpf>>>;
  nacionalidade?: Maybe<Array<Maybe<PerfilDeAutorConnectionNacionalidade>>>;
  estado_civil?: Maybe<Array<Maybe<PerfilDeAutorConnectionEstado_Civil>>>;
  CEP?: Maybe<Array<Maybe<PerfilDeAutorConnectionCep>>>;
  endereco?: Maybe<Array<Maybe<PerfilDeAutorConnectionEndereco>>>;
  numero?: Maybe<Array<Maybe<PerfilDeAutorConnectionNumero>>>;
  cidade?: Maybe<Array<Maybe<PerfilDeAutorConnectionCidade>>>;
  UF?: Maybe<Array<Maybe<PerfilDeAutorConnectionUf>>>;
  Telefone?: Maybe<Array<Maybe<PerfilDeAutorConnectionTelefone>>>;
  profissao?: Maybe<Array<Maybe<PerfilDeAutorConnectionProfissao>>>;
  profissao_tecnico?: Maybe<Array<Maybe<PerfilDeAutorConnectionProfissao_Tecnico>>>;
  outro_qual?: Maybe<Array<Maybe<PerfilDeAutorConnectionOutro_Qual>>>;
  CRM?: Maybe<Array<Maybe<PerfilDeAutorConnectionCrm>>>;
  foto?: Maybe<Array<Maybe<PerfilDeAutorConnectionFoto>>>;
  cargo?: Maybe<Array<Maybe<PerfilDeAutorConnectionCargo>>>;
  link_do_curriculo?: Maybe<Array<Maybe<PerfilDeAutorConnectionLink_Do_Curriculo>>>;
  autoriza_divulgacao_link?: Maybe<Array<Maybe<PerfilDeAutorConnectionAutoriza_Divulgacao_Link>>>;
  email?: Maybe<Array<Maybe<PerfilDeAutorConnectionEmail>>>;
  autoriza_divulgacao_email?: Maybe<Array<Maybe<PerfilDeAutorConnectionAutoriza_Divulgacao_Email>>>;
  termo_cessao_direito?: Maybe<Array<Maybe<PerfilDeAutorConnectionTermo_Cessao_Direito>>>;
  Autoriza_termo_direito?: Maybe<Array<Maybe<PerfilDeAutorConnectionAutoriza_Termo_Direito>>>;
  data_termo?: Maybe<Array<Maybe<PerfilDeAutorConnectionData_Termo>>>;
  nome_projeto?: Maybe<Array<Maybe<PerfilDeAutorConnectionNome_Projeto>>>;
  link_projeto?: Maybe<Array<Maybe<PerfilDeAutorConnectionLink_Projeto>>>;
  users_permissions_user?: Maybe<Array<Maybe<PerfilDeAutorConnectionUsers_Permissions_User>>>;
};

export type PerfilDeAutorInput = {
  nome_completo: Scalars['String'];
  nome_exibicao: Scalars['String'];
  data_nascimento?: Maybe<Scalars['Date']>;
  CPF?: Maybe<Scalars['String']>;
  nacionalidade?: Maybe<Scalars['String']>;
  estado_civil?: Maybe<Scalars['ID']>;
  CEP?: Maybe<Scalars['String']>;
  endereco?: Maybe<Scalars['String']>;
  numero?: Maybe<Scalars['String']>;
  cidade?: Maybe<Scalars['String']>;
  UF?: Maybe<Scalars['String']>;
  Telefone?: Maybe<Scalars['String']>;
  profissao?: Maybe<Scalars['ID']>;
  profissao_tecnico?: Maybe<Scalars['ID']>;
  outro_qual?: Maybe<Scalars['String']>;
  CRM?: Maybe<Scalars['String']>;
  areas_conhecimento?: Maybe<Array<Maybe<ComponentFieldGroupSeletorAreaDeConhecimentoInput>>>;
  foto?: Maybe<Scalars['ID']>;
  cargo?: Maybe<Scalars['String']>;
  link_do_curriculo?: Maybe<Scalars['String']>;
  autoriza_divulgacao_link?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  autoriza_divulgacao_email?: Maybe<Scalars['Boolean']>;
  termo_cessao_direito?: Maybe<Scalars['String']>;
  Autoriza_termo_direito?: Maybe<Scalars['Boolean']>;
  data_termo?: Maybe<Scalars['DateTime']>;
  Publicacoes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Seguidores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  nome_projeto?: Maybe<Scalars['String']>;
  link_projeto?: Maybe<Scalars['String']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
  drive_insumo_objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PerguntaQuizz = {
  __typename?: 'PerguntaQuizz';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  enunciado: Scalars['String'];
  imagem?: Maybe<UploadFile>;
  feedback_acerto?: Maybe<Scalars['String']>;
  feedback_erro?: Maybe<Scalars['String']>;
  duracao?: Maybe<Scalars['Float']>;
  respostas?: Maybe<Array<Maybe<ComponentPerguntaOpcaoRespostas>>>;
  url_vimeo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type PerguntaQuizzAggregator = {
  __typename?: 'PerguntaQuizzAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<PerguntaQuizzAggregatorSum>;
  avg?: Maybe<PerguntaQuizzAggregatorAvg>;
  min?: Maybe<PerguntaQuizzAggregatorMin>;
  max?: Maybe<PerguntaQuizzAggregatorMax>;
};

export type PerguntaQuizzAggregatorAvg = {
  __typename?: 'PerguntaQuizzAggregatorAvg';
  duracao?: Maybe<Scalars['Float']>;
};

export type PerguntaQuizzAggregatorMax = {
  __typename?: 'PerguntaQuizzAggregatorMax';
  duracao?: Maybe<Scalars['Float']>;
};

export type PerguntaQuizzAggregatorMin = {
  __typename?: 'PerguntaQuizzAggregatorMin';
  duracao?: Maybe<Scalars['Float']>;
};

export type PerguntaQuizzAggregatorSum = {
  __typename?: 'PerguntaQuizzAggregatorSum';
  duracao?: Maybe<Scalars['Float']>;
};

export type PerguntaQuizzConnection = {
  __typename?: 'PerguntaQuizzConnection';
  values?: Maybe<Array<Maybe<PerguntaQuizz>>>;
  groupBy?: Maybe<PerguntaQuizzGroupBy>;
  aggregate?: Maybe<PerguntaQuizzAggregator>;
};

export type PerguntaQuizzConnectionCreated_At = {
  __typename?: 'PerguntaQuizzConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PerguntaQuizzConnection>;
};

export type PerguntaQuizzConnectionDuracao = {
  __typename?: 'PerguntaQuizzConnectionDuracao';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<PerguntaQuizzConnection>;
};

export type PerguntaQuizzConnectionEnunciado = {
  __typename?: 'PerguntaQuizzConnectionEnunciado';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerguntaQuizzConnection>;
};

export type PerguntaQuizzConnectionFeedback_Acerto = {
  __typename?: 'PerguntaQuizzConnectionFeedback_acerto';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerguntaQuizzConnection>;
};

export type PerguntaQuizzConnectionFeedback_Erro = {
  __typename?: 'PerguntaQuizzConnectionFeedback_erro';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerguntaQuizzConnection>;
};

export type PerguntaQuizzConnectionId = {
  __typename?: 'PerguntaQuizzConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PerguntaQuizzConnection>;
};

export type PerguntaQuizzConnectionImagem = {
  __typename?: 'PerguntaQuizzConnectionImagem';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PerguntaQuizzConnection>;
};

export type PerguntaQuizzConnectionPublished_At = {
  __typename?: 'PerguntaQuizzConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PerguntaQuizzConnection>;
};

export type PerguntaQuizzConnectionUpdated_At = {
  __typename?: 'PerguntaQuizzConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PerguntaQuizzConnection>;
};

export type PerguntaQuizzConnectionUrl_Vimeo = {
  __typename?: 'PerguntaQuizzConnectionUrl_vimeo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PerguntaQuizzConnection>;
};

export type PerguntaQuizzGroupBy = {
  __typename?: 'PerguntaQuizzGroupBy';
  id?: Maybe<Array<Maybe<PerguntaQuizzConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PerguntaQuizzConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PerguntaQuizzConnectionUpdated_At>>>;
  enunciado?: Maybe<Array<Maybe<PerguntaQuizzConnectionEnunciado>>>;
  imagem?: Maybe<Array<Maybe<PerguntaQuizzConnectionImagem>>>;
  feedback_acerto?: Maybe<Array<Maybe<PerguntaQuizzConnectionFeedback_Acerto>>>;
  feedback_erro?: Maybe<Array<Maybe<PerguntaQuizzConnectionFeedback_Erro>>>;
  duracao?: Maybe<Array<Maybe<PerguntaQuizzConnectionDuracao>>>;
  url_vimeo?: Maybe<Array<Maybe<PerguntaQuizzConnectionUrl_Vimeo>>>;
  published_at?: Maybe<Array<Maybe<PerguntaQuizzConnectionPublished_At>>>;
};

export type PerguntaQuizzInput = {
  enunciado: Scalars['String'];
  imagem?: Maybe<Scalars['ID']>;
  feedback_acerto?: Maybe<Scalars['String']>;
  feedback_erro?: Maybe<Scalars['String']>;
  duracao?: Maybe<Scalars['Float']>;
  respostas?: Maybe<Array<Maybe<ComponentPerguntaOpcaoRespostaInput>>>;
  url_vimeo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ProdutoPrimario = {
  __typename?: 'ProdutoPrimario';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type ProdutoPrimarioObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ProdutoPrimarioAggregator = {
  __typename?: 'ProdutoPrimarioAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProdutoPrimarioConnection = {
  __typename?: 'ProdutoPrimarioConnection';
  values?: Maybe<Array<Maybe<ProdutoPrimario>>>;
  groupBy?: Maybe<ProdutoPrimarioGroupBy>;
  aggregate?: Maybe<ProdutoPrimarioAggregator>;
};

export type ProdutoPrimarioConnectionCreated_At = {
  __typename?: 'ProdutoPrimarioConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProdutoPrimarioConnection>;
};

export type ProdutoPrimarioConnectionId = {
  __typename?: 'ProdutoPrimarioConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProdutoPrimarioConnection>;
};

export type ProdutoPrimarioConnectionTitulo = {
  __typename?: 'ProdutoPrimarioConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProdutoPrimarioConnection>;
};

export type ProdutoPrimarioConnectionUpdated_At = {
  __typename?: 'ProdutoPrimarioConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProdutoPrimarioConnection>;
};

export type ProdutoPrimarioGroupBy = {
  __typename?: 'ProdutoPrimarioGroupBy';
  id?: Maybe<Array<Maybe<ProdutoPrimarioConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProdutoPrimarioConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProdutoPrimarioConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<ProdutoPrimarioConnectionTitulo>>>;
};

export type ProdutoPrimarioInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Profissao = {
  __typename?: 'Profissao';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  PossuiCRM?: Maybe<Scalars['Boolean']>;
  profissaoPai?: Maybe<Profissao>;
  ehEstudante?: Maybe<Scalars['Boolean']>;
  ehTecnicoAuxiliar?: Maybe<Scalars['Boolean']>;
  ehOutro?: Maybe<Scalars['Boolean']>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  profissaos?: Maybe<Array<Maybe<Profissao>>>;
  userProfissaoFilha?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type ProfissaoUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProfissaoProfissaosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProfissaoUserProfissaoFilhaArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ProfissaoAggregator = {
  __typename?: 'ProfissaoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProfissaoConnection = {
  __typename?: 'ProfissaoConnection';
  values?: Maybe<Array<Maybe<Profissao>>>;
  groupBy?: Maybe<ProfissaoGroupBy>;
  aggregate?: Maybe<ProfissaoAggregator>;
};

export type ProfissaoConnectionCreated_At = {
  __typename?: 'ProfissaoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProfissaoConnection>;
};

export type ProfissaoConnectionEhEstudante = {
  __typename?: 'ProfissaoConnectionEhEstudante';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProfissaoConnection>;
};

export type ProfissaoConnectionEhOutro = {
  __typename?: 'ProfissaoConnectionEhOutro';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProfissaoConnection>;
};

export type ProfissaoConnectionEhTecnicoAuxiliar = {
  __typename?: 'ProfissaoConnectionEhTecnicoAuxiliar';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProfissaoConnection>;
};

export type ProfissaoConnectionId = {
  __typename?: 'ProfissaoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProfissaoConnection>;
};

export type ProfissaoConnectionPossuiCrm = {
  __typename?: 'ProfissaoConnectionPossuiCRM';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProfissaoConnection>;
};

export type ProfissaoConnectionProfissaoPai = {
  __typename?: 'ProfissaoConnectionProfissaoPai';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProfissaoConnection>;
};

export type ProfissaoConnectionTitulo = {
  __typename?: 'ProfissaoConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProfissaoConnection>;
};

export type ProfissaoConnectionUpdated_At = {
  __typename?: 'ProfissaoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProfissaoConnection>;
};

export type ProfissaoGroupBy = {
  __typename?: 'ProfissaoGroupBy';
  id?: Maybe<Array<Maybe<ProfissaoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProfissaoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProfissaoConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<ProfissaoConnectionTitulo>>>;
  PossuiCRM?: Maybe<Array<Maybe<ProfissaoConnectionPossuiCrm>>>;
  profissaoPai?: Maybe<Array<Maybe<ProfissaoConnectionProfissaoPai>>>;
  ehEstudante?: Maybe<Array<Maybe<ProfissaoConnectionEhEstudante>>>;
  ehTecnicoAuxiliar?: Maybe<Array<Maybe<ProfissaoConnectionEhTecnicoAuxiliar>>>;
  ehOutro?: Maybe<Array<Maybe<ProfissaoConnectionEhOutro>>>;
};

export type ProfissaoInput = {
  titulo?: Maybe<Scalars['String']>;
  PossuiCRM?: Maybe<Scalars['Boolean']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  profissaoPai?: Maybe<Scalars['ID']>;
  profissaos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ehEstudante?: Maybe<Scalars['Boolean']>;
  ehTecnicoAuxiliar?: Maybe<Scalars['Boolean']>;
  userProfissaoFilha?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ehOutro?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ProfissaoTecnico = {
  __typename?: 'ProfissaoTecnico';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
};

export type ProfissaoTecnicoAggregator = {
  __typename?: 'ProfissaoTecnicoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProfissaoTecnicoConnection = {
  __typename?: 'ProfissaoTecnicoConnection';
  values?: Maybe<Array<Maybe<ProfissaoTecnico>>>;
  groupBy?: Maybe<ProfissaoTecnicoGroupBy>;
  aggregate?: Maybe<ProfissaoTecnicoAggregator>;
};

export type ProfissaoTecnicoConnectionCreated_At = {
  __typename?: 'ProfissaoTecnicoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProfissaoTecnicoConnection>;
};

export type ProfissaoTecnicoConnectionId = {
  __typename?: 'ProfissaoTecnicoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProfissaoTecnicoConnection>;
};

export type ProfissaoTecnicoConnectionTitulo = {
  __typename?: 'ProfissaoTecnicoConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProfissaoTecnicoConnection>;
};

export type ProfissaoTecnicoConnectionUpdated_At = {
  __typename?: 'ProfissaoTecnicoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProfissaoTecnicoConnection>;
};

export type ProfissaoTecnicoGroupBy = {
  __typename?: 'ProfissaoTecnicoGroupBy';
  id?: Maybe<Array<Maybe<ProfissaoTecnicoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProfissaoTecnicoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProfissaoTecnicoConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<ProfissaoTecnicoConnectionTitulo>>>;
};

export type ProfissaoTecnicoInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type PublicoAlvo = {
  __typename?: 'PublicoAlvo';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type PublicoAlvoObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PublicoAlvoAggregator = {
  __typename?: 'PublicoAlvoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PublicoAlvoConnection = {
  __typename?: 'PublicoAlvoConnection';
  values?: Maybe<Array<Maybe<PublicoAlvo>>>;
  groupBy?: Maybe<PublicoAlvoGroupBy>;
  aggregate?: Maybe<PublicoAlvoAggregator>;
};

export type PublicoAlvoConnectionCreated_At = {
  __typename?: 'PublicoAlvoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PublicoAlvoConnection>;
};

export type PublicoAlvoConnectionId = {
  __typename?: 'PublicoAlvoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PublicoAlvoConnection>;
};

export type PublicoAlvoConnectionTitulo = {
  __typename?: 'PublicoAlvoConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PublicoAlvoConnection>;
};

export type PublicoAlvoConnectionUpdated_At = {
  __typename?: 'PublicoAlvoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PublicoAlvoConnection>;
};

export type PublicoAlvoGroupBy = {
  __typename?: 'PublicoAlvoGroupBy';
  id?: Maybe<Array<Maybe<PublicoAlvoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PublicoAlvoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PublicoAlvoConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<PublicoAlvoConnectionTitulo>>>;
};

export type PublicoAlvoInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Query = {
  __typename?: 'Query';
  areaDeConhecimento?: Maybe<AreaDeConhecimento>;
  areaDeConhecimentos?: Maybe<Array<Maybe<AreaDeConhecimento>>>;
  areaDeConhecimentosConnection?: Maybe<AreaDeConhecimentoConnection>;
  areaDeDestaque?: Maybe<AreaDeDestaque>;
  areaDeDestaques?: Maybe<Array<Maybe<AreaDeDestaque>>>;
  areaDeDestaquesConnection?: Maybe<AreaDeDestaqueConnection>;
  autorConvidado?: Maybe<AutorConvidado>;
  autorConvidados?: Maybe<Array<Maybe<AutorConvidado>>>;
  autorConvidadosConnection?: Maybe<AutorConvidadoConnection>;
  autorizacaoDeUso?: Maybe<AutorizacaoDeUso>;
  autorizacaoDeUsos?: Maybe<Array<Maybe<AutorizacaoDeUso>>>;
  autorizacaoDeUsosConnection?: Maybe<AutorizacaoDeUsoConnection>;
  banner?: Maybe<Banner>;
  banners?: Maybe<Array<Maybe<Banner>>>;
  bannersConnection?: Maybe<BannerConnection>;
  categoriaPatrocinador?: Maybe<CategoriaPatrocinador>;
  categoriaPatrocinadors?: Maybe<Array<Maybe<CategoriaPatrocinador>>>;
  categoriaPatrocinadorsConnection?: Maybe<CategoriaPatrocinadorConnection>;
  contato?: Maybe<Contatos>;
  contatos?: Maybe<Array<Maybe<Contatos>>>;
  contatosConnection?: Maybe<ContatosConnection>;
  densidadeSemantica?: Maybe<DensidadeSemantica>;
  densidadeSemanticas?: Maybe<Array<Maybe<DensidadeSemantica>>>;
  densidadeSemanticasConnection?: Maybe<DensidadeSemanticaConnection>;
  descomplicandoCiencia?: Maybe<DescomplicandoCiencia>;
  descomplicandoCiencias?: Maybe<Array<Maybe<DescomplicandoCiencia>>>;
  descomplicandoCienciasConnection?: Maybe<DescomplicandoCienciaConnection>;
  driveInsumoObjetoEducacional?: Maybe<DriveInsumoObjetoEducacional>;
  driveInsumoObjetoEducacionals?: Maybe<Array<Maybe<DriveInsumoObjetoEducacional>>>;
  driveInsumoObjetoEducacionalsConnection?: Maybe<DriveInsumoObjetoEducacionalConnection>;
  ensinoEinsteinPage?: Maybe<EnsinoEinsteinPage>;
  ensinoEinstein?: Maybe<EnsinoEinstein>;
  ensinoEinsteins?: Maybe<Array<Maybe<EnsinoEinstein>>>;
  ensinoEinsteinsConnection?: Maybe<EnsinoEinsteinConnection>;
  estadoCivil?: Maybe<EstadoCivil>;
  estadoCivils?: Maybe<Array<Maybe<EstadoCivil>>>;
  estadoCivilsConnection?: Maybe<EstadoCivilConnection>;
  gestaoFuncionalidade?: Maybe<GestaoFuncionalidade>;
  gestaoFuncionalidades?: Maybe<Array<Maybe<GestaoFuncionalidade>>>;
  gestaoFuncionalidadesConnection?: Maybe<GestaoFuncionalidadeConnection>;
  granularidade?: Maybe<Granularidade>;
  granularidades?: Maybe<Array<Maybe<Granularidade>>>;
  granularidadesConnection?: Maybe<GranularidadeConnection>;
  headerPortal?: Maybe<HeaderPortal>;
  historicoAvaliacaoObjetoEducacional?: Maybe<HistoricoAvaliacaoObjetoEducacional>;
  historicoAvaliacaoObjetoEducacionals?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacional>>>;
  historicoAvaliacaoObjetoEducacionalsConnection?: Maybe<HistoricoAvaliacaoObjetoEducacionalConnection>;
  homeObjetoEducacionalPage?: Maybe<HomeObjetoEducacionalPage>;
  idioma?: Maybe<Idiomas>;
  idiomas?: Maybe<Array<Maybe<Idiomas>>>;
  idiomasConnection?: Maybe<IdiomasConnection>;
  itemMenu?: Maybe<ItemMenu>;
  itemMenus?: Maybe<Array<Maybe<ItemMenu>>>;
  itemMenusConnection?: Maybe<ItemMenuConnection>;
  itemRodape?: Maybe<ItemRodapes>;
  itemRodapes?: Maybe<Array<Maybe<ItemRodapes>>>;
  itemRodapesConnection?: Maybe<ItemRodapesConnection>;
  maturidadePublicoAlvo?: Maybe<MaturidadePublicoAlvo>;
  maturidadePublicoAlvos?: Maybe<Array<Maybe<MaturidadePublicoAlvo>>>;
  maturidadePublicoAlvosConnection?: Maybe<MaturidadePublicoAlvoConnection>;
  modalidadeDeEnsino?: Maybe<ModalidadeDeEnsino>;
  modalidadeDeEnsinos?: Maybe<Array<Maybe<ModalidadeDeEnsino>>>;
  modalidadeDeEnsinosConnection?: Maybe<ModalidadeDeEnsinoConnection>;
  nivelDosObjetivosDeAprendizagem?: Maybe<NivelDosObjetivosDeAprendizagem>;
  nivelDosObjetivosDeAprendizagems?: Maybe<Array<Maybe<NivelDosObjetivosDeAprendizagem>>>;
  nivelDosObjetivosDeAprendizagemsConnection?: Maybe<NivelDosObjetivosDeAprendizagemConnection>;
  oEsAssistidosPorUsuario?: Maybe<OEsAssistidosPorUsuario>;
  oEsAssistidosPorUsuarios?: Maybe<Array<Maybe<OEsAssistidosPorUsuario>>>;
  oEsAssistidosPorUsuariosConnection?: Maybe<OEsAssistidosPorUsuarioConnection>;
  objetoEducacional?: Maybe<ObjetoEducacional>;
  objetoEducacionals?: Maybe<Array<Maybe<ObjetoEducacional>>>;
  objetoEducacionalsConnection?: Maybe<ObjetoEducacionalConnection>;
  oe?: Maybe<Oes>;
  oes?: Maybe<Array<Maybe<Oes>>>;
  oesConnection?: Maybe<OesConnection>;
  paginaAtendimento?: Maybe<PaginaAtendimento>;
  palavraChave?: Maybe<PalavraChave>;
  palavraChaves?: Maybe<Array<Maybe<PalavraChave>>>;
  palavraChavesConnection?: Maybe<PalavraChaveConnection>;
  patrocinador?: Maybe<Patrocinador>;
  patrocinadors?: Maybe<Array<Maybe<Patrocinador>>>;
  patrocinadorsConnection?: Maybe<PatrocinadorConnection>;
  perfilDeAutor?: Maybe<PerfilDeAutor>;
  perfilDeAutors?: Maybe<Array<Maybe<PerfilDeAutor>>>;
  perfilDeAutorsConnection?: Maybe<PerfilDeAutorConnection>;
  perguntaQuizz?: Maybe<PerguntaQuizz>;
  perguntaQuizzes?: Maybe<Array<Maybe<PerguntaQuizz>>>;
  perguntaQuizzesConnection?: Maybe<PerguntaQuizzConnection>;
  produtoPrimario?: Maybe<ProdutoPrimario>;
  produtoPrimarios?: Maybe<Array<Maybe<ProdutoPrimario>>>;
  produtoPrimariosConnection?: Maybe<ProdutoPrimarioConnection>;
  profissaoTecnico?: Maybe<ProfissaoTecnico>;
  profissaoTecnicos?: Maybe<Array<Maybe<ProfissaoTecnico>>>;
  profissaoTecnicosConnection?: Maybe<ProfissaoTecnicoConnection>;
  profissao?: Maybe<Profissao>;
  profissaos?: Maybe<Array<Maybe<Profissao>>>;
  profissaosConnection?: Maybe<ProfissaoConnection>;
  publicoAlvo?: Maybe<PublicoAlvo>;
  publicoAlvos?: Maybe<Array<Maybe<PublicoAlvo>>>;
  publicoAlvosConnection?: Maybe<PublicoAlvoConnection>;
  quizz?: Maybe<Quizz>;
  quizzes?: Maybe<Array<Maybe<Quizz>>>;
  quizzesConnection?: Maybe<QuizzConnection>;
  recuperacaoSenha?: Maybe<RecuperacaoSenha>;
  recuperacaoSenhas?: Maybe<Array<Maybe<RecuperacaoSenha>>>;
  recuperacaoSenhasConnection?: Maybe<RecuperacaoSenhaConnection>;
  rodapePortal?: Maybe<RodapePortal>;
  rota?: Maybe<Rotas>;
  rotas?: Maybe<Array<Maybe<Rotas>>>;
  rotasConnection?: Maybe<RotasConnection>;
  rotulo?: Maybe<Rotulo>;
  rotulos?: Maybe<Array<Maybe<Rotulo>>>;
  rotulosConnection?: Maybe<RotuloConnection>;
  statusDePublicacao?: Maybe<StatusDePublicacao>;
  statusDePublicacaos?: Maybe<Array<Maybe<StatusDePublicacao>>>;
  statusDePublicacaosConnection?: Maybe<StatusDePublicacaoConnection>;
  subAreaConhecimento?: Maybe<SubAreaConhecimento>;
  subAreaConhecimentos?: Maybe<Array<Maybe<SubAreaConhecimento>>>;
  subAreaConhecimentosConnection?: Maybe<SubAreaConhecimentoConnection>;
  subRotulo?: Maybe<SubRotulo>;
  subRotulos?: Maybe<Array<Maybe<SubRotulo>>>;
  subRotulosConnection?: Maybe<SubRotuloConnection>;
  termosDeUso?: Maybe<TermosDeUso>;
  termosDeUsos?: Maybe<Array<Maybe<TermosDeUso>>>;
  termosDeUsosConnection?: Maybe<TermosDeUsoConnection>;
  tipoAreaPagina?: Maybe<TipoAreaPagina>;
  tipoAreaPaginas?: Maybe<Array<Maybe<TipoAreaPagina>>>;
  tipoAreaPaginasConnection?: Maybe<TipoAreaPaginaConnection>;
  tipoAtendimento?: Maybe<TipoAtendimento>;
  tipoAtendimentos?: Maybe<Array<Maybe<TipoAtendimento>>>;
  tipoAtendimentosConnection?: Maybe<TipoAtendimentoConnection>;
  tipoInteratividadeOe?: Maybe<TipoInteratividadeOe>;
  tipoInteratividadeOes?: Maybe<Array<Maybe<TipoInteratividadeOe>>>;
  tipoInteratividadeOesConnection?: Maybe<TipoInteratividadeOeConnection>;
  tipoOe?: Maybe<TipoOe>;
  tipoOes?: Maybe<Array<Maybe<TipoOe>>>;
  tipoOesConnection?: Maybe<TipoOeConnection>;
  tipoPagina?: Maybe<TipoPagina>;
  tipoPaginas?: Maybe<Array<Maybe<TipoPagina>>>;
  tipoPaginasConnection?: Maybe<TipoPaginaConnection>;
  tipoRecursoEducacional?: Maybe<TipoRecursoEducacional>;
  tipoRecursoEducacionals?: Maybe<Array<Maybe<TipoRecursoEducacional>>>;
  tipoRecursoEducacionalsConnection?: Maybe<TipoRecursoEducacionalConnection>;
  tiposRelacionamentosEntreOe?: Maybe<TiposRelacionamentosEntreOe>;
  tiposRelacionamentosEntreOes?: Maybe<Array<Maybe<TiposRelacionamentosEntreOe>>>;
  tiposRelacionamentosEntreOesConnection?: Maybe<TiposRelacionamentosEntreOeConnection>;
  topico?: Maybe<Topico>;
  topicos?: Maybe<Array<Maybe<Topico>>>;
  topicosConnection?: Maybe<TopicoConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  me?: Maybe<UsersPermissionsMe>;
  areasDeConhecimentoByPatrocinador?: Maybe<Array<AreaConhecimentoItem>>;
  findConvitesPendente: ConvitePendentesPayload;
  findAutoresConvidadosByObjetoEducacional?: Maybe<Array<AutorConvidadoOe>>;
  findDriveInsumosByObjetoEducacional?: Maybe<Array<DriveInsumoObjetoEducacional>>;
  findTotalObjetoEducacionalByStatusPublicacaoAndUserRole: TotalPayload;
  findObjetosEducacionaisWithHistoricoAvaliacao: ObjetoEducacionalWithHistoricoAvaliacaoConnection;
  findHistoricoAvaliacaoAtualByOeId: StatusDePublicacao;
  objetosEducacionaisSearch?: Maybe<Array<ObjetoEducacionalSearch>>;
  findTotalObjetosEducacionaisAExpirar: TotalPayload;
  findByKeyWord?: Maybe<Array<KeyWordPayload>>;
  findById?: Maybe<ObjetoEducacional>;
  oesCount: Scalars['Int'];
  findPalavraChavesByOe?: Maybe<Array<Maybe<PalavraChaveOe>>>;
  rotulosByPatrocinador?: Maybe<Array<RotuloItem>>;
  tiposOesByPatrocinador?: Maybe<Array<TipoOeItem>>;
};


export type QueryAreaDeConhecimentoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryAreaDeConhecimentosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryAreaDeConhecimentosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAreaDeDestaqueArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryAreaDeDestaquesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryAreaDeDestaquesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAutorConvidadoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryAutorConvidadosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryAutorConvidadosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAutorizacaoDeUsoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryAutorizacaoDeUsosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryAutorizacaoDeUsosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBannerArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryBannersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryBannersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCategoriaPatrocinadorArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCategoriaPatrocinadorsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCategoriaPatrocinadorsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryContatoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryContatosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryContatosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryDensidadeSemanticaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryDensidadeSemanticasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryDensidadeSemanticasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryDescomplicandoCienciaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryDescomplicandoCienciasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryDescomplicandoCienciasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryDriveInsumoObjetoEducacionalArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryDriveInsumoObjetoEducacionalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryDriveInsumoObjetoEducacionalsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEnsinoEinsteinPageArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryEnsinoEinsteinArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryEnsinoEinsteinsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryEnsinoEinsteinsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEstadoCivilArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryEstadoCivilsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryEstadoCivilsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGestaoFuncionalidadeArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryGestaoFuncionalidadesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGestaoFuncionalidadesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGranularidadeArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryGranularidadesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGranularidadesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryHeaderPortalArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryHistoricoAvaliacaoObjetoEducacionalArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryHistoricoAvaliacaoObjetoEducacionalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryHistoricoAvaliacaoObjetoEducacionalsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryHomeObjetoEducacionalPageArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryIdiomaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryIdiomasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryIdiomasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryItemMenuArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryItemMenusArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryItemMenusConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryItemRodapeArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryItemRodapesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryItemRodapesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryMaturidadePublicoAlvoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryMaturidadePublicoAlvosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryMaturidadePublicoAlvosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryModalidadeDeEnsinoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryModalidadeDeEnsinosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryModalidadeDeEnsinosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNivelDosObjetivosDeAprendizagemArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryNivelDosObjetivosDeAprendizagemsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryNivelDosObjetivosDeAprendizagemsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryOEsAssistidosPorUsuarioArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryOEsAssistidosPorUsuariosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryOEsAssistidosPorUsuariosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryObjetoEducacionalArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryObjetoEducacionalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryObjetoEducacionalsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryOeArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryOesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryOesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPaginaAtendimentoArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryPalavraChaveArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPalavraChavesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPalavraChavesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPatrocinadorArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPatrocinadorsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPatrocinadorsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPerfilDeAutorArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPerfilDeAutorsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPerfilDeAutorsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPerguntaQuizzArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPerguntaQuizzesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPerguntaQuizzesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProdutoPrimarioArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryProdutoPrimariosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryProdutoPrimariosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProfissaoTecnicoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryProfissaoTecnicosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryProfissaoTecnicosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProfissaoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryProfissaosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryProfissaosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPublicoAlvoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPublicoAlvosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPublicoAlvosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryQuizzArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryQuizzesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryQuizzesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRecuperacaoSenhaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRecuperacaoSenhasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRecuperacaoSenhasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRodapePortalArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryRotaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRotasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRotasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRotuloArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRotulosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRotulosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryStatusDePublicacaoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryStatusDePublicacaosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryStatusDePublicacaosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubAreaConhecimentoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerySubAreaConhecimentosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QuerySubAreaConhecimentosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubRotuloArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerySubRotulosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QuerySubRotulosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTermosDeUsoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTermosDeUsosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTermosDeUsosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTipoAreaPaginaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoAreaPaginasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoAreaPaginasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTipoAtendimentoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoAtendimentosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoAtendimentosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTipoInteratividadeOeArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoInteratividadeOesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoInteratividadeOesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTipoOeArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoOesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoOesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTipoPaginaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoPaginasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoPaginasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTipoRecursoEducacionalArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoRecursoEducacionalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTipoRecursoEducacionalsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTiposRelacionamentosEntreOeArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTiposRelacionamentosEntreOesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTiposRelacionamentosEntreOesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTopicoArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTopicosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTopicosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAreasDeConhecimentoByPatrocinadorArgs = {
  patrocinadorId: Scalars['ID'];
};


export type QueryFindConvitesPendenteArgs = {
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFindAutoresConvidadosByObjetoEducacionalArgs = {
  idOe: Scalars['ID'];
};


export type QueryFindDriveInsumosByObjetoEducacionalArgs = {
  idOe: Scalars['ID'];
};


export type QueryFindTotalObjetoEducacionalByStatusPublicacaoAndUserRoleArgs = {
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFindObjetosEducacionaisWithHistoricoAvaliacaoArgs = {
  where: ObjetoEducacionalWithHistoricoAvaliacaoInput;
  order_by?: Maybe<Enum_Objeto_Educacional_With_Historico_Avaliacao_Order_By>;
  start?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryFindHistoricoAvaliacaoAtualByOeIdArgs = {
  id: Scalars['ID'];
};


export type QueryObjetosEducacionaisSearchArgs = {
  start?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  sort?: Maybe<Scalars['String']>;
  whereUser?: Maybe<Scalars['JSON']>;
};


export type QueryFindTotalObjetosEducacionaisAExpirarArgs = {
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFindByKeyWordArgs = {
  where: KeyWordInput;
};


export type QueryFindByIdArgs = {
  id: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};


export type QueryOesCountArgs = {
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFindPalavraChavesByOeArgs = {
  id: Scalars['ID'];
};


export type QueryRotulosByPatrocinadorArgs = {
  patrocinadorId: Scalars['ID'];
};


export type QueryTiposOesByPatrocinadorArgs = {
  patrocinadorId: Scalars['ID'];
};

export type Quizz = {
  __typename?: 'Quizz';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  nome: Scalars['String'];
  feedback: Scalars['String'];
  perguntas?: Maybe<Array<Maybe<QuizzPerguntasDynamicZone>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  UtilizadoEm?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type QuizzUtilizadoEmArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type QuizzAggregator = {
  __typename?: 'QuizzAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type QuizzConnection = {
  __typename?: 'QuizzConnection';
  values?: Maybe<Array<Maybe<Quizz>>>;
  groupBy?: Maybe<QuizzGroupBy>;
  aggregate?: Maybe<QuizzAggregator>;
};

export type QuizzConnectionCreated_At = {
  __typename?: 'QuizzConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<QuizzConnection>;
};

export type QuizzConnectionFeedback = {
  __typename?: 'QuizzConnectionFeedback';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<QuizzConnection>;
};

export type QuizzConnectionId = {
  __typename?: 'QuizzConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<QuizzConnection>;
};

export type QuizzConnectionNome = {
  __typename?: 'QuizzConnectionNome';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<QuizzConnection>;
};

export type QuizzConnectionPublished_At = {
  __typename?: 'QuizzConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<QuizzConnection>;
};

export type QuizzConnectionUpdated_At = {
  __typename?: 'QuizzConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<QuizzConnection>;
};

export type QuizzGroupBy = {
  __typename?: 'QuizzGroupBy';
  id?: Maybe<Array<Maybe<QuizzConnectionId>>>;
  created_at?: Maybe<Array<Maybe<QuizzConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<QuizzConnectionUpdated_At>>>;
  nome?: Maybe<Array<Maybe<QuizzConnectionNome>>>;
  feedback?: Maybe<Array<Maybe<QuizzConnectionFeedback>>>;
  published_at?: Maybe<Array<Maybe<QuizzConnectionPublished_At>>>;
};

export type QuizzInput = {
  nome: Scalars['String'];
  feedback: Scalars['String'];
  perguntas?: Maybe<Array<Scalars['QuizzPerguntasDynamicZoneInput']>>;
  UtilizadoEm?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type QuizzPerguntasDynamicZone = ComponentPerguntaQuizzPergunta;


export type RecuperacaoSenha = {
  __typename?: 'RecuperacaoSenha';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  hash: Scalars['String'];
  Usuario?: Maybe<UsersPermissionsUser>;
  Expiracao: Scalars['DateTime'];
  Utilizado: Scalars['Boolean'];
  canal?: Maybe<Scalars['String']>;
};

export type RecuperacaoSenhaAggregator = {
  __typename?: 'RecuperacaoSenhaAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RecuperacaoSenhaConnection = {
  __typename?: 'RecuperacaoSenhaConnection';
  values?: Maybe<Array<Maybe<RecuperacaoSenha>>>;
  groupBy?: Maybe<RecuperacaoSenhaGroupBy>;
  aggregate?: Maybe<RecuperacaoSenhaAggregator>;
};

export type RecuperacaoSenhaConnectionCanal = {
  __typename?: 'RecuperacaoSenhaConnectionCanal';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RecuperacaoSenhaConnection>;
};

export type RecuperacaoSenhaConnectionCreated_At = {
  __typename?: 'RecuperacaoSenhaConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RecuperacaoSenhaConnection>;
};

export type RecuperacaoSenhaConnectionExpiracao = {
  __typename?: 'RecuperacaoSenhaConnectionExpiracao';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RecuperacaoSenhaConnection>;
};

export type RecuperacaoSenhaConnectionHash = {
  __typename?: 'RecuperacaoSenhaConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RecuperacaoSenhaConnection>;
};

export type RecuperacaoSenhaConnectionId = {
  __typename?: 'RecuperacaoSenhaConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RecuperacaoSenhaConnection>;
};

export type RecuperacaoSenhaConnectionUpdated_At = {
  __typename?: 'RecuperacaoSenhaConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RecuperacaoSenhaConnection>;
};

export type RecuperacaoSenhaConnectionUsuario = {
  __typename?: 'RecuperacaoSenhaConnectionUsuario';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RecuperacaoSenhaConnection>;
};

export type RecuperacaoSenhaConnectionUtilizado = {
  __typename?: 'RecuperacaoSenhaConnectionUtilizado';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<RecuperacaoSenhaConnection>;
};

export type RecuperacaoSenhaGroupBy = {
  __typename?: 'RecuperacaoSenhaGroupBy';
  id?: Maybe<Array<Maybe<RecuperacaoSenhaConnectionId>>>;
  created_at?: Maybe<Array<Maybe<RecuperacaoSenhaConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<RecuperacaoSenhaConnectionUpdated_At>>>;
  hash?: Maybe<Array<Maybe<RecuperacaoSenhaConnectionHash>>>;
  Usuario?: Maybe<Array<Maybe<RecuperacaoSenhaConnectionUsuario>>>;
  Expiracao?: Maybe<Array<Maybe<RecuperacaoSenhaConnectionExpiracao>>>;
  Utilizado?: Maybe<Array<Maybe<RecuperacaoSenhaConnectionUtilizado>>>;
  canal?: Maybe<Array<Maybe<RecuperacaoSenhaConnectionCanal>>>;
};

export type RecuperacaoSenhaInput = {
  hash: Scalars['String'];
  Usuario?: Maybe<Scalars['ID']>;
  Expiracao: Scalars['DateTime'];
  Utilizado?: Maybe<Scalars['Boolean']>;
  canal?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type RodapePortal = {
  __typename?: 'RodapePortal';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  descritivo: Scalars['String'];
  logo?: Maybe<UploadFile>;
  Atendimento?: Maybe<ComponentRodapeAtendimentoAtendimento>;
  RedeSocial?: Maybe<ComponentRodapeRedeSocialRedeSocial>;
  Links?: Maybe<ComponentRodapeLinksLinks>;
};

export type RodapePortalInput = {
  descritivo: Scalars['String'];
  logo?: Maybe<Scalars['ID']>;
  Atendimento?: Maybe<ComponentRodapeAtendimentoAtendimentoInput>;
  RedeSocial?: Maybe<ComponentRodapeRedeSocialRedeSocialInput>;
  Links?: Maybe<ComponentRodapeLinksLinkInput>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  gestao_funcionalidades?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type RotaInput = {
  nome?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Rotas = {
  __typename?: 'Rotas';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  nome?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type RotasAggregator = {
  __typename?: 'RotasAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RotasConnection = {
  __typename?: 'RotasConnection';
  values?: Maybe<Array<Maybe<Rotas>>>;
  groupBy?: Maybe<RotasGroupBy>;
  aggregate?: Maybe<RotasAggregator>;
};

export type RotasConnectionCreated_At = {
  __typename?: 'RotasConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RotasConnection>;
};

export type RotasConnectionId = {
  __typename?: 'RotasConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RotasConnection>;
};

export type RotasConnectionNome = {
  __typename?: 'RotasConnectionNome';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RotasConnection>;
};

export type RotasConnectionPath = {
  __typename?: 'RotasConnectionPath';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RotasConnection>;
};

export type RotasConnectionPublished_At = {
  __typename?: 'RotasConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RotasConnection>;
};

export type RotasConnectionUpdated_At = {
  __typename?: 'RotasConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RotasConnection>;
};

export type RotasGroupBy = {
  __typename?: 'RotasGroupBy';
  id?: Maybe<Array<Maybe<RotasConnectionId>>>;
  created_at?: Maybe<Array<Maybe<RotasConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<RotasConnectionUpdated_At>>>;
  nome?: Maybe<Array<Maybe<RotasConnectionNome>>>;
  path?: Maybe<Array<Maybe<RotasConnectionPath>>>;
  published_at?: Maybe<Array<Maybe<RotasConnectionPublished_At>>>;
};

export type Rotulo = {
  __typename?: 'Rotulo';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  rotulo_pai?: Maybe<Rotulo>;
  ImagemFundo?: Maybe<UploadFile>;
  descricao?: Maybe<Scalars['String']>;
  rotulos?: Maybe<Array<Maybe<Rotulo>>>;
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type RotuloRotulosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type RotuloObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type RotuloAggregator = {
  __typename?: 'RotuloAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RotuloConnection = {
  __typename?: 'RotuloConnection';
  values?: Maybe<Array<Maybe<Rotulo>>>;
  groupBy?: Maybe<RotuloGroupBy>;
  aggregate?: Maybe<RotuloAggregator>;
};

export type RotuloConnectionCreated_At = {
  __typename?: 'RotuloConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RotuloConnection>;
};

export type RotuloConnectionDescricao = {
  __typename?: 'RotuloConnectionDescricao';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RotuloConnection>;
};

export type RotuloConnectionId = {
  __typename?: 'RotuloConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RotuloConnection>;
};

export type RotuloConnectionImagemFundo = {
  __typename?: 'RotuloConnectionImagemFundo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RotuloConnection>;
};

export type RotuloConnectionRotulo_Pai = {
  __typename?: 'RotuloConnectionRotulo_pai';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RotuloConnection>;
};

export type RotuloConnectionTitulo = {
  __typename?: 'RotuloConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RotuloConnection>;
};

export type RotuloConnectionUpdated_At = {
  __typename?: 'RotuloConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RotuloConnection>;
};

export type RotuloGroupBy = {
  __typename?: 'RotuloGroupBy';
  id?: Maybe<Array<Maybe<RotuloConnectionId>>>;
  created_at?: Maybe<Array<Maybe<RotuloConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<RotuloConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<RotuloConnectionTitulo>>>;
  rotulo_pai?: Maybe<Array<Maybe<RotuloConnectionRotulo_Pai>>>;
  ImagemFundo?: Maybe<Array<Maybe<RotuloConnectionImagemFundo>>>;
  descricao?: Maybe<Array<Maybe<RotuloConnectionDescricao>>>;
};

export type RotuloInput = {
  titulo?: Maybe<Scalars['String']>;
  rotulo_pai?: Maybe<Scalars['ID']>;
  rotulos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ImagemFundo?: Maybe<Scalars['ID']>;
  descricao?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type RotuloItem = {
  __typename?: 'RotuloItem';
  id: Scalars['ID'];
  titulo: Scalars['String'];
};

export type StatusDePublicacao = {
  __typename?: 'StatusDePublicacao';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  enum_status?: Maybe<Enum_Statusdepublicacao_Enum_Status>;
  status_pai?: Maybe<Scalars['Boolean']>;
  historico_avaliacao_objeto_educacionals?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacional>>>;
  gestao_funcionalidades?: Maybe<Array<Maybe<GestaoFuncionalidade>>>;
  substatus_de_publicacaos?: Maybe<Array<Maybe<StatusDePublicacao>>>;
};


export type StatusDePublicacaoHistorico_Avaliacao_Objeto_EducacionalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type StatusDePublicacaoGestao_FuncionalidadesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type StatusDePublicacaoSubstatus_De_PublicacaosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type StatusDePublicacaoAggregator = {
  __typename?: 'StatusDePublicacaoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StatusDePublicacaoConnection = {
  __typename?: 'StatusDePublicacaoConnection';
  values?: Maybe<Array<Maybe<StatusDePublicacao>>>;
  groupBy?: Maybe<StatusDePublicacaoGroupBy>;
  aggregate?: Maybe<StatusDePublicacaoAggregator>;
};

export type StatusDePublicacaoConnectionCreated_At = {
  __typename?: 'StatusDePublicacaoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StatusDePublicacaoConnection>;
};

export type StatusDePublicacaoConnectionEnum_Status = {
  __typename?: 'StatusDePublicacaoConnectionEnum_status';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StatusDePublicacaoConnection>;
};

export type StatusDePublicacaoConnectionId = {
  __typename?: 'StatusDePublicacaoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StatusDePublicacaoConnection>;
};

export type StatusDePublicacaoConnectionStatus_Pai = {
  __typename?: 'StatusDePublicacaoConnectionStatus_pai';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<StatusDePublicacaoConnection>;
};

export type StatusDePublicacaoConnectionTitulo = {
  __typename?: 'StatusDePublicacaoConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StatusDePublicacaoConnection>;
};

export type StatusDePublicacaoConnectionUpdated_At = {
  __typename?: 'StatusDePublicacaoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StatusDePublicacaoConnection>;
};

export type StatusDePublicacaoGroupBy = {
  __typename?: 'StatusDePublicacaoGroupBy';
  id?: Maybe<Array<Maybe<StatusDePublicacaoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<StatusDePublicacaoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<StatusDePublicacaoConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<StatusDePublicacaoConnectionTitulo>>>;
  enum_status?: Maybe<Array<Maybe<StatusDePublicacaoConnectionEnum_Status>>>;
  status_pai?: Maybe<Array<Maybe<StatusDePublicacaoConnectionStatus_Pai>>>;
};

export type StatusDePublicacaoInput = {
  titulo?: Maybe<Scalars['String']>;
  historico_avaliacao_objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  gestao_funcionalidades?: Maybe<Array<Maybe<Scalars['ID']>>>;
  enum_status?: Maybe<Enum_Statusdepublicacao_Enum_Status>;
  substatus_de_publicacaos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  status_pai?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type SubAreaConhecimento = {
  __typename?: 'SubAreaConhecimento';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Nome: Scalars['String'];
  published_at?: Maybe<Scalars['DateTime']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type SubAreaConhecimentoObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type SubAreaConhecimentoAggregator = {
  __typename?: 'SubAreaConhecimentoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SubAreaConhecimentoConnection = {
  __typename?: 'SubAreaConhecimentoConnection';
  values?: Maybe<Array<Maybe<SubAreaConhecimento>>>;
  groupBy?: Maybe<SubAreaConhecimentoGroupBy>;
  aggregate?: Maybe<SubAreaConhecimentoAggregator>;
};

export type SubAreaConhecimentoConnectionCreated_At = {
  __typename?: 'SubAreaConhecimentoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubAreaConhecimentoConnection>;
};

export type SubAreaConhecimentoConnectionId = {
  __typename?: 'SubAreaConhecimentoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubAreaConhecimentoConnection>;
};

export type SubAreaConhecimentoConnectionNome = {
  __typename?: 'SubAreaConhecimentoConnectionNome';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubAreaConhecimentoConnection>;
};

export type SubAreaConhecimentoConnectionPublished_At = {
  __typename?: 'SubAreaConhecimentoConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubAreaConhecimentoConnection>;
};

export type SubAreaConhecimentoConnectionUpdated_At = {
  __typename?: 'SubAreaConhecimentoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubAreaConhecimentoConnection>;
};

export type SubAreaConhecimentoGroupBy = {
  __typename?: 'SubAreaConhecimentoGroupBy';
  id?: Maybe<Array<Maybe<SubAreaConhecimentoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SubAreaConhecimentoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SubAreaConhecimentoConnectionUpdated_At>>>;
  Nome?: Maybe<Array<Maybe<SubAreaConhecimentoConnectionNome>>>;
  published_at?: Maybe<Array<Maybe<SubAreaConhecimentoConnectionPublished_At>>>;
};

export type SubAreaConhecimentoInput = {
  Nome: Scalars['String'];
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type SubRotulo = {
  __typename?: 'SubRotulo';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Titulo: Scalars['String'];
};

export type SubRotuloAggregator = {
  __typename?: 'SubRotuloAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SubRotuloConnection = {
  __typename?: 'SubRotuloConnection';
  values?: Maybe<Array<Maybe<SubRotulo>>>;
  groupBy?: Maybe<SubRotuloGroupBy>;
  aggregate?: Maybe<SubRotuloAggregator>;
};

export type SubRotuloConnectionCreated_At = {
  __typename?: 'SubRotuloConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubRotuloConnection>;
};

export type SubRotuloConnectionId = {
  __typename?: 'SubRotuloConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubRotuloConnection>;
};

export type SubRotuloConnectionTitulo = {
  __typename?: 'SubRotuloConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubRotuloConnection>;
};

export type SubRotuloConnectionUpdated_At = {
  __typename?: 'SubRotuloConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubRotuloConnection>;
};

export type SubRotuloGroupBy = {
  __typename?: 'SubRotuloGroupBy';
  id?: Maybe<Array<Maybe<SubRotuloConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SubRotuloConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SubRotuloConnectionUpdated_At>>>;
  Titulo?: Maybe<Array<Maybe<SubRotuloConnectionTitulo>>>;
};

export type SubRotuloInput = {
  Titulo: Scalars['String'];
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TermosDeUso = {
  __typename?: 'TermosDeUso';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Vigencia?: Maybe<Scalars['Date']>;
  Conteudo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type TermosDeUsoAggregator = {
  __typename?: 'TermosDeUsoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TermosDeUsoConnection = {
  __typename?: 'TermosDeUsoConnection';
  values?: Maybe<Array<Maybe<TermosDeUso>>>;
  groupBy?: Maybe<TermosDeUsoGroupBy>;
  aggregate?: Maybe<TermosDeUsoAggregator>;
};

export type TermosDeUsoConnectionConteudo = {
  __typename?: 'TermosDeUsoConnectionConteudo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TermosDeUsoConnection>;
};

export type TermosDeUsoConnectionCreated_At = {
  __typename?: 'TermosDeUsoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TermosDeUsoConnection>;
};

export type TermosDeUsoConnectionId = {
  __typename?: 'TermosDeUsoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TermosDeUsoConnection>;
};

export type TermosDeUsoConnectionPublished_At = {
  __typename?: 'TermosDeUsoConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TermosDeUsoConnection>;
};

export type TermosDeUsoConnectionUpdated_At = {
  __typename?: 'TermosDeUsoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TermosDeUsoConnection>;
};

export type TermosDeUsoConnectionVigencia = {
  __typename?: 'TermosDeUsoConnectionVigencia';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TermosDeUsoConnection>;
};

export type TermosDeUsoGroupBy = {
  __typename?: 'TermosDeUsoGroupBy';
  id?: Maybe<Array<Maybe<TermosDeUsoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TermosDeUsoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TermosDeUsoConnectionUpdated_At>>>;
  Vigencia?: Maybe<Array<Maybe<TermosDeUsoConnectionVigencia>>>;
  Conteudo?: Maybe<Array<Maybe<TermosDeUsoConnectionConteudo>>>;
  published_at?: Maybe<Array<Maybe<TermosDeUsoConnectionPublished_At>>>;
};

export type TermosDeUsoInput = {
  Vigencia?: Maybe<Scalars['Date']>;
  Conteudo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type TipoAreaPagina = {
  __typename?: 'TipoAreaPagina';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Nome: Scalars['String'];
  TipoPagina?: Maybe<TipoPagina>;
  published_at?: Maybe<Scalars['DateTime']>;
  Banners?: Maybe<Array<Maybe<Banner>>>;
};


export type TipoAreaPaginaBannersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type TipoAreaPaginaAggregator = {
  __typename?: 'TipoAreaPaginaAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TipoAreaPaginaConnection = {
  __typename?: 'TipoAreaPaginaConnection';
  values?: Maybe<Array<Maybe<TipoAreaPagina>>>;
  groupBy?: Maybe<TipoAreaPaginaGroupBy>;
  aggregate?: Maybe<TipoAreaPaginaAggregator>;
};

export type TipoAreaPaginaConnectionCreated_At = {
  __typename?: 'TipoAreaPaginaConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoAreaPaginaConnection>;
};

export type TipoAreaPaginaConnectionId = {
  __typename?: 'TipoAreaPaginaConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TipoAreaPaginaConnection>;
};

export type TipoAreaPaginaConnectionNome = {
  __typename?: 'TipoAreaPaginaConnectionNome';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TipoAreaPaginaConnection>;
};

export type TipoAreaPaginaConnectionPublished_At = {
  __typename?: 'TipoAreaPaginaConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoAreaPaginaConnection>;
};

export type TipoAreaPaginaConnectionTipoPagina = {
  __typename?: 'TipoAreaPaginaConnectionTipoPagina';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TipoAreaPaginaConnection>;
};

export type TipoAreaPaginaConnectionUpdated_At = {
  __typename?: 'TipoAreaPaginaConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoAreaPaginaConnection>;
};

export type TipoAreaPaginaGroupBy = {
  __typename?: 'TipoAreaPaginaGroupBy';
  id?: Maybe<Array<Maybe<TipoAreaPaginaConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TipoAreaPaginaConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TipoAreaPaginaConnectionUpdated_At>>>;
  Nome?: Maybe<Array<Maybe<TipoAreaPaginaConnectionNome>>>;
  TipoPagina?: Maybe<Array<Maybe<TipoAreaPaginaConnectionTipoPagina>>>;
  published_at?: Maybe<Array<Maybe<TipoAreaPaginaConnectionPublished_At>>>;
};

export type TipoAreaPaginaInput = {
  Nome: Scalars['String'];
  TipoPagina?: Maybe<Scalars['ID']>;
  Banners?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TipoAtendimento = {
  __typename?: 'TipoAtendimento';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo: Scalars['String'];
  email_atendimento?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  contatos?: Maybe<Array<Maybe<Contatos>>>;
};


export type TipoAtendimentoContatosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type TipoAtendimentoAggregator = {
  __typename?: 'TipoAtendimentoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TipoAtendimentoConnection = {
  __typename?: 'TipoAtendimentoConnection';
  values?: Maybe<Array<Maybe<TipoAtendimento>>>;
  groupBy?: Maybe<TipoAtendimentoGroupBy>;
  aggregate?: Maybe<TipoAtendimentoAggregator>;
};

export type TipoAtendimentoConnectionCreated_At = {
  __typename?: 'TipoAtendimentoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoAtendimentoConnection>;
};

export type TipoAtendimentoConnectionEmail_Atendimento = {
  __typename?: 'TipoAtendimentoConnectionEmail_atendimento';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TipoAtendimentoConnection>;
};

export type TipoAtendimentoConnectionId = {
  __typename?: 'TipoAtendimentoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TipoAtendimentoConnection>;
};

export type TipoAtendimentoConnectionPublished_At = {
  __typename?: 'TipoAtendimentoConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoAtendimentoConnection>;
};

export type TipoAtendimentoConnectionTitulo = {
  __typename?: 'TipoAtendimentoConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TipoAtendimentoConnection>;
};

export type TipoAtendimentoConnectionUpdated_At = {
  __typename?: 'TipoAtendimentoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoAtendimentoConnection>;
};

export type TipoAtendimentoGroupBy = {
  __typename?: 'TipoAtendimentoGroupBy';
  id?: Maybe<Array<Maybe<TipoAtendimentoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TipoAtendimentoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TipoAtendimentoConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<TipoAtendimentoConnectionTitulo>>>;
  email_atendimento?: Maybe<Array<Maybe<TipoAtendimentoConnectionEmail_Atendimento>>>;
  published_at?: Maybe<Array<Maybe<TipoAtendimentoConnectionPublished_At>>>;
};

export type TipoAtendimentoInput = {
  titulo: Scalars['String'];
  contatos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  email_atendimento?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TipoInteratividadeOe = {
  __typename?: 'TipoInteratividadeOe';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
};

export type TipoInteratividadeOeAggregator = {
  __typename?: 'TipoInteratividadeOeAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TipoInteratividadeOeConnection = {
  __typename?: 'TipoInteratividadeOeConnection';
  values?: Maybe<Array<Maybe<TipoInteratividadeOe>>>;
  groupBy?: Maybe<TipoInteratividadeOeGroupBy>;
  aggregate?: Maybe<TipoInteratividadeOeAggregator>;
};

export type TipoInteratividadeOeConnectionCreated_At = {
  __typename?: 'TipoInteratividadeOeConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoInteratividadeOeConnection>;
};

export type TipoInteratividadeOeConnectionId = {
  __typename?: 'TipoInteratividadeOeConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TipoInteratividadeOeConnection>;
};

export type TipoInteratividadeOeConnectionTitulo = {
  __typename?: 'TipoInteratividadeOeConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TipoInteratividadeOeConnection>;
};

export type TipoInteratividadeOeConnectionUpdated_At = {
  __typename?: 'TipoInteratividadeOeConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoInteratividadeOeConnection>;
};

export type TipoInteratividadeOeGroupBy = {
  __typename?: 'TipoInteratividadeOeGroupBy';
  id?: Maybe<Array<Maybe<TipoInteratividadeOeConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TipoInteratividadeOeConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TipoInteratividadeOeConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<TipoInteratividadeOeConnectionTitulo>>>;
};

export type TipoInteratividadeOeInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TipoOe = {
  __typename?: 'TipoOe';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type TipoOeObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type TipoOeAggregator = {
  __typename?: 'TipoOeAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TipoOeConnection = {
  __typename?: 'TipoOeConnection';
  values?: Maybe<Array<Maybe<TipoOe>>>;
  groupBy?: Maybe<TipoOeGroupBy>;
  aggregate?: Maybe<TipoOeAggregator>;
};

export type TipoOeConnectionCreated_At = {
  __typename?: 'TipoOeConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoOeConnection>;
};

export type TipoOeConnectionId = {
  __typename?: 'TipoOeConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TipoOeConnection>;
};

export type TipoOeConnectionTitulo = {
  __typename?: 'TipoOeConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TipoOeConnection>;
};

export type TipoOeConnectionUpdated_At = {
  __typename?: 'TipoOeConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoOeConnection>;
};

export type TipoOeGroupBy = {
  __typename?: 'TipoOeGroupBy';
  id?: Maybe<Array<Maybe<TipoOeConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TipoOeConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TipoOeConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<TipoOeConnectionTitulo>>>;
};

export type TipoOeInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TipoOeItem = {
  __typename?: 'TipoOeItem';
  id: Scalars['ID'];
  titulo: Scalars['String'];
};

export type TipoPagina = {
  __typename?: 'TipoPagina';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Nome: Scalars['String'];
  published_at?: Maybe<Scalars['DateTime']>;
  TiposAreaPagina?: Maybe<Array<Maybe<TipoAreaPagina>>>;
  Banners?: Maybe<Array<Maybe<Banner>>>;
};


export type TipoPaginaTiposAreaPaginaArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TipoPaginaBannersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type TipoPaginaAggregator = {
  __typename?: 'TipoPaginaAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TipoPaginaConnection = {
  __typename?: 'TipoPaginaConnection';
  values?: Maybe<Array<Maybe<TipoPagina>>>;
  groupBy?: Maybe<TipoPaginaGroupBy>;
  aggregate?: Maybe<TipoPaginaAggregator>;
};

export type TipoPaginaConnectionCreated_At = {
  __typename?: 'TipoPaginaConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoPaginaConnection>;
};

export type TipoPaginaConnectionId = {
  __typename?: 'TipoPaginaConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TipoPaginaConnection>;
};

export type TipoPaginaConnectionNome = {
  __typename?: 'TipoPaginaConnectionNome';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TipoPaginaConnection>;
};

export type TipoPaginaConnectionPublished_At = {
  __typename?: 'TipoPaginaConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoPaginaConnection>;
};

export type TipoPaginaConnectionUpdated_At = {
  __typename?: 'TipoPaginaConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoPaginaConnection>;
};

export type TipoPaginaGroupBy = {
  __typename?: 'TipoPaginaGroupBy';
  id?: Maybe<Array<Maybe<TipoPaginaConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TipoPaginaConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TipoPaginaConnectionUpdated_At>>>;
  Nome?: Maybe<Array<Maybe<TipoPaginaConnectionNome>>>;
  published_at?: Maybe<Array<Maybe<TipoPaginaConnectionPublished_At>>>;
};

export type TipoPaginaInput = {
  Nome: Scalars['String'];
  TiposAreaPagina?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Banners?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TipoRecursoEducacional = {
  __typename?: 'TipoRecursoEducacional';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type TipoRecursoEducacionalObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type TipoRecursoEducacionalAggregator = {
  __typename?: 'TipoRecursoEducacionalAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TipoRecursoEducacionalConnection = {
  __typename?: 'TipoRecursoEducacionalConnection';
  values?: Maybe<Array<Maybe<TipoRecursoEducacional>>>;
  groupBy?: Maybe<TipoRecursoEducacionalGroupBy>;
  aggregate?: Maybe<TipoRecursoEducacionalAggregator>;
};

export type TipoRecursoEducacionalConnectionCreated_At = {
  __typename?: 'TipoRecursoEducacionalConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoRecursoEducacionalConnection>;
};

export type TipoRecursoEducacionalConnectionId = {
  __typename?: 'TipoRecursoEducacionalConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TipoRecursoEducacionalConnection>;
};

export type TipoRecursoEducacionalConnectionTitulo = {
  __typename?: 'TipoRecursoEducacionalConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TipoRecursoEducacionalConnection>;
};

export type TipoRecursoEducacionalConnectionUpdated_At = {
  __typename?: 'TipoRecursoEducacionalConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TipoRecursoEducacionalConnection>;
};

export type TipoRecursoEducacionalGroupBy = {
  __typename?: 'TipoRecursoEducacionalGroupBy';
  id?: Maybe<Array<Maybe<TipoRecursoEducacionalConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TipoRecursoEducacionalConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TipoRecursoEducacionalConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<TipoRecursoEducacionalConnectionTitulo>>>;
};

export type TipoRecursoEducacionalInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TiposRelacionamentosEntreOe = {
  __typename?: 'TiposRelacionamentosEntreOe';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
};

export type TiposRelacionamentosEntreOeAggregator = {
  __typename?: 'TiposRelacionamentosEntreOeAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TiposRelacionamentosEntreOeConnection = {
  __typename?: 'TiposRelacionamentosEntreOeConnection';
  values?: Maybe<Array<Maybe<TiposRelacionamentosEntreOe>>>;
  groupBy?: Maybe<TiposRelacionamentosEntreOeGroupBy>;
  aggregate?: Maybe<TiposRelacionamentosEntreOeAggregator>;
};

export type TiposRelacionamentosEntreOeConnectionCreated_At = {
  __typename?: 'TiposRelacionamentosEntreOeConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TiposRelacionamentosEntreOeConnection>;
};

export type TiposRelacionamentosEntreOeConnectionId = {
  __typename?: 'TiposRelacionamentosEntreOeConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TiposRelacionamentosEntreOeConnection>;
};

export type TiposRelacionamentosEntreOeConnectionTitulo = {
  __typename?: 'TiposRelacionamentosEntreOeConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TiposRelacionamentosEntreOeConnection>;
};

export type TiposRelacionamentosEntreOeConnectionUpdated_At = {
  __typename?: 'TiposRelacionamentosEntreOeConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TiposRelacionamentosEntreOeConnection>;
};

export type TiposRelacionamentosEntreOeGroupBy = {
  __typename?: 'TiposRelacionamentosEntreOeGroupBy';
  id?: Maybe<Array<Maybe<TiposRelacionamentosEntreOeConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TiposRelacionamentosEntreOeConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TiposRelacionamentosEntreOeConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<TiposRelacionamentosEntreOeConnectionTitulo>>>;
};

export type TiposRelacionamentosEntreOeInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Topico = {
  __typename?: 'Topico';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titulo?: Maybe<Scalars['String']>;
  corclara?: Maybe<Scalars['String']>;
  corescura?: Maybe<Scalars['String']>;
  rota?: Maybe<Rotas>;
  Imagem?: Maybe<UploadFile>;
  published_at?: Maybe<Scalars['DateTime']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<ObjetoEducacional>>>;
};


export type TopicoObjetosEducacionaisArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type TopicoAggregator = {
  __typename?: 'TopicoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TopicoConnection = {
  __typename?: 'TopicoConnection';
  values?: Maybe<Array<Maybe<Topico>>>;
  groupBy?: Maybe<TopicoGroupBy>;
  aggregate?: Maybe<TopicoAggregator>;
};

export type TopicoConnectionCorclara = {
  __typename?: 'TopicoConnectionCorclara';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TopicoConnection>;
};

export type TopicoConnectionCorescura = {
  __typename?: 'TopicoConnectionCorescura';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TopicoConnection>;
};

export type TopicoConnectionCreated_At = {
  __typename?: 'TopicoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TopicoConnection>;
};

export type TopicoConnectionId = {
  __typename?: 'TopicoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TopicoConnection>;
};

export type TopicoConnectionImagem = {
  __typename?: 'TopicoConnectionImagem';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TopicoConnection>;
};

export type TopicoConnectionPublished_At = {
  __typename?: 'TopicoConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TopicoConnection>;
};

export type TopicoConnectionRota = {
  __typename?: 'TopicoConnectionRota';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TopicoConnection>;
};

export type TopicoConnectionTitulo = {
  __typename?: 'TopicoConnectionTitulo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TopicoConnection>;
};

export type TopicoConnectionUpdated_At = {
  __typename?: 'TopicoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TopicoConnection>;
};

export type TopicoGroupBy = {
  __typename?: 'TopicoGroupBy';
  id?: Maybe<Array<Maybe<TopicoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TopicoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TopicoConnectionUpdated_At>>>;
  titulo?: Maybe<Array<Maybe<TopicoConnectionTitulo>>>;
  corclara?: Maybe<Array<Maybe<TopicoConnectionCorclara>>>;
  corescura?: Maybe<Array<Maybe<TopicoConnectionCorescura>>>;
  rota?: Maybe<Array<Maybe<TopicoConnectionRota>>>;
  Imagem?: Maybe<Array<Maybe<TopicoConnectionImagem>>>;
  published_at?: Maybe<Array<Maybe<TopicoConnectionPublished_At>>>;
};

export type TopicoInput = {
  titulo?: Maybe<Scalars['String']>;
  corclara?: Maybe<Scalars['String']>;
  corescura?: Maybe<Scalars['String']>;
  rota?: Maybe<Scalars['ID']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Imagem?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TotalPayload = {
  __typename?: 'TotalPayload';
  total: Scalars['Int'];
};


export type UploadFile = {
  __typename?: 'UploadFile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_At = {
  __typename?: 'UploadFileConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_At = {
  __typename?: 'UploadFileConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  nome_completo?: Maybe<Scalars['String']>;
  data_nascimento?: Maybe<Scalars['Date']>;
  cpf?: Maybe<Scalars['String']>;
  celular?: Maybe<Scalars['String']>;
  area_de_conhecimentos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Seguindo?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OesCurtidas?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OesFavoritados?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OesConsumidosTotalmente?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OesConsumidosParcialmente?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Avatar?: Maybe<Scalars['ID']>;
  PerfilProfissao?: Maybe<Array<Maybe<Scalars['ID']>>>;
  UF?: Maybe<Scalars['String']>;
  CRM?: Maybe<Scalars['String']>;
  profissaoFilha?: Maybe<Scalars['ID']>;
  OutraProfissaoFilha?: Maybe<Scalars['String']>;
  OesVisualizados?: Maybe<Array<Maybe<Scalars['ID']>>>;
  acceptTerm?: Maybe<Scalars['Boolean']>;
  acceptSharePersonData?: Maybe<Scalars['Boolean']>;
  documentType?: Maybe<Scalars['String']>;
  documentNumber?: Maybe<Scalars['String']>;
  canal?: Maybe<Scalars['String']>;
  historico_avaliacao_objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UserObjetoEducacional = {
  __typename?: 'UserObjetoEducacional';
  id?: Maybe<Scalars['ID']>;
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  gestao_funcionalidades?: Maybe<Array<Maybe<GestaoFuncionalidade>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleGestao_FuncionalidadesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  nome_completo?: Maybe<Scalars['String']>;
  data_nascimento?: Maybe<Scalars['Date']>;
  cpf?: Maybe<Scalars['String']>;
  celular?: Maybe<Scalars['String']>;
  Avatar?: Maybe<UploadFile>;
  UF?: Maybe<Scalars['String']>;
  CRM?: Maybe<Scalars['String']>;
  profissaoFilha?: Maybe<Profissao>;
  OutraProfissaoFilha?: Maybe<Scalars['String']>;
  acceptTerm?: Maybe<Scalars['Boolean']>;
  acceptSharePersonData?: Maybe<Scalars['Boolean']>;
  documentType?: Maybe<Scalars['String']>;
  documentNumber?: Maybe<Scalars['String']>;
  canal?: Maybe<Scalars['String']>;
  area_de_conhecimentos?: Maybe<Array<Maybe<AreaDeConhecimento>>>;
  Seguindo?: Maybe<Array<Maybe<PerfilDeAutor>>>;
  OesCurtidas?: Maybe<Array<Maybe<ObjetoEducacional>>>;
  OesFavoritados?: Maybe<Array<Maybe<ObjetoEducacional>>>;
  OesConsumidosTotalmente?: Maybe<Array<Maybe<ObjetoEducacional>>>;
  OesConsumidosParcialmente?: Maybe<Array<Maybe<OEsAssistidosPorUsuario>>>;
  PerfilProfissao?: Maybe<Array<Maybe<Profissao>>>;
  OesVisualizados?: Maybe<Array<Maybe<ObjetoEducacional>>>;
  historico_avaliacao_objeto_educacionals?: Maybe<Array<Maybe<HistoricoAvaliacaoObjetoEducacional>>>;
};


export type UsersPermissionsUserArea_De_ConhecimentosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserSeguindoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserOesCurtidasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserOesFavoritadosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserOesConsumidosTotalmenteArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserOesConsumidosParcialmenteArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserPerfilProfissaoArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserOesVisualizadosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserHistorico_Avaliacao_Objeto_EducacionalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserConnectionAcceptSharePersonData = {
  __typename?: 'UsersPermissionsUserConnectionAcceptSharePersonData';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionAcceptTerm = {
  __typename?: 'UsersPermissionsUserConnectionAcceptTerm';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionAvatar = {
  __typename?: 'UsersPermissionsUserConnectionAvatar';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCrm = {
  __typename?: 'UsersPermissionsUserConnectionCRM';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCanal = {
  __typename?: 'UsersPermissionsUserConnectionCanal';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCelular = {
  __typename?: 'UsersPermissionsUserConnectionCelular';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCpf = {
  __typename?: 'UsersPermissionsUserConnectionCpf';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_At = {
  __typename?: 'UsersPermissionsUserConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionData_Nascimento = {
  __typename?: 'UsersPermissionsUserConnectionData_nascimento';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionDocumentNumber = {
  __typename?: 'UsersPermissionsUserConnectionDocumentNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionDocumentType = {
  __typename?: 'UsersPermissionsUserConnectionDocumentType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionNome_Completo = {
  __typename?: 'UsersPermissionsUserConnectionNome_completo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionOutraProfissaoFilha = {
  __typename?: 'UsersPermissionsUserConnectionOutraProfissaoFilha';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProfissaoFilha = {
  __typename?: 'UsersPermissionsUserConnectionProfissaoFilha';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUf = {
  __typename?: 'UsersPermissionsUserConnectionUF';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
  __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  nome_completo?: Maybe<Array<Maybe<UsersPermissionsUserConnectionNome_Completo>>>;
  data_nascimento?: Maybe<Array<Maybe<UsersPermissionsUserConnectionData_Nascimento>>>;
  cpf?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCpf>>>;
  celular?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCelular>>>;
  Avatar?: Maybe<Array<Maybe<UsersPermissionsUserConnectionAvatar>>>;
  UF?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUf>>>;
  CRM?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCrm>>>;
  profissaoFilha?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProfissaoFilha>>>;
  OutraProfissaoFilha?: Maybe<Array<Maybe<UsersPermissionsUserConnectionOutraProfissaoFilha>>>;
  acceptTerm?: Maybe<Array<Maybe<UsersPermissionsUserConnectionAcceptTerm>>>;
  acceptSharePersonData?: Maybe<Array<Maybe<UsersPermissionsUserConnectionAcceptSharePersonData>>>;
  documentType?: Maybe<Array<Maybe<UsersPermissionsUserConnectionDocumentType>>>;
  documentNumber?: Maybe<Array<Maybe<UsersPermissionsUserConnectionDocumentNumber>>>;
  canal?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCanal>>>;
};

export type CreateAreaDeConhecimentoInput = {
  data?: Maybe<AreaDeConhecimentoInput>;
};

export type CreateAreaDeConhecimentoPayload = {
  __typename?: 'createAreaDeConhecimentoPayload';
  areaDeConhecimento?: Maybe<AreaDeConhecimento>;
};

export type CreateAreaDeDestaqueInput = {
  data?: Maybe<AreaDeDestaqueInput>;
};

export type CreateAreaDeDestaquePayload = {
  __typename?: 'createAreaDeDestaquePayload';
  areaDeDestaque?: Maybe<AreaDeDestaque>;
};

export type CreateAutorConvidadoInput = {
  data?: Maybe<AutorConvidadoInput>;
};

export type CreateAutorConvidadoPayload = {
  __typename?: 'createAutorConvidadoPayload';
  autorConvidado?: Maybe<AutorConvidado>;
};

export type CreateAutorizacaoDeUsoInput = {
  data?: Maybe<AutorizacaoDeUsoInput>;
};

export type CreateAutorizacaoDeUsoPayload = {
  __typename?: 'createAutorizacaoDeUsoPayload';
  autorizacaoDeUso?: Maybe<AutorizacaoDeUso>;
};

export type CreateBannerInput = {
  data?: Maybe<BannerInput>;
};

export type CreateBannerPayload = {
  __typename?: 'createBannerPayload';
  banner?: Maybe<Banner>;
};

export type CreateCategoriaPatrocinadorInput = {
  data?: Maybe<CategoriaPatrocinadorInput>;
};

export type CreateCategoriaPatrocinadorPayload = {
  __typename?: 'createCategoriaPatrocinadorPayload';
  categoriaPatrocinador?: Maybe<CategoriaPatrocinador>;
};

export type CreateContatoInput = {
  data?: Maybe<ContatoInput>;
};

export type CreateContatoPayload = {
  __typename?: 'createContatoPayload';
  contato?: Maybe<Contatos>;
};

export type CreateDensidadeSemanticaInput = {
  data?: Maybe<DensidadeSemanticaInput>;
};

export type CreateDensidadeSemanticaPayload = {
  __typename?: 'createDensidadeSemanticaPayload';
  densidadeSemantica?: Maybe<DensidadeSemantica>;
};

export type CreateDescomplicandoCienciaInput = {
  data?: Maybe<DescomplicandoCienciaInput>;
};

export type CreateDescomplicandoCienciaPayload = {
  __typename?: 'createDescomplicandoCienciaPayload';
  descomplicandoCiencia?: Maybe<DescomplicandoCiencia>;
};

export type CreateDriveInsumoObjetoEducacionalInput = {
  data?: Maybe<DriveInsumoObjetoEducacionalInput>;
};

export type CreateDriveInsumoObjetoEducacionalPayload = {
  __typename?: 'createDriveInsumoObjetoEducacionalPayload';
  driveInsumoObjetoEducacional?: Maybe<DriveInsumoObjetoEducacional>;
};

export type CreateEnsinoEinsteinInput = {
  data?: Maybe<EnsinoEinsteinInput>;
};

export type CreateEnsinoEinsteinPayload = {
  __typename?: 'createEnsinoEinsteinPayload';
  ensinoEinstein?: Maybe<EnsinoEinstein>;
};

export type CreateEstadoCivilInput = {
  data?: Maybe<EstadoCivilInput>;
};

export type CreateEstadoCivilPayload = {
  __typename?: 'createEstadoCivilPayload';
  estadoCivil?: Maybe<EstadoCivil>;
};

export type CreateGestaoFuncionalidadeInput = {
  data?: Maybe<GestaoFuncionalidadeInput>;
};

export type CreateGestaoFuncionalidadePayload = {
  __typename?: 'createGestaoFuncionalidadePayload';
  gestaoFuncionalidade?: Maybe<GestaoFuncionalidade>;
};

export type CreateGranularidadeInput = {
  data?: Maybe<GranularidadeInput>;
};

export type CreateGranularidadePayload = {
  __typename?: 'createGranularidadePayload';
  granularidade?: Maybe<Granularidade>;
};

export type CreateHistoricoAvaliacaoObjetoEducacionalInput = {
  data?: Maybe<HistoricoAvaliacaoObjetoEducacionalInput>;
};

export type CreateHistoricoAvaliacaoObjetoEducacionalPayload = {
  __typename?: 'createHistoricoAvaliacaoObjetoEducacionalPayload';
  historicoAvaliacaoObjetoEducacional?: Maybe<HistoricoAvaliacaoObjetoEducacional>;
};

export type CreateIdiomaInput = {
  data?: Maybe<IdiomaInput>;
};

export type CreateIdiomaPayload = {
  __typename?: 'createIdiomaPayload';
  idioma?: Maybe<Idiomas>;
};

export type CreateItemMenuInput = {
  data?: Maybe<ItemMenuInput>;
};

export type CreateItemMenuPayload = {
  __typename?: 'createItemMenuPayload';
  itemMenu?: Maybe<ItemMenu>;
};

export type CreateItemRodapeInput = {
  data?: Maybe<ItemRodapeInput>;
};

export type CreateItemRodapePayload = {
  __typename?: 'createItemRodapePayload';
  itemRodape?: Maybe<ItemRodapes>;
};

export type CreateMaturidadePublicoAlvoInput = {
  data?: Maybe<MaturidadePublicoAlvoInput>;
};

export type CreateMaturidadePublicoAlvoPayload = {
  __typename?: 'createMaturidadePublicoAlvoPayload';
  maturidadePublicoAlvo?: Maybe<MaturidadePublicoAlvo>;
};

export type CreateModalidadeDeEnsinoInput = {
  data?: Maybe<ModalidadeDeEnsinoInput>;
};

export type CreateModalidadeDeEnsinoPayload = {
  __typename?: 'createModalidadeDeEnsinoPayload';
  modalidadeDeEnsino?: Maybe<ModalidadeDeEnsino>;
};

export type CreateNivelDosObjetivosDeAprendizagemInput = {
  data?: Maybe<NivelDosObjetivosDeAprendizagemInput>;
};

export type CreateNivelDosObjetivosDeAprendizagemPayload = {
  __typename?: 'createNivelDosObjetivosDeAprendizagemPayload';
  nivelDosObjetivosDeAprendizagem?: Maybe<NivelDosObjetivosDeAprendizagem>;
};

export type CreateOEsAssistidosPorUsuarioInput = {
  data?: Maybe<OEsAssistidosPorUsuarioInput>;
};

export type CreateOEsAssistidosPorUsuarioPayload = {
  __typename?: 'createOEsAssistidosPorUsuarioPayload';
  oEsAssistidosPorUsuario?: Maybe<OEsAssistidosPorUsuario>;
};

export type CreateObjetoEducacionalInput = {
  data?: Maybe<ObjetoEducacionalInput>;
};

export type CreateObjetoEducacionalPayload = {
  __typename?: 'createObjetoEducacionalPayload';
  objetoEducacional?: Maybe<ObjetoEducacional>;
};

export type CreateOeInput = {
  data?: Maybe<OeInput>;
};

export type CreateOePayload = {
  __typename?: 'createOePayload';
  oe?: Maybe<Oes>;
};

export type CreatePalavraChaveInput = {
  data?: Maybe<PalavraChaveInput>;
};

export type CreatePalavraChavePayload = {
  __typename?: 'createPalavraChavePayload';
  palavraChave?: Maybe<PalavraChave>;
};

export type CreatePatrocinadorInput = {
  data?: Maybe<PatrocinadorInput>;
};

export type CreatePatrocinadorPayload = {
  __typename?: 'createPatrocinadorPayload';
  patrocinador?: Maybe<Patrocinador>;
};

export type CreatePerfilDeAutorInput = {
  data?: Maybe<PerfilDeAutorInput>;
};

export type CreatePerfilDeAutorPayload = {
  __typename?: 'createPerfilDeAutorPayload';
  perfilDeAutor?: Maybe<PerfilDeAutor>;
};

export type CreatePerguntaQuizzInput = {
  data?: Maybe<PerguntaQuizzInput>;
};

export type CreatePerguntaQuizzPayload = {
  __typename?: 'createPerguntaQuizzPayload';
  perguntaQuizz?: Maybe<PerguntaQuizz>;
};

export type CreateProdutoPrimarioInput = {
  data?: Maybe<ProdutoPrimarioInput>;
};

export type CreateProdutoPrimarioPayload = {
  __typename?: 'createProdutoPrimarioPayload';
  produtoPrimario?: Maybe<ProdutoPrimario>;
};

export type CreateProfissaoInput = {
  data?: Maybe<ProfissaoInput>;
};

export type CreateProfissaoPayload = {
  __typename?: 'createProfissaoPayload';
  profissao?: Maybe<Profissao>;
};

export type CreateProfissaoTecnicoInput = {
  data?: Maybe<ProfissaoTecnicoInput>;
};

export type CreateProfissaoTecnicoPayload = {
  __typename?: 'createProfissaoTecnicoPayload';
  profissaoTecnico?: Maybe<ProfissaoTecnico>;
};

export type CreatePublicoAlvoInput = {
  data?: Maybe<PublicoAlvoInput>;
};

export type CreatePublicoAlvoPayload = {
  __typename?: 'createPublicoAlvoPayload';
  publicoAlvo?: Maybe<PublicoAlvo>;
};

export type CreateQuizzInput = {
  data?: Maybe<QuizzInput>;
};

export type CreateQuizzPayload = {
  __typename?: 'createQuizzPayload';
  quizz?: Maybe<Quizz>;
};

export type CreateRecuperacaoSenhaInput = {
  data?: Maybe<RecuperacaoSenhaInput>;
};

export type CreateRecuperacaoSenhaPayload = {
  __typename?: 'createRecuperacaoSenhaPayload';
  recuperacaoSenha?: Maybe<RecuperacaoSenha>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type CreateRotaInput = {
  data?: Maybe<RotaInput>;
};

export type CreateRotaPayload = {
  __typename?: 'createRotaPayload';
  rota?: Maybe<Rotas>;
};

export type CreateRotuloInput = {
  data?: Maybe<RotuloInput>;
};

export type CreateRotuloPayload = {
  __typename?: 'createRotuloPayload';
  rotulo?: Maybe<Rotulo>;
};

export type CreateStatusDePublicacaoInput = {
  data?: Maybe<StatusDePublicacaoInput>;
};

export type CreateStatusDePublicacaoPayload = {
  __typename?: 'createStatusDePublicacaoPayload';
  statusDePublicacao?: Maybe<StatusDePublicacao>;
};

export type CreateSubAreaConhecimentoInput = {
  data?: Maybe<SubAreaConhecimentoInput>;
};

export type CreateSubAreaConhecimentoPayload = {
  __typename?: 'createSubAreaConhecimentoPayload';
  subAreaConhecimento?: Maybe<SubAreaConhecimento>;
};

export type CreateSubRotuloInput = {
  data?: Maybe<SubRotuloInput>;
};

export type CreateSubRotuloPayload = {
  __typename?: 'createSubRotuloPayload';
  subRotulo?: Maybe<SubRotulo>;
};

export type CreateTermosDeUsoInput = {
  data?: Maybe<TermosDeUsoInput>;
};

export type CreateTermosDeUsoPayload = {
  __typename?: 'createTermosDeUsoPayload';
  termosDeUso?: Maybe<TermosDeUso>;
};

export type CreateTipoAreaPaginaInput = {
  data?: Maybe<TipoAreaPaginaInput>;
};

export type CreateTipoAreaPaginaPayload = {
  __typename?: 'createTipoAreaPaginaPayload';
  tipoAreaPagina?: Maybe<TipoAreaPagina>;
};

export type CreateTipoAtendimentoInput = {
  data?: Maybe<TipoAtendimentoInput>;
};

export type CreateTipoAtendimentoPayload = {
  __typename?: 'createTipoAtendimentoPayload';
  tipoAtendimento?: Maybe<TipoAtendimento>;
};

export type CreateTipoInteratividadeOeInput = {
  data?: Maybe<TipoInteratividadeOeInput>;
};

export type CreateTipoInteratividadeOePayload = {
  __typename?: 'createTipoInteratividadeOePayload';
  tipoInteratividadeOe?: Maybe<TipoInteratividadeOe>;
};

export type CreateTipoOeInput = {
  data?: Maybe<TipoOeInput>;
};

export type CreateTipoOePayload = {
  __typename?: 'createTipoOePayload';
  tipoOe?: Maybe<TipoOe>;
};

export type CreateTipoPaginaInput = {
  data?: Maybe<TipoPaginaInput>;
};

export type CreateTipoPaginaPayload = {
  __typename?: 'createTipoPaginaPayload';
  tipoPagina?: Maybe<TipoPagina>;
};

export type CreateTipoRecursoEducacionalInput = {
  data?: Maybe<TipoRecursoEducacionalInput>;
};

export type CreateTipoRecursoEducacionalPayload = {
  __typename?: 'createTipoRecursoEducacionalPayload';
  tipoRecursoEducacional?: Maybe<TipoRecursoEducacional>;
};

export type CreateTiposRelacionamentosEntreOeInput = {
  data?: Maybe<TiposRelacionamentosEntreOeInput>;
};

export type CreateTiposRelacionamentosEntreOePayload = {
  __typename?: 'createTiposRelacionamentosEntreOePayload';
  tiposRelacionamentosEntreOe?: Maybe<TiposRelacionamentosEntreOe>;
};

export type CreateTopicoInput = {
  data?: Maybe<TopicoInput>;
};

export type CreateTopicoPayload = {
  __typename?: 'createTopicoPayload';
  topico?: Maybe<Topico>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteAreaDeConhecimentoInput = {
  where?: Maybe<InputId>;
};

export type DeleteAreaDeConhecimentoPayload = {
  __typename?: 'deleteAreaDeConhecimentoPayload';
  areaDeConhecimento?: Maybe<AreaDeConhecimento>;
};

export type DeleteAreaDeDestaqueInput = {
  where?: Maybe<InputId>;
};

export type DeleteAreaDeDestaquePayload = {
  __typename?: 'deleteAreaDeDestaquePayload';
  areaDeDestaque?: Maybe<AreaDeDestaque>;
};

export type DeleteAutorConvidadoInput = {
  where?: Maybe<InputId>;
};

export type DeleteAutorConvidadoPayload = {
  __typename?: 'deleteAutorConvidadoPayload';
  autorConvidado?: Maybe<AutorConvidado>;
};

export type DeleteAutorizacaoDeUsoInput = {
  where?: Maybe<InputId>;
};

export type DeleteAutorizacaoDeUsoPayload = {
  __typename?: 'deleteAutorizacaoDeUsoPayload';
  autorizacaoDeUso?: Maybe<AutorizacaoDeUso>;
};

export type DeleteBannerInput = {
  where?: Maybe<InputId>;
};

export type DeleteBannerPayload = {
  __typename?: 'deleteBannerPayload';
  banner?: Maybe<Banner>;
};

export type DeleteCategoriaPatrocinadorInput = {
  where?: Maybe<InputId>;
};

export type DeleteCategoriaPatrocinadorPayload = {
  __typename?: 'deleteCategoriaPatrocinadorPayload';
  categoriaPatrocinador?: Maybe<CategoriaPatrocinador>;
};

export type DeleteContatoInput = {
  where?: Maybe<InputId>;
};

export type DeleteContatoPayload = {
  __typename?: 'deleteContatoPayload';
  contato?: Maybe<Contatos>;
};

export type DeleteDensidadeSemanticaInput = {
  where?: Maybe<InputId>;
};

export type DeleteDensidadeSemanticaPayload = {
  __typename?: 'deleteDensidadeSemanticaPayload';
  densidadeSemantica?: Maybe<DensidadeSemantica>;
};

export type DeleteDescomplicandoCienciaInput = {
  where?: Maybe<InputId>;
};

export type DeleteDescomplicandoCienciaPayload = {
  __typename?: 'deleteDescomplicandoCienciaPayload';
  descomplicandoCiencia?: Maybe<DescomplicandoCiencia>;
};

export type DeleteDriveInsumoObjetoEducacionalInput = {
  where?: Maybe<InputId>;
};

export type DeleteDriveInsumoObjetoEducacionalPayload = {
  __typename?: 'deleteDriveInsumoObjetoEducacionalPayload';
  driveInsumoObjetoEducacional?: Maybe<DriveInsumoObjetoEducacional>;
};

export type DeleteEnsinoEinsteinInput = {
  where?: Maybe<InputId>;
};

export type DeleteEnsinoEinsteinPagePayload = {
  __typename?: 'deleteEnsinoEinsteinPagePayload';
  ensinoEinsteinPage?: Maybe<EnsinoEinsteinPage>;
};

export type DeleteEnsinoEinsteinPayload = {
  __typename?: 'deleteEnsinoEinsteinPayload';
  ensinoEinstein?: Maybe<EnsinoEinstein>;
};

export type DeleteEstadoCivilInput = {
  where?: Maybe<InputId>;
};

export type DeleteEstadoCivilPayload = {
  __typename?: 'deleteEstadoCivilPayload';
  estadoCivil?: Maybe<EstadoCivil>;
};

export type DeleteFileInput = {
  where?: Maybe<InputId>;
};

export type DeleteFilePayload = {
  __typename?: 'deleteFilePayload';
  file?: Maybe<UploadFile>;
};

export type DeleteGestaoFuncionalidadeInput = {
  where?: Maybe<InputId>;
};

export type DeleteGestaoFuncionalidadePayload = {
  __typename?: 'deleteGestaoFuncionalidadePayload';
  gestaoFuncionalidade?: Maybe<GestaoFuncionalidade>;
};

export type DeleteGranularidadeInput = {
  where?: Maybe<InputId>;
};

export type DeleteGranularidadePayload = {
  __typename?: 'deleteGranularidadePayload';
  granularidade?: Maybe<Granularidade>;
};

export type DeleteHeaderPortalPayload = {
  __typename?: 'deleteHeaderPortalPayload';
  headerPortal?: Maybe<HeaderPortal>;
};

export type DeleteHistoricoAvaliacaoObjetoEducacionalInput = {
  where?: Maybe<InputId>;
};

export type DeleteHistoricoAvaliacaoObjetoEducacionalPayload = {
  __typename?: 'deleteHistoricoAvaliacaoObjetoEducacionalPayload';
  historicoAvaliacaoObjetoEducacional?: Maybe<HistoricoAvaliacaoObjetoEducacional>;
};

export type DeleteHomeObjetoEducacionalPagePayload = {
  __typename?: 'deleteHomeObjetoEducacionalPagePayload';
  homeObjetoEducacionalPage?: Maybe<HomeObjetoEducacionalPage>;
};

export type DeleteIdiomaInput = {
  where?: Maybe<InputId>;
};

export type DeleteIdiomaPayload = {
  __typename?: 'deleteIdiomaPayload';
  idioma?: Maybe<Idiomas>;
};

export type DeleteItemMenuInput = {
  where?: Maybe<InputId>;
};

export type DeleteItemMenuPayload = {
  __typename?: 'deleteItemMenuPayload';
  itemMenu?: Maybe<ItemMenu>;
};

export type DeleteItemRodapeInput = {
  where?: Maybe<InputId>;
};

export type DeleteItemRodapePayload = {
  __typename?: 'deleteItemRodapePayload';
  itemRodape?: Maybe<ItemRodapes>;
};

export type DeleteMaturidadePublicoAlvoInput = {
  where?: Maybe<InputId>;
};

export type DeleteMaturidadePublicoAlvoPayload = {
  __typename?: 'deleteMaturidadePublicoAlvoPayload';
  maturidadePublicoAlvo?: Maybe<MaturidadePublicoAlvo>;
};

export type DeleteModalidadeDeEnsinoInput = {
  where?: Maybe<InputId>;
};

export type DeleteModalidadeDeEnsinoPayload = {
  __typename?: 'deleteModalidadeDeEnsinoPayload';
  modalidadeDeEnsino?: Maybe<ModalidadeDeEnsino>;
};

export type DeleteNivelDosObjetivosDeAprendizagemInput = {
  where?: Maybe<InputId>;
};

export type DeleteNivelDosObjetivosDeAprendizagemPayload = {
  __typename?: 'deleteNivelDosObjetivosDeAprendizagemPayload';
  nivelDosObjetivosDeAprendizagem?: Maybe<NivelDosObjetivosDeAprendizagem>;
};

export type DeleteOEsAssistidosPorUsuarioInput = {
  where?: Maybe<InputId>;
};

export type DeleteOEsAssistidosPorUsuarioPayload = {
  __typename?: 'deleteOEsAssistidosPorUsuarioPayload';
  oEsAssistidosPorUsuario?: Maybe<OEsAssistidosPorUsuario>;
};

export type DeleteObjetoEducacionalInput = {
  where?: Maybe<InputId>;
};

export type DeleteObjetoEducacionalPayload = {
  __typename?: 'deleteObjetoEducacionalPayload';
  objetoEducacional?: Maybe<ObjetoEducacional>;
};

export type DeleteOeInput = {
  where?: Maybe<InputId>;
};

export type DeleteOePayload = {
  __typename?: 'deleteOePayload';
  oe?: Maybe<Oes>;
};

export type DeletePaginaAtendimentoPayload = {
  __typename?: 'deletePaginaAtendimentoPayload';
  paginaAtendimento?: Maybe<PaginaAtendimento>;
};

export type DeletePalavraChaveInput = {
  where?: Maybe<InputId>;
};

export type DeletePalavraChavePayload = {
  __typename?: 'deletePalavraChavePayload';
  palavraChave?: Maybe<PalavraChave>;
};

export type DeletePatrocinadorInput = {
  where?: Maybe<InputId>;
};

export type DeletePatrocinadorPayload = {
  __typename?: 'deletePatrocinadorPayload';
  patrocinador?: Maybe<Patrocinador>;
};

export type DeletePerfilDeAutorInput = {
  where?: Maybe<InputId>;
};

export type DeletePerfilDeAutorPayload = {
  __typename?: 'deletePerfilDeAutorPayload';
  perfilDeAutor?: Maybe<PerfilDeAutor>;
};

export type DeletePerguntaQuizzInput = {
  where?: Maybe<InputId>;
};

export type DeletePerguntaQuizzPayload = {
  __typename?: 'deletePerguntaQuizzPayload';
  perguntaQuizz?: Maybe<PerguntaQuizz>;
};

export type DeleteProdutoPrimarioInput = {
  where?: Maybe<InputId>;
};

export type DeleteProdutoPrimarioPayload = {
  __typename?: 'deleteProdutoPrimarioPayload';
  produtoPrimario?: Maybe<ProdutoPrimario>;
};

export type DeleteProfissaoInput = {
  where?: Maybe<InputId>;
};

export type DeleteProfissaoPayload = {
  __typename?: 'deleteProfissaoPayload';
  profissao?: Maybe<Profissao>;
};

export type DeleteProfissaoTecnicoInput = {
  where?: Maybe<InputId>;
};

export type DeleteProfissaoTecnicoPayload = {
  __typename?: 'deleteProfissaoTecnicoPayload';
  profissaoTecnico?: Maybe<ProfissaoTecnico>;
};

export type DeletePublicoAlvoInput = {
  where?: Maybe<InputId>;
};

export type DeletePublicoAlvoPayload = {
  __typename?: 'deletePublicoAlvoPayload';
  publicoAlvo?: Maybe<PublicoAlvo>;
};

export type DeleteQuizzInput = {
  where?: Maybe<InputId>;
};

export type DeleteQuizzPayload = {
  __typename?: 'deleteQuizzPayload';
  quizz?: Maybe<Quizz>;
};

export type DeleteRecuperacaoSenhaInput = {
  where?: Maybe<InputId>;
};

export type DeleteRecuperacaoSenhaPayload = {
  __typename?: 'deleteRecuperacaoSenhaPayload';
  recuperacaoSenha?: Maybe<RecuperacaoSenha>;
};

export type DeleteRodapePortalPayload = {
  __typename?: 'deleteRodapePortalPayload';
  rodapePortal?: Maybe<RodapePortal>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteRotaInput = {
  where?: Maybe<InputId>;
};

export type DeleteRotaPayload = {
  __typename?: 'deleteRotaPayload';
  rota?: Maybe<Rotas>;
};

export type DeleteRotuloInput = {
  where?: Maybe<InputId>;
};

export type DeleteRotuloPayload = {
  __typename?: 'deleteRotuloPayload';
  rotulo?: Maybe<Rotulo>;
};

export type DeleteStatusDePublicacaoInput = {
  where?: Maybe<InputId>;
};

export type DeleteStatusDePublicacaoPayload = {
  __typename?: 'deleteStatusDePublicacaoPayload';
  statusDePublicacao?: Maybe<StatusDePublicacao>;
};

export type DeleteSubAreaConhecimentoInput = {
  where?: Maybe<InputId>;
};

export type DeleteSubAreaConhecimentoPayload = {
  __typename?: 'deleteSubAreaConhecimentoPayload';
  subAreaConhecimento?: Maybe<SubAreaConhecimento>;
};

export type DeleteSubRotuloInput = {
  where?: Maybe<InputId>;
};

export type DeleteSubRotuloPayload = {
  __typename?: 'deleteSubRotuloPayload';
  subRotulo?: Maybe<SubRotulo>;
};

export type DeleteTermosDeUsoInput = {
  where?: Maybe<InputId>;
};

export type DeleteTermosDeUsoPayload = {
  __typename?: 'deleteTermosDeUsoPayload';
  termosDeUso?: Maybe<TermosDeUso>;
};

export type DeleteTipoAreaPaginaInput = {
  where?: Maybe<InputId>;
};

export type DeleteTipoAreaPaginaPayload = {
  __typename?: 'deleteTipoAreaPaginaPayload';
  tipoAreaPagina?: Maybe<TipoAreaPagina>;
};

export type DeleteTipoAtendimentoInput = {
  where?: Maybe<InputId>;
};

export type DeleteTipoAtendimentoPayload = {
  __typename?: 'deleteTipoAtendimentoPayload';
  tipoAtendimento?: Maybe<TipoAtendimento>;
};

export type DeleteTipoInteratividadeOeInput = {
  where?: Maybe<InputId>;
};

export type DeleteTipoInteratividadeOePayload = {
  __typename?: 'deleteTipoInteratividadeOePayload';
  tipoInteratividadeOe?: Maybe<TipoInteratividadeOe>;
};

export type DeleteTipoOeInput = {
  where?: Maybe<InputId>;
};

export type DeleteTipoOePayload = {
  __typename?: 'deleteTipoOePayload';
  tipoOe?: Maybe<TipoOe>;
};

export type DeleteTipoPaginaInput = {
  where?: Maybe<InputId>;
};

export type DeleteTipoPaginaPayload = {
  __typename?: 'deleteTipoPaginaPayload';
  tipoPagina?: Maybe<TipoPagina>;
};

export type DeleteTipoRecursoEducacionalInput = {
  where?: Maybe<InputId>;
};

export type DeleteTipoRecursoEducacionalPayload = {
  __typename?: 'deleteTipoRecursoEducacionalPayload';
  tipoRecursoEducacional?: Maybe<TipoRecursoEducacional>;
};

export type DeleteTiposRelacionamentosEntreOeInput = {
  where?: Maybe<InputId>;
};

export type DeleteTiposRelacionamentosEntreOePayload = {
  __typename?: 'deleteTiposRelacionamentosEntreOePayload';
  tiposRelacionamentosEntreOe?: Maybe<TiposRelacionamentosEntreOe>;
};

export type DeleteTopicoInput = {
  where?: Maybe<InputId>;
};

export type DeleteTopicoPayload = {
  __typename?: 'deleteTopicoPayload';
  topico?: Maybe<Topico>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type EditAreaDeConhecimentoInput = {
  titulo?: Maybe<Scalars['String']>;
  area_pai?: Maybe<Scalars['ID']>;
  area_de_conhecimentos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  icone?: Maybe<Scalars['ID']>;
  imagem_url?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Banners?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditAreaDeDestaqueInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditAutorConvidadoInput = {
  nome?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  aceita_participacao?: Maybe<Scalars['Boolean']>;
  objeto_educacional?: Maybe<Scalars['ID']>;
  user_autor_responsavel?: Maybe<Scalars['ID']>;
  autor_convidado?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditAutorizacaoDeUsoInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditBannerInput = {
  PeriodoPermanenciaInicial?: Maybe<Scalars['Date']>;
  PeriodoPermanenciaFinal?: Maybe<Scalars['Date']>;
  LinkFuga?: Maybe<Scalars['String']>;
  ImagemDesktop?: Maybe<Scalars['ID']>;
  ImagemMobile?: Maybe<Scalars['ID']>;
  AreasConhecimento?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  TiposAreaPagina?: Maybe<Array<Maybe<Scalars['ID']>>>;
  TiposPaginas?: Maybe<Array<Maybe<Scalars['ID']>>>;
  patrocinador?: Maybe<Scalars['ID']>;
  Titulo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCategoriaPatrocinadorInput = {
  titulo?: Maybe<Scalars['String']>;
  patrocinadores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentAlternativaListaAlternativaInput = {
  id?: Maybe<Scalars['ID']>;
  alternativa1?: Maybe<Scalars['String']>;
  alternativa2?: Maybe<Scalars['String']>;
  alternativa3?: Maybe<Scalars['String']>;
  alternativa_correta?: Maybe<Scalars['String']>;
};

export type EditComponentAudioAudioInput = {
  id?: Maybe<Scalars['ID']>;
  url_vimeo?: Maybe<Scalars['String']>;
  outros_audios?: Maybe<Scalars['ID']>;
  observacao?: Maybe<Scalars['String']>;
  metadados?: Maybe<EditComponentFieldGroupMetadadosAutorInput>;
};

export type EditComponentAutoresAutorInput = {
  id?: Maybe<Scalars['ID']>;
  NomeCompleto?: Maybe<Scalars['String']>;
  Apelido?: Maybe<Scalars['String']>;
  DataNascimento?: Maybe<Scalars['Date']>;
  CPF?: Maybe<Scalars['Int']>;
  Nacionalidade?: Maybe<Scalars['String']>;
  EstadoCivil?: Maybe<Enum_Componentautoresautor_Estadocivil>;
  endereco?: Maybe<Array<Maybe<EditComponentEnderecosEnderecoInput>>>;
  Profissao?: Maybe<Enum_Componentautoresautor_Profissao>;
  Outro?: Maybe<Scalars['String']>;
  CRM?: Maybe<Scalars['String']>;
  area_de_conhecimento?: Maybe<Scalars['ID']>;
  Foto?: Maybe<Scalars['ID']>;
  Cargo?: Maybe<Scalars['String']>;
  Link_Curriculum?: Maybe<Scalars['String']>;
  Autoriza_divulgacao_do_link_do_curriculo_na_sua_pagina_de_autor?: Maybe<Enum_Componentautoresautor_Autoriza_Divulgacao_Do_Link_Do_Curriculo_Na_Sua_Pagina_De_Autor>;
  Email?: Maybe<Scalars['String']>;
  Autoriza_divulgacao_do_email_na_sua_pagina_de_autor?: Maybe<Enum_Componentautoresautor_Autoriza_Divulgacao_Do_Email_Na_Sua_Pagina_De_Autor>;
  Aceite?: Maybe<Scalars['Boolean']>;
  telefone?: Maybe<Array<Maybe<EditComponentTelefoneAutorTelefoneInput>>>;
};

export type EditComponentCessaoDeDireitosCessaoDeDireitoInput = {
  id?: Maybe<Scalars['ID']>;
  NomeCompleto?: Maybe<Scalars['String']>;
  RG?: Maybe<Scalars['String']>;
  CPF?: Maybe<Scalars['String']>;
  TermoDeConcessao?: Maybe<Scalars['ID']>;
};

export type EditComponentCicloDeVidaCicloDeVidaInput = {
  id?: Maybe<Scalars['ID']>;
  AutorizacaoDeUso?: Maybe<Enum_Componentciclodevidaciclodevida_Autorizacaodeuso>;
  ValidadeConteudo?: Maybe<Scalars['Date']>;
  Status?: Maybe<Enum_Componentciclodevidaciclodevida_Status>;
  DireitosUsoImagemTerceirosPacientes?: Maybe<EditComponentCessaoDeDireitosCessaoDeDireitoInput>;
  DataProducao?: Maybe<Scalars['Date']>;
  DataAtualizacaoProducao?: Maybe<Scalars['Date']>;
};

export type EditComponentEnderecosEnderecoInput = {
  id?: Maybe<Scalars['ID']>;
  CEP?: Maybe<Scalars['Int']>;
  Logradouro?: Maybe<Scalars['String']>;
  Numero?: Maybe<Scalars['Int']>;
  Cidade?: Maybe<Scalars['String']>;
  UF?: Maybe<Scalars['String']>;
  Tipo?: Maybe<Enum_Componentenderecosendereco_Tipo>;
};

export type EditComponentFieldGroupArquivoReferenciaInput = {
  id?: Maybe<Scalars['ID']>;
  arquivo?: Maybe<Array<Maybe<Scalars['ID']>>>;
  referencia?: Maybe<Scalars['String']>;
};

export type EditComponentFieldGroupFormularioDeSessaoDeUsoInput = {
  id?: Maybe<Scalars['ID']>;
  nome_completo?: Maybe<Scalars['String']>;
  rg?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
};

export type EditComponentFieldGroupGestaoDeDestaqueInput = {
  id?: Maybe<Scalars['ID']>;
  area_de_destaque?: Maybe<Scalars['ID']>;
  data_inicio?: Maybe<Scalars['Date']>;
  data_fim?: Maybe<Scalars['Date']>;
};

export type EditComponentFieldGroupImagemEDescricaoInput = {
  id?: Maybe<Scalars['ID']>;
  imagem?: Maybe<Scalars['ID']>;
  descricao?: Maybe<Scalars['String']>;
};

export type EditComponentFieldGroupInfograficoInput = {
  id?: Maybe<Scalars['ID']>;
  infografico?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentFieldGroupMaturidadePublicaAlvoInput = {
  id?: Maybe<Scalars['ID']>;
  maturidade_publico_alvo?: Maybe<Scalars['ID']>;
};

export type EditComponentFieldGroupMetadadosAutorInput = {
  id?: Maybe<Scalars['ID']>;
  nome_autor?: Maybe<Scalars['String']>;
  cargo_autor?: Maybe<Scalars['String']>;
  link_autor?: Maybe<Scalars['String']>;
  email_autor?: Maybe<Scalars['String']>;
};

export type EditComponentFieldGroupMetadadosCicloDeVidaInput = {
  id?: Maybe<Scalars['ID']>;
  data_validade?: Maybe<Scalars['Date']>;
  autorizacao_de_uso?: Maybe<Scalars['ID']>;
  cessao_de_direitos?: Maybe<EditComponentFieldGroupFormularioDeSessaoDeUsoInput>;
  status_de_publicacao?: Maybe<Scalars['ID']>;
  versao?: Maybe<Scalars['String']>;
  data_criacao?: Maybe<Scalars['Date']>;
  data_atualizacao?: Maybe<Scalars['Date']>;
  validade_conteudo?: Maybe<Scalars['Date']>;
  status?: Maybe<Enum_Componentfieldgroupmetadadosciclodevida_Status>;
};

export type EditComponentFieldGroupMetadadosEducacionalInput = {
  id?: Maybe<Scalars['ID']>;
  rotulo?: Maybe<Scalars['ID']>;
  tipo_recurso_educacional?: Maybe<Scalars['ID']>;
  tipos_oe?: Maybe<Array<Maybe<EditComponentFieldGroupSeletorTipoOeInput>>>;
  tipo_interatividade_oe?: Maybe<Scalars['ID']>;
  nivel_objetivo_aprendizagem?: Maybe<Array<Maybe<EditComponentFieldGroupSeletorDeNIvelDeObjetivoDeAprendizagemInput>>>;
  maturidade_publico_alvo?: Maybe<Array<Maybe<EditComponentFieldGroupSeletorMaturidadePublicoAlvoInput>>>;
  densidade_semantica?: Maybe<Scalars['ID']>;
  granularidade?: Maybe<Scalars['ID']>;
  relacionado?: Maybe<Scalars['String']>;
  relacionando_indicacao_recurso?: Maybe<Enum_Componentfieldgroupmetadadoseducacional_Relacionando_Indicacao_Recurso>;
};

export type EditComponentFieldGroupMetadadosEinsteinInput = {
  id?: Maybe<Scalars['ID']>;
  modalidade_de_ensino?: Maybe<Scalars['ID']>;
  produto_primarios?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentFieldGroupMetadadosIdentificacaoInput = {
  id?: Maybe<Scalars['ID']>;
  AreaDeConhecimentos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  SubAreaDeConhecimento?: Maybe<Scalars['ID']>;
  PalavrasChave?: Maybe<Array<Maybe<EditComponentFieldGroupPalavraChaveInput>>>;
  Descricao?: Maybe<Scalars['String']>;
  DescricaoResumida?: Maybe<Scalars['String']>;
  PublicoAlvo?: Maybe<Array<Maybe<Scalars['ID']>>>;
  restricao_publico_nao_medico?: Maybe<Scalars['Boolean']>;
  autor?: Maybe<Array<Maybe<EditComponentFieldGroupMetadadosAutorInput>>>;
  idioma?: Maybe<Scalars['ID']>;
  imagem_de_capa_home?: Maybe<Scalars['ID']>;
  area_de_destaque?: Maybe<Array<Maybe<EditComponentFieldGroupGestaoDeDestaqueInput>>>;
  topico?: Maybe<Scalars['ID']>;
  imagem_de_capa_conteudo?: Maybe<Scalars['ID']>;
};

export type EditComponentFieldGroupObjetivosEResultadoInput = {
  id?: Maybe<Scalars['ID']>;
  objetivos_metodologias?: Maybe<Scalars['String']>;
  resultados?: Maybe<Scalars['String']>;
  tabelas_graficos?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentFieldGroupPalavraChaveInput = {
  id?: Maybe<Scalars['ID']>;
  palavra_chave?: Maybe<Scalars['String']>;
};

export type EditComponentFieldGroupResultadoInput = {
  id?: Maybe<Scalars['ID']>;
  descricao_resultado?: Maybe<Scalars['String']>;
  imagem_resultado?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentFieldGroupResumoDoConteudoInfograficoInput = {
  id?: Maybe<Scalars['ID']>;
  objetivos_metodologia?: Maybe<Scalars['String']>;
  resultados?: Maybe<Scalars['String']>;
  limitacoes_estudo?: Maybe<Scalars['String']>;
  conclusao?: Maybe<Scalars['String']>;
};

export type EditComponentFieldGroupSeletorAreaDeConhecimentoInput = {
  id?: Maybe<Scalars['ID']>;
  area_de_conhecimento?: Maybe<Scalars['ID']>;
};

export type EditComponentFieldGroupSeletorDeAutoreInput = {
  id?: Maybe<Scalars['ID']>;
  perfil_de_autor?: Maybe<Scalars['ID']>;
};

export type EditComponentFieldGroupSeletorDeNIvelDeObjetivoDeAprendizagemInput = {
  id?: Maybe<Scalars['ID']>;
  nivel_dos_objetivos_de_aprendizagem?: Maybe<Scalars['ID']>;
};

export type EditComponentFieldGroupSeletorMaturidadePublicoAlvoInput = {
  id?: Maybe<Scalars['ID']>;
  maturidade_publico_alvo?: Maybe<Scalars['ID']>;
};

export type EditComponentFieldGroupSeletorModalidadeDeEnsinoInput = {
  id?: Maybe<Scalars['ID']>;
  modalidade_de_ensino?: Maybe<Scalars['ID']>;
};

export type EditComponentFieldGroupSeletorOeRelacionadoInput = {
  id?: Maybe<Scalars['ID']>;
  tipos_relacionamentos_entre_oe?: Maybe<Scalars['ID']>;
  descomplicando_ciencias?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentFieldGroupSeletorProdutoPrimarioInput = {
  id?: Maybe<Scalars['ID']>;
};

export type EditComponentFieldGroupSeletorTipoOeInput = {
  id?: Maybe<Scalars['ID']>;
  tipo_oe?: Maybe<Scalars['ID']>;
};

export type EditComponentFieldGroupSolicitacaoInfograficoInput = {
  id?: Maybe<Scalars['ID']>;
  resumo_conteudo?: Maybe<EditComponentFieldGroupResumoDoConteudoInfograficoInput>;
  imagem_descricao?: Maybe<Array<Maybe<EditComponentFieldGroupImagemEDescricaoInput>>>;
  referencia?: Maybe<Scalars['String']>;
};

export type EditComponentFieldGroupTecnicaInput = {
  id?: Maybe<Scalars['ID']>;
  Tamanho?: Maybe<Scalars['String']>;
  duracao?: Maybe<Scalars['Float']>;
  dimensoes?: Maybe<Scalars['String']>;
  Formato?: Maybe<Enum_Componentfieldgrouptecnica_Formato>;
};

export type EditComponentGrupoEnsinoGrupoEnsinoInput = {
  id?: Maybe<Scalars['ID']>;
  titulo?: Maybe<Scalars['String']>;
  cursos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ordem?: Maybe<Scalars['Int']>;
};

export type EditComponentHomeConteudosAltaHomeConteudosAltaInput = {
  id?: Maybe<Scalars['ID']>;
  ObjetosEducacionaisConteudosAlta?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Quiz?: Maybe<Scalars['ID']>;
  ObjetosEducacionaisOrdenados?: Maybe<Array<Maybe<EditComponentObjetosEducacionaisOrdenadosObjetosEducacionaisOrdenadoInput>>>;
};

export type EditComponentHomeDestaqueSemanaHomeDestaqueSemanaInput = {
  id?: Maybe<Scalars['ID']>;
  OeQuizz?: Maybe<Scalars['ID']>;
  OesDestaqueSemana?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OePodcast?: Maybe<Scalars['ID']>;
  ObjetosEducacionaisOrdenados?: Maybe<Array<Maybe<EditComponentObjetosEducacionaisOrdenadosObjetosEducacionaisOrdenadoInput>>>;
};

export type EditComponentHomeDestaquesSemanaHomeDestaquesSemanaInput = {
  id?: Maybe<Scalars['ID']>;
  QuizSemana?: Maybe<Scalars['ID']>;
  OEsDestaquesSemana?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentHomeNovidadesHomeNovidadeInput = {
  id?: Maybe<Scalars['ID']>;
  objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentHomeOutrasAreasHomeOutrasAreaInput = {
  id?: Maybe<Scalars['ID']>;
  AreasConhecimento?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentHomeQuizHomeQuizInput = {
  id?: Maybe<Scalars['ID']>;
  Quiz?: Maybe<Scalars['ID']>;
};

export type EditComponentHomeTopicosHomeTopicoInput = {
  id?: Maybe<Scalars['ID']>;
  Topicos?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentHomeVideosAltaHomeVideosAltaInput = {
  id?: Maybe<Scalars['ID']>;
  ObjetosEducacionaisVideosAlta?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentImagemImagemInput = {
  id?: Maybe<Scalars['ID']>;
  url_vimeo?: Maybe<Scalars['String']>;
  outra_imagens?: Maybe<Scalars['ID']>;
  observacao?: Maybe<Scalars['String']>;
  imagem?: Maybe<Scalars['ID']>;
  direitos_uso?: Maybe<Enum_Componentimagemimagem_Direitos_Uso>;
  autorizacao?: Maybe<Scalars['ID']>;
};

export type EditComponentLinksRodapeLinkInput = {
  id?: Maybe<Scalars['ID']>;
  itens_rodapes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentListaAltaAltaInput = {
  id?: Maybe<Scalars['ID']>;
  oe_altas?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentListaAreasConhecimentoOutrasAreasConhecimentoInput = {
  id?: Maybe<Scalars['ID']>;
};

export type EditComponentListaContatosRodapeContatosRodapeInput = {
  id?: Maybe<Scalars['ID']>;
  contato?: Maybe<Scalars['String']>;
};

export type EditComponentListaEmailsAtendimentoListaEmailsAtendimentoInput = {
  id?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
};

export type EditComponentListaHomeSliderListaHomeSliderInput = {
  id?: Maybe<Scalars['ID']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentListaHorarioAtendimentoHorarioAtendimentoInput = {
  id?: Maybe<Scalars['ID']>;
  telefone?: Maybe<Scalars['String']>;
};

export type EditComponentListaHorariosAtendimentoListaHorariosAtendimentoInput = {
  id?: Maybe<Scalars['ID']>;
  dia_semana?: Maybe<Scalars['String']>;
  horario?: Maybe<Scalars['String']>;
};

export type EditComponentListaMenusItemInput = {
  id?: Maybe<Scalars['ID']>;
  Nome?: Maybe<Scalars['String']>;
  rota?: Maybe<Scalars['ID']>;
  Ordem?: Maybe<Scalars['Int']>;
};

export type EditComponentListaMenusRodapeLinksRodapeInput = {
  id?: Maybe<Scalars['ID']>;
  nome?: Maybe<Scalars['String']>;
  ordem?: Maybe<Scalars['Int']>;
  rota?: Maybe<Scalars['ID']>;
  icone?: Maybe<Array<Maybe<Scalars['ID']>>>;
  contatosRodape?: Maybe<Array<Maybe<EditComponentListaContatosRodapeContatosRodapeInput>>>;
};

export type EditComponentListaOutrasAreasOutrasAreaInput = {
  id?: Maybe<Scalars['ID']>;
};

export type EditComponentListaQuizQuizInput = {
  id?: Maybe<Scalars['ID']>;
  oe_quiz?: Maybe<Scalars['ID']>;
};

export type EditComponentListaSliderSliderInput = {
  id?: Maybe<Scalars['ID']>;
  oes_slider?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentListaTopicosTopicoInput = {
  id?: Maybe<Scalars['ID']>;
  topicos?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentListaVideosAltaVideosAltaInput = {
  id?: Maybe<Scalars['ID']>;
};

export type EditComponentMenusRodapeMenusRodapeInput = {
  id?: Maybe<Scalars['ID']>;
  nome?: Maybe<Scalars['String']>;
  ordem?: Maybe<Scalars['Int']>;
  rota?: Maybe<Scalars['ID']>;
  icone?: Maybe<Array<Maybe<Scalars['ID']>>>;
  contatosRodape?: Maybe<Array<Maybe<EditComponentListaContatosRodapeContatosRodapeInput>>>;
};

export type EditComponentObjetoEducacionalInfogaficoInfograficoInput = {
  id?: Maybe<Scalars['ID']>;
  Titulo?: Maybe<Scalars['String']>;
  Imagem?: Maybe<Scalars['ID']>;
  Descricao?: Maybe<Scalars['String']>;
};

export type EditComponentObjetosEducacionaisOrdenadosObjetosEducacionaisOrdenadoInput = {
  id?: Maybe<Scalars['ID']>;
  objeto_educacional?: Maybe<Scalars['ID']>;
  ordem?: Maybe<Scalars['Int']>;
};

export type EditComponentOesParcialmenteConsumidasConsumidosParcialmenteInput = {
  id?: Maybe<Scalars['ID']>;
  OE?: Maybe<Scalars['ID']>;
  TempoAssistido?: Maybe<Scalars['Float']>;
  SecaoParada?: Maybe<Scalars['String']>;
};

export type EditComponentPerguntaOpcaoOpcaoInput = {
  id?: Maybe<Scalars['ID']>;
  opcao?: Maybe<Scalars['String']>;
  opcao_correta?: Maybe<Scalars['Boolean']>;
  contador?: Maybe<Scalars['Int']>;
};

export type EditComponentPerguntaOpcaoRespostaInput = {
  id?: Maybe<Scalars['ID']>;
  opcao?: Maybe<Scalars['String']>;
  opcao_correta?: Maybe<Scalars['Boolean']>;
  contador?: Maybe<Scalars['Int']>;
};

export type EditComponentPerguntaQuizzPerguntaInput = {
  id?: Maybe<Scalars['ID']>;
  pergunta?: Maybe<Scalars['ID']>;
};

export type EditComponentQuizzesQuizInput = {
  id?: Maybe<Scalars['ID']>;
  quiz?: Maybe<Scalars['ID']>;
  duracao?: Maybe<Scalars['Int']>;
};

export type EditComponentRodapeAtendimentoAtendimentoInput = {
  id?: Maybe<Scalars['ID']>;
  itens_rodapes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentRodapeLinksLinkInput = {
  id?: Maybe<Scalars['ID']>;
  itens_rodapes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentRodapeRedeSocialListaTelefonesAtendimentoInput = {
  id?: Maybe<Scalars['ID']>;
  telefone?: Maybe<Scalars['String']>;
};

export type EditComponentRodapeRedeSocialRedeSocialInput = {
  id?: Maybe<Scalars['ID']>;
  itens_rodapes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentSecaoTextSecaoTextoInput = {
  id?: Maybe<Scalars['ID']>;
  Secao?: Maybe<Scalars['String']>;
};

export type EditComponentSecaoVideoAudioVideoAudioInput = {
  id?: Maybe<Scalars['ID']>;
  URL?: Maybe<Scalars['String']>;
  Observacoes?: Maybe<Scalars['String']>;
  Titulo?: Maybe<Scalars['String']>;
  Descricao?: Maybe<Scalars['String']>;
  url_mp3?: Maybe<Scalars['String']>;
  Thumbs?: Maybe<Scalars['ID']>;
  TempoMedioDuracao?: Maybe<Scalars['Int']>;
  OrdemSequencial?: Maybe<Scalars['Int']>;
  url_spotify?: Maybe<Scalars['String']>;
};

export type EditComponentTelefoneAutorTelefoneInput = {
  id?: Maybe<Scalars['ID']>;
  Tipo?: Maybe<Enum_Componenttelefoneautortelefone_Tipo>;
  Telefone?: Maybe<Scalars['Long']>;
};

export type EditComponentTextoTextoInput = {
  id?: Maybe<Scalars['ID']>;
  texto?: Maybe<Scalars['String']>;
  observacao?: Maybe<Scalars['String']>;
  duracao?: Maybe<Scalars['Int']>;
};

export type EditComponentTipoAprovacaoEtapasAprovacaoInput = {
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Componenttipoaprovacaoetapasaprovacao_Status>;
  observacao?: Maybe<Scalars['String']>;
  responsavel?: Maybe<Array<Maybe<Scalars['ID']>>>;
  tipo_aprovacao?: Maybe<Enum_Componenttipoaprovacaoetapasaprovacao_Tipo_Aprovacao>;
};

export type EditComponentUserAreaConhecimentoAreaConhecimentoInput = {
  id?: Maybe<Scalars['ID']>;
};

export type EditComponentVideoVideoInput = {
  id?: Maybe<Scalars['ID']>;
  url_vimeo?: Maybe<Scalars['String']>;
  outros_video?: Maybe<Scalars['ID']>;
  observacao?: Maybe<Scalars['String']>;
  direitosUso?: Maybe<Enum_Componentvideovideo_Direitosuso>;
  anexoDoc?: Maybe<Array<Maybe<Scalars['ID']>>>;
  duracao?: Maybe<Scalars['Int']>;
};

export type EditContatoInput = {
  mensagem?: Maybe<Scalars['String']>;
  tipo_atendimento?: Maybe<Scalars['ID']>;
  nome?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditDensidadeSemanticaInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditDescomplicandoCienciaInput = {
  titulo?: Maybe<Scalars['String']>;
  introducao?: Maybe<Scalars['String']>;
  imagem_resultado?: Maybe<Array<Maybe<EditComponentFieldGroupResultadoInput>>>;
  limitacoes_estudo?: Maybe<Scalars['String']>;
  conclusao?: Maybe<Scalars['String']>;
  referencia?: Maybe<Scalars['String']>;
  meta_dados_identificacao?: Maybe<EditComponentFieldGroupMetadadosIdentificacaoInput>;
  meta_dados_ciclo_de_vida?: Maybe<EditComponentFieldGroupMetadadosCicloDeVidaInput>;
  meta_dados_educacional?: Maybe<EditComponentFieldGroupMetadadosEducacionalInput>;
  oe_relacionado?: Maybe<Array<Scalars['DescomplicandoCienciaOeRelacionadoDynamicZoneInput']>>;
  duracao?: Maybe<Scalars['String']>;
  meta_dados_einstein?: Maybe<EditComponentFieldGroupMetadadosEinsteinInput>;
  tipo_recurso_educacional?: Maybe<Scalars['ID']>;
  objetivos_resultados?: Maybe<EditComponentFieldGroupObjetivosEResultadoInput>;
  infografico?: Maybe<EditComponentFieldGroupInfograficoInput>;
  solicitacao_infografico?: Maybe<EditComponentFieldGroupSolicitacaoInfograficoInput>;
  arquivo_referencia?: Maybe<EditComponentFieldGroupArquivoReferenciaInput>;
  autores?: Maybe<Array<Maybe<EditComponentFieldGroupSeletorDeAutoreInput>>>;
  revisado_ortografia?: Maybe<Scalars['Boolean']>;
  revisado_midia?: Maybe<Scalars['Boolean']>;
  revisado_comunicacao?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditDriveInsumoObjetoEducacionalInput = {
  nome?: Maybe<Scalars['String']>;
  extensao?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  autor?: Maybe<Scalars['ID']>;
  objeto_educacional?: Maybe<Scalars['ID']>;
  tipo?: Maybe<Enum_Driveinsumoobjetoeducacional_Tipo>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditEnsinoEinsteinInput = {
  titulo?: Maybe<Scalars['String']>;
  corClara?: Maybe<Scalars['String']>;
  corEscura?: Maybe<Scalars['String']>;
  imagem?: Maybe<Scalars['ID']>;
  rota?: Maybe<Scalars['ID']>;
  ordem?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditEnsinoEinsteinPageInput = {
  grupos?: Maybe<Array<Maybe<EditComponentGrupoEnsinoGrupoEnsinoInput>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditEstadoCivilInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditGestaoFuncionalidadeInput = {
  users_permissions_roles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  status_de_publicacaos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditGranularidadeInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditHeaderPortalInput = {
  logo?: Maybe<Scalars['ID']>;
  item_menus?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditHistoricoAvaliacaoObjetoEducacionalInput = {
  objeto_educacional?: Maybe<Scalars['ID']>;
  status_de_publicacao?: Maybe<Scalars['ID']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditHomeObjetoEducacionalPageInput = {
  HomeConteudosAlta?: Maybe<EditComponentHomeConteudosAltaHomeConteudosAltaInput>;
  HomeOutrasAreas?: Maybe<EditComponentHomeOutrasAreasHomeOutrasAreaInput>;
  HomeVideosAlta?: Maybe<EditComponentHomeVideosAltaHomeVideosAltaInput>;
  HomeTopicos?: Maybe<EditComponentHomeTopicosHomeTopicoInput>;
  HomeDestaqueSemana?: Maybe<EditComponentHomeDestaqueSemanaHomeDestaqueSemanaInput>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditIdiomaInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditItemMenuInput = {
  nome?: Maybe<Scalars['String']>;
  ordem?: Maybe<Scalars['Int']>;
  rota?: Maybe<Scalars['ID']>;
  subMenu?: Maybe<Array<Maybe<EditComponentListaMenusItemInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditItemRodapeInput = {
  nome?: Maybe<Scalars['String']>;
  ordem?: Maybe<Scalars['Int']>;
  MenusRodape?: Maybe<Array<Maybe<EditComponentMenusRodapeMenusRodapeInput>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditLocaleInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditMaturidadePublicoAlvoInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditModalidadeDeEnsinoInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditNivelDosObjetivosDeAprendizagemInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditOEsAssistidosPorUsuarioInput = {
  duracao?: Maybe<Scalars['Int']>;
  segundos?: Maybe<Scalars['Int']>;
  ConsumidoresParciais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OesAssistidos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  VideoAudioId?: Maybe<Scalars['Int']>;
  ImagemOeId?: Maybe<Scalars['Int']>;
  LeituraOeId?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditObjetoEducacionalInput = {
  Autores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Titulo?: Maybe<Scalars['String']>;
  Quizzes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  AreasConhecimento?: Maybe<Array<Maybe<Scalars['ID']>>>;
  PublicoAlvo?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Idioma?: Maybe<Scalars['ID']>;
  RestricaoPublicoMedico?: Maybe<Scalars['Boolean']>;
  Topicos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Rotulos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  TipoRecursosEducionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ImagemCapa?: Maybe<Scalars['ID']>;
  ImagemPreview?: Maybe<Scalars['ID']>;
  Descricao?: Maybe<Scalars['String']>;
  Resumo?: Maybe<Scalars['String']>;
  MaturidadePublicoAlvo?: Maybe<Scalars['ID']>;
  Granularidade?: Maybe<Scalars['ID']>;
  DensidadeSemantica?: Maybe<Scalars['ID']>;
  TipoInteratividade?: Maybe<Scalars['ID']>;
  NivelDosObjetosDeAprendizagem?: Maybe<Array<Maybe<Scalars['ID']>>>;
  SecoesTexto?: Maybe<Array<Maybe<EditComponentSecaoTextSecaoTextoInput>>>;
  VideoAudio?: Maybe<Array<Maybe<EditComponentSecaoVideoAudioVideoAudioInput>>>;
  TipoObjeto?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Curtidores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Favoritadores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ConsumidoresTotalmente?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ProdutoPrimario?: Maybe<Scalars['ID']>;
  ModalidadeEnsino?: Maybe<Scalars['ID']>;
  OesAssistidos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  TempoMedioDuracao?: Maybe<Scalars['String']>;
  PossuiCertificado?: Maybe<Scalars['Boolean']>;
  SubRotulo?: Maybe<Scalars['ID']>;
  Infografico?: Maybe<Array<Maybe<EditComponentObjetoEducacionalInfogaficoInfograficoInput>>>;
  SubAreaConhecimento?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Visualizadores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ConteudosRelacionados?: Maybe<Array<Maybe<Scalars['ID']>>>;
  RevisaoOrtografica?: Maybe<Scalars['Boolean']>;
  Banners?: Maybe<Array<Maybe<Scalars['ID']>>>;
  patrocinador?: Maybe<Scalars['ID']>;
  AutorizacaoDeUso?: Maybe<Enum_Objetoeducacional_Autorizacaodeuso>;
  ValidadeConteudo?: Maybe<Scalars['Date']>;
  Status?: Maybe<Enum_Objetoeducacional_Status>;
  DireitosUsoImagemTerceirosPacientes?: Maybe<EditComponentCessaoDeDireitosCessaoDeDireitoInput>;
  DataProducao?: Maybe<Scalars['Date']>;
  DataAtualizacaoProducao?: Maybe<Scalars['Date']>;
  palavras_chave?: Maybe<Array<Maybe<Scalars['ID']>>>;
  autor_convidados?: Maybe<Array<Maybe<Scalars['ID']>>>;
  drive_insumo_objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  comentario_drive_insumo?: Maybe<Scalars['String']>;
  historico_avaliacao_objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  uso_imagem_terceiro?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditOeInput = {
  Titulo?: Maybe<Scalars['String']>;
  Rotulo?: Maybe<Enum_Oes_Rotulo>;
  SubRotulo?: Maybe<Enum_Oes_Subrotulo>;
  componentes_auxiliares?: Maybe<Array<Scalars['OesComponentesAuxiliaresDynamicZoneInput']>>;
  secao?: Maybe<Enum_Oes_Secao>;
  revisao?: Maybe<Array<Maybe<EditComponentTipoAprovacaoEtapasAprovacaoInput>>>;
  metadados_identificacao?: Maybe<EditComponentFieldGroupMetadadosIdentificacaoInput>;
  metadados_ciclo_de_vida?: Maybe<EditComponentFieldGroupMetadadosCicloDeVidaInput>;
  metadados_educacional?: Maybe<EditComponentFieldGroupMetadadosEducacionalInput>;
  metadados_einstein?: Maybe<EditComponentFieldGroupMetadadosEinsteinInput>;
  metadados_tecnica?: Maybe<EditComponentFieldGroupTecnicaInput>;
  ConteudoRelacionado?: Maybe<Array<Maybe<Scalars['ID']>>>;
  oes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Autores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPaginaAtendimentoInput = {
  titulo?: Maybe<Scalars['String']>;
  descricao?: Maybe<Scalars['String']>;
  lista_telefones_atendimento?: Maybe<Array<Maybe<EditComponentRodapeRedeSocialListaTelefonesAtendimentoInput>>>;
  lista_horarios_atendimento?: Maybe<Array<Maybe<EditComponentListaHorariosAtendimentoListaHorariosAtendimentoInput>>>;
  lista_emails_atendimento?: Maybe<Array<Maybe<EditComponentListaEmailsAtendimentoListaEmailsAtendimentoInput>>>;
  tipo_atendimentos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPalavraChaveInput = {
  titulo?: Maybe<Scalars['String']>;
  objeto_educacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPatrocinadorInput = {
  titulo?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  categoria_patrocinador?: Maybe<Scalars['ID']>;
  objeto_educacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  banners?: Maybe<Array<Maybe<Scalars['ID']>>>;
  thumbnail?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPerfilDeAutorInput = {
  nome_completo?: Maybe<Scalars['String']>;
  nome_exibicao?: Maybe<Scalars['String']>;
  data_nascimento?: Maybe<Scalars['Date']>;
  CPF?: Maybe<Scalars['String']>;
  nacionalidade?: Maybe<Scalars['String']>;
  estado_civil?: Maybe<Scalars['ID']>;
  CEP?: Maybe<Scalars['String']>;
  endereco?: Maybe<Scalars['String']>;
  numero?: Maybe<Scalars['String']>;
  cidade?: Maybe<Scalars['String']>;
  UF?: Maybe<Scalars['String']>;
  Telefone?: Maybe<Scalars['String']>;
  profissao?: Maybe<Scalars['ID']>;
  profissao_tecnico?: Maybe<Scalars['ID']>;
  outro_qual?: Maybe<Scalars['String']>;
  CRM?: Maybe<Scalars['String']>;
  areas_conhecimento?: Maybe<Array<Maybe<EditComponentFieldGroupSeletorAreaDeConhecimentoInput>>>;
  foto?: Maybe<Scalars['ID']>;
  cargo?: Maybe<Scalars['String']>;
  link_do_curriculo?: Maybe<Scalars['String']>;
  autoriza_divulgacao_link?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  autoriza_divulgacao_email?: Maybe<Scalars['Boolean']>;
  termo_cessao_direito?: Maybe<Scalars['String']>;
  Autoriza_termo_direito?: Maybe<Scalars['Boolean']>;
  data_termo?: Maybe<Scalars['DateTime']>;
  Publicacoes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Seguidores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  nome_projeto?: Maybe<Scalars['String']>;
  link_projeto?: Maybe<Scalars['String']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
  drive_insumo_objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPerguntaQuizzInput = {
  enunciado?: Maybe<Scalars['String']>;
  imagem?: Maybe<Scalars['ID']>;
  feedback_acerto?: Maybe<Scalars['String']>;
  feedback_erro?: Maybe<Scalars['String']>;
  duracao?: Maybe<Scalars['Float']>;
  respostas?: Maybe<Array<Maybe<EditComponentPerguntaOpcaoRespostaInput>>>;
  url_vimeo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditProdutoPrimarioInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditProfissaoInput = {
  titulo?: Maybe<Scalars['String']>;
  PossuiCRM?: Maybe<Scalars['Boolean']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  profissaoPai?: Maybe<Scalars['ID']>;
  profissaos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ehEstudante?: Maybe<Scalars['Boolean']>;
  ehTecnicoAuxiliar?: Maybe<Scalars['Boolean']>;
  userProfissaoFilha?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ehOutro?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditProfissaoTecnicoInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPublicoAlvoInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditQuizzInput = {
  nome?: Maybe<Scalars['String']>;
  feedback?: Maybe<Scalars['String']>;
  perguntas?: Maybe<Array<Scalars['QuizzPerguntasDynamicZoneInput']>>;
  UtilizadoEm?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRecuperacaoSenhaInput = {
  hash?: Maybe<Scalars['String']>;
  Usuario?: Maybe<Scalars['ID']>;
  Expiracao?: Maybe<Scalars['DateTime']>;
  Utilizado?: Maybe<Scalars['Boolean']>;
  canal?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRodapePortalInput = {
  descritivo?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  Atendimento?: Maybe<EditComponentRodapeAtendimentoAtendimentoInput>;
  RedeSocial?: Maybe<EditComponentRodapeRedeSocialRedeSocialInput>;
  Links?: Maybe<EditComponentRodapeLinksLinkInput>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  gestao_funcionalidades?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRotaInput = {
  nome?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRotuloInput = {
  titulo?: Maybe<Scalars['String']>;
  rotulo_pai?: Maybe<Scalars['ID']>;
  rotulos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ImagemFundo?: Maybe<Scalars['ID']>;
  descricao?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditStatusDePublicacaoInput = {
  titulo?: Maybe<Scalars['String']>;
  historico_avaliacao_objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  gestao_funcionalidades?: Maybe<Array<Maybe<Scalars['ID']>>>;
  enum_status?: Maybe<Enum_Statusdepublicacao_Enum_Status>;
  substatus_de_publicacaos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  status_pai?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditSubAreaConhecimentoInput = {
  Nome?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditSubRotuloInput = {
  Titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTermosDeUsoInput = {
  Vigencia?: Maybe<Scalars['Date']>;
  Conteudo?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTipoAreaPaginaInput = {
  Nome?: Maybe<Scalars['String']>;
  TipoPagina?: Maybe<Scalars['ID']>;
  Banners?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTipoAtendimentoInput = {
  titulo?: Maybe<Scalars['String']>;
  contatos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  email_atendimento?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTipoInteratividadeOeInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTipoOeInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTipoPaginaInput = {
  Nome?: Maybe<Scalars['String']>;
  TiposAreaPagina?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Banners?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTipoRecursoEducacionalInput = {
  titulo?: Maybe<Scalars['String']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTiposRelacionamentosEntreOeInput = {
  titulo?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTopicoInput = {
  titulo?: Maybe<Scalars['String']>;
  corclara?: Maybe<Scalars['String']>;
  corescura?: Maybe<Scalars['String']>;
  rota?: Maybe<Scalars['ID']>;
  ObjetosEducacionais?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Imagem?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  nome_completo?: Maybe<Scalars['String']>;
  data_nascimento?: Maybe<Scalars['Date']>;
  cpf?: Maybe<Scalars['String']>;
  celular?: Maybe<Scalars['String']>;
  area_de_conhecimentos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Seguindo?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OesCurtidas?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OesFavoritados?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OesConsumidosTotalmente?: Maybe<Array<Maybe<Scalars['ID']>>>;
  OesConsumidosParcialmente?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Avatar?: Maybe<Scalars['ID']>;
  PerfilProfissao?: Maybe<Array<Maybe<Scalars['ID']>>>;
  UF?: Maybe<Scalars['String']>;
  CRM?: Maybe<Scalars['String']>;
  profissaoFilha?: Maybe<Scalars['ID']>;
  OutraProfissaoFilha?: Maybe<Scalars['String']>;
  OesVisualizados?: Maybe<Array<Maybe<Scalars['ID']>>>;
  acceptTerm?: Maybe<Scalars['Boolean']>;
  acceptSharePersonData?: Maybe<Scalars['Boolean']>;
  documentType?: Maybe<Scalars['String']>;
  documentNumber?: Maybe<Scalars['String']>;
  canal?: Maybe<Scalars['String']>;
  historico_avaliacao_objeto_educacionals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateAreaDeConhecimentoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditAreaDeConhecimentoInput>;
};

export type UpdateAreaDeConhecimentoPayload = {
  __typename?: 'updateAreaDeConhecimentoPayload';
  areaDeConhecimento?: Maybe<AreaDeConhecimento>;
};

export type UpdateAreaDeDestaqueInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditAreaDeDestaqueInput>;
};

export type UpdateAreaDeDestaquePayload = {
  __typename?: 'updateAreaDeDestaquePayload';
  areaDeDestaque?: Maybe<AreaDeDestaque>;
};

export type UpdateAutorConvidadoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditAutorConvidadoInput>;
};

export type UpdateAutorConvidadoPayload = {
  __typename?: 'updateAutorConvidadoPayload';
  autorConvidado?: Maybe<AutorConvidado>;
};

export type UpdateAutorizacaoDeUsoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditAutorizacaoDeUsoInput>;
};

export type UpdateAutorizacaoDeUsoPayload = {
  __typename?: 'updateAutorizacaoDeUsoPayload';
  autorizacaoDeUso?: Maybe<AutorizacaoDeUso>;
};

export type UpdateBannerInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBannerInput>;
};

export type UpdateBannerPayload = {
  __typename?: 'updateBannerPayload';
  banner?: Maybe<Banner>;
};

export type UpdateCategoriaPatrocinadorInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCategoriaPatrocinadorInput>;
};

export type UpdateCategoriaPatrocinadorPayload = {
  __typename?: 'updateCategoriaPatrocinadorPayload';
  categoriaPatrocinador?: Maybe<CategoriaPatrocinador>;
};

export type UpdateContatoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditContatoInput>;
};

export type UpdateContatoPayload = {
  __typename?: 'updateContatoPayload';
  contato?: Maybe<Contatos>;
};

export type UpdateDensidadeSemanticaInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditDensidadeSemanticaInput>;
};

export type UpdateDensidadeSemanticaPayload = {
  __typename?: 'updateDensidadeSemanticaPayload';
  densidadeSemantica?: Maybe<DensidadeSemantica>;
};

export type UpdateDescomplicandoCienciaInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditDescomplicandoCienciaInput>;
};

export type UpdateDescomplicandoCienciaPayload = {
  __typename?: 'updateDescomplicandoCienciaPayload';
  descomplicandoCiencia?: Maybe<DescomplicandoCiencia>;
};

export type UpdateDriveInsumoObjetoEducacionalInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditDriveInsumoObjetoEducacionalInput>;
};

export type UpdateDriveInsumoObjetoEducacionalPayload = {
  __typename?: 'updateDriveInsumoObjetoEducacionalPayload';
  driveInsumoObjetoEducacional?: Maybe<DriveInsumoObjetoEducacional>;
};

export type UpdateEnsinoEinsteinInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditEnsinoEinsteinInput>;
};

export type UpdateEnsinoEinsteinPageInput = {
  data?: Maybe<EditEnsinoEinsteinPageInput>;
};

export type UpdateEnsinoEinsteinPagePayload = {
  __typename?: 'updateEnsinoEinsteinPagePayload';
  ensinoEinsteinPage?: Maybe<EnsinoEinsteinPage>;
};

export type UpdateEnsinoEinsteinPayload = {
  __typename?: 'updateEnsinoEinsteinPayload';
  ensinoEinstein?: Maybe<EnsinoEinstein>;
};

export type UpdateEstadoCivilInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditEstadoCivilInput>;
};

export type UpdateEstadoCivilPayload = {
  __typename?: 'updateEstadoCivilPayload';
  estadoCivil?: Maybe<EstadoCivil>;
};

export type UpdateGestaoFuncionalidadeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditGestaoFuncionalidadeInput>;
};

export type UpdateGestaoFuncionalidadePayload = {
  __typename?: 'updateGestaoFuncionalidadePayload';
  gestaoFuncionalidade?: Maybe<GestaoFuncionalidade>;
};

export type UpdateGranularidadeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditGranularidadeInput>;
};

export type UpdateGranularidadePayload = {
  __typename?: 'updateGranularidadePayload';
  granularidade?: Maybe<Granularidade>;
};

export type UpdateHeaderPortalInput = {
  data?: Maybe<EditHeaderPortalInput>;
};

export type UpdateHeaderPortalPayload = {
  __typename?: 'updateHeaderPortalPayload';
  headerPortal?: Maybe<HeaderPortal>;
};

export type UpdateHistoricoAvaliacaoObjetoEducacionalInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditHistoricoAvaliacaoObjetoEducacionalInput>;
};

export type UpdateHistoricoAvaliacaoObjetoEducacionalPayload = {
  __typename?: 'updateHistoricoAvaliacaoObjetoEducacionalPayload';
  historicoAvaliacaoObjetoEducacional?: Maybe<HistoricoAvaliacaoObjetoEducacional>;
};

export type UpdateHomeObjetoEducacionalPageInput = {
  data?: Maybe<EditHomeObjetoEducacionalPageInput>;
};

export type UpdateHomeObjetoEducacionalPagePayload = {
  __typename?: 'updateHomeObjetoEducacionalPagePayload';
  homeObjetoEducacionalPage?: Maybe<HomeObjetoEducacionalPage>;
};

export type UpdateIdiomaInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditIdiomaInput>;
};

export type UpdateIdiomaPayload = {
  __typename?: 'updateIdiomaPayload';
  idioma?: Maybe<Idiomas>;
};

export type UpdateItemMenuInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditItemMenuInput>;
};

export type UpdateItemMenuPayload = {
  __typename?: 'updateItemMenuPayload';
  itemMenu?: Maybe<ItemMenu>;
};

export type UpdateItemRodapeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditItemRodapeInput>;
};

export type UpdateItemRodapePayload = {
  __typename?: 'updateItemRodapePayload';
  itemRodape?: Maybe<ItemRodapes>;
};

export type UpdateMaturidadePublicoAlvoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditMaturidadePublicoAlvoInput>;
};

export type UpdateMaturidadePublicoAlvoPayload = {
  __typename?: 'updateMaturidadePublicoAlvoPayload';
  maturidadePublicoAlvo?: Maybe<MaturidadePublicoAlvo>;
};

export type UpdateModalidadeDeEnsinoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditModalidadeDeEnsinoInput>;
};

export type UpdateModalidadeDeEnsinoPayload = {
  __typename?: 'updateModalidadeDeEnsinoPayload';
  modalidadeDeEnsino?: Maybe<ModalidadeDeEnsino>;
};

export type UpdateNivelDosObjetivosDeAprendizagemInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditNivelDosObjetivosDeAprendizagemInput>;
};

export type UpdateNivelDosObjetivosDeAprendizagemPayload = {
  __typename?: 'updateNivelDosObjetivosDeAprendizagemPayload';
  nivelDosObjetivosDeAprendizagem?: Maybe<NivelDosObjetivosDeAprendizagem>;
};

export type UpdateOEsAssistidosPorUsuarioInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditOEsAssistidosPorUsuarioInput>;
};

export type UpdateOEsAssistidosPorUsuarioPayload = {
  __typename?: 'updateOEsAssistidosPorUsuarioPayload';
  oEsAssistidosPorUsuario?: Maybe<OEsAssistidosPorUsuario>;
};

export type UpdateObjetoEducacionalInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditObjetoEducacionalInput>;
};

export type UpdateObjetoEducacionalPayload = {
  __typename?: 'updateObjetoEducacionalPayload';
  objetoEducacional?: Maybe<ObjetoEducacional>;
};

export type UpdateOeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditOeInput>;
};

export type UpdateOePayload = {
  __typename?: 'updateOePayload';
  oe?: Maybe<Oes>;
};

export type UpdatePaginaAtendimentoInput = {
  data?: Maybe<EditPaginaAtendimentoInput>;
};

export type UpdatePaginaAtendimentoPayload = {
  __typename?: 'updatePaginaAtendimentoPayload';
  paginaAtendimento?: Maybe<PaginaAtendimento>;
};

export type UpdatePalavraChaveInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPalavraChaveInput>;
};

export type UpdatePalavraChavePayload = {
  __typename?: 'updatePalavraChavePayload';
  palavraChave?: Maybe<PalavraChave>;
};

export type UpdatePatrocinadorInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPatrocinadorInput>;
};

export type UpdatePatrocinadorPayload = {
  __typename?: 'updatePatrocinadorPayload';
  patrocinador?: Maybe<Patrocinador>;
};

export type UpdatePerfilDeAutorInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPerfilDeAutorInput>;
};

export type UpdatePerfilDeAutorPayload = {
  __typename?: 'updatePerfilDeAutorPayload';
  perfilDeAutor?: Maybe<PerfilDeAutor>;
};

export type UpdatePerguntaQuizzInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPerguntaQuizzInput>;
};

export type UpdatePerguntaQuizzPayload = {
  __typename?: 'updatePerguntaQuizzPayload';
  perguntaQuizz?: Maybe<PerguntaQuizz>;
};

export type UpdateProdutoPrimarioInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProdutoPrimarioInput>;
};

export type UpdateProdutoPrimarioPayload = {
  __typename?: 'updateProdutoPrimarioPayload';
  produtoPrimario?: Maybe<ProdutoPrimario>;
};

export type UpdateProfissaoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProfissaoInput>;
};

export type UpdateProfissaoPayload = {
  __typename?: 'updateProfissaoPayload';
  profissao?: Maybe<Profissao>;
};

export type UpdateProfissaoTecnicoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProfissaoTecnicoInput>;
};

export type UpdateProfissaoTecnicoPayload = {
  __typename?: 'updateProfissaoTecnicoPayload';
  profissaoTecnico?: Maybe<ProfissaoTecnico>;
};

export type UpdatePublicoAlvoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPublicoAlvoInput>;
};

export type UpdatePublicoAlvoPayload = {
  __typename?: 'updatePublicoAlvoPayload';
  publicoAlvo?: Maybe<PublicoAlvo>;
};

export type UpdateQuizzInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditQuizzInput>;
};

export type UpdateQuizzPayload = {
  __typename?: 'updateQuizzPayload';
  quizz?: Maybe<Quizz>;
};

export type UpdateRecuperacaoSenhaInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRecuperacaoSenhaInput>;
};

export type UpdateRecuperacaoSenhaPayload = {
  __typename?: 'updateRecuperacaoSenhaPayload';
  recuperacaoSenha?: Maybe<RecuperacaoSenha>;
};

export type UpdateRodapePortalInput = {
  data?: Maybe<EditRodapePortalInput>;
};

export type UpdateRodapePortalPayload = {
  __typename?: 'updateRodapePortalPayload';
  rodapePortal?: Maybe<RodapePortal>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateRotaInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRotaInput>;
};

export type UpdateRotaPayload = {
  __typename?: 'updateRotaPayload';
  rota?: Maybe<Rotas>;
};

export type UpdateRotuloInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRotuloInput>;
};

export type UpdateRotuloPayload = {
  __typename?: 'updateRotuloPayload';
  rotulo?: Maybe<Rotulo>;
};

export type UpdateStatusDePublicacaoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditStatusDePublicacaoInput>;
};

export type UpdateStatusDePublicacaoPayload = {
  __typename?: 'updateStatusDePublicacaoPayload';
  statusDePublicacao?: Maybe<StatusDePublicacao>;
};

export type UpdateSubAreaConhecimentoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSubAreaConhecimentoInput>;
};

export type UpdateSubAreaConhecimentoPayload = {
  __typename?: 'updateSubAreaConhecimentoPayload';
  subAreaConhecimento?: Maybe<SubAreaConhecimento>;
};

export type UpdateSubRotuloInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSubRotuloInput>;
};

export type UpdateSubRotuloPayload = {
  __typename?: 'updateSubRotuloPayload';
  subRotulo?: Maybe<SubRotulo>;
};

export type UpdateTermosDeUsoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTermosDeUsoInput>;
};

export type UpdateTermosDeUsoPayload = {
  __typename?: 'updateTermosDeUsoPayload';
  termosDeUso?: Maybe<TermosDeUso>;
};

export type UpdateTipoAreaPaginaInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTipoAreaPaginaInput>;
};

export type UpdateTipoAreaPaginaPayload = {
  __typename?: 'updateTipoAreaPaginaPayload';
  tipoAreaPagina?: Maybe<TipoAreaPagina>;
};

export type UpdateTipoAtendimentoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTipoAtendimentoInput>;
};

export type UpdateTipoAtendimentoPayload = {
  __typename?: 'updateTipoAtendimentoPayload';
  tipoAtendimento?: Maybe<TipoAtendimento>;
};

export type UpdateTipoInteratividadeOeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTipoInteratividadeOeInput>;
};

export type UpdateTipoInteratividadeOePayload = {
  __typename?: 'updateTipoInteratividadeOePayload';
  tipoInteratividadeOe?: Maybe<TipoInteratividadeOe>;
};

export type UpdateTipoOeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTipoOeInput>;
};

export type UpdateTipoOePayload = {
  __typename?: 'updateTipoOePayload';
  tipoOe?: Maybe<TipoOe>;
};

export type UpdateTipoPaginaInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTipoPaginaInput>;
};

export type UpdateTipoPaginaPayload = {
  __typename?: 'updateTipoPaginaPayload';
  tipoPagina?: Maybe<TipoPagina>;
};

export type UpdateTipoRecursoEducacionalInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTipoRecursoEducacionalInput>;
};

export type UpdateTipoRecursoEducacionalPayload = {
  __typename?: 'updateTipoRecursoEducacionalPayload';
  tipoRecursoEducacional?: Maybe<TipoRecursoEducacional>;
};

export type UpdateTiposRelacionamentosEntreOeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTiposRelacionamentosEntreOeInput>;
};

export type UpdateTiposRelacionamentosEntreOePayload = {
  __typename?: 'updateTiposRelacionamentosEntreOePayload';
  tiposRelacionamentosEntreOe?: Maybe<TiposRelacionamentosEntreOe>;
};

export type UpdateTopicoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTopicoInput>;
};

export type UpdateTopicoPayload = {
  __typename?: 'updateTopicoPayload';
  topico?: Maybe<Topico>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type AutorFragment = (
  { __typename?: 'PerfilDeAutor' }
  & Pick<PerfilDeAutor, 'id' | 'nome_completo' | 'nome_exibicao' | 'CPF' | 'data_nascimento' | 'nacionalidade' | 'CEP' | 'endereco' | 'numero' | 'cidade' | 'UF' | 'Telefone' | 'outro_qual' | 'CRM' | 'cargo' | 'link_do_curriculo' | 'autoriza_divulgacao_link' | 'email' | 'autoriza_divulgacao_email' | 'termo_cessao_direito' | 'Autoriza_termo_direito' | 'nome_projeto' | 'link_projeto'>
  & { estado_civil?: Maybe<(
    { __typename?: 'EstadoCivil' }
    & Pick<EstadoCivil, 'titulo' | 'id'>
  )>, profissao?: Maybe<(
    { __typename?: 'Profissao' }
    & Pick<Profissao, 'id' | 'titulo'>
  )>, profissao_tecnico?: Maybe<(
    { __typename?: 'ProfissaoTecnico' }
    & Pick<ProfissaoTecnico, 'titulo'>
  )>, foto?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'id' | 'name' | 'alternativeText'>
  )> }
);

export type CreateAuthorMutationVariables = Exact<{
  input?: Maybe<CreatePerfilDeAutorInput>;
}>;


export type CreateAuthorMutation = (
  { __typename?: 'Mutation' }
  & { createPerfilDeAutor?: Maybe<(
    { __typename?: 'createPerfilDeAutorPayload' }
    & { perfilDeAutor?: Maybe<(
      { __typename?: 'PerfilDeAutor' }
      & AutorFragment
    )> }
  )> }
);

export type ApproveInvitationMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ApproveInvitationMutation = (
  { __typename?: 'Mutation' }
  & { approveInvitation: (
    { __typename?: 'AutorConviteMessage' }
    & Pick<AutorConviteMessage, 'message'>
  ) }
);

export type DeleteDriveInsumoMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDriveInsumoMutation = (
  { __typename?: 'Mutation' }
  & { deleteDriveInsumo: (
    { __typename?: 'MessageResponse' }
    & Pick<MessageResponse, 'message'>
  ) }
);

export type CreateDriveInsumoObjetoEducacionalMutationVariables = Exact<{
  input: CreateDriveInsumoObjetoEducacionalInput;
}>;


export type CreateDriveInsumoObjetoEducacionalMutation = (
  { __typename?: 'Mutation' }
  & { createDriveInsumoObjetoEducacional?: Maybe<(
    { __typename?: 'createDriveInsumoObjetoEducacionalPayload' }
    & { driveInsumoObjetoEducacional?: Maybe<(
      { __typename?: 'DriveInsumoObjetoEducacional' }
      & Pick<DriveInsumoObjetoEducacional, 'id' | 'nome' | 'extensao' | 'url' | 'tipo' | 'created_at'>
    )> }
  )> }
);

export type CreateHistoricoAvaliacaoObjetoEducacionalMutationVariables = Exact<{
  input: CreateHistoricoAvaliacaoObjetoEducacionalInput;
}>;


export type CreateHistoricoAvaliacaoObjetoEducacionalMutation = (
  { __typename?: 'Mutation' }
  & { createHistoricoAvaliacaoObjetoEducacional?: Maybe<(
    { __typename?: 'createHistoricoAvaliacaoObjetoEducacionalPayload' }
    & { historicoAvaliacaoObjetoEducacional?: Maybe<(
      { __typename?: 'HistoricoAvaliacaoObjetoEducacional' }
      & { objeto_educacional?: Maybe<(
        { __typename?: 'ObjetoEducacional' }
        & Pick<ObjetoEducacional, 'id'>
      )>, status_de_publicacao?: Maybe<(
        { __typename?: 'StatusDePublicacao' }
        & Pick<StatusDePublicacao, 'id'>
      )>, users_permissions_user?: Maybe<(
        { __typename?: 'UsersPermissionsUser' }
        & Pick<UsersPermissionsUser, 'id'>
      )> }
    )> }
  )> }
);

export type LoginMutationVariables = Exact<{
  identifier: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { login: (
    { __typename?: 'UsersPermissionsLoginPayload' }
    & Pick<UsersPermissionsLoginPayload, 'jwt'>
    & { user: (
      { __typename?: 'UsersPermissionsMe' }
      & Pick<UsersPermissionsMe, 'id'>
    ) }
  ) }
);

export type CreateObjetoEducacionalMutationVariables = Exact<{
  input?: Maybe<CreateObjetoEducacionalInput>;
}>;


export type CreateObjetoEducacionalMutation = (
  { __typename?: 'Mutation' }
  & { createObjetoEducacional?: Maybe<(
    { __typename?: 'createObjetoEducacionalPayload' }
    & { objetoEducacional?: Maybe<(
      { __typename?: 'ObjetoEducacional' }
      & Pick<ObjetoEducacional, 'published_at'>
      & ObjetoEducacionalEdicaoFragment
    )> }
  )> }
);

export type UpdateObjetoEducacionalMutationVariables = Exact<{
  input?: Maybe<UpdateObjetoEducacionalInput>;
}>;


export type UpdateObjetoEducacionalMutation = (
  { __typename?: 'Mutation' }
  & { updateObjetoEducacional?: Maybe<(
    { __typename?: 'updateObjetoEducacionalPayload' }
    & { objetoEducacional?: Maybe<(
      { __typename?: 'ObjetoEducacional' }
      & ObjetoEducacionalFragment
    )> }
  )> }
);

export type UpdateObjetoEducacionalDriveInsumoMutationVariables = Exact<{
  id: Scalars['ID'];
  comentario: Scalars['String'];
  uso_imagem_terceiro: Scalars['Boolean'];
}>;


export type UpdateObjetoEducacionalDriveInsumoMutation = (
  { __typename?: 'Mutation' }
  & { updateObjetoEducacionalDriveInsumo?: Maybe<(
    { __typename?: 'ObjetoEducacionalComentarioDriveInsumo' }
    & Pick<ObjetoEducacionalComentarioDriveInsumo, 'id' | 'uso_imagem_terceiro' | 'comentario' | 'updated_at'>
  )> }
);

export type PalavrasChaveFragment = (
  { __typename?: 'PalavraChave' }
  & Pick<PalavraChave, 'id' | 'titulo'>
);

export type CreatePalavraChaveMutationVariables = Exact<{
  input?: Maybe<CreatePalavraChaveInput>;
}>;


export type CreatePalavraChaveMutation = (
  { __typename?: 'Mutation' }
  & { createPalavraChave?: Maybe<(
    { __typename?: 'createPalavraChavePayload' }
    & { palavraChave?: Maybe<(
      { __typename?: 'PalavraChave' }
      & PalavrasChaveFragment
    )> }
  )> }
);

export type PerguntaQuizFragment = (
  { __typename?: 'PerguntaQuizz' }
  & Pick<PerguntaQuizz, 'enunciado' | 'feedback_erro' | 'feedback_acerto'>
  & { respostas?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentPerguntaOpcaoRespostas' }
    & RespostaQuizzFragment
  )>>> }
);

export type RespostaQuizzFragment = (
  { __typename?: 'ComponentPerguntaOpcaoRespostas' }
  & Pick<ComponentPerguntaOpcaoRespostas, 'opcao' | 'opcao_correta'>
);

export type CreatePerguntasQuizMutationVariables = Exact<{
  input: CreatePerguntaQuizzInput;
}>;


export type CreatePerguntasQuizMutation = (
  { __typename?: 'Mutation' }
  & { createPerguntaQuizz?: Maybe<(
    { __typename?: 'createPerguntaQuizzPayload' }
    & { perguntaQuizz?: Maybe<(
      { __typename?: 'PerguntaQuizz' }
      & Pick<PerguntaQuizz, 'enunciado' | 'feedback_acerto' | 'feedback_erro'>
      & { respostas?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentPerguntaOpcaoRespostas' }
        & Pick<ComponentPerguntaOpcaoRespostas, 'opcao' | 'opcao_correta'>
      )>>> }
    )> }
  )> }
);

export type GetEstadoCivisQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEstadoCivisQuery = (
  { __typename?: 'Query' }
  & { estadoCivils?: Maybe<Array<Maybe<(
    { __typename?: 'EstadoCivil' }
    & Pick<EstadoCivil, 'id' | 'titulo'>
  )>>> }
);

export type CategoriaFragment = (
  { __typename?: 'Rotulo' }
  & Pick<Rotulo, 'id' | 'titulo'>
);

export type GetAllCategoriasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCategoriasQuery = (
  { __typename?: 'Query' }
  & { rotulosConnection?: Maybe<(
    { __typename?: 'RotuloConnection' }
    & { values?: Maybe<Array<Maybe<(
      { __typename?: 'Rotulo' }
      & CategoriaFragment
    )>>> }
  )> }
);

export type StatusPublicacaoDataFragment = (
  { __typename?: 'StatusDePublicacao' }
  & Pick<StatusDePublicacao, 'id' | 'titulo' | 'enum_status' | 'status_pai'>
);

export type StatusPublicacaoFragment = (
  { __typename?: 'StatusDePublicacao' }
  & Pick<StatusDePublicacao, 'status_pai'>
  & { substatus_de_publicacaos?: Maybe<Array<Maybe<(
    { __typename?: 'StatusDePublicacao' }
    & StatusPublicacaoDataFragment
  )>>> }
  & StatusPublicacaoDataFragment
);

export type GetAllStatusPublicacoesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStatusPublicacoesQuery = (
  { __typename?: 'Query' }
  & { statusDePublicacaosConnection?: Maybe<(
    { __typename?: 'StatusDePublicacaoConnection' }
    & { values?: Maybe<Array<Maybe<(
      { __typename?: 'StatusDePublicacao' }
      & StatusPublicacaoFragment
    )>>> }
  )> }
);

export type AutorConvidadoFragment = (
  { __typename?: 'AutorConvidadoOE' }
  & Pick<AutorConvidadoOe, 'id' | 'nome' | 'email' | 'status' | 'aceita_participacao'>
);

export type GetAutorConvidadoByOeIdQueryVariables = Exact<{
  idOe: Scalars['ID'];
}>;


export type GetAutorConvidadoByOeIdQuery = (
  { __typename?: 'Query' }
  & { findAutoresConvidadosByObjetoEducacional?: Maybe<Array<(
    { __typename?: 'AutorConvidadoOE' }
    & AutorConvidadoFragment
  )>> }
);

export type GetConvitesPendenteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConvitesPendenteQuery = (
  { __typename?: 'Query' }
  & { findConvitesPendente: (
    { __typename?: 'ConvitePendentesPayload' }
    & Pick<ConvitePendentesPayload, 'total'>
    & { data?: Maybe<Array<(
      { __typename?: 'ConvitePendentesData' }
      & Pick<ConvitePendentesData, 'id' | 'oe_id' | 'titulo' | 'categoria' | 'tipo' | 'data_criacao'>
    )>> }
  ) }
);

export type DriveInsumoObjetoEducacionalFragment = (
  { __typename?: 'DriveInsumoObjetoEducacional' }
  & Pick<DriveInsumoObjetoEducacional, 'id' | 'nome' | 'extensao' | 'url' | 'tipo'>
  & { objeto_educacional?: Maybe<(
    { __typename?: 'ObjetoEducacional' }
    & Pick<ObjetoEducacional, 'id'>
  )>, autor?: Maybe<(
    { __typename?: 'PerfilDeAutor' }
    & Pick<PerfilDeAutor, 'id'>
  )> }
);

export type GetDriveInsumosByObjetoEducacionalIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDriveInsumosByObjetoEducacionalIdQuery = (
  { __typename?: 'Query' }
  & { findDriveInsumosByObjetoEducacional?: Maybe<Array<(
    { __typename?: 'DriveInsumoObjetoEducacional' }
    & DriveInsumoObjetoEducacionalFragment
  )>> }
);

export type KeyWordPayloadFragment = (
  { __typename?: 'KeyWordPayload' }
  & Pick<KeyWordPayload, 'id' | 'titulo'>
);

export type GetGetObjetosEducacionaisByKeyWordQueryVariables = Exact<{
  where: KeyWordInput;
}>;


export type GetGetObjetosEducacionaisByKeyWordQuery = (
  { __typename?: 'Query' }
  & { findByKeyWord?: Maybe<Array<(
    { __typename?: 'KeyWordPayload' }
    & KeyWordPayloadFragment
  )>> }
);

export type GetHistoricoAvaliacaoAtualOePorIdQueryVariables = Exact<{
  oeId: Scalars['ID'];
}>;


export type GetHistoricoAvaliacaoAtualOePorIdQuery = (
  { __typename?: 'Query' }
  & { findHistoricoAvaliacaoAtualByOeId: (
    { __typename?: 'StatusDePublicacao' }
    & Pick<StatusDePublicacao, 'titulo' | 'enum_status'>
  ) }
);

export type ObjetoEducacionalEdicaoFragment = (
  { __typename?: 'ObjetoEducacional' }
  & Pick<ObjetoEducacional, 'id' | 'Titulo' | 'Descricao' | 'Resumo' | 'DataProducao' | 'DataAtualizacaoProducao' | 'ValidadeConteudo' | 'RestricaoPublicoMedico' | 'comentario_drive_insumo' | 'uso_imagem_terceiro'>
  & { Autores?: Maybe<Array<Maybe<(
    { __typename?: 'PerfilDeAutor' }
    & Pick<PerfilDeAutor, 'id' | 'nome_exibicao' | 'email' | 'cargo'>
    & { foto?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )> }
  )>>>, PublicoAlvo?: Maybe<Array<Maybe<(
    { __typename?: 'PublicoAlvo' }
    & Pick<PublicoAlvo, 'id' | 'titulo'>
  )>>>, Rotulos?: Maybe<Array<Maybe<(
    { __typename?: 'Rotulo' }
    & Pick<Rotulo, 'id' | 'titulo'>
  )>>>, AreasConhecimento?: Maybe<Array<Maybe<(
    { __typename?: 'AreaDeConhecimento' }
    & Pick<AreaDeConhecimento, 'id' | 'titulo'>
  )>>>, palavras_chave?: Maybe<Array<Maybe<(
    { __typename?: 'PalavraChave' }
    & Pick<PalavraChave, 'id' | 'titulo'>
  )>>>, TipoObjeto?: Maybe<Array<Maybe<(
    { __typename?: 'TipoOe' }
    & Pick<TipoOe, 'id' | 'titulo'>
  )>>>, autor_convidados_v2?: Maybe<Array<(
    { __typename?: 'AutorConvidadoOE' }
    & Pick<AutorConvidadoOe, 'id' | 'nome' | 'email' | 'status' | 'aceita_participacao' | 'autor_convidado'>
  )>> }
);

export type ObjetoEducacionalFragment = (
  { __typename?: 'ObjetoEducacional' }
  & { SecoesTexto?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentSecaoTextSecaoTexto' }
    & Pick<ComponentSecaoTextSecaoTexto, 'id' | 'Secao'>
  )>>>, VideoAudio?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentSecaoVideoAudioVideoAudio' }
    & Pick<ComponentSecaoVideoAudioVideoAudio, 'id' | 'URL' | 'url_mp3'>
    & { Thumbs?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )> }
  )>>>, Infografico?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentObjetoEducacionalInfogaficoInfografico' }
    & Pick<ComponentObjetoEducacionalInfogaficoInfografico, 'id' | 'Descricao'>
  )>>> }
  & ObjetoEducacionalEdicaoFragment
);

export type GetObjetoEducacionalPorIdQueryVariables = Exact<{
  input: Scalars['ID'];
}>;


export type GetObjetoEducacionalPorIdQuery = (
  { __typename?: 'Query' }
  & { objetoEducacional?: Maybe<(
    { __typename?: 'ObjetoEducacional' }
    & ObjetoEducacionalFragment
  )> }
);

export type GetObjetoEducacionalEdicaoPorIdQueryVariables = Exact<{
  id: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
}>;


export type GetObjetoEducacionalEdicaoPorIdQuery = (
  { __typename?: 'Query' }
  & { findById?: Maybe<(
    { __typename?: 'ObjetoEducacional' }
    & ObjetoEducacionalEdicaoFragment
  )> }
);

export type ComponentPerguntaQuizzPerguntaFragment = (
  { __typename?: 'ComponentPerguntaQuizzPergunta' }
  & { pergunta?: Maybe<(
    { __typename?: 'PerguntaQuizz' }
    & Pick<PerguntaQuizz, 'id' | 'enunciado' | 'feedback_acerto' | 'feedback_erro' | 'duracao' | 'url_vimeo'>
    & { imagem?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, respostas?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentPerguntaOpcaoRespostas' }
      & Pick<ComponentPerguntaOpcaoRespostas, 'id' | 'opcao' | 'opcao_correta' | 'contador'>
    )>>> }
  )> }
);

export type GetObjetoEducacionalWithQuizByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetObjetoEducacionalWithQuizByIdQuery = (
  { __typename?: 'Query' }
  & { objetoEducacional?: Maybe<(
    { __typename?: 'ObjetoEducacional' }
    & Pick<ObjetoEducacional, 'id'>
    & { Quizzes?: Maybe<Array<Maybe<(
      { __typename?: 'Quizz' }
      & Pick<Quizz, 'id'>
      & { perguntas?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentPerguntaQuizzPergunta' }
        & ComponentPerguntaQuizzPerguntaFragment
      )>>> }
    )>>> }
  )> }
);

export type ObjetoEducacionalWithHistoricoAvaliacaoDataFragment = (
  { __typename?: 'ObjetoEducacionalWithHistoricoAvaliacaoData' }
  & Pick<ObjetoEducacionalWithHistoricoAvaliacaoData, 'id' | 'titulo' | 'data_criacao' | 'data_validade' | 'tipo' | 'categoria' | 'status' | 'expirado'>
);

export type GetObjetosEducacionaisBySearchQueryVariables = Exact<{
  where: ObjetoEducacionalWithHistoricoAvaliacaoInput;
  order_by: Enum_Objeto_Educacional_With_Historico_Avaliacao_Order_By;
  start: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetObjetosEducacionaisBySearchQuery = (
  { __typename?: 'Query' }
  & { findObjetosEducacionaisWithHistoricoAvaliacao: (
    { __typename?: 'ObjetoEducacionalWithHistoricoAvaliacaoConnection' }
    & Pick<ObjetoEducacionalWithHistoricoAvaliacaoConnection, 'total' | 'totalCount' | 'error'>
    & { data?: Maybe<Array<(
      { __typename?: 'ObjetoEducacionalWithHistoricoAvaliacaoData' }
      & ObjetoEducacionalWithHistoricoAvaliacaoDataFragment
    )>> }
  ) }
);

export type GetPalavrasChaveQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPalavrasChaveQuery = (
  { __typename?: 'Query' }
  & { palavraChaves?: Maybe<Array<Maybe<(
    { __typename?: 'PalavraChave' }
    & Pick<PalavraChave, 'id' | 'titulo'>
  )>>> }
);

export type GetPalavrasChaveByOeQueryVariables = Exact<{
  oe: Scalars['ID'];
}>;


export type GetPalavrasChaveByOeQuery = (
  { __typename?: 'Query' }
  & { findPalavraChavesByOe?: Maybe<Array<Maybe<(
    { __typename?: 'PalavraChaveOE' }
    & Pick<PalavraChaveOe, 'id' | 'titulo'>
  )>>> }
);

export type GetPalavrasChavePorNomeQueryVariables = Exact<{
  input?: Maybe<Scalars['String']>;
}>;


export type GetPalavrasChavePorNomeQuery = (
  { __typename?: 'Query' }
  & { palavraChaves?: Maybe<Array<Maybe<(
    { __typename?: 'PalavraChave' }
    & Pick<PalavraChave, 'id' | 'titulo'>
  )>>> }
);

export type GetStatusPorTituloQueryVariables = Exact<{
  enum_status: Scalars['String'];
}>;


export type GetStatusPorTituloQuery = (
  { __typename?: 'Query' }
  & { statusDePublicacaos?: Maybe<Array<Maybe<(
    { __typename?: 'StatusDePublicacao' }
    & Pick<StatusDePublicacao, 'id' | 'titulo'>
  )>>> }
);

export type GetTipoObjetosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTipoObjetosQuery = (
  { __typename?: 'Query' }
  & { tipoOes?: Maybe<Array<Maybe<(
    { __typename?: 'TipoOe' }
    & Pick<TipoOe, 'id' | 'titulo'>
  )>>> }
);

export type GetTotalObjetosEducacionaisAExpirarQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalObjetosEducacionaisAExpirarQuery = (
  { __typename?: 'Query' }
  & { findTotalObjetosEducacionaisAExpirar: (
    { __typename?: 'TotalPayload' }
    & Pick<TotalPayload, 'total'>
  ) }
);

export type GetTotalConteudosByUserRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalConteudosByUserRoleQuery = (
  { __typename?: 'Query' }
  & { findTotalObjetoEducacionalByStatusPublicacaoAndUserRole: (
    { __typename?: 'TotalPayload' }
    & Pick<TotalPayload, 'total'>
  ) }
);

export type GetProfissoesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfissoesQuery = (
  { __typename?: 'Query' }
  & { profissaos?: Maybe<Array<Maybe<(
    { __typename?: 'Profissao' }
    & Pick<Profissao, 'id' | 'titulo' | 'PossuiCRM'>
  )>>> }
);

export type GetPublicoAlvoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublicoAlvoQuery = (
  { __typename?: 'Query' }
  & { publicoAlvos?: Maybe<Array<Maybe<(
    { __typename?: 'PublicoAlvo' }
    & Pick<PublicoAlvo, 'id' | 'titulo'>
  )>>> }
);

export type GetRotulosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRotulosQuery = (
  { __typename?: 'Query' }
  & { rotulos?: Maybe<Array<Maybe<(
    { __typename?: 'Rotulo' }
    & Pick<Rotulo, 'id' | 'titulo' | 'descricao'>
  )>>> }
);

export const AutorFragmentDoc = gql`
    fragment Autor on PerfilDeAutor {
  id
  nome_completo
  nome_exibicao
  CPF
  data_nascimento
  nacionalidade
  estado_civil {
    titulo
    id
  }
  CEP
  endereco
  numero
  cidade
  UF
  Telefone
  profissao {
    id
    titulo
  }
  profissao_tecnico {
    titulo
  }
  outro_qual
  CRM
  foto {
    id
    name
    alternativeText
  }
  cargo
  link_do_curriculo
  autoriza_divulgacao_link
  email
  autoriza_divulgacao_email
  termo_cessao_direito
  Autoriza_termo_direito
  nome_projeto
  link_projeto
}
    `;
export const PalavrasChaveFragmentDoc = gql`
    fragment PalavrasChave on PalavraChave {
  id
  titulo
}
    `;
export const RespostaQuizzFragmentDoc = gql`
    fragment respostaQuizz on ComponentPerguntaOpcaoRespostas {
  opcao
  opcao_correta
}
    `;
export const PerguntaQuizFragmentDoc = gql`
    fragment perguntaQuiz on PerguntaQuizz {
  enunciado
  feedback_erro
  feedback_acerto
  respostas {
    ...respostaQuizz
  }
}
    ${RespostaQuizzFragmentDoc}`;
export const CategoriaFragmentDoc = gql`
    fragment Categoria on Rotulo {
  id
  titulo
}
    `;
export const StatusPublicacaoDataFragmentDoc = gql`
    fragment StatusPublicacaoData on StatusDePublicacao {
  id
  titulo
  enum_status
  status_pai
}
    `;
export const StatusPublicacaoFragmentDoc = gql`
    fragment StatusPublicacao on StatusDePublicacao {
  ...StatusPublicacaoData
  status_pai
  substatus_de_publicacaos {
    ...StatusPublicacaoData
  }
}
    ${StatusPublicacaoDataFragmentDoc}`;
export const AutorConvidadoFragmentDoc = gql`
    fragment AutorConvidado on AutorConvidadoOE {
  id
  nome
  email
  status
  aceita_participacao
}
    `;
export const DriveInsumoObjetoEducacionalFragmentDoc = gql`
    fragment DriveInsumoObjetoEducacional on DriveInsumoObjetoEducacional {
  id
  nome
  extensao
  url
  tipo
  objeto_educacional {
    id
  }
  autor {
    id
  }
}
    `;
export const KeyWordPayloadFragmentDoc = gql`
    fragment KeyWordPayload on KeyWordPayload {
  id
  titulo
}
    `;
export const ObjetoEducacionalEdicaoFragmentDoc = gql`
    fragment ObjetoEducacionalEdicao on ObjetoEducacional {
  id
  Titulo
  Descricao
  Resumo
  DataProducao
  DataAtualizacaoProducao
  ValidadeConteudo
  RestricaoPublicoMedico
  comentario_drive_insumo
  uso_imagem_terceiro
  Autores {
    id
    nome_exibicao
    email
    cargo
    foto {
      id
      url
    }
  }
  PublicoAlvo {
    id
    titulo
  }
  Rotulos {
    id
    titulo
  }
  AreasConhecimento {
    id
    titulo
  }
  palavras_chave {
    id
    titulo
  }
  TipoObjeto {
    id
    titulo
  }
  autor_convidados_v2 {
    id
    nome
    email
    status
    aceita_participacao
    autor_convidado
  }
}
    `;
export const ObjetoEducacionalFragmentDoc = gql`
    fragment ObjetoEducacional on ObjetoEducacional {
  ...ObjetoEducacionalEdicao
  SecoesTexto {
    id
    Secao
  }
  VideoAudio {
    id
    URL
    url_mp3
    Thumbs {
      id
      url
    }
  }
  Infografico {
    id
    Descricao
  }
}
    ${ObjetoEducacionalEdicaoFragmentDoc}`;
export const ComponentPerguntaQuizzPerguntaFragmentDoc = gql`
    fragment ComponentPerguntaQuizzPergunta on ComponentPerguntaQuizzPergunta {
  pergunta {
    id
    enunciado
    imagem {
      url
    }
    feedback_acerto
    feedback_erro
    duracao
    respostas {
      id
      opcao
      opcao_correta
      contador
    }
    url_vimeo
  }
}
    `;
export const ObjetoEducacionalWithHistoricoAvaliacaoDataFragmentDoc = gql`
    fragment ObjetoEducacionalWithHistoricoAvaliacaoData on ObjetoEducacionalWithHistoricoAvaliacaoData {
  id
  titulo
  data_criacao
  data_validade
  tipo
  categoria
  status
  expirado
}
    `;
export const CreateAuthorDocument = gql`
    mutation CreateAuthor($input: createPerfilDeAutorInput) {
  createPerfilDeAutor(input: $input) {
    perfilDeAutor {
      ...Autor
    }
  }
}
    ${AutorFragmentDoc}`;
export type CreateAuthorMutationFn = Apollo.MutationFunction<CreateAuthorMutation, CreateAuthorMutationVariables>;

/**
 * __useCreateAuthorMutation__
 *
 * To run a mutation, you first call `useCreateAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorMutation, { data, loading, error }] = useCreateAuthorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthorMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuthorMutation, CreateAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuthorMutation, CreateAuthorMutationVariables>(CreateAuthorDocument, options);
      }
export type CreateAuthorMutationHookResult = ReturnType<typeof useCreateAuthorMutation>;
export type CreateAuthorMutationResult = Apollo.MutationResult<CreateAuthorMutation>;
export type CreateAuthorMutationOptions = Apollo.BaseMutationOptions<CreateAuthorMutation, CreateAuthorMutationVariables>;
export const ApproveInvitationDocument = gql`
    mutation ApproveInvitation($ids: [ID!]!) {
  approveInvitation(ids: $ids) {
    message
  }
}
    `;
export type ApproveInvitationMutationFn = Apollo.MutationFunction<ApproveInvitationMutation, ApproveInvitationMutationVariables>;

/**
 * __useApproveInvitationMutation__
 *
 * To run a mutation, you first call `useApproveInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveInvitationMutation, { data, loading, error }] = useApproveInvitationMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useApproveInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveInvitationMutation, ApproveInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveInvitationMutation, ApproveInvitationMutationVariables>(ApproveInvitationDocument, options);
      }
export type ApproveInvitationMutationHookResult = ReturnType<typeof useApproveInvitationMutation>;
export type ApproveInvitationMutationResult = Apollo.MutationResult<ApproveInvitationMutation>;
export type ApproveInvitationMutationOptions = Apollo.BaseMutationOptions<ApproveInvitationMutation, ApproveInvitationMutationVariables>;
export const DeleteDriveInsumoDocument = gql`
    mutation DeleteDriveInsumo($id: ID!) {
  deleteDriveInsumo(id: $id) {
    message
  }
}
    `;
export type DeleteDriveInsumoMutationFn = Apollo.MutationFunction<DeleteDriveInsumoMutation, DeleteDriveInsumoMutationVariables>;

/**
 * __useDeleteDriveInsumoMutation__
 *
 * To run a mutation, you first call `useDeleteDriveInsumoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDriveInsumoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDriveInsumoMutation, { data, loading, error }] = useDeleteDriveInsumoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDriveInsumoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDriveInsumoMutation, DeleteDriveInsumoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDriveInsumoMutation, DeleteDriveInsumoMutationVariables>(DeleteDriveInsumoDocument, options);
      }
export type DeleteDriveInsumoMutationHookResult = ReturnType<typeof useDeleteDriveInsumoMutation>;
export type DeleteDriveInsumoMutationResult = Apollo.MutationResult<DeleteDriveInsumoMutation>;
export type DeleteDriveInsumoMutationOptions = Apollo.BaseMutationOptions<DeleteDriveInsumoMutation, DeleteDriveInsumoMutationVariables>;
export const CreateDriveInsumoObjetoEducacionalDocument = gql`
    mutation CreateDriveInsumoObjetoEducacional($input: createDriveInsumoObjetoEducacionalInput!) {
  createDriveInsumoObjetoEducacional(input: $input) {
    driveInsumoObjetoEducacional {
      id
      nome
      extensao
      url
      tipo
      created_at
    }
  }
}
    `;
export type CreateDriveInsumoObjetoEducacionalMutationFn = Apollo.MutationFunction<CreateDriveInsumoObjetoEducacionalMutation, CreateDriveInsumoObjetoEducacionalMutationVariables>;

/**
 * __useCreateDriveInsumoObjetoEducacionalMutation__
 *
 * To run a mutation, you first call `useCreateDriveInsumoObjetoEducacionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriveInsumoObjetoEducacionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriveInsumoObjetoEducacionalMutation, { data, loading, error }] = useCreateDriveInsumoObjetoEducacionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDriveInsumoObjetoEducacionalMutation(baseOptions?: Apollo.MutationHookOptions<CreateDriveInsumoObjetoEducacionalMutation, CreateDriveInsumoObjetoEducacionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDriveInsumoObjetoEducacionalMutation, CreateDriveInsumoObjetoEducacionalMutationVariables>(CreateDriveInsumoObjetoEducacionalDocument, options);
      }
export type CreateDriveInsumoObjetoEducacionalMutationHookResult = ReturnType<typeof useCreateDriveInsumoObjetoEducacionalMutation>;
export type CreateDriveInsumoObjetoEducacionalMutationResult = Apollo.MutationResult<CreateDriveInsumoObjetoEducacionalMutation>;
export type CreateDriveInsumoObjetoEducacionalMutationOptions = Apollo.BaseMutationOptions<CreateDriveInsumoObjetoEducacionalMutation, CreateDriveInsumoObjetoEducacionalMutationVariables>;
export const CreateHistoricoAvaliacaoObjetoEducacionalDocument = gql`
    mutation CreateHistoricoAvaliacaoObjetoEducacional($input: createHistoricoAvaliacaoObjetoEducacionalInput!) {
  createHistoricoAvaliacaoObjetoEducacional(input: $input) {
    historicoAvaliacaoObjetoEducacional {
      objeto_educacional {
        id
      }
      status_de_publicacao {
        id
      }
      users_permissions_user {
        id
      }
    }
  }
}
    `;
export type CreateHistoricoAvaliacaoObjetoEducacionalMutationFn = Apollo.MutationFunction<CreateHistoricoAvaliacaoObjetoEducacionalMutation, CreateHistoricoAvaliacaoObjetoEducacionalMutationVariables>;

/**
 * __useCreateHistoricoAvaliacaoObjetoEducacionalMutation__
 *
 * To run a mutation, you first call `useCreateHistoricoAvaliacaoObjetoEducacionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHistoricoAvaliacaoObjetoEducacionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHistoricoAvaliacaoObjetoEducacionalMutation, { data, loading, error }] = useCreateHistoricoAvaliacaoObjetoEducacionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHistoricoAvaliacaoObjetoEducacionalMutation(baseOptions?: Apollo.MutationHookOptions<CreateHistoricoAvaliacaoObjetoEducacionalMutation, CreateHistoricoAvaliacaoObjetoEducacionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHistoricoAvaliacaoObjetoEducacionalMutation, CreateHistoricoAvaliacaoObjetoEducacionalMutationVariables>(CreateHistoricoAvaliacaoObjetoEducacionalDocument, options);
      }
export type CreateHistoricoAvaliacaoObjetoEducacionalMutationHookResult = ReturnType<typeof useCreateHistoricoAvaliacaoObjetoEducacionalMutation>;
export type CreateHistoricoAvaliacaoObjetoEducacionalMutationResult = Apollo.MutationResult<CreateHistoricoAvaliacaoObjetoEducacionalMutation>;
export type CreateHistoricoAvaliacaoObjetoEducacionalMutationOptions = Apollo.BaseMutationOptions<CreateHistoricoAvaliacaoObjetoEducacionalMutation, CreateHistoricoAvaliacaoObjetoEducacionalMutationVariables>;
export const LoginDocument = gql`
    mutation Login($identifier: String!, $password: String!) {
  login(input: {identifier: $identifier, password: $password}) {
    jwt
    user {
      id
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const CreateObjetoEducacionalDocument = gql`
    mutation CreateObjetoEducacional($input: createObjetoEducacionalInput) {
  createObjetoEducacional(input: $input) {
    objetoEducacional {
      ...ObjetoEducacionalEdicao
      published_at
    }
  }
}
    ${ObjetoEducacionalEdicaoFragmentDoc}`;
export type CreateObjetoEducacionalMutationFn = Apollo.MutationFunction<CreateObjetoEducacionalMutation, CreateObjetoEducacionalMutationVariables>;

/**
 * __useCreateObjetoEducacionalMutation__
 *
 * To run a mutation, you first call `useCreateObjetoEducacionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObjetoEducacionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObjetoEducacionalMutation, { data, loading, error }] = useCreateObjetoEducacionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateObjetoEducacionalMutation(baseOptions?: Apollo.MutationHookOptions<CreateObjetoEducacionalMutation, CreateObjetoEducacionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateObjetoEducacionalMutation, CreateObjetoEducacionalMutationVariables>(CreateObjetoEducacionalDocument, options);
      }
export type CreateObjetoEducacionalMutationHookResult = ReturnType<typeof useCreateObjetoEducacionalMutation>;
export type CreateObjetoEducacionalMutationResult = Apollo.MutationResult<CreateObjetoEducacionalMutation>;
export type CreateObjetoEducacionalMutationOptions = Apollo.BaseMutationOptions<CreateObjetoEducacionalMutation, CreateObjetoEducacionalMutationVariables>;
export const UpdateObjetoEducacionalDocument = gql`
    mutation updateObjetoEducacional($input: updateObjetoEducacionalInput) {
  updateObjetoEducacional(input: $input) {
    objetoEducacional {
      ...ObjetoEducacional
    }
  }
}
    ${ObjetoEducacionalFragmentDoc}`;
export type UpdateObjetoEducacionalMutationFn = Apollo.MutationFunction<UpdateObjetoEducacionalMutation, UpdateObjetoEducacionalMutationVariables>;

/**
 * __useUpdateObjetoEducacionalMutation__
 *
 * To run a mutation, you first call `useUpdateObjetoEducacionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObjetoEducacionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObjetoEducacionalMutation, { data, loading, error }] = useUpdateObjetoEducacionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateObjetoEducacionalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateObjetoEducacionalMutation, UpdateObjetoEducacionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateObjetoEducacionalMutation, UpdateObjetoEducacionalMutationVariables>(UpdateObjetoEducacionalDocument, options);
      }
export type UpdateObjetoEducacionalMutationHookResult = ReturnType<typeof useUpdateObjetoEducacionalMutation>;
export type UpdateObjetoEducacionalMutationResult = Apollo.MutationResult<UpdateObjetoEducacionalMutation>;
export type UpdateObjetoEducacionalMutationOptions = Apollo.BaseMutationOptions<UpdateObjetoEducacionalMutation, UpdateObjetoEducacionalMutationVariables>;
export const UpdateObjetoEducacionalDriveInsumoDocument = gql`
    mutation UpdateObjetoEducacionalDriveInsumo($id: ID!, $comentario: String!, $uso_imagem_terceiro: Boolean!) {
  updateObjetoEducacionalDriveInsumo(
    id: $id
    comentario: $comentario
    uso_imagem_terceiro: $uso_imagem_terceiro
  ) {
    id
    uso_imagem_terceiro
    comentario
    updated_at
  }
}
    `;
export type UpdateObjetoEducacionalDriveInsumoMutationFn = Apollo.MutationFunction<UpdateObjetoEducacionalDriveInsumoMutation, UpdateObjetoEducacionalDriveInsumoMutationVariables>;

/**
 * __useUpdateObjetoEducacionalDriveInsumoMutation__
 *
 * To run a mutation, you first call `useUpdateObjetoEducacionalDriveInsumoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObjetoEducacionalDriveInsumoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObjetoEducacionalDriveInsumoMutation, { data, loading, error }] = useUpdateObjetoEducacionalDriveInsumoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comentario: // value for 'comentario'
 *      uso_imagem_terceiro: // value for 'uso_imagem_terceiro'
 *   },
 * });
 */
export function useUpdateObjetoEducacionalDriveInsumoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateObjetoEducacionalDriveInsumoMutation, UpdateObjetoEducacionalDriveInsumoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateObjetoEducacionalDriveInsumoMutation, UpdateObjetoEducacionalDriveInsumoMutationVariables>(UpdateObjetoEducacionalDriveInsumoDocument, options);
      }
export type UpdateObjetoEducacionalDriveInsumoMutationHookResult = ReturnType<typeof useUpdateObjetoEducacionalDriveInsumoMutation>;
export type UpdateObjetoEducacionalDriveInsumoMutationResult = Apollo.MutationResult<UpdateObjetoEducacionalDriveInsumoMutation>;
export type UpdateObjetoEducacionalDriveInsumoMutationOptions = Apollo.BaseMutationOptions<UpdateObjetoEducacionalDriveInsumoMutation, UpdateObjetoEducacionalDriveInsumoMutationVariables>;
export const CreatePalavraChaveDocument = gql`
    mutation CreatePalavraChave($input: createPalavraChaveInput) {
  createPalavraChave(input: $input) {
    palavraChave {
      ...PalavrasChave
    }
  }
}
    ${PalavrasChaveFragmentDoc}`;
export type CreatePalavraChaveMutationFn = Apollo.MutationFunction<CreatePalavraChaveMutation, CreatePalavraChaveMutationVariables>;

/**
 * __useCreatePalavraChaveMutation__
 *
 * To run a mutation, you first call `useCreatePalavraChaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePalavraChaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPalavraChaveMutation, { data, loading, error }] = useCreatePalavraChaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePalavraChaveMutation(baseOptions?: Apollo.MutationHookOptions<CreatePalavraChaveMutation, CreatePalavraChaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePalavraChaveMutation, CreatePalavraChaveMutationVariables>(CreatePalavraChaveDocument, options);
      }
export type CreatePalavraChaveMutationHookResult = ReturnType<typeof useCreatePalavraChaveMutation>;
export type CreatePalavraChaveMutationResult = Apollo.MutationResult<CreatePalavraChaveMutation>;
export type CreatePalavraChaveMutationOptions = Apollo.BaseMutationOptions<CreatePalavraChaveMutation, CreatePalavraChaveMutationVariables>;
export const CreatePerguntasQuizDocument = gql`
    mutation createPerguntasQuiz($input: createPerguntaQuizzInput!) {
  createPerguntaQuizz(input: $input) {
    perguntaQuizz {
      enunciado
      feedback_acerto
      feedback_erro
      respostas {
        opcao
        opcao_correta
      }
    }
  }
}
    `;
export type CreatePerguntasQuizMutationFn = Apollo.MutationFunction<CreatePerguntasQuizMutation, CreatePerguntasQuizMutationVariables>;

/**
 * __useCreatePerguntasQuizMutation__
 *
 * To run a mutation, you first call `useCreatePerguntasQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePerguntasQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPerguntasQuizMutation, { data, loading, error }] = useCreatePerguntasQuizMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePerguntasQuizMutation(baseOptions?: Apollo.MutationHookOptions<CreatePerguntasQuizMutation, CreatePerguntasQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePerguntasQuizMutation, CreatePerguntasQuizMutationVariables>(CreatePerguntasQuizDocument, options);
      }
export type CreatePerguntasQuizMutationHookResult = ReturnType<typeof useCreatePerguntasQuizMutation>;
export type CreatePerguntasQuizMutationResult = Apollo.MutationResult<CreatePerguntasQuizMutation>;
export type CreatePerguntasQuizMutationOptions = Apollo.BaseMutationOptions<CreatePerguntasQuizMutation, CreatePerguntasQuizMutationVariables>;
export const GetEstadoCivisDocument = gql`
    query GetEstadoCivis {
  estadoCivils {
    id
    titulo
  }
}
    `;

/**
 * __useGetEstadoCivisQuery__
 *
 * To run a query within a React component, call `useGetEstadoCivisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstadoCivisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstadoCivisQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEstadoCivisQuery(baseOptions?: Apollo.QueryHookOptions<GetEstadoCivisQuery, GetEstadoCivisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstadoCivisQuery, GetEstadoCivisQueryVariables>(GetEstadoCivisDocument, options);
      }
export function useGetEstadoCivisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstadoCivisQuery, GetEstadoCivisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstadoCivisQuery, GetEstadoCivisQueryVariables>(GetEstadoCivisDocument, options);
        }
export type GetEstadoCivisQueryHookResult = ReturnType<typeof useGetEstadoCivisQuery>;
export type GetEstadoCivisLazyQueryHookResult = ReturnType<typeof useGetEstadoCivisLazyQuery>;
export type GetEstadoCivisQueryResult = Apollo.QueryResult<GetEstadoCivisQuery, GetEstadoCivisQueryVariables>;
export const GetAllCategoriasDocument = gql`
    query GetAllCategorias {
  rotulosConnection(sort: "titulo:asc") {
    values {
      ...Categoria
    }
  }
}
    ${CategoriaFragmentDoc}`;

/**
 * __useGetAllCategoriasQuery__
 *
 * To run a query within a React component, call `useGetAllCategoriasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCategoriasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCategoriasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCategoriasQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCategoriasQuery, GetAllCategoriasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCategoriasQuery, GetAllCategoriasQueryVariables>(GetAllCategoriasDocument, options);
      }
export function useGetAllCategoriasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCategoriasQuery, GetAllCategoriasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCategoriasQuery, GetAllCategoriasQueryVariables>(GetAllCategoriasDocument, options);
        }
export type GetAllCategoriasQueryHookResult = ReturnType<typeof useGetAllCategoriasQuery>;
export type GetAllCategoriasLazyQueryHookResult = ReturnType<typeof useGetAllCategoriasLazyQuery>;
export type GetAllCategoriasQueryResult = Apollo.QueryResult<GetAllCategoriasQuery, GetAllCategoriasQueryVariables>;
export const GetAllStatusPublicacoesDocument = gql`
    query GetAllStatusPublicacoes {
  statusDePublicacaosConnection(sort: "titulo:asc") {
    values {
      ...StatusPublicacao
    }
  }
}
    ${StatusPublicacaoFragmentDoc}`;

/**
 * __useGetAllStatusPublicacoesQuery__
 *
 * To run a query within a React component, call `useGetAllStatusPublicacoesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStatusPublicacoesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStatusPublicacoesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStatusPublicacoesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStatusPublicacoesQuery, GetAllStatusPublicacoesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStatusPublicacoesQuery, GetAllStatusPublicacoesQueryVariables>(GetAllStatusPublicacoesDocument, options);
      }
export function useGetAllStatusPublicacoesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStatusPublicacoesQuery, GetAllStatusPublicacoesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStatusPublicacoesQuery, GetAllStatusPublicacoesQueryVariables>(GetAllStatusPublicacoesDocument, options);
        }
export type GetAllStatusPublicacoesQueryHookResult = ReturnType<typeof useGetAllStatusPublicacoesQuery>;
export type GetAllStatusPublicacoesLazyQueryHookResult = ReturnType<typeof useGetAllStatusPublicacoesLazyQuery>;
export type GetAllStatusPublicacoesQueryResult = Apollo.QueryResult<GetAllStatusPublicacoesQuery, GetAllStatusPublicacoesQueryVariables>;
export const GetAutorConvidadoByOeIdDocument = gql`
    query GetAutorConvidadoByOeId($idOe: ID!) {
  findAutoresConvidadosByObjetoEducacional(idOe: $idOe) {
    ...AutorConvidado
  }
}
    ${AutorConvidadoFragmentDoc}`;

/**
 * __useGetAutorConvidadoByOeIdQuery__
 *
 * To run a query within a React component, call `useGetAutorConvidadoByOeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutorConvidadoByOeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutorConvidadoByOeIdQuery({
 *   variables: {
 *      idOe: // value for 'idOe'
 *   },
 * });
 */
export function useGetAutorConvidadoByOeIdQuery(baseOptions: Apollo.QueryHookOptions<GetAutorConvidadoByOeIdQuery, GetAutorConvidadoByOeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutorConvidadoByOeIdQuery, GetAutorConvidadoByOeIdQueryVariables>(GetAutorConvidadoByOeIdDocument, options);
      }
export function useGetAutorConvidadoByOeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutorConvidadoByOeIdQuery, GetAutorConvidadoByOeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutorConvidadoByOeIdQuery, GetAutorConvidadoByOeIdQueryVariables>(GetAutorConvidadoByOeIdDocument, options);
        }
export type GetAutorConvidadoByOeIdQueryHookResult = ReturnType<typeof useGetAutorConvidadoByOeIdQuery>;
export type GetAutorConvidadoByOeIdLazyQueryHookResult = ReturnType<typeof useGetAutorConvidadoByOeIdLazyQuery>;
export type GetAutorConvidadoByOeIdQueryResult = Apollo.QueryResult<GetAutorConvidadoByOeIdQuery, GetAutorConvidadoByOeIdQueryVariables>;
export const GetConvitesPendenteDocument = gql`
    query GetConvitesPendente {
  findConvitesPendente {
    total
    data {
      id
      oe_id
      titulo
      categoria
      tipo
      data_criacao
    }
  }
}
    `;

/**
 * __useGetConvitesPendenteQuery__
 *
 * To run a query within a React component, call `useGetConvitesPendenteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConvitesPendenteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConvitesPendenteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConvitesPendenteQuery(baseOptions?: Apollo.QueryHookOptions<GetConvitesPendenteQuery, GetConvitesPendenteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConvitesPendenteQuery, GetConvitesPendenteQueryVariables>(GetConvitesPendenteDocument, options);
      }
export function useGetConvitesPendenteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConvitesPendenteQuery, GetConvitesPendenteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConvitesPendenteQuery, GetConvitesPendenteQueryVariables>(GetConvitesPendenteDocument, options);
        }
export type GetConvitesPendenteQueryHookResult = ReturnType<typeof useGetConvitesPendenteQuery>;
export type GetConvitesPendenteLazyQueryHookResult = ReturnType<typeof useGetConvitesPendenteLazyQuery>;
export type GetConvitesPendenteQueryResult = Apollo.QueryResult<GetConvitesPendenteQuery, GetConvitesPendenteQueryVariables>;
export const GetDriveInsumosByObjetoEducacionalIdDocument = gql`
    query GetDriveInsumosByObjetoEducacionalId($id: ID!) {
  findDriveInsumosByObjetoEducacional(idOe: $id) {
    ...DriveInsumoObjetoEducacional
  }
}
    ${DriveInsumoObjetoEducacionalFragmentDoc}`;

/**
 * __useGetDriveInsumosByObjetoEducacionalIdQuery__
 *
 * To run a query within a React component, call `useGetDriveInsumosByObjetoEducacionalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriveInsumosByObjetoEducacionalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriveInsumosByObjetoEducacionalIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDriveInsumosByObjetoEducacionalIdQuery(baseOptions: Apollo.QueryHookOptions<GetDriveInsumosByObjetoEducacionalIdQuery, GetDriveInsumosByObjetoEducacionalIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriveInsumosByObjetoEducacionalIdQuery, GetDriveInsumosByObjetoEducacionalIdQueryVariables>(GetDriveInsumosByObjetoEducacionalIdDocument, options);
      }
export function useGetDriveInsumosByObjetoEducacionalIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriveInsumosByObjetoEducacionalIdQuery, GetDriveInsumosByObjetoEducacionalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriveInsumosByObjetoEducacionalIdQuery, GetDriveInsumosByObjetoEducacionalIdQueryVariables>(GetDriveInsumosByObjetoEducacionalIdDocument, options);
        }
export type GetDriveInsumosByObjetoEducacionalIdQueryHookResult = ReturnType<typeof useGetDriveInsumosByObjetoEducacionalIdQuery>;
export type GetDriveInsumosByObjetoEducacionalIdLazyQueryHookResult = ReturnType<typeof useGetDriveInsumosByObjetoEducacionalIdLazyQuery>;
export type GetDriveInsumosByObjetoEducacionalIdQueryResult = Apollo.QueryResult<GetDriveInsumosByObjetoEducacionalIdQuery, GetDriveInsumosByObjetoEducacionalIdQueryVariables>;
export const GetGetObjetosEducacionaisByKeyWordDocument = gql`
    query GetGetObjetosEducacionaisByKeyWord($where: KeyWordInput!) {
  findByKeyWord(where: $where) {
    ...KeyWordPayload
  }
}
    ${KeyWordPayloadFragmentDoc}`;

/**
 * __useGetGetObjetosEducacionaisByKeyWordQuery__
 *
 * To run a query within a React component, call `useGetGetObjetosEducacionaisByKeyWordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGetObjetosEducacionaisByKeyWordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGetObjetosEducacionaisByKeyWordQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetGetObjetosEducacionaisByKeyWordQuery(baseOptions: Apollo.QueryHookOptions<GetGetObjetosEducacionaisByKeyWordQuery, GetGetObjetosEducacionaisByKeyWordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGetObjetosEducacionaisByKeyWordQuery, GetGetObjetosEducacionaisByKeyWordQueryVariables>(GetGetObjetosEducacionaisByKeyWordDocument, options);
      }
export function useGetGetObjetosEducacionaisByKeyWordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGetObjetosEducacionaisByKeyWordQuery, GetGetObjetosEducacionaisByKeyWordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGetObjetosEducacionaisByKeyWordQuery, GetGetObjetosEducacionaisByKeyWordQueryVariables>(GetGetObjetosEducacionaisByKeyWordDocument, options);
        }
export type GetGetObjetosEducacionaisByKeyWordQueryHookResult = ReturnType<typeof useGetGetObjetosEducacionaisByKeyWordQuery>;
export type GetGetObjetosEducacionaisByKeyWordLazyQueryHookResult = ReturnType<typeof useGetGetObjetosEducacionaisByKeyWordLazyQuery>;
export type GetGetObjetosEducacionaisByKeyWordQueryResult = Apollo.QueryResult<GetGetObjetosEducacionaisByKeyWordQuery, GetGetObjetosEducacionaisByKeyWordQueryVariables>;
export const GetHistoricoAvaliacaoAtualOePorIdDocument = gql`
    query GetHistoricoAvaliacaoAtualOePorId($oeId: ID!) {
  findHistoricoAvaliacaoAtualByOeId(id: $oeId) {
    titulo
    enum_status
  }
}
    `;

/**
 * __useGetHistoricoAvaliacaoAtualOePorIdQuery__
 *
 * To run a query within a React component, call `useGetHistoricoAvaliacaoAtualOePorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricoAvaliacaoAtualOePorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricoAvaliacaoAtualOePorIdQuery({
 *   variables: {
 *      oeId: // value for 'oeId'
 *   },
 * });
 */
export function useGetHistoricoAvaliacaoAtualOePorIdQuery(baseOptions: Apollo.QueryHookOptions<GetHistoricoAvaliacaoAtualOePorIdQuery, GetHistoricoAvaliacaoAtualOePorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricoAvaliacaoAtualOePorIdQuery, GetHistoricoAvaliacaoAtualOePorIdQueryVariables>(GetHistoricoAvaliacaoAtualOePorIdDocument, options);
      }
export function useGetHistoricoAvaliacaoAtualOePorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricoAvaliacaoAtualOePorIdQuery, GetHistoricoAvaliacaoAtualOePorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricoAvaliacaoAtualOePorIdQuery, GetHistoricoAvaliacaoAtualOePorIdQueryVariables>(GetHistoricoAvaliacaoAtualOePorIdDocument, options);
        }
export type GetHistoricoAvaliacaoAtualOePorIdQueryHookResult = ReturnType<typeof useGetHistoricoAvaliacaoAtualOePorIdQuery>;
export type GetHistoricoAvaliacaoAtualOePorIdLazyQueryHookResult = ReturnType<typeof useGetHistoricoAvaliacaoAtualOePorIdLazyQuery>;
export type GetHistoricoAvaliacaoAtualOePorIdQueryResult = Apollo.QueryResult<GetHistoricoAvaliacaoAtualOePorIdQuery, GetHistoricoAvaliacaoAtualOePorIdQueryVariables>;
export const GetObjetoEducacionalPorIdDocument = gql`
    query getObjetoEducacionalPorId($input: ID!) {
  objetoEducacional(id: $input) {
    ...ObjetoEducacional
  }
}
    ${ObjetoEducacionalFragmentDoc}`;

/**
 * __useGetObjetoEducacionalPorIdQuery__
 *
 * To run a query within a React component, call `useGetObjetoEducacionalPorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjetoEducacionalPorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjetoEducacionalPorIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetObjetoEducacionalPorIdQuery(baseOptions: Apollo.QueryHookOptions<GetObjetoEducacionalPorIdQuery, GetObjetoEducacionalPorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjetoEducacionalPorIdQuery, GetObjetoEducacionalPorIdQueryVariables>(GetObjetoEducacionalPorIdDocument, options);
      }
export function useGetObjetoEducacionalPorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjetoEducacionalPorIdQuery, GetObjetoEducacionalPorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjetoEducacionalPorIdQuery, GetObjetoEducacionalPorIdQueryVariables>(GetObjetoEducacionalPorIdDocument, options);
        }
export type GetObjetoEducacionalPorIdQueryHookResult = ReturnType<typeof useGetObjetoEducacionalPorIdQuery>;
export type GetObjetoEducacionalPorIdLazyQueryHookResult = ReturnType<typeof useGetObjetoEducacionalPorIdLazyQuery>;
export type GetObjetoEducacionalPorIdQueryResult = Apollo.QueryResult<GetObjetoEducacionalPorIdQuery, GetObjetoEducacionalPorIdQueryVariables>;
export const GetObjetoEducacionalEdicaoPorIdDocument = gql`
    query getObjetoEducacionalEdicaoPorId($id: ID!, $userId: ID) {
  findById(id: $id, userId: $userId) {
    ...ObjetoEducacionalEdicao
  }
}
    ${ObjetoEducacionalEdicaoFragmentDoc}`;

/**
 * __useGetObjetoEducacionalEdicaoPorIdQuery__
 *
 * To run a query within a React component, call `useGetObjetoEducacionalEdicaoPorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjetoEducacionalEdicaoPorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjetoEducacionalEdicaoPorIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetObjetoEducacionalEdicaoPorIdQuery(baseOptions: Apollo.QueryHookOptions<GetObjetoEducacionalEdicaoPorIdQuery, GetObjetoEducacionalEdicaoPorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjetoEducacionalEdicaoPorIdQuery, GetObjetoEducacionalEdicaoPorIdQueryVariables>(GetObjetoEducacionalEdicaoPorIdDocument, options);
      }
export function useGetObjetoEducacionalEdicaoPorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjetoEducacionalEdicaoPorIdQuery, GetObjetoEducacionalEdicaoPorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjetoEducacionalEdicaoPorIdQuery, GetObjetoEducacionalEdicaoPorIdQueryVariables>(GetObjetoEducacionalEdicaoPorIdDocument, options);
        }
export type GetObjetoEducacionalEdicaoPorIdQueryHookResult = ReturnType<typeof useGetObjetoEducacionalEdicaoPorIdQuery>;
export type GetObjetoEducacionalEdicaoPorIdLazyQueryHookResult = ReturnType<typeof useGetObjetoEducacionalEdicaoPorIdLazyQuery>;
export type GetObjetoEducacionalEdicaoPorIdQueryResult = Apollo.QueryResult<GetObjetoEducacionalEdicaoPorIdQuery, GetObjetoEducacionalEdicaoPorIdQueryVariables>;
export const GetObjetoEducacionalWithQuizByIdDocument = gql`
    query GetObjetoEducacionalWithQuizById($id: ID!) {
  objetoEducacional(id: $id) {
    id
    Quizzes {
      id
      perguntas {
        ...ComponentPerguntaQuizzPergunta
      }
    }
  }
}
    ${ComponentPerguntaQuizzPerguntaFragmentDoc}`;

/**
 * __useGetObjetoEducacionalWithQuizByIdQuery__
 *
 * To run a query within a React component, call `useGetObjetoEducacionalWithQuizByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjetoEducacionalWithQuizByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjetoEducacionalWithQuizByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetObjetoEducacionalWithQuizByIdQuery(baseOptions: Apollo.QueryHookOptions<GetObjetoEducacionalWithQuizByIdQuery, GetObjetoEducacionalWithQuizByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjetoEducacionalWithQuizByIdQuery, GetObjetoEducacionalWithQuizByIdQueryVariables>(GetObjetoEducacionalWithQuizByIdDocument, options);
      }
export function useGetObjetoEducacionalWithQuizByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjetoEducacionalWithQuizByIdQuery, GetObjetoEducacionalWithQuizByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjetoEducacionalWithQuizByIdQuery, GetObjetoEducacionalWithQuizByIdQueryVariables>(GetObjetoEducacionalWithQuizByIdDocument, options);
        }
export type GetObjetoEducacionalWithQuizByIdQueryHookResult = ReturnType<typeof useGetObjetoEducacionalWithQuizByIdQuery>;
export type GetObjetoEducacionalWithQuizByIdLazyQueryHookResult = ReturnType<typeof useGetObjetoEducacionalWithQuizByIdLazyQuery>;
export type GetObjetoEducacionalWithQuizByIdQueryResult = Apollo.QueryResult<GetObjetoEducacionalWithQuizByIdQuery, GetObjetoEducacionalWithQuizByIdQueryVariables>;
export const GetObjetosEducacionaisBySearchDocument = gql`
    query GetObjetosEducacionaisBySearch($where: ObjetoEducacionalWithHistoricoAvaliacaoInput!, $order_by: ENUM_OBJETO_EDUCACIONAL_WITH_HISTORICO_AVALIACAO_ORDER_BY!, $start: Int!, $limit: Int!) {
  findObjetosEducacionaisWithHistoricoAvaliacao(
    where: $where
    order_by: $order_by
    start: $start
    limit: $limit
  ) {
    total
    totalCount
    data {
      ...ObjetoEducacionalWithHistoricoAvaliacaoData
    }
    error
  }
}
    ${ObjetoEducacionalWithHistoricoAvaliacaoDataFragmentDoc}`;

/**
 * __useGetObjetosEducacionaisBySearchQuery__
 *
 * To run a query within a React component, call `useGetObjetosEducacionaisBySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjetosEducacionaisBySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjetosEducacionaisBySearchQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetObjetosEducacionaisBySearchQuery(baseOptions: Apollo.QueryHookOptions<GetObjetosEducacionaisBySearchQuery, GetObjetosEducacionaisBySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjetosEducacionaisBySearchQuery, GetObjetosEducacionaisBySearchQueryVariables>(GetObjetosEducacionaisBySearchDocument, options);
      }
export function useGetObjetosEducacionaisBySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjetosEducacionaisBySearchQuery, GetObjetosEducacionaisBySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjetosEducacionaisBySearchQuery, GetObjetosEducacionaisBySearchQueryVariables>(GetObjetosEducacionaisBySearchDocument, options);
        }
export type GetObjetosEducacionaisBySearchQueryHookResult = ReturnType<typeof useGetObjetosEducacionaisBySearchQuery>;
export type GetObjetosEducacionaisBySearchLazyQueryHookResult = ReturnType<typeof useGetObjetosEducacionaisBySearchLazyQuery>;
export type GetObjetosEducacionaisBySearchQueryResult = Apollo.QueryResult<GetObjetosEducacionaisBySearchQuery, GetObjetosEducacionaisBySearchQueryVariables>;
export const GetPalavrasChaveDocument = gql`
    query GetPalavrasChave {
  palavraChaves {
    id
    titulo
  }
}
    `;

/**
 * __useGetPalavrasChaveQuery__
 *
 * To run a query within a React component, call `useGetPalavrasChaveQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPalavrasChaveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPalavrasChaveQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPalavrasChaveQuery(baseOptions?: Apollo.QueryHookOptions<GetPalavrasChaveQuery, GetPalavrasChaveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPalavrasChaveQuery, GetPalavrasChaveQueryVariables>(GetPalavrasChaveDocument, options);
      }
export function useGetPalavrasChaveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPalavrasChaveQuery, GetPalavrasChaveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPalavrasChaveQuery, GetPalavrasChaveQueryVariables>(GetPalavrasChaveDocument, options);
        }
export type GetPalavrasChaveQueryHookResult = ReturnType<typeof useGetPalavrasChaveQuery>;
export type GetPalavrasChaveLazyQueryHookResult = ReturnType<typeof useGetPalavrasChaveLazyQuery>;
export type GetPalavrasChaveQueryResult = Apollo.QueryResult<GetPalavrasChaveQuery, GetPalavrasChaveQueryVariables>;
export const GetPalavrasChaveByOeDocument = gql`
    query GetPalavrasChaveByOe($oe: ID!) {
  findPalavraChavesByOe(id: $oe) {
    id
    titulo
  }
}
    `;

/**
 * __useGetPalavrasChaveByOeQuery__
 *
 * To run a query within a React component, call `useGetPalavrasChaveByOeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPalavrasChaveByOeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPalavrasChaveByOeQuery({
 *   variables: {
 *      oe: // value for 'oe'
 *   },
 * });
 */
export function useGetPalavrasChaveByOeQuery(baseOptions: Apollo.QueryHookOptions<GetPalavrasChaveByOeQuery, GetPalavrasChaveByOeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPalavrasChaveByOeQuery, GetPalavrasChaveByOeQueryVariables>(GetPalavrasChaveByOeDocument, options);
      }
export function useGetPalavrasChaveByOeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPalavrasChaveByOeQuery, GetPalavrasChaveByOeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPalavrasChaveByOeQuery, GetPalavrasChaveByOeQueryVariables>(GetPalavrasChaveByOeDocument, options);
        }
export type GetPalavrasChaveByOeQueryHookResult = ReturnType<typeof useGetPalavrasChaveByOeQuery>;
export type GetPalavrasChaveByOeLazyQueryHookResult = ReturnType<typeof useGetPalavrasChaveByOeLazyQuery>;
export type GetPalavrasChaveByOeQueryResult = Apollo.QueryResult<GetPalavrasChaveByOeQuery, GetPalavrasChaveByOeQueryVariables>;
export const GetPalavrasChavePorNomeDocument = gql`
    query GetPalavrasChavePorNome($input: String) {
  palavraChaves(where: {titulo_contains: $input}) {
    id
    titulo
  }
}
    `;

/**
 * __useGetPalavrasChavePorNomeQuery__
 *
 * To run a query within a React component, call `useGetPalavrasChavePorNomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPalavrasChavePorNomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPalavrasChavePorNomeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPalavrasChavePorNomeQuery(baseOptions?: Apollo.QueryHookOptions<GetPalavrasChavePorNomeQuery, GetPalavrasChavePorNomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPalavrasChavePorNomeQuery, GetPalavrasChavePorNomeQueryVariables>(GetPalavrasChavePorNomeDocument, options);
      }
export function useGetPalavrasChavePorNomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPalavrasChavePorNomeQuery, GetPalavrasChavePorNomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPalavrasChavePorNomeQuery, GetPalavrasChavePorNomeQueryVariables>(GetPalavrasChavePorNomeDocument, options);
        }
export type GetPalavrasChavePorNomeQueryHookResult = ReturnType<typeof useGetPalavrasChavePorNomeQuery>;
export type GetPalavrasChavePorNomeLazyQueryHookResult = ReturnType<typeof useGetPalavrasChavePorNomeLazyQuery>;
export type GetPalavrasChavePorNomeQueryResult = Apollo.QueryResult<GetPalavrasChavePorNomeQuery, GetPalavrasChavePorNomeQueryVariables>;
export const GetStatusPorTituloDocument = gql`
    query getStatusPorTitulo($enum_status: String!) {
  statusDePublicacaos(where: {enum_status: $enum_status}) {
    id
    titulo
  }
}
    `;

/**
 * __useGetStatusPorTituloQuery__
 *
 * To run a query within a React component, call `useGetStatusPorTituloQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusPorTituloQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusPorTituloQuery({
 *   variables: {
 *      enum_status: // value for 'enum_status'
 *   },
 * });
 */
export function useGetStatusPorTituloQuery(baseOptions: Apollo.QueryHookOptions<GetStatusPorTituloQuery, GetStatusPorTituloQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusPorTituloQuery, GetStatusPorTituloQueryVariables>(GetStatusPorTituloDocument, options);
      }
export function useGetStatusPorTituloLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusPorTituloQuery, GetStatusPorTituloQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusPorTituloQuery, GetStatusPorTituloQueryVariables>(GetStatusPorTituloDocument, options);
        }
export type GetStatusPorTituloQueryHookResult = ReturnType<typeof useGetStatusPorTituloQuery>;
export type GetStatusPorTituloLazyQueryHookResult = ReturnType<typeof useGetStatusPorTituloLazyQuery>;
export type GetStatusPorTituloQueryResult = Apollo.QueryResult<GetStatusPorTituloQuery, GetStatusPorTituloQueryVariables>;
export const GetTipoObjetosDocument = gql`
    query GetTipoObjetos {
  tipoOes {
    id
    titulo
  }
}
    `;

/**
 * __useGetTipoObjetosQuery__
 *
 * To run a query within a React component, call `useGetTipoObjetosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipoObjetosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipoObjetosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTipoObjetosQuery(baseOptions?: Apollo.QueryHookOptions<GetTipoObjetosQuery, GetTipoObjetosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipoObjetosQuery, GetTipoObjetosQueryVariables>(GetTipoObjetosDocument, options);
      }
export function useGetTipoObjetosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipoObjetosQuery, GetTipoObjetosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipoObjetosQuery, GetTipoObjetosQueryVariables>(GetTipoObjetosDocument, options);
        }
export type GetTipoObjetosQueryHookResult = ReturnType<typeof useGetTipoObjetosQuery>;
export type GetTipoObjetosLazyQueryHookResult = ReturnType<typeof useGetTipoObjetosLazyQuery>;
export type GetTipoObjetosQueryResult = Apollo.QueryResult<GetTipoObjetosQuery, GetTipoObjetosQueryVariables>;
export const GetTotalObjetosEducacionaisAExpirarDocument = gql`
    query GetTotalObjetosEducacionaisAExpirar {
  findTotalObjetosEducacionaisAExpirar {
    total
  }
}
    `;

/**
 * __useGetTotalObjetosEducacionaisAExpirarQuery__
 *
 * To run a query within a React component, call `useGetTotalObjetosEducacionaisAExpirarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalObjetosEducacionaisAExpirarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalObjetosEducacionaisAExpirarQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalObjetosEducacionaisAExpirarQuery(baseOptions?: Apollo.QueryHookOptions<GetTotalObjetosEducacionaisAExpirarQuery, GetTotalObjetosEducacionaisAExpirarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalObjetosEducacionaisAExpirarQuery, GetTotalObjetosEducacionaisAExpirarQueryVariables>(GetTotalObjetosEducacionaisAExpirarDocument, options);
      }
export function useGetTotalObjetosEducacionaisAExpirarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalObjetosEducacionaisAExpirarQuery, GetTotalObjetosEducacionaisAExpirarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalObjetosEducacionaisAExpirarQuery, GetTotalObjetosEducacionaisAExpirarQueryVariables>(GetTotalObjetosEducacionaisAExpirarDocument, options);
        }
export type GetTotalObjetosEducacionaisAExpirarQueryHookResult = ReturnType<typeof useGetTotalObjetosEducacionaisAExpirarQuery>;
export type GetTotalObjetosEducacionaisAExpirarLazyQueryHookResult = ReturnType<typeof useGetTotalObjetosEducacionaisAExpirarLazyQuery>;
export type GetTotalObjetosEducacionaisAExpirarQueryResult = Apollo.QueryResult<GetTotalObjetosEducacionaisAExpirarQuery, GetTotalObjetosEducacionaisAExpirarQueryVariables>;
export const GetTotalConteudosByUserRoleDocument = gql`
    query GetTotalConteudosByUserRole {
  findTotalObjetoEducacionalByStatusPublicacaoAndUserRole {
    total
  }
}
    `;

/**
 * __useGetTotalConteudosByUserRoleQuery__
 *
 * To run a query within a React component, call `useGetTotalConteudosByUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalConteudosByUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalConteudosByUserRoleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalConteudosByUserRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetTotalConteudosByUserRoleQuery, GetTotalConteudosByUserRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalConteudosByUserRoleQuery, GetTotalConteudosByUserRoleQueryVariables>(GetTotalConteudosByUserRoleDocument, options);
      }
export function useGetTotalConteudosByUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalConteudosByUserRoleQuery, GetTotalConteudosByUserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalConteudosByUserRoleQuery, GetTotalConteudosByUserRoleQueryVariables>(GetTotalConteudosByUserRoleDocument, options);
        }
export type GetTotalConteudosByUserRoleQueryHookResult = ReturnType<typeof useGetTotalConteudosByUserRoleQuery>;
export type GetTotalConteudosByUserRoleLazyQueryHookResult = ReturnType<typeof useGetTotalConteudosByUserRoleLazyQuery>;
export type GetTotalConteudosByUserRoleQueryResult = Apollo.QueryResult<GetTotalConteudosByUserRoleQuery, GetTotalConteudosByUserRoleQueryVariables>;
export const GetProfissoesDocument = gql`
    query GetProfissoes {
  profissaos {
    id
    titulo
    PossuiCRM
  }
}
    `;

/**
 * __useGetProfissoesQuery__
 *
 * To run a query within a React component, call `useGetProfissoesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfissoesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfissoesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfissoesQuery(baseOptions?: Apollo.QueryHookOptions<GetProfissoesQuery, GetProfissoesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfissoesQuery, GetProfissoesQueryVariables>(GetProfissoesDocument, options);
      }
export function useGetProfissoesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfissoesQuery, GetProfissoesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfissoesQuery, GetProfissoesQueryVariables>(GetProfissoesDocument, options);
        }
export type GetProfissoesQueryHookResult = ReturnType<typeof useGetProfissoesQuery>;
export type GetProfissoesLazyQueryHookResult = ReturnType<typeof useGetProfissoesLazyQuery>;
export type GetProfissoesQueryResult = Apollo.QueryResult<GetProfissoesQuery, GetProfissoesQueryVariables>;
export const GetPublicoAlvoDocument = gql`
    query GetPublicoAlvo {
  publicoAlvos {
    id
    titulo
  }
}
    `;

/**
 * __useGetPublicoAlvoQuery__
 *
 * To run a query within a React component, call `useGetPublicoAlvoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicoAlvoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicoAlvoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublicoAlvoQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicoAlvoQuery, GetPublicoAlvoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicoAlvoQuery, GetPublicoAlvoQueryVariables>(GetPublicoAlvoDocument, options);
      }
export function useGetPublicoAlvoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicoAlvoQuery, GetPublicoAlvoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicoAlvoQuery, GetPublicoAlvoQueryVariables>(GetPublicoAlvoDocument, options);
        }
export type GetPublicoAlvoQueryHookResult = ReturnType<typeof useGetPublicoAlvoQuery>;
export type GetPublicoAlvoLazyQueryHookResult = ReturnType<typeof useGetPublicoAlvoLazyQuery>;
export type GetPublicoAlvoQueryResult = Apollo.QueryResult<GetPublicoAlvoQuery, GetPublicoAlvoQueryVariables>;
export const GetRotulosDocument = gql`
    query GetRotulos {
  rotulos {
    id
    titulo
    descricao
  }
}
    `;

/**
 * __useGetRotulosQuery__
 *
 * To run a query within a React component, call `useGetRotulosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRotulosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRotulosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRotulosQuery(baseOptions?: Apollo.QueryHookOptions<GetRotulosQuery, GetRotulosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRotulosQuery, GetRotulosQueryVariables>(GetRotulosDocument, options);
      }
export function useGetRotulosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRotulosQuery, GetRotulosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRotulosQuery, GetRotulosQueryVariables>(GetRotulosDocument, options);
        }
export type GetRotulosQueryHookResult = ReturnType<typeof useGetRotulosQuery>;
export type GetRotulosLazyQueryHookResult = ReturnType<typeof useGetRotulosLazyQuery>;
export type GetRotulosQueryResult = Apollo.QueryResult<GetRotulosQuery, GetRotulosQueryVariables>;